(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js', './korge-root-korio.js', './korge-root-korma.js', './korge-root-kds.js', './korge-root-kmem.js', './korge-root-krypto.js', './korge-root-klock.js', './korge-root-klogger.js', './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./korge-root-korio.js'), require('./korge-root-korma.js'), require('./korge-root-kds.js'), require('./korge-root-kmem.js'), require('./korge-root-krypto.js'), require('./korge-root-klock.js'), require('./korge-root-klogger.js'), require('./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'korge-root-korim'.");
    }
    if (typeof this['korge-root-korio'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'korge-root-korio' was not found. Please, check whether 'korge-root-korio' is loaded prior to 'korge-root-korim'.");
    }
    if (typeof this['korge-root-korma'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'korge-root-korma' was not found. Please, check whether 'korge-root-korma' is loaded prior to 'korge-root-korim'.");
    }
    if (typeof this['korge-root-kds'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'korge-root-kds' was not found. Please, check whether 'korge-root-kds' is loaded prior to 'korge-root-korim'.");
    }
    if (typeof this['korge-root-kmem'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'korge-root-kmem' was not found. Please, check whether 'korge-root-kmem' is loaded prior to 'korge-root-korim'.");
    }
    if (typeof this['korge-root-krypto'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'korge-root-krypto' was not found. Please, check whether 'korge-root-krypto' is loaded prior to 'korge-root-korim'.");
    }
    if (typeof this['korge-root-klock'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'korge-root-klock' was not found. Please, check whether 'korge-root-klock' is loaded prior to 'korge-root-korim'.");
    }
    if (typeof this['korge-root-klogger'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'korge-root-klogger' was not found. Please, check whether 'korge-root-klogger' is loaded prior to 'korge-root-korim'.");
    }
    if (typeof this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korim'. Its dependency 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' was not found. Please, check whether 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' is loaded prior to 'korge-root-korim'.");
    }
    root['korge-root-korim'] = factory(typeof this['korge-root-korim'] === 'undefined' ? {} : this['korge-root-korim'], this['kotlin-kotlin-stdlib-js-ir'], this['korge-root-korio'], this['korge-root-korma'], this['korge-root-kds'], this['korge-root-kmem'], this['korge-root-krypto'], this['korge-root-klock'], this['korge-root-klogger'], this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir']);
  }
}(this, function (_, kotlin_kotlin, kotlin_com_soywiz_korlibs_korio_korio, kotlin_com_soywiz_korlibs_korma_korma, kotlin_com_soywiz_korlibs_kds_kds, kotlin_com_soywiz_korlibs_kmem_kmem, kotlin_com_soywiz_korlibs_krypto_krypto, kotlin_com_soywiz_korlibs_klock_klock, kotlin_com_soywiz_korlibs_klogger_klogger, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var hypot = Math.hypot;
  var log2 = Math.log2;
  var toString = kotlin_kotlin.$_$.k9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var VOID = kotlin_kotlin.$_$.nd;
  var protoOf = kotlin_kotlin.$_$.f9;
  var classMeta = kotlin_kotlin.$_$.a8;
  var setMetadataFor = kotlin_kotlin.$_$.g9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.i;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.l3;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.h;
  var Unit_getInstance = kotlin_kotlin.$_$.t2;
  var addAll = kotlin_kotlin.$_$.g3;
  var mapCapacity = kotlin_kotlin.$_$.l5;
  var coerceAtLeast = kotlin_kotlin.$_$.s9;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.n;
  var interfaceMeta = kotlin_kotlin.$_$.m8;
  var CoroutineImpl = kotlin_kotlin.$_$.o7;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.x6;
  var firstOrNull = kotlin_kotlin.$_$.ta;
  var Char = kotlin_kotlin.$_$.ec;
  var startsWith = kotlin_kotlin.$_$.ib;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r1;
  var startsWith_0 = kotlin_kotlin.$_$.jb;
  var to = kotlin_kotlin.$_$.md;
  var objectMeta = kotlin_kotlin.$_$.e9;
  var Dyn__get_impl_6l2p80 = kotlin_com_soywiz_korlibs_korio_korio.$_$.v;
  var _Dyn___get_int__impl__sh8lhm = kotlin_com_soywiz_korlibs_korio_korio.$_$.w;
  var _RectangleInt___init__impl__1g5gox = kotlin_com_soywiz_korlibs_korma_korma.$_$.x4;
  var _SizeInt___init__impl__vivn9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.c6;
  var _Dyn___get_bool__impl__nv3iun = kotlin_com_soywiz_korlibs_korio_korio.$_$.t;
  var _SizeInt___get_width__impl__swntg6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.f6;
  var _SizeInt___get_height__impl__d3sy61 = kotlin_com_soywiz_korlibs_korma_korma.$_$.e6;
  var _RectangleInt___get_x__impl__6tm2y6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.h5;
  var _RectangleInt___get_y__impl__zdvhyr = kotlin_com_soywiz_korlibs_korma_korma.$_$.i5;
  var _RectangleInt___get_height__impl__gd473j = kotlin_com_soywiz_korlibs_korma_korma.$_$.c5;
  var _RectangleInt___get_width__impl__gtay8w = kotlin_com_soywiz_korlibs_korma_korma.$_$.g5;
  var Companion_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.b7;
  var charArrayOf = kotlin_kotlin.$_$.w7;
  var split = kotlin_kotlin.$_$.gb;
  var first = kotlin_kotlin.$_$.q4;
  var THROW_CCE = kotlin_kotlin.$_$.pc;
  var isCharSequence = kotlin_kotlin.$_$.p8;
  var trim = kotlin_kotlin.$_$.cc;
  var toInt = kotlin_kotlin.$_$.tb;
  var last = kotlin_kotlin.$_$.g5;
  var _Vector2___init__impl__67w0ru = kotlin_com_soywiz_korlibs_korma_korma.$_$.i6;
  var _Vector2___get_x__impl__zywdz = kotlin_com_soywiz_korlibs_korma_korma.$_$.n6;
  var numberToInt = kotlin_kotlin.$_$.b9;
  var _Vector2___get_y__impl__ttldg6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.p6;
  var listOf = kotlin_kotlin.$_$.j5;
  var objectCreate = kotlin_kotlin.$_$.d9;
  var emptyList = kotlin_kotlin.$_$.h4;
  var SizeInt = kotlin_com_soywiz_korlibs_korma_korma.$_$.i9;
  var getStringHashCode = kotlin_kotlin.$_$.j8;
  var getNumberHashCode = kotlin_kotlin.$_$.h8;
  var SizeInt__hashCode_impl_xg010c = kotlin_com_soywiz_korlibs_korma_korma.$_$.d6;
  var hashCode = kotlin_kotlin.$_$.k8;
  var equals = kotlin_kotlin.$_$.c8;
  var RectangleInt = kotlin_com_soywiz_korlibs_korma_korma.$_$.f9;
  var RectangleInt__hashCode_impl_wuqys2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.b5;
  var _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq = kotlin_com_soywiz_korlibs_korma_korma.$_$.q;
  var SliceOrientation = kotlin_com_soywiz_korlibs_korma_korma.$_$.z7;
  var SliceOrientation__hashCode_impl_7mjkdw = kotlin_com_soywiz_korlibs_korma_korma.$_$.p;
  var Json_getInstance = kotlin_com_soywiz_korlibs_korio_korio.$_$.o1;
  var get_dyn = kotlin_com_soywiz_korlibs_korio_korio.$_$.h2;
  var _Dyn___get_value__impl__bemnlg = kotlin_com_soywiz_korlibs_korio_korio.$_$.f1;
  var _Dyn___get_list__impl__qpwjp = kotlin_com_soywiz_korlibs_korio_korio.$_$.x;
  var _Dyn___get_orNull__impl__ox3tzj = kotlin_com_soywiz_korlibs_korio_korio.$_$.y;
  var _Dyn___get_str__impl__dup4cs = kotlin_com_soywiz_korlibs_korio_korio.$_$.a1;
  var Map = kotlin_kotlin.$_$.a3;
  var isInterface = kotlin_kotlin.$_$.u8;
  var _Dyn___get_double__impl__jlvfa0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.u;
  var List = kotlin_kotlin.$_$.z2;
  var Xml = kotlin_com_soywiz_korlibs_korio_korio.$_$.m3;
  var plus = kotlin_kotlin.$_$.s5;
  var lines = kotlin_kotlin.$_$.za;
  var ListReader = kotlin_com_soywiz_korlibs_kds_kds.$_$.k1;
  var charSequenceLength = kotlin_kotlin.$_$.z7;
  var Companion_getInstance_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.p7;
  var contains = kotlin_kotlin.$_$.oa;
  var toBoolean = kotlin_kotlin.$_$.ob;
  var split_0 = kotlin_kotlin.$_$.hb;
  var Companion_getInstance_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.z6;
  var Enum = kotlin_kotlin.$_$.hc;
  var toList = kotlin_kotlin.$_$.k6;
  var _MarginInt___init__impl__dx1aag = kotlin_com_soywiz_korlibs_korma_korma.$_$.a2;
  var arrayListOf = kotlin_kotlin.$_$.i3;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.o;
  var RectSlice = kotlin_com_soywiz_korlibs_korma_korma.$_$.y7;
  var ensureNotNull = kotlin_kotlin.$_$.xc;
  var _Rectangle___get_left__impl__sgtjiw = kotlin_com_soywiz_korlibs_korma_korma.$_$.h4;
  var _Rectangle___get_top__impl__3kuxui = kotlin_com_soywiz_korlibs_korma_korma.$_$.o4;
  var RectangleInt__expanded_impl_u776to = kotlin_com_soywiz_korlibs_korma_korma.$_$.z4;
  var ImageDoNotFitException = kotlin_com_soywiz_korlibs_korma_korma.$_$.v7;
  var setExtra = kotlin_com_soywiz_korlibs_kds_kds.$_$.o2;
  var hasExtra = kotlin_com_soywiz_korlibs_kds_kds.$_$.i2;
  var Mixin = kotlin_com_soywiz_korlibs_kds_kds.$_$.w;
  var lazy = kotlin_kotlin.$_$.dd;
  var Companion_getInstance_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.m7;
  var NotImplementedError = kotlin_kotlin.$_$.mc;
  var toIntFloor = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.s6;
  var toIntCeil = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.p6;
  var toRatio = kotlin_com_soywiz_korlibs_korma_korma.$_$.v9;
  var clamp = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.w3;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.ed;
  var _SliceOrientation___get_flipX__impl__lgb7bx = kotlin_com_soywiz_korlibs_korma_korma.$_$.o;
  var _SliceOrientation___get_rotation__impl__m65r0o = kotlin_com_soywiz_korlibs_korma_korma.$_$.r;
  var IntArray2 = kotlin_com_soywiz_korlibs_kds_kds.$_$.h1;
  var Companion_getInstance_3 = kotlin_com_soywiz_korlibs_kds_kds.$_$.p;
  var isIntArray = kotlin_kotlin.$_$.t8;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var invalidOp = kotlin_com_soywiz_korlibs_korio_korio.$_$.b3;
  var KMutableProperty1 = kotlin_kotlin.$_$.ea;
  var getPropertyCallableRef = kotlin_kotlin.$_$.i8;
  var KProperty1 = kotlin_kotlin.$_$.ha;
  var Property = kotlin_com_soywiz_korlibs_kds_kds.$_$.y;
  var fill = kotlin_kotlin.$_$.k4;
  var toByte = kotlin_kotlin.$_$.h9;
  var SequenceScope = kotlin_kotlin.$_$.ia;
  var until = kotlin_kotlin.$_$.ba;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.m1;
  var arraycopy = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.a3;
  var _RectangleInt___get_left__impl__rhzld = kotlin_com_soywiz_korlibs_korma_korma.$_$.d5;
  var _RectangleInt___get_top__impl__ie2ifj = kotlin_com_soywiz_korlibs_korma_korma.$_$.f5;
  var _RectangleInt___get_right__impl__9c8zzq = kotlin_com_soywiz_korlibs_korma_korma.$_$.e5;
  var _RectangleInt___get_bottom__impl__za67bh = kotlin_com_soywiz_korlibs_korma_korma.$_$.y4;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.x;
  var iterator = kotlin_kotlin.$_$.ja;
  var Iterable = kotlin_kotlin.$_$.y2;
  var UByteArrayInt__get_impl_px6q8a = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.q;
  var UByteArrayInt__set_impl_gn4532 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.r;
  var arraycopy_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.z2;
  var _UByteArrayInt___init__impl__xif7bu = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.m;
  var ilog2 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.q4;
  var extract = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.h4;
  var insert = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.a5;
  var Companion_getInstance_4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.i7;
  var _MarginInt___get_leftPlusRight__impl__bp8ljy = kotlin_com_soywiz_korlibs_korma_korma.$_$.c2;
  var _MarginInt___get_topPlusBottom__impl__i58c3h = kotlin_com_soywiz_korlibs_korma_korma.$_$.e2;
  var _MarginInt___get_left__impl__786btm = kotlin_com_soywiz_korlibs_korma_korma.$_$.b2;
  var _MarginInt___get_top__impl__9baalk = kotlin_com_soywiz_korlibs_korma_korma.$_$.d2;
  var AssertionError_init_$Create$ = kotlin_kotlin.$_$.y;
  var FloatCompanionObject_getInstance = kotlin_kotlin.$_$.k2;
  var clamp01 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.s3;
  var min = kotlin_com_soywiz_korlibs_korma_korma.$_$.aa;
  var max = kotlin_com_soywiz_korlibs_korma_korma.$_$.x9;
  var convertRange = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.b4;
  var clamp_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.v3;
  var coerceAtMost = kotlin_kotlin.$_$.t9;
  var toIntFloor_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.r6;
  var round = kotlin_kotlin.$_$.o9;
  var readU8 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.d6;
  var Companion_getInstance_5 = kotlin_com_soywiz_korlibs_kds_kds.$_$.o;
  var isFloatArray = kotlin_kotlin.$_$.s8;
  var FloatArray2 = kotlin_com_soywiz_korlibs_kds_kds.$_$.d1;
  var _UShortArrayInt___init__impl__kdofb8 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.u;
  var toIntRound = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.t6;
  var divCeil = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.e4;
  var UShortArrayInt__set_impl_38wgvc = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.w;
  var UShortArrayInt__get_impl_ciz20k = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.v;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.d1;
  var readU16LE = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.y5;
  var readU16BE = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.x5;
  var readU24LE = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.b6;
  var readU24BE = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.a6;
  var readS32LE = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.s5;
  var readS32BE = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.r5;
  var mapOf = kotlin_kotlin.$_$.m5;
  var removePrefix = kotlin_kotlin.$_$.bb;
  var removeSuffix = kotlin_kotlin.$_$.cb;
  var get_lastIndex = kotlin_kotlin.$_$.b5;
  var toIntOrNull = kotlin_kotlin.$_$.sb;
  var toDoubleOrNull = kotlin_kotlin.$_$.pb;
  var substr = kotlin_com_soywiz_korlibs_korio_korio.$_$.g3;
  var setOf = kotlin_kotlin.$_$.z5;
  var substr_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.f3;
  var toInt_0 = kotlin_kotlin.$_$.ub;
  var printStackTrace = kotlin_kotlin.$_$.fd;
  var contains_0 = kotlin_kotlin.$_$.m3;
  var Collection = kotlin_kotlin.$_$.x2;
  var GenericListIterator = kotlin_com_soywiz_korlibs_kds_kds.$_$.g1;
  var Ratio__toFloat_impl_1ftup5 = kotlin_com_soywiz_korlibs_korma_korma.$_$.x6;
  var clampUByte = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.u3;
  var appendHexByte = kotlin_com_soywiz_korlibs_krypto_krypto.$_$.b;
  var get_niceStr = kotlin_com_soywiz_korlibs_korio_korio.$_$.i4;
  var compareTo = kotlin_kotlin.$_$.b8;
  var interpolate = kotlin_com_soywiz_korlibs_korma_korma.$_$.t9;
  var Comparable = kotlin_kotlin.$_$.fc;
  var clamp01_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.t3;
  var Companion_getInstance_6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.l7;
  var numberToDouble = kotlin_kotlin.$_$.a9;
  var _Vector2___init__impl__67w0ru_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.j6;
  var _Size___init__impl__aywn0g = kotlin_com_soywiz_korlibs_korma_korma.$_$.r5;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.j;
  var firstOrNull_0 = kotlin_kotlin.$_$.p4;
  var get = kotlin_com_soywiz_korlibs_korio_korio.$_$.n3;
  var first_0 = kotlin_kotlin.$_$.r4;
  var toMap = kotlin_kotlin.$_$.n6;
  var toIntMap = kotlin_com_soywiz_korlibs_kds_kds.$_$.x2;
  var Dyn__toFloatDefault_impl_tuvm0c = kotlin_com_soywiz_korlibs_korio_korio.$_$.b1;
  var Dyn__toStringOrNull_impl_7e6cgy = kotlin_com_soywiz_korlibs_korio_korio.$_$.d1;
  var Dyn__toList_impl_pxssgr = kotlin_com_soywiz_korlibs_korio_korio.$_$.c1;
  var Dyn__toString_impl_9l0v3s = kotlin_com_soywiz_korlibs_korio_korio.$_$.e1;
  var listOf_0 = kotlin_kotlin.$_$.k5;
  var plus_0 = kotlin_kotlin.$_$.t5;
  var numberToChar = kotlin_kotlin.$_$.z8;
  var unquote = kotlin_com_soywiz_korlibs_korio_korio.$_$.m4;
  var toDouble = kotlin_kotlin.$_$.qb;
  var associateByInt = kotlin_com_soywiz_korlibs_kds_kds.$_$.t1;
  var PerformanceCounter_getInstance = kotlin_com_soywiz_korlibs_klock_klock.$_$.w;
  var Companion_getInstance_7 = kotlin_com_soywiz_korlibs_klock_klock.$_$.y;
  var TimedResult = kotlin_com_soywiz_korlibs_klock_klock.$_$.c1;
  var fromBase64 = kotlin_com_soywiz_korlibs_krypto_krypto.$_$.c;
  var Companion_getInstance_8 = kotlin_com_soywiz_korlibs_korio_korio.$_$.h1;
  var uncompress = kotlin_com_soywiz_korlibs_korio_korio.$_$.b2;
  var Vector2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.k9;
  var Companion_getInstance_9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.j7;
  var VectorPath = kotlin_com_soywiz_korlibs_korma_korma.$_$.q8;
  var Matrix__translated_impl_3xg5y = kotlin_com_soywiz_korlibs_korma_korma.$_$.g3;
  var Matrix__premultiplied_impl_rsndx4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.r2;
  var applyTransform = kotlin_com_soywiz_korlibs_korma_korma.$_$.r8;
  var getCurves = kotlin_com_soywiz_korlibs_korma_korma.$_$.s8;
  var println = kotlin_kotlin.$_$.s7;
  var _Line___get_b__impl__d23fm8 = kotlin_com_soywiz_korlibs_korma_korma.$_$.y1;
  var _Line___get_a__impl__frj1fz = kotlin_com_soywiz_korlibs_korma_korma.$_$.x1;
  var _Line___init__impl__emhr1v = kotlin_com_soywiz_korlibs_korma_korma.$_$.w1;
  var Line__toBezier_impl_tok61t = kotlin_com_soywiz_korlibs_korma_korma.$_$.z1;
  var Matrix = kotlin_com_soywiz_korlibs_korma_korma.$_$.e9;
  var Vector2__hashCode_impl_uqm9wj = kotlin_com_soywiz_korlibs_korma_korma.$_$.m6;
  var Matrix__hashCode_impl_s9ntm9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.k2;
  var IntCompanionObject_getInstance = kotlin_kotlin.$_$.l2;
  var Companion_getInstance_10 = kotlin_com_soywiz_korlibs_korma_korma.$_$.g7;
  var plus_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.t8;
  var _BoundsBuilder___get_bounds__impl__s1l1gx = kotlin_com_soywiz_korlibs_korma_korma.$_$.j1;
  var Rectangle = kotlin_com_soywiz_korlibs_korma_korma.$_$.g9;
  var BoundsBuilder__plus_impl_cz7f7x = kotlin_com_soywiz_korlibs_korma_korma.$_$.m1;
  var FastArrayList_init_$Create$ = kotlin_com_soywiz_korlibs_kds_kds.$_$.b;
  var BoundsBuilder__plus_impl_cz7f7x_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.n1;
  var _Matrix___get_immutable__impl__k08qr = kotlin_com_soywiz_korlibs_korma_korma.$_$.l2;
  var _Scale___init__impl__ov1qs1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.k5;
  var toFloat = kotlin_com_soywiz_korlibs_korma_korma.$_$.o9;
  var Size__times_impl_fnp4nc = kotlin_com_soywiz_korlibs_korma_korma.$_$.y5;
  var Scale = kotlin_com_soywiz_korlibs_korma_korma.$_$.h9;
  var Scale__hashCode_impl_uultfs = kotlin_com_soywiz_korlibs_korma_korma.$_$.m5;
  var getExtraTyped = kotlin_com_soywiz_korlibs_kds_kds.$_$.f2;
  var IntMap_init_$Create$ = kotlin_com_soywiz_korlibs_kds_kds.$_$.f;
  var numberRangeToNumber = kotlin_kotlin.$_$.y8;
  var IntArrayList = kotlin_com_soywiz_korlibs_kds_kds.$_$.i1;
  var toIntCeil_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.o6;
  var toIntRound_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.u6;
  var PropertyThis = kotlin_com_soywiz_korlibs_kds_kds.$_$.x;
  var niceStr = kotlin_com_soywiz_korlibs_korio_korio.$_$.j4;
  var _Rectangle___get_bottom__impl__1duj44 = kotlin_com_soywiz_korlibs_korma_korma.$_$.x3;
  var _Rectangle___get_width__impl__y1u79l = kotlin_com_soywiz_korlibs_korma_korma.$_$.t4;
  var _Rectangle___get_height__impl__kro6o8 = kotlin_com_soywiz_korlibs_korma_korma.$_$.d4;
  var Rectangle__clone_impl_pibhs1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.a4;
  var Rectangle__times_impl_w4xjii = kotlin_com_soywiz_korlibs_korma_korma.$_$.m4;
  var roundToInt = kotlin_kotlin.$_$.n9;
  var Rectangle__toInt_impl_jycbk8 = kotlin_com_soywiz_korlibs_korma_korma.$_$.n4;
  var Rectangle__hashCode_impl_j3wwhv = kotlin_com_soywiz_korlibs_korma_korma.$_$.c4;
  var firstOrNull_1 = kotlin_kotlin.$_$.o4;
  var openFastStream = kotlin_com_soywiz_korlibs_korio_korio.$_$.s3;
  var copyOfRange = kotlin_kotlin.$_$.y3;
  var toList_0 = kotlin_kotlin.$_$.i6;
  var emptyMap = kotlin_kotlin.$_$.i4;
  var Level_DEBUG_getInstance = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.a;
  var reserved = kotlin_com_soywiz_korlibs_korio_korio.$_$.e3;
  var THROW_IAE = kotlin_kotlin.$_$.qc;
  var getProgressionLastElement = kotlin_kotlin.$_$.r7;
  var isNumber = kotlin_kotlin.$_$.v8;
  var get_unreachable = kotlin_com_soywiz_korlibs_korio_korio.$_$.i3;
  var get_reserved = kotlin_com_soywiz_korlibs_korio_korio.$_$.d3;
  var toShort = kotlin_kotlin.$_$.j9;
  var Char__plus_impl_qi7pgj = kotlin_kotlin.$_$.v1;
  var _Vector2___init__impl__67w0ru_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.g6;
  var _Vector2___get_xD__impl__1832jh = kotlin_com_soywiz_korlibs_korma_korma.$_$.o6;
  var _Vector2___get_yD__impl__v473bw = kotlin_com_soywiz_korlibs_korma_korma.$_$.q6;
  var Default_getInstance = kotlin_kotlin.$_$.p2;
  var step = kotlin_kotlin.$_$.z9;
  var reverse = kotlin_com_soywiz_korlibs_kds_kds.$_$.m2;
  var DoubleArrayList = kotlin_com_soywiz_korlibs_kds_kds.$_$.v;
  var Companion_getInstance_11 = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.f;
  var fillArrayVal = kotlin_kotlin.$_$.e8;
  var get_UTF8 = kotlin_com_soywiz_korlibs_korio_korio.$_$.w2;
  var charSequenceGet = kotlin_kotlin.$_$.y7;
  var get_UTF16_BE = kotlin_com_soywiz_korlibs_korio_korio.$_$.v2;
  var toSyncStream = kotlin_com_soywiz_korlibs_korio_korio.$_$.f4;
  var FastByteArrayInputStream = kotlin_com_soywiz_korlibs_korio_korio.$_$.o3;
  var IntIntMap_init_$Create$ = kotlin_com_soywiz_korlibs_kds_kds.$_$.e;
  var getCyclic = kotlin_com_soywiz_korlibs_kds_kds.$_$.e2;
  var toList_1 = kotlin_kotlin.$_$.l6;
  var arc$default = kotlin_com_soywiz_korlibs_korma_korma.$_$.i;
  var VectorBuilder = kotlin_com_soywiz_korlibs_korma_korma.$_$.p8;
  var _Rectangle___get_right__impl__7wa90z = kotlin_com_soywiz_korlibs_korma_korma.$_$.k4;
  var FloatArrayList = kotlin_com_soywiz_korlibs_kds_kds.$_$.f1;
  var Matrix__scaled_impl_ogn4b6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.x2;
  var Matrix__translated_impl_3xg5y_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.i3;
  var _Scale___init__impl__ov1qs1_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.j5;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.id;
  var get_invalidOp = kotlin_com_soywiz_korlibs_korio_korio.$_$.a3;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x1;
  var get_hex = kotlin_com_soywiz_korlibs_krypto_krypto.$_$.e;
  var Long = kotlin_kotlin.$_$.kc;
  var copyOfRange_0 = kotlin_kotlin.$_$.x3;
  var toIntArrayList = kotlin_com_soywiz_korlibs_kds_kds.$_$.w2;
  var _Matrix___init__impl__q3kp4w = kotlin_com_soywiz_korlibs_korma_korma.$_$.f2;
  var repeat = kotlin_kotlin.$_$.db;
  var getOrNull = kotlin_kotlin.$_$.t4;
  var joinToString = kotlin_kotlin.$_$.y4;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.j1;
  var Companion_getInstance_12 = kotlin_com_soywiz_korlibs_korio_korio.$_$.n1;
  var primitiveArrayConcat = kotlin_kotlin.$_$.c;
  var Level_INFO_getInstance = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.c;
  var toIntArray = kotlin_kotlin.$_$.h6;
  var first_1 = kotlin_kotlin.$_$.s4;
  var getOrNull_0 = kotlin_kotlin.$_$.v4;
  var extractSigned = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.g4;
  var lastOrNull = kotlin_kotlin.$_$.f5;
  var insert16 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.t4;
  var get_baseName = kotlin_com_soywiz_korlibs_korio_korio.$_$.o2;
  var readU16 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.z5;
  var readS32 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.t5;
  var sliceHere = kotlin_com_soywiz_korlibs_korio_korio.$_$.r;
  var Charsets_getInstance = kotlin_com_soywiz_korlibs_korio_korio.$_$.k1;
  var readString = kotlin_com_soywiz_korlibs_korio_korio.$_$.o;
  var Endian_LITTLE_ENDIAN_getInstance = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.b;
  var Endian_BIG_ENDIAN_getInstance = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.a;
  var readU16_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.p;
  var readS32_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.l;
  var Level_ERROR_getInstance = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.b;
  var readBytesExact = kotlin_com_soywiz_korlibs_korio_korio.$_$.g;
  var toLong = kotlin_kotlin.$_$.i9;
  var sliceStart = kotlin_com_soywiz_korlibs_korio_korio.$_$.s;
  var readStringz = kotlin_com_soywiz_korlibs_korio_korio.$_$.n;
  var skipToAlign = kotlin_com_soywiz_korlibs_korio_korio.$_$.b4;
  var Comparator = kotlin_kotlin.$_$.gc;
  var compareValues = kotlin_kotlin.$_$.u6;
  var distinct = kotlin_kotlin.$_$.g4;
  var sortedWith = kotlin_kotlin.$_$.b6;
  var fastArrayListOf = kotlin_com_soywiz_korlibs_kds_kds.$_$.y1;
  var toSet = kotlin_kotlin.$_$.q6;
  var openSync = kotlin_com_soywiz_korlibs_korio_korio.$_$.t3;
  var Exception = kotlin_kotlin.$_$.jc;
  var minus = kotlin_kotlin.$_$.p5;
  var KorAtomicRef = kotlin_com_soywiz_korlibs_korio_korio.$_$.c2;
  var sliceStart_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.c4;
  var CancellationException = kotlin_kotlin.$_$.w6;
  var ASCII_getInstance = kotlin_com_soywiz_korlibs_korio_korio.$_$.j1;
  var readString_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.z3;
  var readBytes = kotlin_com_soywiz_korlibs_korio_korio.$_$.v3;
  var get_hex_0 = kotlin_com_soywiz_korlibs_krypto_krypto.$_$.d;
  var toString_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.h3;
  var toMutableSet = kotlin_kotlin.$_$.p6;
  var setOf_0 = kotlin_kotlin.$_$.y5;
  var NonRecursiveLock = kotlin_com_soywiz_korlibs_kds_kds.$_$.s;
  var plus_2 = kotlin_kotlin.$_$.q5;
  var TimeSpan = kotlin_com_soywiz_korlibs_klock_klock.$_$.b1;
  var toMap_0 = kotlin_com_soywiz_korlibs_kds_kds.$_$.y2;
  var readAll = kotlin_com_soywiz_korlibs_korio_korio.$_$.f;
  var FileNotFoundException = kotlin_com_soywiz_korlibs_korio_korio.$_$.u2;
  var readS32BE_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.w3;
  var ByteArrayBuilder_init_$Create$ = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.d;
  var _UByteArrayInt___init__impl__xif7bu_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.n;
  var get_eof = kotlin_com_soywiz_korlibs_korio_korio.$_$.q3;
  var toIntArray_0 = kotlin_kotlin.$_$.g6;
  var asByteArray = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.p3;
  var readStringz_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.y3;
  var readStream = kotlin_com_soywiz_korlibs_korio_korio.$_$.x3;
  var readU8_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.a4;
  var readAll_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.u3;
  var runBlockingNoSuspensions = kotlin_com_soywiz_korlibs_korio_korio.$_$.a2;
  var openAsync = kotlin_com_soywiz_korlibs_korio_korio.$_$.r3;
  var abs = kotlin_kotlin.$_$.m9;
  var _UByteArrayInt___get_size__impl__bcjnte = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.t;
  var UByteArrayInt = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.s2;
  var Matrix__preconcated_impl_s9s2ig = kotlin_com_soywiz_korlibs_korma_korma.$_$.q2;
  var Matrix__inverted_impl_3pqbyv = kotlin_com_soywiz_korlibs_korma_korma.$_$.m2;
  var _Matrix___get_isNIL__impl__n63x5q = kotlin_com_soywiz_korlibs_korma_korma.$_$.o2;
  var _Matrix___get_a__impl__f7jypo = kotlin_com_soywiz_korlibs_korma_korma.$_$.g2;
  var _Matrix___get_c__impl__slf2ke = kotlin_com_soywiz_korlibs_korma_korma.$_$.i2;
  var _Matrix___get_tx__impl__yc1n9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.k3;
  var _Matrix___get_d__impl__87eht = kotlin_com_soywiz_korlibs_korma_korma.$_$.j2;
  var _Matrix___get_b__impl__dm2icj = kotlin_com_soywiz_korlibs_korma_korma.$_$.h2;
  var _Matrix___get_ty__impl__tryipg = kotlin_com_soywiz_korlibs_korma_korma.$_$.l3;
  var _Ratio___init__impl__9mwvn2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.w6;
  var Companion_getInstance_13 = kotlin_com_soywiz_korlibs_korma_korma.$_$.f7;
  var Matrix__translated_impl_3xg5y_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.h3;
  var clamp_1 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.x3;
  var Matrix__scaled$default_impl_qe0yl1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.m;
  var Angle_between = kotlin_com_soywiz_korlibs_korma_korma.$_$.z8;
  var Angle__unaryMinus_impl_7901fr = kotlin_com_soywiz_korlibs_korma_korma.$_$.i1;
  var Matrix__rotated_impl_2adiit = kotlin_com_soywiz_korlibs_korma_korma.$_$.v2;
  var get_degrees = kotlin_com_soywiz_korlibs_korma_korma.$_$.m9;
  var Angle__div_impl_ut2btd = kotlin_com_soywiz_korlibs_korma_korma.$_$.d1;
  var Vector2__component1_impl_k3h45m = kotlin_com_soywiz_korlibs_korma_korma.$_$.k6;
  var Vector2__component2_impl_kkiqjt = kotlin_com_soywiz_korlibs_korma_korma.$_$.l6;
  var Matrix__transformX_impl_adb2o0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.c3;
  var Angle = kotlin_com_soywiz_korlibs_korma_korma.$_$.a9;
  var Angle__hashCode_impl_szcndt = kotlin_com_soywiz_korlibs_korma_korma.$_$.e1;
  var interpolate_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.u9;
  var _Anchor___init__impl__4yyw24 = kotlin_com_soywiz_korlibs_korma_korma.$_$.u;
  var BoundsBuilder__xminOr_impl_k3l1m2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.t1;
  var BoundsBuilder = kotlin_com_soywiz_korlibs_korma_korma.$_$.b9;
  var BoundsBuilder__hashCode_impl_649zbo = kotlin_com_soywiz_korlibs_korma_korma.$_$.l1;
  var Matrix__transformX_impl_adb2o0_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.d3;
  var Matrix__transformY_impl_aucp27 = kotlin_com_soywiz_korlibs_korma_korma.$_$.e3;
  var BoundsBuilder__plus_impl_cz7f7x_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.o1;
  var getOrNull_1 = kotlin_kotlin.$_$.u4;
  var get_radians = kotlin_com_soywiz_korlibs_korma_korma.$_$.n9;
  var _Angle___get_degreesD__impl__9qro6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.c1;
  var get_niceStr_0 = kotlin_com_soywiz_korlibs_korio_korio.$_$.h4;
  var floatArrayListOf = kotlin_com_soywiz_korlibs_kds_kds.$_$.a2;
  var VectorArrayList = kotlin_com_soywiz_korlibs_korma_korma.$_$.l9;
  var _MatrixTransform___init__impl__7axsoi = kotlin_com_soywiz_korlibs_korma_korma.$_$.n3;
  var _Angle___init__impl__g23q1m = kotlin_com_soywiz_korlibs_korma_korma.$_$.a1;
  var Matrix__toTransform_impl_lr8urh = kotlin_com_soywiz_korlibs_korma_korma.$_$.a3;
  var _MatrixTransform___get_scaleX__impl__t9pp1f = kotlin_com_soywiz_korlibs_korma_korma.$_$.r3;
  var _MatrixTransform___get_scaleY__impl__g37z8 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s3;
  var _MatrixTransform___get_rotation__impl__d5fsj = kotlin_com_soywiz_korlibs_korma_korma.$_$.o3;
  var _Angle___get_ratio__impl__ap3on4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.g1;
  var WStringReader = kotlin_com_soywiz_korlibs_korio_korio.$_$.x2;
  var _WChar___get_codePoint__impl__c8brwu = kotlin_com_soywiz_korlibs_korio_korio.$_$.g1;
  var WString = kotlin_com_soywiz_korlibs_korio_korio.$_$.y2;
  var intArrayListOf = kotlin_com_soywiz_korlibs_kds_kds.$_$.j2;
  var fill_0 = kotlin_kotlin.$_$.l4;
  var Companion_getInstance_14 = kotlin_com_soywiz_korlibs_korma_korma.$_$.c7;
  var coerceIn = kotlin_kotlin.$_$.u9;
  var _RectangleInt___get_float__impl__bwdmra = kotlin_com_soywiz_korlibs_korma_korma.$_$.a5;
  var Winding_EVEN_ODD_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.f;
  var StrokeToFill = kotlin_com_soywiz_korlibs_korma_korma.$_$.d8;
  var strokeToFill = kotlin_com_soywiz_korlibs_korma_korma.$_$.u8;
  var _Vector2___init__impl__67w0ru_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.h6;
  var Command_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.d7;
  var Companion_getInstance_15 = kotlin_com_soywiz_korlibs_korma_korma.$_$.y6;
  var MatrixTransform = kotlin_com_soywiz_korlibs_korma_korma.$_$.d9;
  var LineScaleMode_NORMAL_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.e;
  var LineCap_BUTT_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.b;
  var LineJoin_MITER_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.c;
  var _MatrixTransform___get_scaleAvg__impl__ku8ljx = kotlin_com_soywiz_korlibs_korma_korma.$_$.q3;
  var _TGenStack___init__impl__yynjgt = kotlin_com_soywiz_korlibs_kds_kds.$_$.l;
  var TGenStack__push_impl_9yh33t = kotlin_com_soywiz_korlibs_kds_kds.$_$.n;
  var TGenStack__pop_impl_qisxa0 = kotlin_com_soywiz_korlibs_kds_kds.$_$.m;
  var Matrix__prescaled_impl_gy2bxt = kotlin_com_soywiz_korlibs_korma_korma.$_$.s2;
  var Matrix__pretranslated_impl_9mjs3v = kotlin_com_soywiz_korlibs_korma_korma.$_$.t2;
  var Winding_NON_ZERO_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.g;
  var Size = kotlin_com_soywiz_korlibs_korma_korma.$_$.j9;
  var line = kotlin_com_soywiz_korlibs_korma_korma.$_$.h8;
  var isEmpty = kotlin_com_soywiz_korlibs_korma_korma.$_$.g8;
  var rect = kotlin_com_soywiz_korlibs_korma_korma.$_$.k8;
  var rect_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.n8;
  var rect_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.m8;
  var rect_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.l8;
  var arc = kotlin_com_soywiz_korlibs_korma_korma.$_$.e8;
  var circle = kotlin_com_soywiz_korlibs_korma_korma.$_$.f8;
  var rMoveTo = kotlin_com_soywiz_korlibs_korma_korma.$_$.j8;
  var rLineTo = kotlin_com_soywiz_korlibs_korma_korma.$_$.i8;
  var transformed = kotlin_com_soywiz_korlibs_korma_korma.$_$.o8;
  var BoundsBuilder__plus_impl_cz7f7x_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.q1;
  var Rectangle__transformed_impl_5k4zxr = kotlin_com_soywiz_korlibs_korma_korma.$_$.r4;
  var Matrix__translated_impl_3xg5y_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.j3;
  var umod = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.y6;
  var insert8 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.y4;
  var toCurvesList = kotlin_com_soywiz_korlibs_korma_korma.$_$.w8;
  var checkIndexOverflow = kotlin_kotlin.$_$.k3;
  var ProjectedPoint = kotlin_com_soywiz_korlibs_korma_korma.$_$.s7;
  var Companion_getInstance_16 = kotlin_com_soywiz_korlibs_korma_korma.$_$.h7;
  var DoubleCompanionObject_getInstance = kotlin_kotlin.$_$.j2;
  var write = kotlin_com_soywiz_korlibs_korma_korma.$_$.x8;
  var get_isConvex = kotlin_com_soywiz_korlibs_korma_korma.$_$.t7;
  var strokeToFill_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.v8;
  var BoundsBuilder__boundsOrNull_impl_se9lyg = kotlin_com_soywiz_korlibs_korma_korma.$_$.k1;
  var _Rectangle___get_mutable__impl__e29r87 = kotlin_com_soywiz_korlibs_korma_korma.$_$.i4;
  var KProperty0 = kotlin_kotlin.$_$.ga;
  var StrokeInfo = kotlin_com_soywiz_korlibs_korma_korma.$_$.c8;
  var Size__div_impl_f5ffdp = kotlin_com_soywiz_korlibs_korma_korma.$_$.u5;
  var Matrix__scaled_impl_ogn4b6_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.y2;
  var toStringDecimal = kotlin_com_soywiz_korlibs_korio_korio.$_$.k4;
  var RastScale = kotlin_com_soywiz_korlibs_korma_korma.$_$.b8;
  var PolygonScanline = kotlin_com_soywiz_korlibs_korma_korma.$_$.a8;
  var IntSegmentSet = kotlin_com_soywiz_korlibs_korma_korma.$_$.w9;
  var _Matrix___get_type__impl__g2man3 = kotlin_com_soywiz_korlibs_korma_korma.$_$.m3;
  var MatrixType_IDENTITY_getInstance = kotlin_com_soywiz_korlibs_korma_korma.$_$.h;
  var Companion_getInstance_17 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.b1;
  var UrlVfs = kotlin_com_soywiz_korlibs_korio_korio.$_$.k2;
  var LocalVfs = kotlin_com_soywiz_korlibs_korio_korio.$_$.i2;
  var TimeSpan__minus_impl_5w5v8s = kotlin_com_soywiz_korlibs_klock_klock.$_$.o;
  var TimeSpan__compareTo_impl_zidry4 = kotlin_com_soywiz_korlibs_klock_klock.$_$.f;
  var asInt32Array = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.q3;
  var Companion_getInstance_18 = kotlin_kotlin.$_$.s2;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.y1;
  var createFailure = kotlin_kotlin.$_$.wc;
  var intercepted = kotlin_kotlin.$_$.z6;
  var get_MODE_CANCELLABLE = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var _Angle___get_radiansD__impl__thfj8f = kotlin_com_soywiz_korlibs_korma_korma.$_$.f1;
  var _Size___get_widthD__impl__i6r1cr = kotlin_com_soywiz_korlibs_korma_korma.$_$.a6;
  var _Size___get_heightD__impl__67jnfc = kotlin_com_soywiz_korlibs_korma_korma.$_$.x5;
  var copyToArray = kotlin_kotlin.$_$.f4;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Entry, 'Entry', classMeta);
  function tryGet(name) {
    var tmp0_safe_receiver = this.a44(name);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b43_1;
  }
  function get_0(name) {
    var tmp0_elvis_lhs = this.b44(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Can't find '" + name + "' it atlas";
      throw IllegalStateException_init_$Create$(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  setMetadataFor(AtlasLookup, 'AtlasLookup', interfaceMeta);
  setMetadataFor(Atlas, 'Atlas', classMeta, VOID, [AtlasLookup]);
  setMetadataFor($readAtlasCOROUTINE$0, '$readAtlasCOROUTINE$0', classMeta, CoroutineImpl);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(Meta, 'Meta', classMeta);
  setMetadataFor(FrameTag, 'FrameTag', classMeta);
  setMetadataFor(Layer, 'Layer', classMeta);
  setMetadataFor(Slice, 'Slice', classMeta);
  setMetadataFor(Key, 'Key', classMeta);
  setMetadataFor(Page, 'Page', classMeta);
  setMetadataFor(Region, 'Region', classMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(AtlasInfo, 'AtlasInfo', classMeta);
  setMetadataFor(GrowMethod, 'GrowMethod', classMeta, Enum);
  setMetadataFor(Entry_0, 'Entry', classMeta);
  setMetadataFor(MutableAtlas, 'MutableAtlas', classMeta);
  setMetadataFor(Bitmap, 'Bitmap', classMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta, VOID, VOID, VOID, VOID, [2, 3]);
  setMetadataFor(Bitmap32$iterator$slambda, 'Bitmap32$iterator$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(Bitmap32, 'Bitmap32', classMeta, Bitmap, [Bitmap, Iterable]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(BitmapIndexed, 'BitmapIndexed', classMeta, Bitmap);
  setMetadataFor(Bitmap8, 'Bitmap8', classMeta, BitmapIndexed);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(BitmapChannel, 'BitmapChannel', classMeta, Enum);
  setMetadataFor(Bitmaps, 'Bitmaps', objectMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(DistanceBitmap, 'DistanceBitmap', classMeta);
  setMetadataFor(FloatBitmap32, 'FloatBitmap32', classMeta, Bitmap);
  setMetadataFor(MultiBitmap, 'MultiBitmap', classMeta, Bitmap);
  setMetadataFor(NativeImage, 'NativeImage', classMeta, Bitmap);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  function get_forcedTexTarget() {
    Companion_getInstance_25();
    return 3553;
  }
  setMetadataFor(ForcedTexId, 'ForcedTexId', interfaceMeta);
  setMetadataFor(NullBitmap, 'NullBitmap', classMeta, Bitmap);
  setMetadataFor(Palette, 'Palette', classMeta);
  setMetadataFor(Result, 'Result', classMeta);
  setMetadataFor(NewSDF, 'NewSDF', objectMeta);
  setMetadataFor(ColorFormat32, 'ColorFormat32', classMeta);
  setMetadataFor(ColorFormat24, 'ColorFormat24', classMeta);
  setMetadataFor(ColorTransformMul, 'ColorTransformMul', classMeta);
  setMetadataFor(Colors, 'Colors', objectMeta);
  setMetadataFor(RGB, 'RGB', classMeta, ColorFormat24);
  setMetadataFor(Companion_6, 'Companion', objectMeta, RGB);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(RgbaArray, 'RgbaArray', classMeta, VOID, [List]);
  setMetadataFor(Companion_8, 'Companion', objectMeta, ColorFormat32);
  setMetadataFor(RGBA, 'RGBA', classMeta, VOID, [Comparable]);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor(RgbaPremultipliedArray, 'RgbaPremultipliedArray', classMeta);
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor(Kerning, 'Kerning', classMeta);
  setMetadataFor(Glyph, 'Glyph', classMeta);
  function getOrNull_2() {
    return this;
  }
  function getFontMetrics$default(size, metrics, $super) {
    metrics = metrics === VOID ? new FontMetrics() : metrics;
    return $super === VOID ? this.k4p(size, metrics) : $super.k4p.call(this, size, metrics);
  }
  function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
    metrics = metrics === VOID ? new GlyphMetrics() : metrics;
    reader = reader === VOID ? null : reader;
    return $super === VOID ? this.v4p(size, codePoint, metrics, reader) : $super.v4p.call(this, size, codePoint, metrics, reader);
  }
  function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
    reader = reader === VOID ? null : reader;
    beforeDraw = beforeDraw === VOID ? null : beforeDraw;
    return $super === VOID ? this.f4q(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.f4q.call(this, ctx, size, codePoint, new Vector2(pos), fill, metrics, reader, beforeDraw);
  }
  setMetadataFor(Font, 'Font', interfaceMeta, VOID, VOID, VOID, VOID, [0]);
  function get_baseBmp() {
    return get_bmp(this.h4p().p4o_1);
  }
  function getFontMetrics(size, metrics) {
    return metrics.u4p(this.i4p(), size);
  }
  function getGlyphMetrics(size, codePoint, metrics, reader) {
    var tmp0_safe_receiver = this.w4p(codePoint);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u4o_1;
    return metrics.c4q(tmp1_elvis_lhs == null ? this.j4p() : tmp1_elvis_lhs, size, codePoint);
  }
  function getTextScale(size) {
    return size / this.b4p();
  }
  function get_1(charCode) {
    var tmp0_elvis_lhs = this.w4p(charCode);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.w4p(32) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? this.h4p() : tmp1_elvis_lhs;
  }
  function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
    var scale = this.e4q(size);
    var tmp0_elvis_lhs = this.e4p().k(codePoint);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var tmp$ret$1;
    // Inline function 'kotlin.takeIf' call
    var tmp0_takeIf = this.v4p(size, codePoint, metrics, reader);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    var tmp$ret$0;
    // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
    tmp$ret$0 = tmp0_takeIf.y4p_1;
    if (tmp$ret$0) {
      tmp_0 = tmp0_takeIf;
    } else {
      tmp_0 = null;
    }
    tmp$ret$1 = tmp_0;
    var tmp1_elvis_lhs = tmp$ret$1;
    if (tmp1_elvis_lhs == null)
      return false;
    else
      tmp1_elvis_lhs;
    if (metrics.ck() === 0.0 ? metrics.dk() === 0.0 : false)
      return false;
    var texX = _Vector2___get_x__impl__zywdz(pos) + metrics.k3f();
    var texY = _Vector2___get_y__impl__ttldg6(pos) + metrics.l3f();
    var swidth = metrics.ck();
    var sheight = metrics.dk();
    var tmp_1;
    if (equals(ctx.c4r(), new RGBA(get_DefaultPaint()))) {
      tmp_1 = g.a4p();
    } else {
      var tmp$ret$4;
      // Inline function 'korlibs.image.bitmap.context2d' call
      var tmp2_context2d = new Bitmap32(g.a4p().r46_1, g.a4p().s46_1, VOID, true);
      var tmp$ret$3;
      // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
      var tmp1_lock = tmp2_context2d.w46_1;
      {
        tmp2_context2d.f47();
      }
      var result;
      try {
        // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
        var ctx_0 = tmp2_context2d.b4f(true);
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
          var t = ctx_0.g4f_1.g4q_1;
          try {
            // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
            ctx_0.b4r(1.0 / scale);
            ctx_0.d4r(ctx.c4r());
            var tmp$ret$2;
            // Inline function 'korlibs.image.vector.Context2d.fillRect' call
            var tmp0_fillRect = ctx_0.ck() * scale;
            var tmp1_fillRect = ctx_0.dk() * scale;
            ctx_0.e4r(0.0, 0.0, numberToDouble(tmp0_fillRect), numberToDouble(tmp1_fillRect));
            tmp$ret$2 = Unit_getInstance();
          }finally {
            ctx_0.g4f_1.g4q_1 = t;
          }
        }finally {
          ctx_0.p13();
        }
      }finally {
        result = tmp2_context2d.x47(tmp1_lock);
      }
      tmp$ret$3 = result;
      tmp$ret$4 = tmp2_context2d;
      var bmpFill = tmp$ret$4;
      bmpFill.v4h(BitmapChannel_ALPHA_getInstance(), g.a4p(), BitmapChannel_ALPHA_getInstance());
      tmp_1 = bmpFill;
    }
    var bmp = tmp_1;
    var tmp2_safe_receiver = beforeDraw;
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver();
    ctx.f4r(bmp, _Vector2___init__impl__67w0ru_0(texX, texY - metrics.n3f()), _Size___init__impl__aywn0g(swidth, sheight));
    return true;
  }
  function getKerning(size, leftCodePoint, rightCodePoint) {
    var tmp = this.e4q(size);
    var tmp0_safe_receiver = this.d4q(leftCodePoint, rightCodePoint);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z4o_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    return tmp * (tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs);
  }
  setMetadataFor(BitmapFont, 'BitmapFont', interfaceMeta, VOID, [Font], VOID, VOID, [0]);
  setMetadataFor(BitmapFontImpl, 'BitmapFontImpl', classMeta, VOID, [BitmapFont], VOID, VOID, [0]);
  setMetadataFor($readBitmapFontCOROUTINE$1, '$readBitmapFontCOROUTINE$1', classMeta, CoroutineImpl);
  setMetadataFor($readBitmapFontXmlCOROUTINE$2, '$readBitmapFontXmlCOROUTINE$2', classMeta, CoroutineImpl);
  setMetadataFor($readBitmapFontJsonCOROUTINE$3, '$readBitmapFontJsonCOROUTINE$3', classMeta, CoroutineImpl);
  setMetadataFor($readBitmapFontTxtCOROUTINE$4, '$readBitmapFontTxtCOROUTINE$4', classMeta, CoroutineImpl);
  setMetadataFor(TextToBitmapResult, 'TextToBitmapResult', classMeta);
  setMetadataFor(PlacedGlyphMetrics, 'PlacedGlyphMetrics', classMeta);
  setMetadataFor(TextMetricsResult, 'TextMetricsResult', classMeta);
  setMetadataFor(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', classMeta);
  function reset() {
    this.l51(Companion_getInstance_0().h3b_1);
  }
  function advance(x) {
    var tmp0_this = this;
    var tmp$ret$0;
    // Inline function 'korlibs.math.geom.Vector2.plus' call
    var tmp0_plus = tmp0_this.e51();
    var tmp1_plus = _Vector2___init__impl__67w0ru_0(x, 0.0);
    tmp$ret$0 = _Vector2___init__impl__67w0ru_0(_Vector2___get_x__impl__zywdz(tmp0_plus) + _Vector2___get_x__impl__zywdz(tmp1_plus), _Vector2___get_y__impl__ttldg6(tmp0_plus) + _Vector2___get_y__impl__ttldg6(tmp1_plus));
    tmp0_this.l51(tmp$ret$0);
  }
  function newLine(y, end) {
    this.l51(_Vector2___init__impl__67w0ru_0(0.0, _Vector2___get_y__impl__ttldg6(this.e51()) + y));
    var tmp0_this = this;
    var tmp1 = tmp0_this.c51();
    tmp0_this.j51(tmp1 + 1 | 0);
  }
  setMetadataFor(ITextRendererActions, 'ITextRendererActions', interfaceMeta);
  setMetadataFor(TextRendererActions, 'TextRendererActions', classMeta, VOID, [ITextRendererActions]);
  setMetadataFor(drawText$actions$1, VOID, classMeta, TextRendererActions);
  setMetadataFor($readFontCOROUTINE$5, '$readFontCOROUTINE$5', classMeta, CoroutineImpl);
  setMetadataFor(GlyphPath, 'GlyphPath', classMeta);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(LazyBitmapFont, 'LazyBitmapFont', classMeta, VOID, [BitmapFont], VOID, VOID, [0]);
  setMetadataFor(FontMetrics, 'FontMetrics', classMeta);
  setMetadataFor(GlyphMetrics, 'GlyphMetrics', classMeta);
  setMetadataFor(TextMetrics, 'TextMetrics', classMeta);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(GlyphPath_0, 'GlyphPath', classMeta);
  setMetadataFor(CFFResult, 'CFFResult', classMeta);
  setMetadataFor(DataIndex, 'DataIndex', classMeta, VOID, [Iterable]);
  setMetadataFor(Op, 'Op', classMeta, Enum);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor(EvalContext, 'EvalContext', classMeta);
  setMetadataFor(Op_0, 'Op', classMeta, Enum);
  setMetadataFor(CFF, 'CFF', objectMeta);
  setMetadataFor(CharStringType2, 'CharStringType2', objectMeta);
  setMetadataFor(TtfCIDFont, 'TtfCIDFont', objectMeta);
  setMetadataFor(Companion_16, 'Companion', objectMeta, VOID, VOID, VOID, VOID, [1]);
  function getGlyphPath$default(size, codePoint, path, reader, $super) {
    path = path === VOID ? new GlyphPath() : path;
    reader = reader === VOID ? null : reader;
    return $super === VOID ? this.z5a(size, codePoint, path, reader) : $super.z5a.call(this, size, codePoint, path, reader);
  }
  function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_safe_receiver = reader;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2a_1;
      var old = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      try {
        var tmp$ret$0;
        // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
        tmp$ret$0 = this.v4p(size, codePoint, metrics, reader);
        tmp$ret$1 = tmp$ret$0;
        break $l$block;
      }finally {
        var tmp2_safe_receiver = reader;
        if (tmp2_safe_receiver == null) {
        } else
          tmp2_safe_receiver.r2a_1 = old;
      }
    }
    var g = this.a5b(size, codePoint, VOID, reader);
    if (!(g == null)) {
      if (!(fill == null)) {
        ctx.t4x();
      }
      if (!g.m52()) {
        var tmp0_safe_receiver_0 = beforeDraw;
        if (tmp0_safe_receiver_0 == null)
          null;
        else
          tmp0_safe_receiver_0();
      }
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = ctx.g4f_1.g4q_1;
      try {
        // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
        var tmp$ret$2;
        // Inline function 'korlibs.image.vector.Context2d.translate' call
        ctx.f51(_Vector2___get_x__impl__zywdz(pos), _Vector2___get_y__impl__ttldg6(pos));
        tmp$ret$2 = Unit_getInstance();
        g.n52(ctx);
      }finally {
        ctx.g4f_1.g4q_1 = t;
      }
      var tmp1_subject = fill;
      switch (tmp1_subject) {
        case true:
          ctx.c4z();
          ;
          break;
        case false:
          ctx.b4z();
          ;
          break;
        case null:
          ;
          break;
      }
      return !g.m52();
    }
    return false;
  }
  setMetadataFor(VectorFont, 'VectorFont', interfaceMeta, VOID, [Font], VOID, VOID, [0]);
  setMetadataFor(BaseTtfFont, 'BaseTtfFont', classMeta, VOID, [VectorFont], VOID, VOID, [0]);
  setMetadataFor(TtfFont, 'TtfFont', classMeta, BaseTtfFont, VOID, VOID, VOID, [0]);
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  setMetadataFor(Companion_18, 'Companion', objectMeta);
  setMetadataFor(NamesInfo, 'NamesInfo', classMeta);
  setMetadataFor(SubstitutionInfo, 'SubstitutionInfo', classMeta);
  setMetadataFor(Table, 'Table', classMeta);
  setMetadataFor(HorMetric, 'HorMetric', classMeta);
  setMetadataFor(Companion_19, 'Companion', objectMeta);
  setMetadataFor(NameId, 'NameId', classMeta, Enum);
  setMetadataFor(ColorBitmapInfo, 'ColorBitmapInfo', classMeta);
  setMetadataFor(SbitLineMetrics, 'SbitLineMetrics', classMeta);
  setMetadataFor(BitmapGlyphInfo, 'BitmapGlyphInfo', classMeta);
  setMetadataFor(ColorLine, 'ColorLine', classMeta);
  setMetadataFor(ColorStop, 'ColorStop', classMeta);
  setMetadataFor(Colrv1Paint, 'Colrv1Paint', classMeta, Enum);
  setMetadataFor(COLRv1, 'COLRv1', classMeta);
  setMetadataFor(Contour, 'Contour', classMeta);
  setMetadataFor(GlyphReference, 'GlyphReference', classMeta);
  setMetadataFor(ColrLayerInfo, 'ColrLayerInfo', classMeta);
  function getColorShape$default(pal, $super) {
    pal = pal === VOID ? 0 : pal;
    return $super === VOID ? this.d5i(pal) : $super.d5i.call(this, pal);
  }
  setMetadataFor(ColrGlyphInfo, 'ColrGlyphInfo', interfaceMeta);
  setMetadataFor(ColrGlyphInfoV1, 'ColrGlyphInfoV1', classMeta, VOID, [ColrGlyphInfo]);
  setMetadataFor(ColrGlyphInfoV0, 'ColrGlyphInfoV0', classMeta, VOID, [ColrGlyphInfo]);
  setMetadataFor(GlyphGraphicsPath, 'GlyphGraphicsPath', classMeta, VOID, [VectorBuilder]);
  setMetadataFor(Glyph_0, 'Glyph', classMeta);
  setMetadataFor(CompositeGlyph, 'CompositeGlyph', classMeta, Glyph_0);
  setMetadataFor(CFFGlyph, 'CFFGlyph', classMeta, Glyph_0);
  setMetadataFor(SimpleGlyph, 'SimpleGlyph', classMeta, Glyph_0);
  setMetadataFor(BaseTtfFont$readCblc$1$Subtable, 'Subtable', classMeta);
  setMetadataFor(BaseTtfFont$readSbix$1$StrikeInfo, 'StrikeInfo', classMeta);
  setMetadataFor(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo', classMeta);
  setMetadataFor(BaseTtfFont$readCmap$1$EncodingRecord, 'EncodingRecord', classMeta);
  setMetadataFor(Companion_20, 'Companion', objectMeta);
  setMetadataFor($readTtfFontCOROUTINE$12, '$readTtfFontCOROUTINE$12', classMeta, CoroutineImpl);
  setMetadataFor(Companion_21, 'Companion', objectMeta);
  setMetadataFor(DataFormat, 'DataFormat', classMeta, Enum);
  setMetadataFor($readExifBaseCOROUTINE$16, '$readExifBaseCOROUTINE$16', classMeta, CoroutineImpl);
  setMetadataFor(EXIF, 'EXIF', objectMeta, VOID, VOID, VOID, VOID, [3]);
  setMetadataFor(Direction, 'Direction', classMeta, Enum);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(ImageAnimation, 'ImageAnimation', classMeta);
  setMetadataFor(Companion_22, 'Companion', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(ImageData, 'ImageData', classMeta);
  setMetadataFor(Companion_23, 'Companion', objectMeta);
  setMetadataFor(ImageDecodingProps, 'ImageDecodingProps', classMeta);
  setMetadataFor($decodeCOROUTINE$20, '$decodeCOROUTINE$20', classMeta, CoroutineImpl);
  setMetadataFor(ImageFormat, 'ImageFormat', classMeta, VOID, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException', classMeta, Exception);
  setMetadataFor(ImageFormats, 'ImageFormats', classMeta, ImageFormat, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(ImageFormatsMutable, 'ImageFormatsMutable', classMeta, ImageFormats, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(Companion_24, 'Companion', objectMeta);
  setMetadataFor(ImageFrame, 'ImageFrame', classMeta);
  setMetadataFor(ImageFrameLayer, 'ImageFrameLayer', classMeta);
  setMetadataFor(ImageInfo, 'ImageInfo', classMeta);
  setMetadataFor(Companion_25, 'Companion', objectMeta);
  setMetadataFor(Type, 'Type', classMeta, Enum);
  setMetadataFor(ImageLayer, 'ImageLayer', classMeta);
  setMetadataFor($readBitmapSliceCOROUTINE$25, '$readBitmapSliceCOROUTINE$25', classMeta, CoroutineImpl);
  setMetadataFor($readBitmapCOROUTINE$26, '$readBitmapCOROUTINE$26', classMeta, CoroutineImpl);
  setMetadataFor($_readBitmapCOROUTINE$27, '$_readBitmapCOROUTINE$27', classMeta, CoroutineImpl);
  setMetadataFor($decodeInternalCOROUTINE$29, '$decodeInternalCOROUTINE$29', classMeta, CoroutineImpl);
  setMetadataFor($decodeSuspendCOROUTINE$33, '$decodeSuspendCOROUTINE$33', classMeta, CoroutineImpl);
  setMetadataFor($decodeCOROUTINE$34, '$decodeCOROUTINE$34', classMeta, CoroutineImpl);
  setMetadataFor($decodeCOROUTINE$35, '$decodeCOROUTINE$35', classMeta, CoroutineImpl);
  setMetadataFor(NativeImageFormatProvider, 'NativeImageFormatProvider', classMeta, VOID, VOID, VOID, VOID, [1, 2, 3]);
  setMetadataFor(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', classMeta, NativeImageFormatProvider, VOID, VOID, VOID, [2, 1, 3]);
  setMetadataFor(NativeImageResult, 'NativeImageResult', classMeta);
  setMetadataFor(BitmapNativeImage, 'BitmapNativeImage', classMeta, NativeImage);
  setMetadataFor(Companion_26, 'Companion', objectMeta);
  setMetadataFor(InterlacedPass, 'InterlacedPass', classMeta);
  setMetadataFor(Colorspace, 'Colorspace', classMeta, Enum);
  setMetadataFor(Header, 'Header', classMeta);
  setMetadataFor(DecodingContext, 'DecodingContext', classMeta);
  setMetadataFor(PNG$readCommon$readChunk$slambda, 'PNG$readCommon$readChunk$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(PNG, 'PNG', objectMeta, ImageFormat, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(BaseFiller, 'BaseFiller', classMeta);
  setMetadataFor(ColorFiller, 'ColorFiller', classMeta, BaseFiller);
  setMetadataFor(Companion_27, 'Companion', objectMeta);
  setMetadataFor(GradientFiller, 'GradientFiller', classMeta, BaseFiller);
  setMetadataFor(BitmapFiller, 'BitmapFiller', classMeta, BaseFiller);
  setMetadataFor(NoneFiller, 'NoneFiller', objectMeta, BaseFiller);
  setMetadataFor(Companion_28, 'Companion', objectMeta);
  setMetadataFor(TransformedPaint, 'TransformedPaint', interfaceMeta);
  setMetadataFor(GradientPaint, 'GradientPaint', classMeta, VOID, [TransformedPaint]);
  setMetadataFor(GradientKind, 'GradientKind', classMeta, Enum);
  setMetadataFor(GradientInterpolationMethod, 'GradientInterpolationMethod', classMeta, Enum);
  setMetadataFor(GradientUnits, 'GradientUnits', classMeta, Enum);
  setMetadataFor(NonePaint, 'NonePaint', objectMeta);
  setMetadataFor(BitmapPaint, 'BitmapPaint', classMeta, VOID, [TransformedPaint]);
  setMetadataFor(Companion_29, 'Companion', objectMeta);
  setMetadataFor(VerticalAlign, 'VerticalAlign', classMeta);
  setMetadataFor(Companion_30, 'Companion', objectMeta);
  setMetadataFor(HorizontalAlign, 'HorizontalAlign', classMeta);
  setMetadataFor(Companion_31, 'Companion', objectMeta);
  setMetadataFor(TextAlignment, 'TextAlignment', classMeta);
  function get_version() {
    return 0;
  }
  setMetadataFor(TextRenderer, 'TextRenderer', interfaceMeta);
  setMetadataFor(LineStats, 'LineStats', classMeta);
  setMetadataFor(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', classMeta, TextRendererActions);
  setMetadataFor(LineInfo, 'LineInfo', classMeta);
  setMetadataFor(Entry_1, 'Entry', classMeta);
  setMetadataFor(Text2TextRendererActions, 'Text2TextRendererActions', classMeta, TextRendererActions);
  setMetadataFor(CreateWStringTextRenderer$2, VOID, classMeta, VOID, [TextRenderer]);
  setMetadataFor(CreateStringTextRenderer$2, VOID, classMeta, VOID, [TextRenderer]);
  setMetadataFor(SegmentHandler, 'SegmentHandler', classMeta);
  setMetadataFor(ScanlineWriter, 'ScanlineWriter', classMeta);
  setMetadataFor(Renderer, 'Renderer', classMeta);
  setMetadataFor(Bitmap32Context2d, 'Bitmap32Context2d', classMeta, Renderer);
  setMetadataFor(CompositeOperation$Companion$invoke$1, VOID, classMeta);
  setMetadataFor(Companion_32, 'Companion', objectMeta);
  setMetadataFor(Companion_33, 'Companion', objectMeta);
  setMetadataFor(CompositeMode, 'CompositeMode', classMeta, Enum);
  setMetadataFor(BlendMode, 'BlendMode', classMeta, Enum);
  setMetadataFor(State, 'State', classMeta);
  setMetadataFor(Context2d, 'Context2d', classMeta, VOID, [VectorBuilder]);
  setMetadataFor(Companion_34, 'Companion', objectMeta);
  setMetadataFor(CycleMethod, 'CycleMethod', classMeta, Enum);
  setMetadataFor(ColorizedBeziers, 'ColorizedBeziers', classMeta);
  setMetadataFor(ColoredBezier, 'ColoredBezier', classMeta);
  setMetadataFor(ProjectCurvesLookup, 'ProjectCurvesLookup', classMeta);
  function getPath(path) {
    return path;
  }
  function getPath$default(path, $super) {
    path = path === VOID ? new VectorPath() : path;
    return $super === VOID ? this.j64(path) : getPath(path);
  }
  function get_bounds() {
    return this.k64(true);
  }
  setMetadataFor(Shape, 'Shape', interfaceMeta);
  function get_path() {
    return null;
  }
  function getBounds(includeStrokes) {
    var tmp0_safe_receiver = this.g1z();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
      tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_1(Companion_getInstance_10().f3b(), tmp0_safe_receiver));
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp1_elvis_lhs;
    if ((tmp_1 == null ? null : new Rectangle(tmp_1)) == null) {
      tmp_0 = Companion_getInstance_6().e3b();
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  function getPath_0(path) {
    var tmp$ret$1;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
    var tmp0_safe_receiver = this.g1z();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      path.i3z(tmp0_safe_receiver);
      tmp$ret$0 = Unit_getInstance();
    }
    tmp$ret$1 = path;
    return tmp$ret$1;
  }
  function draw(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.g4f_1.g4q_1;
    try {
      // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
      c.t4x();
      var tmp0_safe_receiver = this.g1z();
      if (tmp0_safe_receiver == null)
        null;
      else {
        draw_0(tmp0_safe_receiver, c);
      }
      if (!(this.s64() == null)) {
        draw_0(ensureNotNull(this.s64()), c);
        c.j63();
      }
      c.h51(_Matrix___get_immutable__impl__k08qr(this.g51()));
      this.w64(c);
    }finally {
      c.g4f_1.g4q_1 = t;
    }
  }
  function drawInternal(c) {
  }
  setMetadataFor(StyledShape, 'StyledShape', interfaceMeta, VOID, [Shape]);
  setMetadataFor(FillShape, 'FillShape', classMeta, VOID, [StyledShape]);
  setMetadataFor(CompoundShape, 'CompoundShape', classMeta, VOID, [Shape]);
  setMetadataFor(EmptyShape, 'EmptyShape', objectMeta, VOID, [Shape]);
  setMetadataFor(PolylineShape, 'PolylineShape', classMeta, VOID, [StyledShape]);
  setMetadataFor(TextShape, 'TextShape', classMeta, VOID, [StyledShape]);
  setMetadataFor(ShapeBuilder, 'ShapeBuilder', classMeta, Context2d);
  setMetadataFor(SvgPath, 'SvgPath', objectMeta);
  setMetadataFor(Rasterizer, 'Rasterizer', classMeta, RastScale);
  setMetadataFor(DummyRenderer, 'DummyRenderer', classMeta, Renderer);
  setMetadataFor(Companion_35, 'Companion', objectMeta, DummyRenderer);
  setMetadataFor(HtmlCanvas, 'HtmlCanvas', objectMeta);
  setMetadataFor(HtmlImage, 'HtmlImage', objectMeta);
  setMetadataFor(NodeJsNativeImageFormatProvider, 'NodeJsNativeImageFormatProvider', objectMeta, BaseNativeImageFormatProvider, VOID, VOID, VOID, [2, 3, 1]);
  setMetadataFor($decodeInternalCOROUTINE$36, '$decodeInternalCOROUTINE$36', classMeta, CoroutineImpl);
  setMetadataFor($decodeInternalCOROUTINE$37, '$decodeInternalCOROUTINE$37', classMeta, CoroutineImpl);
  setMetadataFor(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', objectMeta, NativeImageFormatProvider, VOID, VOID, VOID, [2, 3, 1]);
  setMetadataFor(HtmlNativeImage, 'HtmlNativeImage', classMeta, NativeImage);
  setMetadataFor($decodeToCanvasCOROUTINE$38, '$decodeToCanvasCOROUTINE$38', classMeta, CoroutineImpl);
  setMetadataFor($loadCanvasCOROUTINE$39, '$loadCanvasCOROUTINE$39', classMeta, CoroutineImpl);
  setMetadataFor(BrowserImage, 'BrowserImage', objectMeta, VOID, VOID, VOID, VOID, [2, 1]);
  setMetadataFor(CanvasContext2dRenderer, 'CanvasContext2dRenderer', classMeta, Renderer);
  //endregion
  function Entry($outer, info, page) {
    this.c43_1 = $outer;
    this.y42_1 = info;
    this.z42_1 = page;
    var tmp = this;
    var tmp0_elvis_lhs = this.c43_1.d43_1.z1(this.z42_1.h43_1);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Can't find '" + this.z42_1.h43_1 + "' in " + this.c43_1.d43_1.a2();
      throw IllegalStateException_init_$Create$(toString(tmp0_error));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.a43_1 = tmp_0;
    this.b43_1 = this.a43_1.v3s(this.y42_1.q43_1, this.y42_1.p43_1, VOID, this.y42_1.s43_1).y3s(this.y42_1.r43_1);
  }
  protoOf(Entry).v43 = function () {
    return this.y42_1.p43_1;
  };
  function Atlas(textures, info) {
    info = info === VOID ? new AtlasInfo() : info;
    this.d43_1 = textures;
    this.e43_1 = info;
    var tmp = this;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp1_flatMap = this.e43_1.x43_1;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList_init_$Create$();
    var tmp0_iterator = tmp1_flatMap.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      var tmp$ret$3;
      // Inline function 'korlibs.image.atlas.Atlas.entries.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = element.o43_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var tmp0_iterator_0 = tmp1_map.g();
      while (tmp0_iterator_0.h()) {
        var item = tmp0_iterator_0.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.atlas.Atlas.entries.<anonymous>.<anonymous>' call
        tmp$ret$0 = new Entry(this, item, element);
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$3 = tmp$ret$2;
      var list = tmp$ret$3;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$4 = tmp0_flatMapTo;
    tmp$ret$5 = tmp$ret$4;
    tmp.f43_1 = tmp$ret$5;
    var tmp_0 = this;
    var tmp$ret$8;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy = this.f43_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associateBy, 10)), 16);
    var tmp$ret$7;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator_1 = tmp1_associateBy.g();
    while (tmp0_iterator_1.h()) {
      var element_0 = tmp0_iterator_1.i();
      var tmp$ret$6;
      // Inline function 'korlibs.image.atlas.Atlas.entriesMap.<anonymous>' call
      tmp$ret$6 = element_0.v43();
      tmp0_associateByTo.x3(tmp$ret$6, element_0);
    }
    tmp$ret$7 = tmp0_associateByTo;
    tmp$ret$8 = tmp$ret$7;
    tmp_0.g43_1 = tmp$ret$8;
  }
  protoOf(Atlas).a44 = function (name) {
    return this.g43_1.z1(name);
  };
  function AtlasLookup() {
  }
  function readAtlas(_this__u8e3s4, props, $completion) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    var tmp = new $readAtlasCOROUTINE$0(_this__u8e3s4, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function $readAtlasCOROUTINE$0(_this__u8e3s4, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n44_1 = _this__u8e3s4;
    this.o44_1 = props;
  }
  protoOf($readAtlasCOROUTINE$0).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 5;
            this.hh_1 = 1;
            suspendResult = this.n44_1.a1z(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.p44_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (startsWith(this.p44_1, '{')) {
              tmp_1 = Companion_getInstance_20().a45(this.p44_1);
            } else if (startsWith(this.p44_1, '<')) {
              tmp_1 = Companion_getInstance_20().z44(this.p44_1);
            } else if (startsWith_0(this.p44_1, _Char___init__impl__6a9atx(10))) {
              tmp_1 = Companion_getInstance_20().y44(this.p44_1);
            } else if (startsWith(this.p44_1, '\r\n')) {
              tmp_1 = Companion_getInstance_20().y44(this.p44_1);
            } else {
              var tmp_2 = firstOrNull(this.p44_1);
              var tmp0_error = "Unexpected atlas starting with '" + (tmp_2 == null ? null : new Char(tmp_2)) + "'";
              throw IllegalStateException_init_$Create$(toString(tmp0_error));
            }

            tmp_0.q44_1 = tmp_1;
            this.r44_1 = this.n44_1.u1y();
            var tmp_3 = this;
            tmp_3.s44_1 = this.q44_1.x43_1;
            this.t44_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this.s44_1, 10)), 16);
            var tmp_4 = this;
            tmp_4.u44_1 = LinkedHashMap_init_$Create$(this.t44_1);
            this.v44_1 = this.s44_1.g();
            this.hh_1 = 2;
            continue $sm;
          case 2:
            if (!this.v44_1.h()) {
              this.hh_1 = 4;
              continue $sm;
            }

            this.w44_1 = this.v44_1.i();
            this.x44_1 = this.w44_1.h43_1;
            this.hh_1 = 3;
            suspendResult = readBitmapSlice(this.r44_1.ro(this.w44_1.h43_1), VOID, VOID, this.o44_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            var tmp1_plusAssign = to(this.x44_1, ARGUMENT);
            this.u44_1.x3(tmp1_plusAssign.t3_1, tmp1_plusAssign.u3_1);
            ;
            this.hh_1 = 2;
            continue $sm;
          case 4:
            var textures = this.u44_1;
            return new Atlas(textures, this.q44_1);
          case 5:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 5) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function Companion() {
    Companion_instance = this;
    this.b45_1 = '1.0.0';
  }
  var Companion_instance;
  function Companion_getInstance_19() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function toRect(_this__u8e3s4, $this) {
    return _RectangleInt___init__impl__1g5gox(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'w')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'h')));
  }
  function toSize(_this__u8e3s4, $this) {
    return _SizeInt___init__impl__vivn9(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'w')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'h')));
  }
  function createEntry($this, name, it) {
    var rotated = _Dyn___get_bool__impl__nv3iun(Dyn__get_impl_6l2p80(it, 'rotated'));
    var sourceSize = toSize(Dyn__get_impl_6l2p80(it, 'sourceSize'), $this);
    var spriteSourceSize = toRect(Dyn__get_impl_6l2p80(it, 'spriteSourceSize'), $this);
    var sW = _SizeInt___get_width__impl__swntg6(sourceSize);
    var sH = _SizeInt___get_height__impl__d3sy61(sourceSize);
    var frame = toRect(Dyn__get_impl_6l2p80(it, 'frame'), $this);
    return new Region(name, !rotated ? frame : _RectangleInt___init__impl__1g5gox(_RectangleInt___get_x__impl__6tm2y6(frame), _RectangleInt___get_y__impl__zdvhyr(frame), _RectangleInt___get_height__impl__gd473j(frame), _RectangleInt___get_width__impl__gtay8w(frame)), _RectangleInt___init__impl__1g5gox(_RectangleInt___get_x__impl__6tm2y6(spriteSourceSize), _RectangleInt___get_y__impl__zdvhyr(spriteSourceSize), sW, sH), rotated ? Companion_getInstance().d3r_1 : Companion_getInstance().a3r_1);
  }
  function loadText$point(_this__u8e3s4) {
    var list = split(_this__u8e3s4, charArrayOf([_Char___init__impl__6a9atx(44)]), VOID, 2);
    var tmp$ret$0;
    // Inline function 'kotlin.text.trim' call
    var tmp0_trim = first(list);
    tmp$ret$0 = toString(trim(isCharSequence(tmp0_trim) ? tmp0_trim : THROW_CCE()));
    var tmp = toInt(tmp$ret$0);
    var tmp$ret$1;
    // Inline function 'kotlin.text.trim' call
    var tmp1_trim = last(list);
    tmp$ret$1 = toString(trim(isCharSequence(tmp1_trim) ? tmp1_trim : THROW_CCE()));
    return _Vector2___init__impl__67w0ru(tmp, toInt(tmp$ret$1));
  }
  function loadText$size(_this__u8e3s4) {
    var tmp$ret$1;
    // Inline function 'kotlin.let' call
    var tmp0_let = loadText$point(_this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.image.atlas.Companion.loadText.size.<anonymous>' call
    tmp$ret$0 = _SizeInt___init__impl__vivn9(numberToInt(_Vector2___get_x__impl__zywdz(tmp0_let)), numberToInt(_Vector2___get_y__impl__ttldg6(tmp0_let)));
    tmp$ret$1 = tmp$ret$0;
    return tmp$ret$1;
  }
  function loadText$keyValue(_this__u8e3s4) {
    var list = split(_this__u8e3s4, charArrayOf([_Char___init__impl__6a9atx(58)]), VOID, 2);
    var tmp$ret$2;
    // Inline function 'kotlin.text.toLowerCase' call
    var tmp$ret$0;
    // Inline function 'kotlin.text.trim' call
    var tmp0_trim = first(list);
    tmp$ret$0 = toString(trim(isCharSequence(tmp0_trim) ? tmp0_trim : THROW_CCE()));
    var tmp1_toLowerCase = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$1 = tmp1_toLowerCase;
    tmp$ret$2 = tmp$ret$1.toLowerCase();
    var tmp = tmp$ret$2;
    var tmp$ret$3;
    // Inline function 'kotlin.text.trim' call
    var tmp2_trim = last(list);
    tmp$ret$3 = toString(trim(isCharSequence(tmp2_trim) ? tmp2_trim : THROW_CCE()));
    return to(tmp, tmp$ret$3);
  }
  function loadText$filter(_this__u8e3s4) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.toLowerCase' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    tmp$ret$1 = tmp$ret$0.toLowerCase();
    var tmp0_subject = tmp$ret$1;
    switch (tmp0_subject) {
      case 'nearest':
        return false;
      case 'linear':
        return true;
      case 'mipmap':
        return true;
      case 'mipmapnearestnearest':
        return false;
      case 'mipmaplinearnearest':
        return false;
      case 'mipmapnearestlinear':
        return false;
      case 'mipmaplinearlinear':
        return false;
      default:
        return false;
    }
  }
  function AtlasInfo_init_$Init$(frames, meta, $this) {
    AtlasInfo.call($this, meta, listOf(new Page(meta.e45_1, meta.g45_1, meta.d45_1, true, true, false, false, frames)));
    return $this;
  }
  function AtlasInfo_init_$Create$(frames, meta) {
    return AtlasInfo_init_$Init$(frames, meta, objectCreate(protoOf(AtlasInfo)));
  }
  function Meta(app, format, image, scale, size, version, frameTags, layers, slices) {
    Companion_getInstance_19();
    app = app === VOID ? 'app' : app;
    format = format === VOID ? 'format' : format;
    image = image === VOID ? 'image' : image;
    scale = scale === VOID ? 1.0 : scale;
    size = size === VOID ? _SizeInt___init__impl__vivn9(1, 1) : size;
    version = version === VOID ? Companion_getInstance_19().b45_1 : version;
    var tmp;
    if (frameTags === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.collections.listOf' call
      tmp$ret$0 = emptyList();
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = frameTags;
    }
    frameTags = tmp;
    var tmp_0;
    if (layers === VOID) {
      var tmp$ret$0_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.listOf' call
      tmp$ret$0_1 = emptyList();
      tmp$ret$1 = Unit_getInstance();
      tmp_0 = tmp$ret$0_1;
    } else {
      tmp_0 = layers;
    }
    layers = tmp_0;
    var tmp_1;
    if (slices === VOID) {
      var tmp$ret$0_2;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.listOf' call
      tmp$ret$0_2 = emptyList();
      tmp$ret$2 = Unit_getInstance();
      tmp_1 = tmp$ret$0_2;
    } else {
      tmp_1 = slices;
    }
    slices = tmp_1;
    this.c45_1 = app;
    this.d45_1 = format;
    this.e45_1 = image;
    this.f45_1 = scale;
    this.g45_1 = size;
    this.h45_1 = version;
    this.i45_1 = frameTags;
    this.j45_1 = layers;
    this.k45_1 = slices;
  }
  protoOf(Meta).toString = function () {
    return 'Meta(app=' + this.c45_1 + ', format=' + this.d45_1 + ', image=' + this.e45_1 + ', scale=' + this.f45_1 + ', size=' + new SizeInt(this.g45_1) + ', version=' + this.h45_1 + ', frameTags=' + this.i45_1 + ', layers=' + this.j45_1 + ', slices=' + this.k45_1 + ')';
  };
  protoOf(Meta).hashCode = function () {
    var result = getStringHashCode(this.c45_1);
    result = imul(result, 31) + getStringHashCode(this.d45_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e45_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f45_1) | 0;
    result = imul(result, 31) + SizeInt__hashCode_impl_xg010c(this.g45_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h45_1) | 0;
    result = imul(result, 31) + hashCode(this.i45_1) | 0;
    result = imul(result, 31) + hashCode(this.j45_1) | 0;
    result = imul(result, 31) + hashCode(this.k45_1) | 0;
    return result;
  };
  protoOf(Meta).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Meta))
      return false;
    var tmp0_other_with_cast = other instanceof Meta ? other : THROW_CCE();
    if (!(this.c45_1 === tmp0_other_with_cast.c45_1))
      return false;
    if (!(this.d45_1 === tmp0_other_with_cast.d45_1))
      return false;
    if (!(this.e45_1 === tmp0_other_with_cast.e45_1))
      return false;
    if (!equals(this.f45_1, tmp0_other_with_cast.f45_1))
      return false;
    if (!equals(this.g45_1, tmp0_other_with_cast.g45_1))
      return false;
    if (!(this.h45_1 === tmp0_other_with_cast.h45_1))
      return false;
    if (!equals(this.i45_1, tmp0_other_with_cast.i45_1))
      return false;
    if (!equals(this.j45_1, tmp0_other_with_cast.j45_1))
      return false;
    if (!equals(this.k45_1, tmp0_other_with_cast.k45_1))
      return false;
    return true;
  };
  function FrameTag(name, from, to, direction) {
    name = name === VOID ? '' : name;
    from = from === VOID ? 0 : from;
    to = to === VOID ? 0 : to;
    direction = direction === VOID ? '' : direction;
    this.l45_1 = name;
    this.m45_1 = from;
    this.n45_1 = to;
    this.o45_1 = direction;
  }
  protoOf(FrameTag).toString = function () {
    return 'FrameTag(name=' + this.l45_1 + ', from=' + this.m45_1 + ', to=' + this.n45_1 + ', direction=' + this.o45_1 + ')';
  };
  protoOf(FrameTag).hashCode = function () {
    var result = getStringHashCode(this.l45_1);
    result = imul(result, 31) + this.m45_1 | 0;
    result = imul(result, 31) + this.n45_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.o45_1) | 0;
    return result;
  };
  protoOf(FrameTag).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FrameTag))
      return false;
    var tmp0_other_with_cast = other instanceof FrameTag ? other : THROW_CCE();
    if (!(this.l45_1 === tmp0_other_with_cast.l45_1))
      return false;
    if (!(this.m45_1 === tmp0_other_with_cast.m45_1))
      return false;
    if (!(this.n45_1 === tmp0_other_with_cast.n45_1))
      return false;
    if (!(this.o45_1 === tmp0_other_with_cast.o45_1))
      return false;
    return true;
  };
  function Layer(name, opacity, blendMode) {
    name = name === VOID ? '' : name;
    opacity = opacity === VOID ? 255 : opacity;
    blendMode = blendMode === VOID ? '' : blendMode;
    this.p45_1 = name;
    this.q45_1 = opacity;
    this.r45_1 = blendMode;
  }
  protoOf(Layer).toString = function () {
    return 'Layer(name=' + this.p45_1 + ', opacity=' + this.q45_1 + ', blendMode=' + this.r45_1 + ')';
  };
  protoOf(Layer).hashCode = function () {
    var result = getStringHashCode(this.p45_1);
    result = imul(result, 31) + this.q45_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.r45_1) | 0;
    return result;
  };
  protoOf(Layer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Layer))
      return false;
    var tmp0_other_with_cast = other instanceof Layer ? other : THROW_CCE();
    if (!(this.p45_1 === tmp0_other_with_cast.p45_1))
      return false;
    if (!(this.q45_1 === tmp0_other_with_cast.q45_1))
      return false;
    if (!(this.r45_1 === tmp0_other_with_cast.r45_1))
      return false;
    return true;
  };
  function Slice(name, color, keys) {
    name = name === VOID ? 'slice' : name;
    color = color === VOID ? '#0000ffff' : color;
    this.s45_1 = name;
    this.t45_1 = color;
    this.u45_1 = keys;
  }
  protoOf(Slice).toString = function () {
    return 'Slice(name=' + this.s45_1 + ', color=' + this.t45_1 + ', keys=' + this.u45_1 + ')';
  };
  protoOf(Slice).hashCode = function () {
    var result = getStringHashCode(this.s45_1);
    result = imul(result, 31) + getStringHashCode(this.t45_1) | 0;
    result = imul(result, 31) + hashCode(this.u45_1) | 0;
    return result;
  };
  protoOf(Slice).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Slice))
      return false;
    var tmp0_other_with_cast = other instanceof Slice ? other : THROW_CCE();
    if (!(this.s45_1 === tmp0_other_with_cast.s45_1))
      return false;
    if (!(this.t45_1 === tmp0_other_with_cast.t45_1))
      return false;
    if (!equals(this.u45_1, tmp0_other_with_cast.u45_1))
      return false;
    return true;
  };
  function Key(frame, bounds) {
    frame = frame === VOID ? 0 : frame;
    this.v45_1 = frame;
    this.w45_1 = bounds;
  }
  protoOf(Key).toString = function () {
    return 'Key(frame=' + this.v45_1 + ', bounds=' + new RectangleInt(this.w45_1) + ')';
  };
  protoOf(Key).hashCode = function () {
    var result = this.v45_1;
    result = imul(result, 31) + RectangleInt__hashCode_impl_wuqys2(this.w45_1) | 0;
    return result;
  };
  protoOf(Key).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Key))
      return false;
    var tmp0_other_with_cast = other instanceof Key ? other : THROW_CCE();
    if (!(this.v45_1 === tmp0_other_with_cast.v45_1))
      return false;
    if (!equals(this.w45_1, tmp0_other_with_cast.w45_1))
      return false;
    return true;
  };
  function Page(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) {
    this.h43_1 = fileName;
    this.i43_1 = size;
    this.j43_1 = format;
    this.k43_1 = filterMin;
    this.l43_1 = filterMag;
    this.m43_1 = repeatX;
    this.n43_1 = repeatY;
    this.o43_1 = regions;
  }
  protoOf(Page).x45 = function (fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) {
    return new Page(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions);
  };
  protoOf(Page).y45 = function (fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions, $super) {
    fileName = fileName === VOID ? this.h43_1 : fileName;
    size = size === VOID ? this.i43_1 : size;
    format = format === VOID ? this.j43_1 : format;
    filterMin = filterMin === VOID ? this.k43_1 : filterMin;
    filterMag = filterMag === VOID ? this.l43_1 : filterMag;
    repeatX = repeatX === VOID ? this.m43_1 : repeatX;
    repeatY = repeatY === VOID ? this.n43_1 : repeatY;
    regions = regions === VOID ? this.o43_1 : regions;
    return $super === VOID ? this.x45(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) : $super.x45.call(this, fileName, new SizeInt(size), format, filterMin, filterMag, repeatX, repeatY, regions);
  };
  protoOf(Page).toString = function () {
    return 'Page(fileName=' + this.h43_1 + ', size=' + new SizeInt(this.i43_1) + ', format=' + this.j43_1 + ', filterMin=' + this.k43_1 + ', filterMag=' + this.l43_1 + ', repeatX=' + this.m43_1 + ', repeatY=' + this.n43_1 + ', regions=' + this.o43_1 + ')';
  };
  protoOf(Page).hashCode = function () {
    var result = getStringHashCode(this.h43_1);
    result = imul(result, 31) + SizeInt__hashCode_impl_xg010c(this.i43_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j43_1) | 0;
    result = imul(result, 31) + (this.k43_1 | 0) | 0;
    result = imul(result, 31) + (this.l43_1 | 0) | 0;
    result = imul(result, 31) + (this.m43_1 | 0) | 0;
    result = imul(result, 31) + (this.n43_1 | 0) | 0;
    result = imul(result, 31) + hashCode(this.o43_1) | 0;
    return result;
  };
  protoOf(Page).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Page))
      return false;
    var tmp0_other_with_cast = other instanceof Page ? other : THROW_CCE();
    if (!(this.h43_1 === tmp0_other_with_cast.h43_1))
      return false;
    if (!equals(this.i43_1, tmp0_other_with_cast.i43_1))
      return false;
    if (!(this.j43_1 === tmp0_other_with_cast.j43_1))
      return false;
    if (!(this.k43_1 === tmp0_other_with_cast.k43_1))
      return false;
    if (!(this.l43_1 === tmp0_other_with_cast.l43_1))
      return false;
    if (!(this.m43_1 === tmp0_other_with_cast.m43_1))
      return false;
    if (!(this.n43_1 === tmp0_other_with_cast.n43_1))
      return false;
    if (!equals(this.o43_1, tmp0_other_with_cast.o43_1))
      return false;
    return true;
  };
  function Region(name, frame, virtFrame, imageOrientation) {
    virtFrame = virtFrame === VOID ? null : virtFrame;
    var tmp;
    if (imageOrientation === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call
      var tmp0__get_NORMAL__2qt1ti = Companion_getInstance();
      tmp$ret$0 = tmp0__get_NORMAL__2qt1ti.a3r_1;
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = imageOrientation;
    }
    imageOrientation = tmp;
    this.p43_1 = name;
    this.q43_1 = frame;
    this.r43_1 = virtFrame;
    this.s43_1 = imageOrientation;
    this.t43_1 = _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.s43_1) ? _RectangleInt___get_height__impl__gd473j(this.q43_1) : _RectangleInt___get_width__impl__gtay8w(this.q43_1);
    this.u43_1 = _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.s43_1) ? _RectangleInt___get_width__impl__gtay8w(this.q43_1) : _RectangleInt___get_height__impl__gd473j(this.q43_1);
  }
  protoOf(Region).toString = function () {
    var tmp = new RectangleInt(this.q43_1);
    var tmp_0 = this.r43_1;
    return 'Region(name=' + this.p43_1 + ', frame=' + tmp + ', virtFrame=' + (tmp_0 == null ? null : new RectangleInt(tmp_0)) + ', imageOrientation=' + new SliceOrientation(this.s43_1) + ')';
  };
  protoOf(Region).hashCode = function () {
    var result = getStringHashCode(this.p43_1);
    result = imul(result, 31) + RectangleInt__hashCode_impl_wuqys2(this.q43_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.r43_1;
    if ((tmp_1 == null ? null : new RectangleInt(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RectangleInt__hashCode_impl_wuqys2(this.r43_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.s43_1) | 0;
    return result;
  };
  protoOf(Region).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Region))
      return false;
    var tmp0_other_with_cast = other instanceof Region ? other : THROW_CCE();
    if (!(this.p43_1 === tmp0_other_with_cast.p43_1))
      return false;
    if (!equals(this.q43_1, tmp0_other_with_cast.q43_1))
      return false;
    var tmp = this.r43_1;
    var tmp_0 = tmp == null ? null : new RectangleInt(tmp);
    var tmp_1 = tmp0_other_with_cast.r43_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RectangleInt(tmp_1)))
      return false;
    if (!(this.s43_1 === tmp0_other_with_cast.s43_1))
      return false;
    return true;
  };
  function Companion_0() {
    Companion_instance_0 = this;
  }
  protoOf(Companion_0).a45 = function (json) {
    var it = get_dyn(Json_getInstance().d23(json));
    var tmp$ret$7;
    // Inline function 'kotlin.let' call
    var tmp0_let = Dyn__get_impl_6l2p80(it, 'frames');
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$6;
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
    var frames = _Dyn___get_value__impl__bemnlg(tmp0_let);
    var tmp0_subject = frames;
    var tmp;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map) : false) {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = frames.a2();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var tmp0_iterator = tmp1_map.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        tmp$ret$0 = createEntry(Companion_getInstance_20(), _Dyn___get_str__impl__dup4cs(get_dyn(item)), Dyn__get_impl_6l2p80(tmp0_let, _Dyn___get_str__impl__dup4cs(get_dyn(item))));
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      tmp = tmp$ret$2;
    } else {
      var tmp$ret$5;
      // Inline function 'kotlin.collections.map' call
      var tmp3_map = _Dyn___get_list__impl__qpwjp(tmp0_let);
      var tmp$ret$4;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp2_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map, 10));
      var tmp0_iterator_0 = tmp3_map.g();
      while (tmp0_iterator_0.h()) {
        var item_0 = tmp0_iterator_0.i().t1r_1;
        var tmp$ret$3;
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        var tmp_0 = Companion_getInstance_20();
        var tmp0_safe_receiver = _Dyn___get_orNull__impl__ox3tzj(Dyn__get_impl_6l2p80(item_0, 'name'));
        var tmp2_elvis_lhs = tmp0_safe_receiver == null ? null : _Dyn___get_str__impl__dup4cs(tmp0_safe_receiver.t1r_1);
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          var tmp1_safe_receiver = _Dyn___get_orNull__impl__ox3tzj(Dyn__get_impl_6l2p80(item_0, 'filename'));
          tmp_1 = tmp1_safe_receiver == null ? null : _Dyn___get_str__impl__dup4cs(tmp1_safe_receiver.t1r_1);
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp_1;
        tmp$ret$3 = createEntry(tmp_0, tmp3_elvis_lhs == null ? 'unknown' : tmp3_elvis_lhs, item_0);
        tmp2_mapTo.b(tmp$ret$3);
      }
      tmp$ret$4 = tmp2_mapTo;
      tmp$ret$5 = tmp$ret$4;
      tmp = tmp$ret$5;
    }
    tmp$ret$6 = tmp;
    tmp$ret$7 = tmp$ret$6;
    var tmp_2 = tmp$ret$7;
    var tmp$ret$33;
    // Inline function 'kotlin.let' call
    var tmp1_let = Dyn__get_impl_6l2p80(it, 'meta');
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$32;
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
    var tmp_3 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(tmp1_let, 'app'));
    var tmp_4 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(tmp1_let, 'format'));
    var tmp_5 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(tmp1_let, 'image'));
    var tmp_6 = _Dyn___get_double__impl__jlvfa0(Dyn__get_impl_6l2p80(tmp1_let, 'scale'));
    var tmp_7 = toSize(Dyn__get_impl_6l2p80(tmp1_let, 'size'), Companion_getInstance_20());
    var tmp_8 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(tmp1_let, 'version'));
    var tmp$ret$13;
    // Inline function 'kotlin.let' call
    var tmp0_let_0 = Dyn__get_impl_6l2p80(tmp1_let, 'frameTags');
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$12;
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var frameTags = _Dyn___get_value__impl__bemnlg(tmp0_let_0);
    var tmp_9;
    if (!(frameTags == null) ? isInterface(frameTags, List) : false) {
      var tmp$ret$10;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map_0 = _Dyn___get_list__impl__qpwjp(tmp0_let_0);
      var tmp$ret$9;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
      var tmp0_iterator_1 = tmp1_map_0.g();
      while (tmp0_iterator_1.h()) {
        var item_1 = tmp0_iterator_1.i().t1r_1;
        var tmp$ret$8;
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        tmp$ret$8 = new FrameTag(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(item_1, 'name')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item_1, 'from')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item_1, 'to')), _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(item_1, 'direction')));
        tmp0_mapTo_0.b(tmp$ret$8);
      }
      tmp$ret$9 = tmp0_mapTo_0;
      tmp$ret$10 = tmp$ret$9;
      tmp_9 = tmp$ret$10;
    } else {
      var tmp$ret$11;
      // Inline function 'kotlin.collections.listOf' call
      tmp$ret$11 = emptyList();
      tmp_9 = tmp$ret$11;
    }
    tmp$ret$12 = tmp_9;
    tmp$ret$13 = tmp$ret$12;
    var tmp_10 = tmp$ret$13;
    var tmp$ret$19;
    // Inline function 'kotlin.let' call
    var tmp1_let_0 = Dyn__get_impl_6l2p80(tmp1_let, 'layers');
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$18;
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var layers = _Dyn___get_value__impl__bemnlg(tmp1_let_0);
    var tmp_11;
    if (!(layers == null) ? isInterface(layers, List) : false) {
      var tmp$ret$16;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map_1 = _Dyn___get_list__impl__qpwjp(tmp1_let_0);
      var tmp$ret$15;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_1, 10));
      var tmp0_iterator_2 = tmp1_map_1.g();
      while (tmp0_iterator_2.h()) {
        var item_2 = tmp0_iterator_2.i().t1r_1;
        var tmp$ret$14;
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        tmp$ret$14 = new Layer(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(item_2, 'name')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item_2, 'opacity')), _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(item_2, 'blendMode')));
        tmp0_mapTo_1.b(tmp$ret$14);
      }
      tmp$ret$15 = tmp0_mapTo_1;
      tmp$ret$16 = tmp$ret$15;
      tmp_11 = tmp$ret$16;
    } else {
      var tmp$ret$17;
      // Inline function 'kotlin.collections.listOf' call
      tmp$ret$17 = emptyList();
      tmp_11 = tmp$ret$17;
    }
    tmp$ret$18 = tmp_11;
    tmp$ret$19 = tmp$ret$18;
    var tmp_12 = tmp$ret$19;
    var tmp$ret$31;
    // Inline function 'kotlin.let' call
    var tmp2_let = Dyn__get_impl_6l2p80(tmp1_let, 'slices');
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$30;
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var slices = _Dyn___get_value__impl__bemnlg(tmp2_let);
    var tmp_13;
    if (!(slices == null) ? isInterface(slices, List) : false) {
      var tmp$ret$28;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map_2 = _Dyn___get_list__impl__qpwjp(tmp2_let);
      var tmp$ret$27;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_2, 10));
      var tmp0_iterator_3 = tmp1_map_2.g();
      while (tmp0_iterator_3.h()) {
        var item_3 = tmp0_iterator_3.i().t1r_1;
        var tmp$ret$26;
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        var tmp_14 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(item_3, 'name'));
        var tmp_15 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(item_3, 'color'));
        var tmp$ret$25;
        // Inline function 'kotlin.let' call
        var tmp0_let_1 = Dyn__get_impl_6l2p80(item_3, 'keys');
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$24;
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        var keys = _Dyn___get_value__impl__bemnlg(tmp0_let_1);
        var tmp_16;
        if (!(keys == null) ? isInterface(keys, List) : false) {
          var tmp$ret$22;
          // Inline function 'kotlin.collections.map' call
          var tmp1_map_3 = _Dyn___get_list__impl__qpwjp(tmp0_let_1);
          var tmp$ret$21;
          // Inline function 'kotlin.collections.mapTo' call
          var tmp0_mapTo_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_3, 10));
          var tmp0_iterator_4 = tmp1_map_3.g();
          while (tmp0_iterator_4.h()) {
            var item_4 = tmp0_iterator_4.i().t1r_1;
            var tmp$ret$20;
            // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            tmp$ret$20 = new Key(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item_4, 'frame')), toRect(Dyn__get_impl_6l2p80(item_4, 'bounds'), Companion_getInstance_20()));
            tmp0_mapTo_3.b(tmp$ret$20);
          }
          tmp$ret$21 = tmp0_mapTo_3;
          tmp$ret$22 = tmp$ret$21;
          tmp_16 = tmp$ret$22;
        } else {
          var tmp$ret$23;
          // Inline function 'kotlin.collections.listOf' call
          tmp$ret$23 = emptyList();
          tmp_16 = tmp$ret$23;
        }
        tmp$ret$24 = tmp_16;
        tmp$ret$25 = tmp$ret$24;
        tmp$ret$26 = new Slice(tmp_14, tmp_15, tmp$ret$25);
        tmp0_mapTo_2.b(tmp$ret$26);
      }
      tmp$ret$27 = tmp0_mapTo_2;
      tmp$ret$28 = tmp$ret$27;
      tmp_13 = tmp$ret$28;
    } else {
      var tmp$ret$29;
      // Inline function 'kotlin.collections.listOf' call
      tmp$ret$29 = emptyList();
      tmp_13 = tmp$ret$29;
    }
    tmp$ret$30 = tmp_13;
    tmp$ret$31 = tmp$ret$30;
    tmp$ret$32 = new Meta(tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_10, tmp_12, tmp$ret$31);
    tmp$ret$33 = tmp$ret$32;
    var info = AtlasInfo_init_$Create$(tmp_2, tmp$ret$33);
    var tmp$ret$41;
    // Inline function 'kotlin.collections.map' call
    var tmp3_map_0 = info.x43_1;
    var tmp$ret$40;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp2_mapTo_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map_0, 10));
    var tmp0_iterator_5 = tmp3_map_0.g();
    while (tmp0_iterator_5.h()) {
      var item_5 = tmp0_iterator_5.i();
      var tmp$ret$39;
      // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
      var tmp$ret$38;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map_4 = item_5.o43_1;
      var tmp$ret$37;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_4, 10));
      var tmp0_iterator_6 = tmp1_map_4.g();
      while (tmp0_iterator_6.h()) {
        var item_6 = tmp0_iterator_6.i();
        var tmp$ret$36;
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        var tmp$ret$35;
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$34;
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        tmp$ret$34 = Unit_getInstance();
        tmp$ret$35 = item_6;
        tmp$ret$36 = tmp$ret$35;
        tmp0_mapTo_4.b(tmp$ret$36);
      }
      tmp$ret$37 = tmp0_mapTo_4;
      tmp$ret$38 = tmp$ret$37;
      tmp$ret$39 = item_5.y45(VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$38);
      tmp2_mapTo_0.b(tmp$ret$39);
    }
    tmp$ret$40 = tmp2_mapTo_0;
    tmp$ret$41 = tmp$ret$40;
    return info.z45(VOID, tmp$ret$41);
  };
  protoOf(Companion_0).z44 = function (content) {
    var xml = Xml(content);
    var imagePath = xml.g2k('imagePath');
    var size = _SizeInt___init__impl__vivn9(xml.h2k('width', -1), xml.h2k('height', -1));
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map = plus(xml.d2k('SubTexture'), xml.d2k('sprite'));
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
    var tmp0_iterator = tmp1_map.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$0;
      // Inline function 'korlibs.image.atlas.Companion.loadXml.<anonymous>' call
      var virtFrame = _RectangleInt___init__impl__1g5gox(imul(item.h2k('frameX', 0), -1), imul(item.h2k('frameY', 0), -1), item.h2k('frameWidth', 0), item.h2k('frameHeight', 0));
      var tmp0_elvis_lhs = item.m2k('name');
      var tmp = tmp0_elvis_lhs == null ? item.g2k('n') : tmp0_elvis_lhs;
      var tmp_0 = item.i2k('x');
      var tmp_1 = item.i2k('y');
      var tmp1_elvis_lhs = item.l2k('width');
      var tmp_2 = tmp1_elvis_lhs == null ? item.i2k('w') : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = item.l2k('height');
      tmp$ret$0 = new Region(tmp, _RectangleInt___init__impl__1g5gox(tmp_0, tmp_1, tmp_2, tmp2_elvis_lhs == null ? item.i2k('h') : tmp2_elvis_lhs), (!(_RectangleInt___get_width__impl__gtay8w(virtFrame) === 0) ? true : !(_RectangleInt___get_height__impl__gd473j(virtFrame) === 0)) ? virtFrame : null, item.e2k('rotated', false) ? Companion_getInstance().d3r_1 : Companion_getInstance().a3r_1);
      tmp0_mapTo.b(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return AtlasInfo_init_$Create$(tmp$ret$2, new Meta('Unknown', 'xml', imagePath, 1.0, size, '1.0'));
  };
  protoOf(Companion_0).y44 = function (content) {
    var r = new ListReader(lines(content));
    var pageImage = null;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    var currentEntryList = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$1 = ArrayList_init_$Create$();
    var pages = tmp$ret$1;
    $l$loop: while (r.gs()) {
      var tmp$ret$2;
      // Inline function 'kotlin.text.trim' call
      var tmp0_trim = r.is();
      tmp$ret$2 = toString(trim(isCharSequence(tmp0_trim) ? tmp0_trim : THROW_CCE()));
      var line = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.text.isEmpty' call
      tmp$ret$3 = charSequenceLength(line) === 0;
      if (tmp$ret$3) {
        if (r.fs())
          break $l$loop;
        var tmp$ret$4;
        // Inline function 'kotlin.text.trim' call
        var tmp1_trim = r.is();
        tmp$ret$4 = toString(trim(isCharSequence(tmp1_trim) ? tmp1_trim : THROW_CCE()));
        var fileName = tmp$ret$4;
        var size = _SizeInt___init__impl__vivn9(0, 0);
        var format = 'rgba8888';
        var filterMin = false;
        var filterMag = false;
        var repeatX = false;
        var repeatY = false;
        while (r.gs() ? contains(r.hs(), _Char___init__impl__6a9atx(58)) : false) {
          var tmp$ret$5;
          // Inline function 'kotlin.text.trim' call
          var tmp2_trim = r.is();
          tmp$ret$5 = toString(trim(isCharSequence(tmp2_trim) ? tmp2_trim : THROW_CCE()));
          var tmp0_container = loadText$keyValue(tmp$ret$5);
          var key = tmp0_container.v3();
          var value = tmp0_container.w3();
          var tmp1_subject = key;
          switch (tmp1_subject) {
            case 'size':
              size = loadText$size(value);
              break;
            case 'format':
              format = value;
              break;
            case 'filter':
              var tmp$ret$11;
              // Inline function 'kotlin.collections.map' call
              var tmp4_map = split_0(value, [',']);
              var tmp$ret$10;
              // Inline function 'kotlin.collections.mapTo' call
              var tmp3_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp4_map, 10));
              var tmp0_iterator = tmp4_map.g();
              while (tmp0_iterator.h()) {
                var item = tmp0_iterator.i();
                var tmp$ret$9;
                // Inline function 'korlibs.image.atlas.Companion.loadText.<anonymous>' call
                var tmp$ret$8;
                // Inline function 'kotlin.text.toLowerCase' call
                var tmp$ret$6;
                // Inline function 'kotlin.text.trim' call
                tmp$ret$6 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
                var tmp0_toLowerCase = tmp$ret$6;
                var tmp$ret$7;
                // Inline function 'kotlin.js.asDynamic' call
                tmp$ret$7 = tmp0_toLowerCase;
                tmp$ret$8 = tmp$ret$7.toLowerCase();
                tmp$ret$9 = tmp$ret$8;
                tmp3_mapTo.b(tmp$ret$9);
              }
              tmp$ret$10 = tmp3_mapTo;
              tmp$ret$11 = tmp$ret$10;

              var filter = tmp$ret$11;
              filterMin = loadText$filter(first(filter));
              filterMag = loadText$filter(last(filter));
              break;
            case 'repeat':
              repeatX = contains(value, _Char___init__impl__6a9atx(120));
              repeatY = contains(value, _Char___init__impl__6a9atx(121));
              break;
          }
        }
        var tmp$ret$12;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp$ret$12 = ArrayList_init_$Create$();
        currentEntryList = tmp$ret$12;
        pages.b(new Page(fileName, size, format, filterMin, filterMag, repeatX, repeatY, currentEntryList));
      } else {
        var name = line;
        var rotate = false;
        var xy = Companion_getInstance_0().h3b_1;
        var size_0 = _SizeInt___init__impl__vivn9(0, 0);
        var orig = _SizeInt___init__impl__vivn9(0, 0);
        var offset = Companion_getInstance_0().h3b_1;
        while (r.gs() ? contains(r.hs(), _Char___init__impl__6a9atx(58)) : false) {
          var tmp$ret$13;
          // Inline function 'kotlin.text.trim' call
          var tmp5_trim = r.is();
          tmp$ret$13 = toString(trim(isCharSequence(tmp5_trim) ? tmp5_trim : THROW_CCE()));
          var tmp2_container = loadText$keyValue(tmp$ret$13);
          var key_0 = tmp2_container.v3();
          var value_0 = tmp2_container.w3();
          var tmp3_subject = key_0;
          switch (tmp3_subject) {
            case 'rotate':
              rotate = toBoolean(value_0);
              break;
            case 'xy':
              xy = loadText$point(value_0);
              break;
            case 'size':
              size_0 = loadText$size(value_0);
              break;
            case 'orig':
              orig = loadText$size(value_0);
              break;
            case 'offset':
              offset = loadText$point(value_0);
              break;
          }
        }
        var orientation = rotate ? Companion_getInstance().b3r_1 : Companion_getInstance().a3r_1;
        var w = !rotate ? _SizeInt___get_width__impl__swntg6(size_0) : _SizeInt___get_height__impl__d3sy61(size_0);
        var h = !rotate ? _SizeInt___get_height__impl__d3sy61(size_0) : _SizeInt___get_width__impl__swntg6(size_0);
        var oW = _SizeInt___get_width__impl__swntg6(orig);
        var oH = _SizeInt___get_height__impl__d3sy61(orig);
        currentEntryList.b(new Region(name, _RectangleInt___init__impl__1g5gox(numberToInt(_Vector2___get_x__impl__zywdz(xy)), numberToInt(_Vector2___get_y__impl__ttldg6(xy)), w, h), _RectangleInt___init__impl__1g5gox(numberToInt(_Vector2___get_x__impl__zywdz(offset)), (_SizeInt___get_height__impl__d3sy61(orig) - _SizeInt___get_height__impl__d3sy61(size_0) | 0) - numberToInt(_Vector2___get_y__impl__ttldg6(offset)) | 0, oW, oH), orientation));
      }
    }
    var firstPage = first(pages);
    return new AtlasInfo(new Meta('unknown', firstPage.j43_1, firstPage.h43_1, 1.0, firstPage.i43_1, '1.0'), pages);
  };
  var Companion_instance_0;
  function Companion_getInstance_20() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function AtlasInfo(meta, pages) {
    Companion_getInstance_20();
    meta = meta === VOID ? new Meta() : meta;
    var tmp;
    if (pages === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.collections.listOf' call
      tmp$ret$0 = emptyList();
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = pages;
    }
    pages = tmp;
    this.w43_1 = meta;
    this.x43_1 = pages;
    var tmp_0 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp1_flatMap = this.x43_1;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList_init_$Create$();
    var tmp0_iterator = tmp1_flatMap.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      var tmp$ret$1;
      // Inline function 'korlibs.image.atlas.AtlasInfo.frames.<anonymous>' call
      tmp$ret$1 = element.o43_1;
      var list = tmp$ret$1;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$2 = tmp0_flatMapTo;
    tmp$ret$3 = tmp$ret$2;
    tmp_0.y43_1 = tmp$ret$3;
    var tmp_1 = this;
    var tmp$ret$6;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy = this.y43_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associateBy, 10)), 16);
    var tmp$ret$5;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator_0 = tmp1_associateBy.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      var tmp$ret$4;
      // Inline function 'korlibs.image.atlas.AtlasInfo.framesMap.<anonymous>' call
      tmp$ret$4 = element_0.p43_1;
      tmp0_associateByTo.x3(tmp$ret$4, element_0);
    }
    tmp$ret$5 = tmp0_associateByTo;
    tmp$ret$6 = tmp$ret$5;
    tmp_1.z43_1 = tmp$ret$6;
  }
  protoOf(AtlasInfo).a46 = function (meta, pages) {
    return new AtlasInfo(meta, pages);
  };
  protoOf(AtlasInfo).z45 = function (meta, pages, $super) {
    meta = meta === VOID ? this.w43_1 : meta;
    pages = pages === VOID ? this.x43_1 : pages;
    return $super === VOID ? this.a46(meta, pages) : $super.a46.call(this, meta, pages);
  };
  protoOf(AtlasInfo).toString = function () {
    return 'AtlasInfo(meta=' + this.w43_1 + ', pages=' + this.x43_1 + ')';
  };
  protoOf(AtlasInfo).hashCode = function () {
    var result = this.w43_1.hashCode();
    result = imul(result, 31) + hashCode(this.x43_1) | 0;
    return result;
  };
  protoOf(AtlasInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AtlasInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AtlasInfo ? other : THROW_CCE();
    if (!this.w43_1.equals(tmp0_other_with_cast.w43_1))
      return false;
    if (!equals(this.x43_1, tmp0_other_with_cast.x43_1))
      return false;
    return true;
  };
  var GrowMethod_GROW_IMAGE_instance;
  var GrowMethod_NEW_IMAGES_instance;
  var GrowMethod_entriesInitialized;
  function GrowMethod_initEntries() {
    if (GrowMethod_entriesInitialized)
      return Unit_getInstance();
    GrowMethod_entriesInitialized = true;
    GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
    GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
  }
  function MutableAtlas_init_$Init$(width, height, border, premultiplied, allowToGrow, growMethod, $this) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    MutableAtlas.call($this, Companion_getInstance_1().t3p(width, height), border, premultiplied, allowToGrow, growMethod);
    return $this;
  }
  function MutableAtlas_init_$Create$(width, height, border, premultiplied, allowToGrow, growMethod) {
    return MutableAtlas_init_$Init$(width, height, border, premultiplied, allowToGrow, growMethod, objectCreate(protoOf(MutableAtlas)));
  }
  function GrowMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Entry_0(slice, data) {
    this.b46_1 = slice;
    this.c46_1 = data;
  }
  protoOf(Entry_0).toString = function () {
    return 'Entry(slice=' + this.b46_1 + ', data=' + this.c46_1 + ')';
  };
  protoOf(Entry_0).hashCode = function () {
    var result = this.b46_1.hashCode();
    result = imul(result, 31) + (this.c46_1 == null ? 0 : hashCode(this.c46_1)) | 0;
    return result;
  };
  protoOf(Entry_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.b46_1.equals(tmp0_other_with_cast.b46_1))
      return false;
    if (!equals(this.c46_1, tmp0_other_with_cast.c46_1))
      return false;
    return true;
  };
  function reconstructWithSize($this, width, height) {
    var slices = toList($this.l46_1);
    $this.d46_1 = Companion_getInstance_1().t3p(width, height);
    $this.j46_1 = new Bitmap32(width, height, VOID, $this.f46_1);
    $this.k46_1.v2();
    $this.k46_1.b($this.j46_1);
    $this.m46_1.v2();
    $this.l46_1.v2();
    var tmp0_iterator = slices.g();
    while (tmp0_iterator.h()) {
      var entry = tmp0_iterator.i();
      $this.o46(entry.b46_1, entry.c46_1, entry.b46_1.n3r_1);
    }
  }
  function growAtlas($this, bmp) {
    var tmp0_subject = $this.h46_1;
    var tmp0 = tmp0_subject.j5_1;
    if (tmp0 === 0) {
      reconstructWithSize($this, imul($this.ck(), 2), imul($this.dk(), 2));
    } else if (tmp0 === 1) {
      if (bmp.s3r_1 > $this.ck() ? true : bmp.t3r_1 > $this.dk()) {
        // Inline function 'kotlin.error' call
        var tmp0_error = 'Atlas is too small (' + $this.ck() + 'x' + $this.dk() + ') to hold a slice of (' + bmp.s3r_1 + 'x' + bmp.t3r_1 + ')';
        throw IllegalStateException_init_$Create$(toString(tmp0_error));
      }
      $this.d46_1 = Companion_getInstance_1().t3p($this.ck(), $this.dk());
      $this.j46_1 = new Bitmap32($this.ck(), $this.dk(), VOID, $this.f46_1);
      $this.k46_1.b($this.j46_1);
    }
  }
  function GrowMethod_NEW_IMAGES_getInstance() {
    GrowMethod_initEntries();
    return GrowMethod_NEW_IMAGES_instance;
  }
  function MutableAtlas(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    this.d46_1 = binPacker;
    this.e46_1 = border;
    this.f46_1 = premultiplied;
    this.g46_1 = allowToGrow;
    this.h46_1 = growMethod;
    this.i46_1 = _MarginInt___init__impl__dx1aag(this.e46_1);
    this.j46_1 = new Bitmap32(this.ck(), this.dk(), VOID, this.f46_1);
    this.k46_1 = arrayListOf([this.j46_1]);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    tmp.l46_1 = tmp$ret$0;
    this.m46_1 = LinkedHashMap_init_$Create$_0();
    this.n46_1 = null;
  }
  protoOf(MutableAtlas).ck = function () {
    return numberToInt(this.d46_1.ck());
  };
  protoOf(MutableAtlas).dk = function () {
    return numberToInt(this.d46_1.dk());
  };
  protoOf(MutableAtlas).j = function () {
    return this.l46_1.j();
  };
  protoOf(MutableAtlas).p46 = function (bmp, data, name) {
    return this.o46(slice(bmp, VOID, name), data, name);
  };
  protoOf(MutableAtlas).q46 = function (bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.j() : name;
    return $super === VOID ? this.p46(bmp, data, name) : $super.p46.call(this, bmp, data, name);
  };
  protoOf(MutableAtlas).o46 = function (bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.p46(extract_0(bmp).e47(), data, name);
    }
    if (bmp instanceof RectSlice)
      bmp;
    else
      THROW_CCE();
    try {
      var tmp0_elvis_lhs = name;
      var rname = tmp0_elvis_lhs == null ? 'Slice' + this.j() : tmp0_elvis_lhs;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty ? !(this.n46_1 == null) : false) {
        var bigEmptySlice = ensureNotNull(this.n46_1).b46_1;
        if (bigEmptySlice.s3r_1 >= bmp.s3r_1 ? bigEmptySlice.t3r_1 >= bmp.t3r_1 : false) {
          entry = new Entry_0(bigEmptySlice.v3s(_RectangleInt___init__impl__1g5gox(0, 0, bmp.s3r_1, bmp.t3r_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.d46_1.a3q(bmp.s3r_1 + imul(this.e46_1, 2), bmp.t3r_1 + imul(this.e46_1, 2));
        var slice = sliceWithSize(this.j46_1, numberToInt(_Rectangle___get_left__impl__sgtjiw(rect) + this.e46_1), numberToInt(_Rectangle___get_top__impl__3kuxui(rect) + this.e46_1), bmp.s3r_1, bmp.t3r_1, rname);
        var dstX = slice.k3f();
        var dstY = slice.l3f();
        var boundsWithBorder = RectangleInt__expanded_impl_u776to(get_bounds_0(slice), this.i46_1);
        var tmp$ret$0;
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var tmp0_lock = this.j46_1;
        {
          tmp0_lock.f47();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.j46_1.w47(bmp, dstX, dstY);
          expandBorder(this.j46_1, slice.k3r_1, this.e46_1);
        }finally {
          result = tmp0_lock.x47(boundsWithBorder);
        }
        tmp$ret$0 = result;
        entry = new Entry_0(slice, data);
        if (this.n46_1 == null ? true : bmp.a3t() > ensureNotNull(this.n46_1).b46_1.a3t()) {
          this.n46_1 = entry;
        }
      }
      var tmp1_this = this;
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp1_plusAssign = tmp1_this.l46_1;
      var tmp2_plusAssign = entry;
      tmp1_plusAssign.b(tmp2_plusAssign);
      // Inline function 'kotlin.collections.set' call
      var tmp3_set = this.m46_1;
      var tmp4_set = entry;
      tmp3_set.x3(rname, tmp4_set);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.g46_1)
          throw e;
        growAtlas(this, bmp);
        return this.o46(bmp, data, name);
      } else {
        throw $p;
      }
    }
  };
  protoOf(MutableAtlas).y47 = function (bmp, data, name, $super) {
    name = name === VOID ? bmp.n3r_1 : name;
    return $super === VOID ? this.o46(bmp, data, name) : $super.o46.call(this, bmp, data, name);
  };
  function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
    _init_properties_Bitmap_kt__y1ku1b();
    var tmp0_setValue = baseMipmapLevel$factory();
    var tmp0_elvis_lhs = baseMipmapLevel$delegate.nu_1;
    var tmp = tmp0_elvis_lhs == null ? tmp0_setValue.callableName : tmp0_elvis_lhs;
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _set____db54di;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return setExtra(_this__u8e3s4, tmp, tmp$ret$2);
  }
  function get_baseMipmapLevel(_this__u8e3s4) {
    _init_properties_Bitmap_kt__y1ku1b();
    var tmp$ret$8;
    $l$block: {
      // Inline function 'korlibs.datastructure.Property.getValue' call
      var tmp2_getValue = baseMipmapLevel$factory_0();
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.fastCastTo' call
      var tmp1_safe_receiver = _this__u8e3s4.mu();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        // Inline function 'korlibs.datastructure.get' call
        var tmp0_elvis_lhs = baseMipmapLevel$delegate.nu_1;
        var tmp0_get = tmp0_elvis_lhs == null ? tmp2_getValue.callableName : tmp0_elvis_lhs;
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp1_safe_receiver;
        tmp$ret$1 = tmp$ret$0.get(tmp0_get);
        tmp = tmp$ret$1;
      }
      var tmp1_fastCastTo = tmp;
      var tmp$ret$3;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$2;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$2 = tmp1_fastCastTo;
      tmp$ret$3 = tmp$ret$2;
      tmp$ret$4 = tmp$ret$3;
      var res = tmp$ret$4;
      if (res == null) {
        var r = baseMipmapLevel$delegate.ou_1();
        var tmp_0;
        if (!(r == null)) {
          tmp_0 = true;
        } else {
          var tmp2_elvis_lhs = baseMipmapLevel$delegate.nu_1;
          tmp_0 = hasExtra(_this__u8e3s4, tmp2_elvis_lhs == null ? tmp2_getValue.callableName : tmp2_elvis_lhs);
        }
        if (tmp_0) {
          // Inline function 'korlibs.datastructure.Property.setValue' call
          var tmp0_elvis_lhs_0 = baseMipmapLevel$delegate.nu_1;
          var tmp_1 = tmp0_elvis_lhs_0 == null ? tmp2_getValue.callableName : tmp0_elvis_lhs_0;
          var tmp$ret$7;
          // Inline function 'korlibs.datastructure.fastCastTo' call
          var tmp$ret$6;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$5;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$5 = r;
          tmp$ret$6 = tmp$ret$5;
          tmp$ret$7 = tmp$ret$6;
          setExtra(_this__u8e3s4, tmp_1, tmp$ret$7);
        }
        tmp$ret$8 = r;
        break $l$block;
      }
      tmp$ret$8 = res;
    }
    return tmp$ret$8;
  }
  var baseMipmapLevel$delegate;
  function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
    _init_properties_Bitmap_kt__y1ku1b();
    var tmp0_setValue = maxMipmapLevel$factory();
    var tmp0_elvis_lhs = maxMipmapLevel$delegate.nu_1;
    var tmp = tmp0_elvis_lhs == null ? tmp0_setValue.callableName : tmp0_elvis_lhs;
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _set____db54di;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return setExtra(_this__u8e3s4, tmp, tmp$ret$2);
  }
  function get_maxMipmapLevel(_this__u8e3s4) {
    _init_properties_Bitmap_kt__y1ku1b();
    var tmp$ret$8;
    $l$block: {
      // Inline function 'korlibs.datastructure.Property.getValue' call
      var tmp2_getValue = maxMipmapLevel$factory_0();
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.fastCastTo' call
      var tmp1_safe_receiver = _this__u8e3s4.mu();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        // Inline function 'korlibs.datastructure.get' call
        var tmp0_elvis_lhs = maxMipmapLevel$delegate.nu_1;
        var tmp0_get = tmp0_elvis_lhs == null ? tmp2_getValue.callableName : tmp0_elvis_lhs;
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp1_safe_receiver;
        tmp$ret$1 = tmp$ret$0.get(tmp0_get);
        tmp = tmp$ret$1;
      }
      var tmp1_fastCastTo = tmp;
      var tmp$ret$3;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$2;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$2 = tmp1_fastCastTo;
      tmp$ret$3 = tmp$ret$2;
      tmp$ret$4 = tmp$ret$3;
      var res = tmp$ret$4;
      if (res == null) {
        var r = maxMipmapLevel$delegate.ou_1();
        var tmp_0;
        if (!(r == null)) {
          tmp_0 = true;
        } else {
          var tmp2_elvis_lhs = maxMipmapLevel$delegate.nu_1;
          tmp_0 = hasExtra(_this__u8e3s4, tmp2_elvis_lhs == null ? tmp2_getValue.callableName : tmp2_elvis_lhs);
        }
        if (tmp_0) {
          // Inline function 'korlibs.datastructure.Property.setValue' call
          var tmp0_elvis_lhs_0 = maxMipmapLevel$delegate.nu_1;
          var tmp_1 = tmp0_elvis_lhs_0 == null ? tmp2_getValue.callableName : tmp0_elvis_lhs_0;
          var tmp$ret$7;
          // Inline function 'korlibs.datastructure.fastCastTo' call
          var tmp$ret$6;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$5;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$5 = r;
          tmp$ret$6 = tmp$ret$5;
          tmp$ret$7 = tmp$ret$6;
          setExtra(_this__u8e3s4, tmp_1, tmp$ret$7);
        }
        tmp$ret$8 = r;
        break $l$block;
      }
      tmp$ret$8 = res;
    }
    return tmp$ret$8;
  }
  var maxMipmapLevel$delegate;
  function Bitmap$tempInts$delegate$lambda(this$0) {
    return function () {
      return new Int32Array(imul(this$0.r46_1, 2));
    };
  }
  function Bitmap(width, height, bpp, premultiplied, backingArray) {
    this.r46_1 = width;
    this.s46_1 = height;
    this.t46_1 = bpp;
    this.u46_1 = backingArray;
    this.v46_1 = new Mixin();
    this.w46_1 = _RectangleInt___init__impl__1g5gox(0, 0, this.r46_1, this.s46_1);
    this.x46_1 = null;
    this.y46_1 = premultiplied;
    this.z46_1 = false;
    var tmp = this;
    tmp.a47_1 = lazy(Bitmap$tempInts$delegate$lambda(this));
    this.b47_1 = 0;
    this.c47_1 = null;
    this.d47_1 = false;
  }
  protoOf(Bitmap).lu = function (_set____db54di) {
    this.v46_1.lu(_set____db54di);
  };
  protoOf(Bitmap).mu = function () {
    return this.v46_1.mu();
  };
  protoOf(Bitmap).k3s = function () {
    return _SizeInt___init__impl__vivn9(this.r46_1, this.s46_1);
  };
  protoOf(Bitmap).z47 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = tempInts$factory();
    tmp$ret$0 = this.a47_1.q();
    return tmp$ret$0;
  };
  protoOf(Bitmap).a48 = function () {
    return _RgbaArray___init__impl__oib4y4(this.z47());
  };
  protoOf(Bitmap).b48 = function () {
    return imul(this.r46_1, this.t46_1) / 8 | 0;
  };
  protoOf(Bitmap).a3t = function () {
    return imul(this.r46_1, this.s46_1);
  };
  protoOf(Bitmap).c48 = function (x, y) {
    return imul(y, this.r46_1) + x | 0;
  };
  protoOf(Bitmap).d48 = function () {
    var tmp = this.c47_1;
    if (!((tmp == null ? null : new RectangleInt(tmp)) == null)) {
      this.c47_1 = null;
    }
  };
  protoOf(Bitmap).f47 = function () {
    return Unit_getInstance();
  };
  protoOf(Bitmap).x47 = function (rect) {
    var tmp0_subject = this.c47_1;
    var tmp = tmp0_subject;
    if ((tmp == null ? null : new RectangleInt(tmp)) == null)
      this.c47_1 = rect;
    else {
      var tmp_0 = this;
      var tmp_1 = Companion_getInstance_2();
      var tmp_2 = this.c47_1;
      tmp_0.c47_1 = tmp_1.x3i(ensureNotNull(tmp_2 == null ? null : new RectangleInt(tmp_2)).z3i_1, rect);
    }
    var tmp1_this = this;
    tmp1_this.b47_1 = tmp1_this.b47_1 + 1 | 0;
    return tmp1_this.b47_1;
  };
  protoOf(Bitmap).e48 = function (x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            out[tmp2] = _RGBA___get_value__impl__hhco8v(this.f48(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap).g48 = function (x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            this.h48(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[tmp2]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap).i48 = function (x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.g48(x, y, width, height, out, offset);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.g48.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  };
  protoOf(Bitmap).h48 = function (x, y, v) {
    // Inline function 'kotlin.TODO' call
    throw new NotImplementedError();
  };
  protoOf(Bitmap).f48 = function (x, y) {
    return Colors_getInstance().o48_1;
  };
  protoOf(Bitmap).b4e = function (x, y, color) {
    return Unit_getInstance();
  };
  protoOf(Bitmap).c4e = function (x, y) {
    return 0;
  };
  protoOf(Bitmap).d4e = function (x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (((x0 < 0 ? true : y0 < 0) ? true : x0 >= this.r46_1) ? true : y0 >= this.s46_1)
      return Colors_getInstance().o48_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.r46_1 - 1 | 0);
    var y1Inside = y1 < (this.s46_1 - 1 | 0);
    var tmp$ret$0;
    // Inline function 'korlibs.memory.fract' call
    tmp$ret$0 = x - toIntFloor(x);
    var xratio = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'korlibs.memory.fract' call
    tmp$ret$1 = y - toIntFloor(y);
    var yratio = tmp$ret$1;
    var c00 = this.f48(x0, y0);
    var c10 = x1Inside ? this.f48(x1, y0) : c00;
    var c01 = y1Inside ? this.f48(x0, y1) : c00;
    var c11 = (x1Inside ? y1Inside : false) ? this.f48(x1, y1) : c01;
    return Companion_getInstance_28().j4e(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  };
  protoOf(Bitmap).k4e = function (srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.l4e(srcX);
    var srcX1 = src.l4e(srcX + width | 0);
    var srcY0 = src.m4e(srcY);
    var srcY1 = src.m4e(srcY + height | 0);
    var dstX0 = dst.l4e(dstX);
    var dstX1 = dst.l4e(dstX + width | 0);
    var dstY0 = dst.m4e(dstY);
    var dstY1 = dst.m4e(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = srcX1 - srcX0 | 0;
    var tmp1_min = dstX1 - dstX0 | 0;
    tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
    var width_0 = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.math.min' call
    var tmp2_min = srcY1 - srcY0 | 0;
    var tmp3_min = dstY1 - dstY0 | 0;
    tmp$ret$1 = Math.min(tmp2_min, tmp3_min);
    var height_0 = tmp$ret$1;
    this.n4e(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  };
  protoOf(Bitmap).n4e = function (srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.e48(srcX, srcY + y | 0, width, 1, this.z47(), 0);
        dst.g48(dstX, dstY + y | 0, width, 1, this.z47(), 0);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap).o4e = function (x) {
    return x >= 0 ? x < this.r46_1 : false;
  };
  protoOf(Bitmap).p4e = function (y) {
    return y >= 0 ? y < this.s46_1 : false;
  };
  protoOf(Bitmap).q4e = function (x, y) {
    return this.o4e(x) ? this.p4e(y) : false;
  };
  protoOf(Bitmap).r4e = function (x) {
    return clamp(x, 0, this.r46_1 - 1 | 0);
  };
  protoOf(Bitmap).s4e = function (y) {
    return clamp(y, 0, this.s46_1 - 1 | 0);
  };
  protoOf(Bitmap).l4e = function (x) {
    return clamp(x, 0, this.r46_1);
  };
  protoOf(Bitmap).m4e = function (y) {
    return clamp(y, 0, this.s46_1);
  };
  protoOf(Bitmap).t4e = function () {
    var inductionVariable = 0;
    var last = this.s46_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.u4e(y, (this.s46_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  };
  protoOf(Bitmap).v4e = function () {
    var inductionVariable = 0;
    var last = this.r46_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w4e(x, (this.r46_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  };
  protoOf(Bitmap).x4e = function (rotation) {
    var tmp0_subject = rotation;
    var tmp0 = tmp0_subject.j5_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = this.dn();
        break;
      case 1:
        tmp = this.y4e().v4e();
        break;
      case 2:
        tmp = this.y4e().v4e().y4e().v4e();
        break;
      case 3:
        tmp = this.y4e().t4e();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(Bitmap).z4e = function (orientation) {
    var out = this.dn();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.v4e();
    }
    return out.x4e(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  };
  protoOf(Bitmap).y4e = function () {
    var temp = new IntArray2(this.r46_1, this.s46_1, readPixelsUnsafe(this, 0, 0, this.r46_1, this.s46_1));
    var tmp$ret$1;
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var tmp0_invoke = Companion_getInstance_3();
    var tmp1_invoke = this.s46_1;
    var tmp2_invoke = this.r46_1;
    var tmp = 0;
    var tmp_0 = imul(tmp1_invoke, tmp2_invoke);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp$ret$0;
      // Inline function 'korlibs.datastructure.Companion.invoke.<anonymous>' call
      tmp$ret$0 = 0;
      tmp_1[tmp_2] = tmp$ret$0;
      tmp = tmp + 1 | 0;
    }
    var tmp_3 = tmp_1;
    tmp$ret$1 = new IntArray2(tmp1_invoke, tmp2_invoke, isIntArray(tmp_3) ? tmp_3 : THROW_CCE());
    var out = tmp$ret$1;
    var inductionVariable = 0;
    var last = this.s46_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.r46_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.gk(y, x, temp.fk(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var tmp$ret$2;
    // Inline function 'kotlin.also' call
    var tmp3_also = this.a4f(this.s46_1, this.r46_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    tmp3_also.i48(0, 0, this.s46_1, this.r46_1, out.ak_1);
    tmp$ret$2 = tmp3_also;
    return tmp$ret$2;
  };
  protoOf(Bitmap).u4e = function (y0, y1) {
    var inductionVariable = 0;
    var last = this.r46_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.c4e(x, y0);
        var c1 = this.c4e(x, y1);
        this.b4e(x, y0, c1);
        this.b4e(x, y1, c0);
      }
       while (inductionVariable < last);
  };
  protoOf(Bitmap).w4e = function (x0, x1) {
    var inductionVariable = 0;
    var last = this.s46_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.c4e(x0, y);
        var c1 = this.c4e(x1, y);
        this.b4e(x0, y, c1);
        this.b4e(x1, y, c0);
      }
       while (inductionVariable < last);
  };
  protoOf(Bitmap).b4f = function (antialiasing) {
    throw UnsupportedOperationException_init_$Create$('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  };
  protoOf(Bitmap).a4f = function (width, height) {
    invalidOp('Unsupported createWithThisFormat (' + this + ')');
  };
  protoOf(Bitmap).e47 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new Bitmap32(this.r46_1, this.s46_1, VOID, this.y46_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.e48(0, 0, this.r46_1, this.s46_1, tmp0_also.t47_1, 0);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  };
  protoOf(Bitmap).c4f = function () {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.e47();
    }
    return tmp;
  };
  protoOf(Bitmap).dn = function () {
    var out = this.a4f(this.r46_1, this.s46_1);
    this.n4e(0, 0, out, 0, 0, this.r46_1, this.s46_1);
    return out;
  };
  function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
    _init_properties_Bitmap_kt__y1ku1b();
    var out = new Int32Array(imul(width, height));
    _this__u8e3s4.e48(x, y, width, height, out, 0);
    return out;
  }
  function mipmaps(_this__u8e3s4, enable) {
    enable = enable === VOID ? true : enable;
    _init_properties_Bitmap_kt__y1ku1b();
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
    _this__u8e3s4.d47_1 = enable;
    tmp$ret$0 = _this__u8e3s4;
    return tmp$ret$0;
  }
  function NativeImageContext2d(width, height, antialiased, block) {
    antialiased = antialiased === VOID ? true : antialiased;
    _init_properties_Bitmap_kt__y1ku1b();
    var tmp$ret$1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    var tmp1_context2d = NativeImage_0(width, height, true);
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var tmp0_lock = tmp1_context2d.w46_1;
    if (false) {
      tmp1_context2d.f47();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = tmp1_context2d.b4f(antialiased);
      try {
        // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
        block(ctx);
      }finally {
        ctx.p13();
      }
    }finally {
      result = false ? tmp1_context2d.x47(tmp0_lock) : 0;
    }
    tmp$ret$0 = result;
    tmp$ret$1 = tmp1_context2d;
    return tmp$ret$1;
  }
  function asumePremultiplied(_this__u8e3s4) {
    _init_properties_Bitmap_kt__y1ku1b();
    _this__u8e3s4.y46_1 = true;
    _this__u8e3s4.z46_1 = true;
    return _this__u8e3s4;
  }
  function baseMipmapLevel$delegate$lambda() {
    _init_properties_Bitmap_kt__y1ku1b();
    return null;
  }
  function maxMipmapLevel$delegate$lambda() {
    _init_properties_Bitmap_kt__y1ku1b();
    return null;
  }
  function baseMipmapLevel$factory() {
    return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
      return get_baseMipmapLevel(receiver);
    }, function (receiver, value) {
      return set_baseMipmapLevel(receiver, value);
    });
  }
  function baseMipmapLevel$factory_0() {
    return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
      return get_baseMipmapLevel(receiver);
    }, function (receiver, value) {
      return set_baseMipmapLevel(receiver, value);
    });
  }
  function maxMipmapLevel$factory() {
    return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
      return get_maxMipmapLevel(receiver);
    }, function (receiver, value) {
      return set_maxMipmapLevel(receiver, value);
    });
  }
  function maxMipmapLevel$factory_0() {
    return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
      return get_maxMipmapLevel(receiver);
    }, function (receiver, value) {
      return set_maxMipmapLevel(receiver, value);
    });
  }
  function tempInts$factory() {
    return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
      return receiver.z47();
    }, null);
  }
  var properties_initialized_Bitmap_kt_sxrn69;
  function _init_properties_Bitmap_kt__y1ku1b() {
    if (properties_initialized_Bitmap_kt_sxrn69) {
    } else {
      properties_initialized_Bitmap_kt_sxrn69 = true;
      baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
      maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
    }
  }
  function Companion_1() {
    Companion_instance_1 = this;
    this.k4f_1 = new Bitmap32(0, 0, VOID, true);
  }
  protoOf(Companion_1).l4f = function (width, height, value) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new Bitmap32(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(tmp0_apply.t47_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  };
  protoOf(Companion_1).m4f = function (width, height, premultiplied) {
    return new Bitmap32(width, height, new Int32Array(imul(width, height)), premultiplied);
  };
  protoOf(Companion_1).n4f = function (src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.r4f_1;
    var dstShift = dstChannel.r4f_1;
    var dstClear = dstChannel.t4f_1;
    var dstData = dst.t47_1;
    var srcData = src.t47_1;
    var inductionVariable = 0;
    var last = dst.a3t();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  };
  protoOf(Companion_1).u4f = function (src, dst, dstChannel) {
    var destShift = imul(dstChannel.q4f_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.a3t();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.p4g()[n] & 255;
        dst.t47_1[n] = dst.t47_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  };
  protoOf(Companion_1).q4g = function (src, srcChannel, dst) {
    var shift = srcChannel.r4f_1;
    var inductionVariable = 0;
    var last = src.a3t();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.p4g()[n] = toByte((src.t47_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  };
  var Companion_instance_1;
  function Companion_getInstance_21() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function Bitmap32$iterator$slambda(this$0, resultContinuation) {
    this.z4g_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Bitmap32$iterator$slambda).d4h = function ($this$iterator, $completion) {
    var tmp = this.e4h($this$iterator, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Bitmap32$iterator$slambda).mi = function (p1, $completion) {
    return this.d4h(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Bitmap32$iterator$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.b4h_1 = until(0, this.z4g_1.a3t()).g();
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (!this.b4h_1.h()) {
              this.hh_1 = 3;
              continue $sm;
            }

            this.c4h_1 = this.b4h_1.i();
            this.hh_1 = 2;
            suspendResult = this.a4h_1.c4(new RGBA(this.z4g_1.f4h(this.c4h_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(Bitmap32$iterator$slambda).e4h = function ($this$iterator, completion) {
    var i = new Bitmap32$iterator$slambda(this.z4g_1, completion);
    i.a4h_1 = $this$iterator;
    return i;
  };
  function Bitmap32$iterator$slambda_0(this$0, resultContinuation) {
    var i = new Bitmap32$iterator$slambda(this$0, resultContinuation);
    var l = function ($this$iterator, $completion) {
      return i.d4h($this$iterator, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Bitmap32(width, height, ints, premultiplied) {
    Companion_getInstance_21();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    Bitmap.call(this, width, height, 32, premultiplied, ints);
    this.t47_1 = ints;
    if (this.t47_1.length < imul(width, height))
      throw RuntimeException_init_$Create$('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + this.t47_1.length + '), area=' + imul(width, height));
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    tmp$ret$0 = Math.max(width, height);
    tmp.u47_1 = new Int32Array(tmp$ret$0);
    this.v47_1 = _RectangleInt___init__impl__1g5gox(0, 0, width, height);
  }
  protoOf(Bitmap32).a4f = function (width, height) {
    return new Bitmap32(width, height, VOID, this.y46_1);
  };
  protoOf(Bitmap32).n4e = function (srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return protoOf(Bitmap).n4e.call(this, srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.t47_1;
    var dstArray = dst.t47_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.c48(srcX, srcY + y | 0), dstArray, dst.c48(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap32).g4h = function (x, y, color) {
    this.h4h(x, y, color);
  };
  protoOf(Bitmap32).i4h = function (x, y) {
    return this.j4h(x, y);
  };
  protoOf(Bitmap32).b4e = function (x, y, color) {
    this.t47_1[this.c48(x, y)] = color;
  };
  protoOf(Bitmap32).c4e = function (x, y) {
    return this.t47_1[this.c48(x, y)];
  };
  protoOf(Bitmap32).f48 = function (x, y) {
    return _RGBA___init__impl__lqpay5(this.c4e(x, y));
  };
  protoOf(Bitmap32).h48 = function (x, y, v) {
    return this.b4e(x, y, _RGBA___get_value__impl__hhco8v(v));
  };
  protoOf(Bitmap32).h4h = function (x, y, v) {
    return this.k4h(this.c48(x, y), v);
  };
  protoOf(Bitmap32).j4h = function (x, y) {
    return this.f4h(this.c48(x, y));
  };
  protoOf(Bitmap32).k4h = function (n, color) {
    this.t47_1[n] = this.y46_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  };
  protoOf(Bitmap32).l4h = function (n, color) {
    var tmp;
    if (this.y46_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      var tmp$ret$0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.t47_1[n] = tmp;
  };
  protoOf(Bitmap32).f4h = function (n) {
    var tmp;
    if (this.y46_1) {
      var tmp$ret$0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp0__get_depremultiplied__z56aq2 = _RGBAPremultiplied___init__impl__uos02x(this.t47_1[n]);
      tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(tmp0__get_depremultiplied__z56aq2);
      tmp = tmp$ret$0;
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.t47_1[n]);
    }
    return tmp;
  };
  protoOf(Bitmap32).m4h = function (n) {
    return this.y46_1 ? _RGBAPremultiplied___init__impl__uos02x(this.t47_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.t47_1[n]));
  };
  protoOf(Bitmap32).n4h = function (src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.c48(dx, dy + y | 0);
        var srcOffset = src.c48(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.l4h(dstOffset + x | 0, mix(dst.m4h(dstOffset + x | 0), src.m4h(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.y46_1 === src.y46_1) {
            arraycopy(src.t47_1, srcOffset, dst.t47_1, dstOffset, width);
          } else if (!dst.y46_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.k4h(dstOffset + x_0 | 0, src.f4h(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.l4h(dstOffset + x_1 | 0, src.m4h(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap32).o4h = function (src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.r46_1 - dx_0 | 0;
    var availableHeight = this.s46_1 - dy_0 | 0;
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = sright - sleft_0 | 0;
    tmp$ret$0 = Math.min(availableWidth, tmp0_min);
    var awidth = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.math.min' call
    var tmp1_min = sbottom - stop_0 | 0;
    tmp$ret$1 = Math.min(availableHeight, tmp1_min);
    var aheight = tmp$ret$1;
    this.n4h(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  };
  protoOf(Bitmap32).p4h = function (mix, other, _dx, _dy) {
    this.o4h(other, _dx, _dy, 0, 0, other.r46_1, other.s46_1, mix);
  };
  protoOf(Bitmap32).q4h = function (color, x, y, width, height) {
    var x1 = this.r4e(x);
    var x2 = this.r4e((x + width | 0) - 1 | 0);
    var y1 = this.s4e(y);
    var y2 = this.s4e((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.y46_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.t47_1, colorInt, this.c48(x1, cy), this.c48(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  };
  protoOf(Bitmap32).r4h = function (color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.r46_1 - x | 0 : width;
    height = height === VOID ? this.s46_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.q4h(color, x, y, width, height);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.q4h.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  };
  protoOf(Bitmap32).s4h = function (src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.o4h(get_bmp(src), dx, dy, _RectangleInt___get_left__impl__rhzld(b), _RectangleInt___get_top__impl__ie2ifj(b), _RectangleInt___get_right__impl__9c8zzq(b), _RectangleInt___get_bottom__impl__za67bh(b), mix);
  };
  protoOf(Bitmap32).t4h = function (src, dx, dy) {
    return this.p4h(false, src, dx, dy);
  };
  protoOf(Bitmap32).u4h = function (src, dx, dy) {
    return this.p4h(true, src, dx, dy);
  };
  protoOf(Bitmap32).w47 = function (src, dx, dy) {
    return this.s4h(src, dx, dy, true);
  };
  protoOf(Bitmap32).v4h = function (destination, input, source) {
    return Companion_getInstance_21().n4f(input, source, this, destination);
  };
  protoOf(Bitmap32).w4h = function (destination, input) {
    return Companion_getInstance_21().u4f(input, this, destination);
  };
  protoOf(Bitmap32).x4h = function (channel, out) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_21().q4g(this, channel, out);
    tmp$ret$0 = out;
    return tmp$ret$0;
  };
  protoOf(Bitmap32).y4h = function (channel, out, $super) {
    out = out === VOID ? new Bitmap8(this.r46_1, this.s46_1) : out;
    return $super === VOID ? this.x4h(channel, out) : $super.x4h.call(this, channel, out);
  };
  protoOf(Bitmap32).toString = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    tmp0_apply.ve('Bitmap32(');
    tmp0_apply.ue(this.r46_1);
    tmp0_apply.ve(', ');
    tmp0_apply.ue(this.s46_1);
    if (!(this.x46_1 == null)) {
      tmp0_apply.ve(', name=');
      tmp0_apply.ve(this.x46_1);
    }
    tmp0_apply.ve(')');
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  protoOf(Bitmap32).u4e = function (y0, y1) {
    var s0 = this.c48(0, y0);
    var s1 = this.c48(0, y1);
    arraycopy(this.t47_1, s0, this.u47_1, 0, this.r46_1);
    arraycopy(this.t47_1, s1, this.t47_1, s0, this.r46_1);
    arraycopy(this.u47_1, 0, this.t47_1, s1, this.r46_1);
  };
  protoOf(Bitmap32).dn = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.copyOf' call
    var tmp0_copyOf = this.t47_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_copyOf;
    tmp$ret$1 = tmp$ret$0.slice();
    return new Bitmap32(this.r46_1, this.s46_1, tmp$ret$1, this.y46_1);
  };
  protoOf(Bitmap32).b4f = function (antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  };
  protoOf(Bitmap32).z4h = function () {
    return this.y46_1 ? this : this.copyPremultiplied();
  };
  protoOf(Bitmap32).a4i = function () {
    return !this.y46_1 ? this : this.b4i();
  };
  protoOf(Bitmap32).copyPremultiplied = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = this.dn();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    tmp0_apply.c4i();
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  };
  protoOf(Bitmap32).b4i = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = this.dn();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    tmp0_apply.d4i();
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  };
  protoOf(Bitmap32).c4i = function () {
    if (this.y46_1)
      return Unit_getInstance();
    this.y46_1 = true;
    var inductionVariable = 0;
    var last = this.a3t();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.t47_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.t47_1[n])));
      }
       while (inductionVariable < last);
  };
  protoOf(Bitmap32).d4i = function () {
    if (!this.y46_1)
      return Unit_getInstance();
    this.y46_1 = false;
    var inductionVariable = 0;
    var last = this.a3t();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var tmp0__get_depremultiplied__z56aq2 = _RGBAPremultiplied___init__impl__uos02x(this.t47_1[n]);
        tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(tmp0__get_depremultiplied__z56aq2);
        this.t47_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  };
  protoOf(Bitmap32).g = function () {
    return iterator(Bitmap32$iterator$slambda_0(this, null));
  };
  protoOf(Bitmap32).e4i = function (x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.t47_1, this.c48(x, y), width);
    } else {
      var m = this.c48(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.t47_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  };
  protoOf(Bitmap32).e47 = function () {
    return this;
  };
  function isFullyTransparent(_this__u8e3s4) {
    var bmp = get_bmp(_this__u8e3s4);
    var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).t47_1);
    var width = _this__u8e3s4.m3f() - _this__u8e3s4.k3f() | 0;
    var inductionVariable = _this__u8e3s4.l3f();
    var last = _this__u8e3s4.n3f();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var index = bmp.c48(_this__u8e3s4.k3f(), y);
        // Inline function 'kotlin.check' call
        var tmp0_check = index >= 0 ? index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0) : false;
        // Inline function 'kotlin.contracts.contract' call
        if (!tmp0_check) {
          var tmp$ret$0;
          // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
          tmp$ret$0 = 'left=' + _this__u8e3s4.k3f() + ', top=' + _this__u8e3s4.l3f() + ', right=' + _this__u8e3s4.m3f() + ', bottom=' + _this__u8e3s4.n3f();
          var message = tmp$ret$0;
          throw IllegalStateException_init_$Create$(toString(message));
        }
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
              return false;
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < last);
    return true;
  }
  function expandBorder(_this__u8e3s4, area, border) {
    return expandBorder_0(_this__u8e3s4, _RectangleInt___get_top__impl__ie2ifj(area), _RectangleInt___get_left__impl__rhzld(area), _RectangleInt___get_bottom__impl__za67bh(area), _RectangleInt___get_right__impl__9c8zzq(area), border);
  }
  function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
    var data = _this__u8e3s4.t47_1;
    var x0Index = _this__u8e3s4.c48(areaLeft, areaTop);
    var x1Index = _this__u8e3s4.c48(areaRight - 1 | 0, areaTop);
    var areaWidth = areaRight - areaLeft | 0;
    var areaHeight = areaBottom - areaTop | 0;
    var inductionVariable = 0;
    if (inductionVariable < areaHeight)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x0Color = data[x0Index];
        var x1Color = data[x1Index];
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < border)
          do {
            var m = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            data[(x0Index - m | 0) - 1 | 0] = x0Color;
            data[(x1Index + m | 0) + 1 | 0] = x1Color;
          }
           while (inductionVariable_0 < border);
        x0Index = x0Index + _this__u8e3s4.r46_1 | 0;
        x1Index = x1Index + _this__u8e3s4.r46_1 | 0;
      }
       while (inductionVariable < areaHeight);
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < border)
      do {
        var m_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var x = areaLeft - border | 0;
        var npixels = areaWidth + imul(border, 2) | 0;
        arraycopy(data, _this__u8e3s4.c48(x, areaTop), data, _this__u8e3s4.c48(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
        arraycopy(data, _this__u8e3s4.c48(x, areaBottom - 1 | 0), data, _this__u8e3s4.c48(x, areaBottom + m_0 | 0), npixels);
      }
       while (inductionVariable_1 < border);
  }
  function Companion_2() {
    Companion_instance_2 = this;
  }
  protoOf(Companion_2).f4i = function (src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.k4e(srcX, srcY, dst, dstX, dstY, width, height);
  };
  var Companion_instance_2;
  function Companion_getInstance_22() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function Bitmap8(width, height, data, palette) {
    Companion_getInstance_22();
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_getInstance_27().g4i(256) : palette;
    BitmapIndexed.call(this, 8, width, height, data, palette);
  }
  protoOf(Bitmap8).a4f = function (width, height) {
    return new Bitmap8(width, height, VOID, this.j4g_1);
  };
  protoOf(Bitmap8).b4e = function (x, y, color) {
    return this.b4j(this.c48(x, y), color);
  };
  protoOf(Bitmap8).c4e = function (x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.l4g_1, this.c48(x, y));
  };
  protoOf(Bitmap8).f48 = function (x, y) {
    var tmp = this.j4g_1;
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    tmp$ret$0 = this.c4e(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  };
  protoOf(Bitmap8).c4j = function (n) {
    return UByteArrayInt__get_impl_px6q8a(this.l4g_1, n);
  };
  protoOf(Bitmap8).b4j = function (n, color) {
    UByteArrayInt__set_impl_gn4532(this.l4g_1, n, color);
  };
  protoOf(Bitmap8).n4e = function (srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return protoOf(BitmapIndexed).n4e.call(this, srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.p4g();
        var tmp_0 = this.c48(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).p4g(), dst.c48(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  };
  protoOf(Bitmap8).dn = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.copyOf' call
    var tmp0_copyOf = this.p4g();
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_copyOf;
    tmp$ret$1 = tmp$ret$0.slice();
    var tmp = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.copyOf' call
    var tmp1_copyOf = _RgbaArray___get_ints__impl__u2kps1(this.j4g_1);
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = tmp1_copyOf;
    tmp$ret$3 = tmp$ret$2.slice();
    return new Bitmap8(this.r46_1, this.s46_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  };
  protoOf(Bitmap8).toString = function () {
    return 'Bitmap8(' + this.r46_1 + ', ' + this.s46_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.j4g_1) + ')';
  };
  var BitmapChannel_RED_instance;
  var BitmapChannel_GREEN_instance;
  var BitmapChannel_BLUE_instance;
  var BitmapChannel_ALPHA_instance;
  function Companion_3() {
    Companion_instance_3 = this;
    this.h4j_1 = values();
  }
  protoOf(Companion_3).k = function (index) {
    return this.h4j_1[index];
  };
  var Companion_instance_3;
  function Companion_getInstance_23() {
    BitmapChannel_initEntries();
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function values() {
    return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
  }
  var BitmapChannel_entriesInitialized;
  function BitmapChannel_initEntries() {
    if (BitmapChannel_entriesInitialized)
      return Unit_getInstance();
    BitmapChannel_entriesInitialized = true;
    BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
    BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
    BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
    BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
    Companion_getInstance_23();
  }
  function BitmapChannel(name, ordinal, index) {
    Enum.call(this, name, ordinal);
    this.q4f_1 = index;
    this.r4f_1 = imul(this.q4f_1, 8);
    this.s4f_1 = 255 << this.r4f_1;
    this.t4f_1 = ~this.s4f_1;
  }
  function BitmapChannel_RED_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_RED_instance;
  }
  function BitmapChannel_GREEN_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_GREEN_instance;
  }
  function BitmapChannel_BLUE_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_BLUE_instance;
  }
  function BitmapChannel_ALPHA_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_ALPHA_instance;
  }
  function BitmapIndexed(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_getInstance_27().g4i(1 << bpp) : palette;
    Bitmap.call(this, width, height, bpp, false, bytes);
    this.i4g_1 = bytes;
    this.j4g_1 = palette;
    if (this.i4g_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException_init_$Create$('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + this.p4g().length + '), area=' + imul(width, height));
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    tmp$ret$0 = Math.max(width, height);
    tmp.k4g_1 = new Int8Array(tmp$ret$0);
    this.l4g_1 = _UByteArrayInt___init__impl__xif7bu(this.p4g());
    this.m4g_1 = 8 / bpp | 0;
    this.n4g_1 = ilog2(this.m4g_1);
    this.o4g_1 = this.m4g_1 - 1 | 0;
  }
  protoOf(BitmapIndexed).p4g = function () {
    return this.i4g_1;
  };
  protoOf(BitmapIndexed).toString = function () {
    return 'BitmapIndexed(bpp=' + this.t46_1 + ', width=' + this.r46_1 + ', height=' + this.s46_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.j4g_1) + ')';
  };
  protoOf(BitmapIndexed).c4e = function (x, y) {
    return this.c4j(this.c48(x, y));
  };
  protoOf(BitmapIndexed).b4e = function (x, y, color) {
    return this.b4j(this.c48(x, y), color);
  };
  protoOf(BitmapIndexed).c4j = function (n) {
    var iD = this.e4j(n);
    var iM = this.f4j(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.l4g_1, iD), imul(this.t46_1, iM), this.t46_1);
  };
  protoOf(BitmapIndexed).b4j = function (n, color) {
    var iD = this.e4j(n);
    var iM = this.f4j(n);
    UByteArrayInt__set_impl_gn4532(this.l4g_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.l4g_1, iD), color, imul(this.t46_1, iM), this.t46_1));
  };
  protoOf(BitmapIndexed).f48 = function (x, y) {
    var tmp = this.j4g_1;
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    tmp$ret$0 = this.c4e(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  };
  protoOf(BitmapIndexed).d4j = function (x, y) {
    return this.e4j(this.c48(x, y));
  };
  protoOf(BitmapIndexed).e4j = function (n) {
    return n >>> this.n4g_1 | 0;
  };
  protoOf(BitmapIndexed).f4j = function (n) {
    return n & this.o4g_1;
  };
  protoOf(BitmapIndexed).u4e = function (y0, y1) {
    var s0 = this.d4j(0, y0);
    var s1 = this.d4j(0, y1);
    arraycopy_0(this.p4g(), s0, this.k4g_1, 0, this.b48());
    arraycopy_0(this.p4g(), s1, this.p4g(), s0, this.b48());
    arraycopy_0(this.k4g_1, 0, this.p4g(), s1, this.b48());
  };
  protoOf(BitmapIndexed).g4j = function (x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.p4g(), this.c48(x, y), width / this.m4g_1 | 0);
    } else {
      var m = this.c48(x, y);
      var inductionVariable = 0;
      var last = width / this.m4g_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.p4g()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  };
  protoOf(BitmapIndexed).e47 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new Bitmap32(this.r46_1, this.s46_1, VOID, this.y46_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = tmp0_also.t47_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.j4g_1);
    var inductionVariable = 0;
    var last = this.a3t();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.c4j(n)];
      }
       while (inductionVariable < last);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  };
  function get_bounds_0(_this__u8e3s4) {
    return _this__u8e3s4.k3r_1;
  }
  function get_bmp(_this__u8e3s4) {
    return get_container(_this__u8e3s4);
  }
  function get_container(_this__u8e3s4) {
    return _this__u8e3s4.l3s();
  }
  function slice(_this__u8e3s4, bounds, name, orientation, padding) {
    bounds = bounds === VOID ? _RectangleInt___init__impl__1g5gox(0, 0, _this__u8e3s4.r46_1, _this__u8e3s4.s46_1) : bounds;
    name = name === VOID ? null : name;
    orientation = orientation === VOID ? Companion_getInstance().a3r_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_4().t3f_1 : padding;
    var left = clamp(_RectangleInt___get_left__impl__rhzld(bounds), 0, _this__u8e3s4.r46_1);
    var top = clamp(_RectangleInt___get_top__impl__ie2ifj(bounds), 0, _this__u8e3s4.s46_1);
    return new RectSlice(_this__u8e3s4, Companion_getInstance_2().w3i(left, top, clamp(_RectangleInt___get_right__impl__9c8zzq(bounds), left, _this__u8e3s4.r46_1), clamp(_RectangleInt___get_bottom__impl__za67bh(bounds), top, _this__u8e3s4.s46_1)), orientation, padding, name);
  }
  function extract_0(_this__u8e3s4) {
    var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.l3r_1) ? _RectangleInt___get_width__impl__gtay8w(_this__u8e3s4.k3r_1) : _RectangleInt___get_height__impl__gd473j(_this__u8e3s4.k3r_1);
    var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.l3r_1) ? _RectangleInt___get_height__impl__gd473j(_this__u8e3s4.k3r_1) : _RectangleInt___get_width__impl__gtay8w(_this__u8e3s4.k3r_1);
    var tmp = get_container(_this__u8e3s4).a4f(w + _MarginInt___get_leftPlusRight__impl__bp8ljy(_this__u8e3s4.m3r_1) | 0, h + _MarginInt___get_topPlusBottom__impl__i58c3h(_this__u8e3s4.m3r_1) | 0);
    var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
    var raw = extractUntransformed(_this__u8e3s4).z4e(_this__u8e3s4.l3r_1);
    raw.n4e(0, 0, out, _MarginInt___get_left__impl__786btm(_this__u8e3s4.m3r_1), _MarginInt___get_top__impl__9baalk(_this__u8e3s4.m3r_1), raw.r46_1, raw.s46_1);
    return out;
  }
  function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
    name = name === VOID ? null : name;
    orientation = orientation === VOID ? Companion_getInstance().a3r_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_4().t3f_1 : padding;
    return slice(_this__u8e3s4, _RectangleInt___init__impl__1g5gox(x, y, width, height), name, orientation, padding);
  }
  function extractUntransformed(_this__u8e3s4) {
    var tmp = get_container(_this__u8e3s4).a4f(_RectangleInt___get_width__impl__gtay8w(_this__u8e3s4.k3r_1), _RectangleInt___get_height__impl__gd473j(_this__u8e3s4.k3r_1));
    var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
    get_container(_this__u8e3s4).k4e(_RectangleInt___get_x__impl__6tm2y6(_this__u8e3s4.k3r_1), _RectangleInt___get_y__impl__zdvhyr(_this__u8e3s4.k3r_1), out, 0, 0, _RectangleInt___get_width__impl__gtay8w(_this__u8e3s4.k3r_1), _RectangleInt___get_height__impl__gd473j(_this__u8e3s4.k3r_1));
    return out;
  }
  function get_Bitmaps_transparent() {
    _init_properties_Bitmaps_kt__92w93i();
    return Bitmaps_transparent;
  }
  var Bitmaps_transparent;
  function get_Bitmaps_white() {
    _init_properties_Bitmaps_kt__92w93i();
    return Bitmaps_white;
  }
  var Bitmaps_white;
  function Bitmaps() {
    Bitmaps_instance = this;
  }
  var Bitmaps_instance;
  function Bitmaps_getInstance() {
    if (Bitmaps_instance == null)
      new Bitmaps();
    return Bitmaps_instance;
  }
  var properties_initialized_Bitmaps_kt_qcuk18;
  function _init_properties_Bitmaps_kt__92w93i() {
    if (properties_initialized_Bitmaps_kt_qcuk18) {
    } else {
      properties_initialized_Bitmaps_kt_qcuk18 = true;
      Bitmaps_transparent = slice(Companion_getInstance_21().l4f(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().o48_1)), VOID, 'transparent');
      Bitmaps_white = slice(Companion_getInstance_21().l4f(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().j48_1)), VOID, 'white');
    }
  }
  function Companion_4() {
    Companion_instance_4 = this;
    this.i4j_1 = 1.0;
    this.j4j_1 = 1.4142135;
  }
  var Companion_instance_4;
  function Companion_getInstance_24() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
    return _this__u8e3s4.q4e(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.f48(x, y)) >= min : false;
  }
  function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
    if (this$0.u4j(x + dx | 0, y + dy | 0) + d < this$0.u4j(x, y)) {
      this$0.q4j(x, y, x + dx | 0, y + dy | 0);
      var tmp$ret$0;
      // Inline function 'kotlin.math.hypot' call
      var tmp0_hypot = x - this$0.r4j(x, y) | 0;
      var tmp1_hypot = y - this$0.s4j(x, y) | 0;
      tmp$ret$0 = hypot(tmp0_hypot, tmp1_hypot);
      this$0.t4j(x, y, tmp$ret$0);
    }
  }
  function DistanceBitmap(width, height, d, px, py) {
    Companion_getInstance_24();
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.k4j_1 = width;
    this.l4j_1 = height;
    this.m4j_1 = d;
    this.n4j_1 = px;
    this.o4j_1 = py;
    this.p4j_1 = imul(this.k4j_1, this.l4j_1);
    // Inline function 'korlibs.io.lang.assert' call
    var tmp0_assert = this.m4j_1.length >= this.p4j_1;
    if (!tmp0_assert)
      throw AssertionError_init_$Create$();
    // Inline function 'korlibs.io.lang.assert' call
    var tmp1_assert = this.n4j_1.length >= this.p4j_1;
    if (!tmp1_assert)
      throw AssertionError_init_$Create$();
    // Inline function 'korlibs.io.lang.assert' call
    var tmp2_assert = this.o4j_1.length >= this.p4j_1;
    if (!tmp2_assert)
      throw AssertionError_init_$Create$();
  }
  protoOf(DistanceBitmap).o4e = function (x) {
    return x >= 0 ? x < this.k4j_1 : false;
  };
  protoOf(DistanceBitmap).p4e = function (y) {
    return y >= 0 ? y < this.l4j_1 : false;
  };
  protoOf(DistanceBitmap).q4e = function (x, y) {
    return this.o4e(x) ? this.p4e(y) : false;
  };
  protoOf(DistanceBitmap).c48 = function (x, y) {
    return imul(y, this.k4j_1) + x | 0;
  };
  protoOf(DistanceBitmap).u4j = function (x, y) {
    var tmp;
    if (this.q4e(x, y)) {
      tmp = this.m4j_1[this.c48(x, y)];
    } else {
      FloatCompanionObject_getInstance();
      tmp = Infinity;
    }
    return tmp;
  };
  protoOf(DistanceBitmap).r4j = function (x, y) {
    return this.q4e(x, y) ? this.n4j_1[this.c48(x, y)] : -1;
  };
  protoOf(DistanceBitmap).s4j = function (x, y) {
    return this.q4e(x, y) ? this.o4j_1[this.c48(x, y)] : -1;
  };
  protoOf(DistanceBitmap).t4j = function (x, y, d) {
    if (!this.q4e(x, y))
      return Unit_getInstance();
    this.m4j_1[this.c48(x, y)] = d;
  };
  protoOf(DistanceBitmap).v4j = function (x, y, px, py) {
    if (!this.q4e(x, y))
      return Unit_getInstance();
    var index = this.c48(x, y);
    this.n4j_1[index] = px;
    this.o4j_1[index] = py;
  };
  protoOf(DistanceBitmap).q4j = function (x, y, px, py) {
    return this.v4j(x, y, this.r4j(px, py), this.s4j(px, py));
  };
  protoOf(DistanceBitmap).w4j = function (bmp, thresold) {
    // Inline function 'korlibs.io.lang.assert' call
    var tmp0_assert = this.k4j_1 === bmp.r46_1;
    if (!tmp0_assert)
      throw AssertionError_init_$Create$();
    // Inline function 'korlibs.io.lang.assert' call
    var tmp1_assert = this.l4j_1 === bmp.s46_1;
    if (!tmp1_assert)
      throw AssertionError_init_$Create$();
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.l4j_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.k4j_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            FloatCompanionObject_getInstance();
            this.t4j(x, y, Infinity);
            this.v4j(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.l4j_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.k4j_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (((!(left === cur) ? true : !(right === cur)) ? true : !(up === cur)) ? true : !(down === cur)) {
              this.t4j(x_0, y_0, 0.0);
              this.v4j(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.l4j_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.k4j_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            Companion_getInstance_24();
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            Companion_getInstance_24();
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            Companion_getInstance_24();
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            Companion_getInstance_24();
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.l4j_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.k4j_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            Companion_getInstance_24();
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            Companion_getInstance_24();
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            Companion_getInstance_24();
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            Companion_getInstance_24();
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.l4j_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.k4j_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.t4j(x_3, y_3, -this.u4j(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  };
  function distanceMap(_this__u8e3s4, out, thresold) {
    out = out === VOID ? new DistanceBitmap(_this__u8e3s4.r46_1, _this__u8e3s4.s46_1) : out;
    thresold = thresold === VOID ? 0.5 : thresold;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
    out.w4j(_this__u8e3s4, thresold);
    tmp$ret$0 = out;
    return tmp$ret$0;
  }
  function index4($this, x, y) {
    return imul($this.c48(x, y), 4);
  }
  function FloatBitmap32(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    Bitmap.call(this, width, height, 32, premultiplied, data);
    this.k4k_1 = data;
  }
  protoOf(FloatBitmap32).h48 = function (x, y, v) {
    var rindex = index4(this, x, y);
    this.k4k_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.k4k_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.k4k_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.k4k_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  };
  protoOf(FloatBitmap32).f48 = function (x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_28().l4k(this.k4k_1[rindex + 0 | 0], this.k4k_1[rindex + 1 | 0], this.k4k_1[rindex + 2 | 0], this.k4k_1[rindex + 3 | 0]);
  };
  protoOf(FloatBitmap32).m4k = function (x, y) {
    return this.k4k_1[index4(this, x, y) + 0 | 0];
  };
  protoOf(FloatBitmap32).n4k = function (x, y) {
    return this.k4k_1[index4(this, x, y) + 1 | 0];
  };
  protoOf(FloatBitmap32).o4k = function (x, y) {
    return this.k4k_1[index4(this, x, y) + 2 | 0];
  };
  protoOf(FloatBitmap32).p4k = function (x, y) {
    return this.k4k_1[index4(this, x, y) + 3 | 0];
  };
  protoOf(FloatBitmap32).q4k = function (x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.k4k_1[rindex + 0 | 0] = r;
    this.k4k_1[rindex + 1 | 0] = g;
    this.k4k_1[rindex + 2 | 0] = b;
    this.k4k_1[rindex + 3 | 0] = a;
  };
  protoOf(FloatBitmap32).r4k = function (x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.k4k_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.k4k_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.k4k_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.k4k_1[rindex + 3 | 0]);
    return out;
  };
  protoOf(FloatBitmap32).s4k = function (out) {
    FloatCompanionObject_getInstance();
    var min_0 = Infinity;
    FloatCompanionObject_getInstance();
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var tmp0_forEach = this.r46_1 - 0 | 0;
    var tmp1_forEach = this.s46_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + tmp1_forEach | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.c48(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + tmp0_forEach | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            var tmp2__anonymous__z9zvc9 = tmp2;
            var c = this.r4k(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  };
  protoOf(FloatBitmap32).t4k = function (out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.s4k(out) : $super.s4k.call(this, out);
  };
  protoOf(FloatBitmap32).u4k = function (minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var tmp0_forEach = this.r46_1 - 0 | 0;
    var tmp1_forEach = this.s46_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + tmp1_forEach | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.c48(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + tmp0_forEach | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            var tmp2__anonymous__z9zvc9 = tmp2;
            var rgbaf = this.r4k(x, y, out);
            this.q4k(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  };
  protoOf(FloatBitmap32).v4k = function (minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.u4k(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.u4k.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  };
  protoOf(FloatBitmap32).w4k = function () {
    var tmp0_container = this.t4k();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.component1' call
    tmp$ret$0 = tmp0_container[0];
    var min = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.component2' call
    tmp$ret$1 = tmp0_container[1];
    var max = tmp$ret$1;
    var tmp$ret$4;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$2;
    // Inline function 'kotlin.math.absoluteValue' call
    tmp$ret$2 = Math.abs(min);
    var tmp0_max = tmp$ret$2;
    var tmp$ret$3;
    // Inline function 'kotlin.math.absoluteValue' call
    tmp$ret$3 = Math.abs(max);
    var tmp1_max = tmp$ret$3;
    tmp$ret$4 = Math.max(tmp0_max, tmp1_max);
    var range = tmp$ret$4;
    this.v4k(-range, +range);
  };
  protoOf(FloatBitmap32).x4k = function (scale) {
    return this.y4k(scale, scale, scale, scale);
  };
  protoOf(FloatBitmap32).y4k = function (scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var tmp0_forEach = this.r46_1 - 0 | 0;
    var tmp1_forEach = this.s46_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + tmp1_forEach | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.c48(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + tmp0_forEach | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            var tmp2__anonymous__z9zvc9 = tmp2;
            this.q4k(x, y, this.m4k(x, y) * scaleRed, this.n4k(x, y) * scaleGreen, this.o4k(x, y) * scaleBlue, this.p4k(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  };
  protoOf(FloatBitmap32).z4k = function (min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var tmp0_forEach = this.r46_1 - 0 | 0;
    var tmp1_forEach = this.s46_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + tmp1_forEach | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.c48(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + tmp0_forEach | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            var tmp2__anonymous__z9zvc9 = tmp2;
            var tmp$ret$0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var tmp3__anonymous__ufb84q = this.m4k(x, y);
            tmp$ret$0 = clamp_0(tmp3__anonymous__ufb84q, min, max);
            var tmp = tmp$ret$0;
            var tmp$ret$1;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var tmp4__anonymous__pkmkx7 = this.n4k(x, y);
            tmp$ret$1 = clamp_0(tmp4__anonymous__pkmkx7, min, max);
            var tmp_0 = tmp$ret$1;
            var tmp$ret$2;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var tmp5__anonymous__kpxxpo = this.o4k(x, y);
            tmp$ret$2 = clamp_0(tmp5__anonymous__kpxxpo, min, max);
            var tmp_1 = tmp$ret$2;
            var tmp$ret$3;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var tmp6__anonymous__fv9ai5 = this.p4k(x, y);
            tmp$ret$3 = clamp_0(tmp6__anonymous__fv9ai5, min, max);
            this.q4k(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  };
  function MultiBitmap() {
  }
  function NativeImageOrBitmap32(width, height, native, premultiplied) {
    native = native === VOID ? true : native;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    var tmp;
    if (native) {
      tmp = NativeImage_0(width, height, premultiplied);
    } else {
      var tmp0_elvis_lhs = premultiplied;
      tmp = new Bitmap32(width, height, VOID, tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
    }
    return tmp;
  }
  function NativeImage(width, height, data, premultiplied) {
    Bitmap.call(this, width, height, 32, premultiplied, null);
    this.n4l_1 = data;
  }
  protoOf(NativeImage).e47 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = Companion_getInstance_21().m4f(this.r46_1, this.s46_1, this.y46_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.e48(0, 0, this.r46_1, this.s46_1, tmp0_also.t47_1, 0);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  };
  protoOf(NativeImage).h48 = function (x, y, v) {
    RgbaArray__set_impl_epw2wg(this.a48(), 0, v);
    this.g48(x, y, 1, 1, this.z47(), 0);
  };
  protoOf(NativeImage).f48 = function (x, y) {
    this.e48(x, y, 1, 1, this.z47(), 0);
    return RgbaArray__get_impl_nzyo1o(this.a48(), 0);
  };
  protoOf(NativeImage).b4e = function (x, y, color) {
    return this.h48(x, y, _RGBA___init__impl__lqpay5(color));
  };
  protoOf(NativeImage).c4e = function (x, y) {
    return _RGBA___get_value__impl__hhco8v(this.f48(x, y));
  };
  protoOf(NativeImage).t4e = function () {
    var tmp = this.e47().t4e();
    this.i48(0, 0, this.r46_1, this.s46_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).t47_1);
    return this;
  };
  protoOf(NativeImage).v4e = function () {
    var tmp = this.e47().v4e();
    this.i48(0, 0, this.r46_1, this.s46_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).t47_1);
    return this;
  };
  protoOf(NativeImage).u4e = function (y0, y1) {
    this.e48(0, y0, this.r46_1, 1, this.z47(), 0);
    this.e48(0, y1, this.r46_1, 1, this.z47(), this.r46_1);
    this.g48(0, y1, this.r46_1, 1, this.z47(), 0);
    this.g48(0, y0, this.r46_1, 1, this.z47(), this.r46_1);
  };
  protoOf(NativeImage).w4e = function (x0, x1) {
    this.e48(x0, 0, 1, this.s46_1, this.z47(), 0);
    this.e48(x1, 0, 1, this.s46_1, this.z47(), this.r46_1);
    this.g48(x1, 0, 1, this.s46_1, this.z47(), 0);
    this.g48(x0, 0, 1, this.s46_1, this.z47(), this.r46_1);
  };
  protoOf(NativeImage).a4f = function (width, height) {
    return NativeImage_0(width, height);
  };
  protoOf(NativeImage).toString = function () {
    return this.qg() + '(' + this.r46_1 + ', ' + this.s46_1 + ')';
  };
  function ensureNative(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp;
    if (tmp0_subject instanceof NativeImage) {
      tmp = _this__u8e3s4;
    } else {
      tmp = get_nativeImageFormatProvider().o4l(_this__u8e3s4);
    }
    return tmp;
  }
  function NativeImage_0(width, height, premultiplied) {
    premultiplied = premultiplied === VOID ? null : premultiplied;
    return get_nativeImageFormatProvider().p4l(width, height, premultiplied);
  }
  function Companion_5() {
    Companion_instance_5 = this;
    this.q4l_1 = 3553;
    this.r4l_1 = 36197;
  }
  var Companion_instance_5;
  function Companion_getInstance_25() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function ForcedTexId() {
  }
  function NullBitmap(width, height, premultiplied) {
    premultiplied = premultiplied === VOID ? true : premultiplied;
    Bitmap.call(this, width, height, 32, premultiplied, null);
  }
  function Palette(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.t4l_1 = colors;
    this.u4l_1 = names;
    this.v4l_1 = changeStart;
    this.w4l_1 = changeEnd;
  }
  protoOf(Palette).toString = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    tmp0_apply.ve('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.t4l_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.t4l_1, n);
        var tmp1_safe_receiver = this.u4l_1;
        var name = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[n];
        if (n > 0) {
          tmp0_apply.ve(', ');
        }
        if (!(name == null)) {
          tmp0_apply.ve(name);
          tmp0_apply.ve(': ');
        }
        tmp0_apply.ve(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    tmp0_apply.ve(')');
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  function applyEffect(_this__u8e3s4, effect) {
    var safeBorder = get_safeBorder(effect);
    var out = Companion_getInstance_21().m4f(_this__u8e3s4.r46_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.s46_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.y46_1);
    out.t4h(_this__u8e3s4, safeBorder, safeBorder);
    applyEffectInline(out, effect);
    return out;
  }
  function get_safeBorder(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e4m();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  function applyEffectInline(_this__u8e3s4, effect) {
    if (effect == null)
      return Unit_getInstance();
    if (!(effect.x4l_1 === 0)) {
      blurInplace(_this__u8e3s4, effect.x4l_1);
    }
    if ((!(effect.a4m_1 === 0) ? true : !(effect.y4l_1 === 0)) ? true : !(effect.z4l_1 === 0)) {
      dropShadowInplace(_this__u8e3s4, effect.y4l_1, effect.z4l_1, effect.a4m_1, effect.b4m_1);
    }
    if (!(effect.c4m_1 === 0)) {
      borderInline(_this__u8e3s4, effect.c4m_1, effect.d4m_1);
    }
  }
  function blurInplace(_this__u8e3s4, r) {
    var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.r46_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.s46_1 / 2 | 0) - 1 | 0);
    var t1 = new Bitmap8(_this__u8e3s4.r46_1, _this__u8e3s4.s46_1);
    var t2 = new Bitmap8(_this__u8e3s4.r46_1, _this__u8e3s4.s46_1);
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var channel = Companion_getInstance_23().k(n);
        _this__u8e3s4.x4h(channel, t1);
        arraycopy_0(t1.p4g(), 0, t2.p4g(), 0, t2.a3t());
        gaussBlur(t1.p4g(), t2.p4g(), _this__u8e3s4.r46_1, _this__u8e3s4.s46_1, r_0);
        _this__u8e3s4.w4h(channel, t2);
      }
       while (inductionVariable < 4);
  }
  function gaussBlur(scl, tcl, w, h, r) {
    var a = 0;
    var b = 0;
    var c = 0;
    // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
    var n = 3;
    var tmp$ret$0;
    // Inline function 'kotlin.math.sqrt' call
    var tmp0_sqrt = 12.0 * r * r / n + 1;
    tmp$ret$0 = Math.sqrt(tmp0_sqrt);
    var wIdeal = tmp$ret$0;
    var wl = toIntFloor_0(wIdeal);
    if ((wl % 2 | 0) === 0) {
      var tmp0 = wl;
      wl = tmp0 - 1 | 0;
    }
    var wu = wl + 2 | 0;
    var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
    var m = round(mIdeal);
    // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
    var tmp1__anonymous__uwfjfc = 0.0 < m ? wl : wu;
    var tmp2__anonymous__z9zvc9 = 1.0 < m ? wl : wu;
    var tmp3__anonymous__ufb84q = 2.0 < m ? wl : wu;
    a = tmp1__anonymous__uwfjfc;
    b = tmp2__anonymous__z9zvc9;
    c = tmp3__anonymous__ufb84q;
    boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
    boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
    boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
  }
  function boxBlur(scl, tcl, w, h, r) {
    arraycopy_0(scl, 0, tcl, 0, scl.length);
    boxBlurH(tcl, scl, w, h, r);
    boxBlurT(scl, tcl, w, h, r);
  }
  function boxBlurH(scl, tcl, w, h, r) {
    var arr = (r + r | 0) + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < h)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ti = imul(i, w);
        var li = ti;
        var ri = ti + r | 0;
        var fv = readU8(scl, ti);
        var lv = readU8(scl, (ti + w | 0) - 1 | 0);
        var v = imul(r + 1 | 0, fv);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < r)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            v = v + readU8(scl, ti + j | 0) | 0;
          }
           while (inductionVariable_0 < r);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= r)
          do {
            var j_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp = v;
            var tmp3 = ri;
            ri = tmp3 + 1 | 0;
            v = tmp + (readU8(scl, tmp3) - fv | 0) | 0;
            var tmp4 = ti;
            ti = tmp4 + 1 | 0;
            tcl[tmp4] = toByte(v / arr | 0);
          }
           while (!(j_0 === r));
        var inductionVariable_2 = r + 1 | 0;
        var last = w - r | 0;
        if (inductionVariable_2 < last)
          do {
            var j_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var tmp_0 = v;
            var tmp7 = ri;
            ri = tmp7 + 1 | 0;
            var tmp_1 = readU8(scl, tmp7);
            var tmp6 = li;
            li = tmp6 + 1 | 0;
            v = tmp_0 + (tmp_1 - readU8(scl, tmp6) | 0) | 0;
            var tmp8 = ti;
            ti = tmp8 + 1 | 0;
            tcl[tmp8] = toByte(v / arr | 0);
          }
           while (inductionVariable_2 < last);
        var inductionVariable_3 = w - r | 0;
        if (inductionVariable_3 < w)
          do {
            var j_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var tmp_2 = v;
            var tmp10 = li;
            li = tmp10 + 1 | 0;
            v = tmp_2 + (lv - readU8(scl, tmp10) | 0) | 0;
            var tmp11 = ti;
            ti = tmp11 + 1 | 0;
            tcl[tmp11] = toByte(v / arr | 0);
          }
           while (inductionVariable_3 < w);
      }
       while (inductionVariable < h);
  }
  function boxBlurT(scl, tcl, w, h, r) {
    var arr = (r + r | 0) + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < w)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ti = i;
        var li = ti;
        var ri = ti + imul(r, w) | 0;
        var fv = readU8(scl, ti);
        var lv = readU8(scl, ti + imul(w, h - 1 | 0) | 0);
        var v = imul(r + 1 | 0, fv);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < r)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            v = v + readU8(scl, ti + imul(j, w) | 0) | 0;
          }
           while (inductionVariable_0 < r);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= r)
          do {
            var j_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            v = v + (readU8(scl, ri) - fv | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            ri = ri + w | 0;
            ti = ti + w | 0;
          }
           while (!(j_0 === r));
        var inductionVariable_2 = r + 1 | 0;
        var last = h - r | 0;
        if (inductionVariable_2 < last)
          do {
            var j_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            v = v + (readU8(scl, ri) - readU8(scl, li) | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            li = li + w | 0;
            ri = ri + w | 0;
            ti = ti + w | 0;
          }
           while (inductionVariable_2 < last);
        var inductionVariable_3 = h - r | 0;
        if (inductionVariable_3 < h)
          do {
            var j_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            v = v + (lv - readU8(scl, li) | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            li = li + w | 0;
            ti = ti + w | 0;
          }
           while (inductionVariable_3 < h);
      }
       while (inductionVariable < w);
  }
  function blur(_this__u8e3s4, r) {
    var out = new Bitmap8(_this__u8e3s4.r46_1 + imul(r, 2) | 0, _this__u8e3s4.s46_1 + imul(r, 2) | 0);
    Companion_getInstance_22().f4i(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.r46_1, _this__u8e3s4.s46_1);
    blurInplace_0(out, r);
    return out;
  }
  function blurInplace_0(_this__u8e3s4, r) {
    var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.r46_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.s46_1 / 2 | 0) - 1 | 0);
    var t2 = new Bitmap8(_this__u8e3s4.r46_1, _this__u8e3s4.s46_1);
    arraycopy_0(_this__u8e3s4.p4g(), 0, t2.p4g(), 0, _this__u8e3s4.a3t());
    gaussBlur(t2.p4g(), _this__u8e3s4.p4g(), _this__u8e3s4.r46_1, _this__u8e3s4.s46_1, r_0);
  }
  function borderInline(_this__u8e3s4, r, color) {
    color = color === VOID ? Colors_getInstance().k48_1 : color;
    var out = _this__u8e3s4;
    var distance = distanceMap(out);
    var inductionVariable = 0;
    var last = out.s46_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = out.r46_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var dist = distance.u4j(x, y);
            if (dist < (r + 1 | 0)) {
              var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
              var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
              out.g4h(x, y, Companion_getInstance_28().f4m(rcolor, out.i4h(x, y)));
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
    color = color === VOID ? Colors_getInstance().k48_1 : color;
    var tmp$ret$1;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
    var copy = _this__u8e3s4.dn();
    var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = blur(_this__u8e3s4.y4h(BitmapChannel_ALPHA_getInstance()), r);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
    tmp0_also.y46_1 = true;
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__set_impl_epw2wg(tmp0_also.j4g_1, n, Companion_getInstance_28().g4m(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
      }
       while (inductionVariable < 256);
    tmp$ret$0 = tmp0_also;
    var shadow = tmp$ret$0.e47();
    _this__u8e3s4.r4h(Colors_getInstance().o48_1);
    _this__u8e3s4.u4h(shadow, x - r | 0, y - r | 0);
    _this__u8e3s4.u4h(copy, 0, 0);
    tmp$ret$1 = _this__u8e3s4;
    return tmp$ret$1;
  }
  function Result(bmp, buffer, radius, cutoff) {
    this.h4m_1 = bmp;
    this.i4m_1 = buffer;
    this.j4m_1 = radius;
    this.k4m_1 = cutoff;
  }
  protoOf(Result).toString = function () {
    return 'Result(bmp=' + this.h4m_1 + ', buffer=' + this.i4m_1 + ', radius=' + this.j4m_1 + ', cutoff=' + this.k4m_1 + ')';
  };
  protoOf(Result).hashCode = function () {
    var result = hashCode(this.h4m_1);
    result = imul(result, 31) + this.i4m_1 | 0;
    result = imul(result, 31) + this.j4m_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.k4m_1) | 0;
    return result;
  };
  protoOf(Result).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.h4m_1, tmp0_other_with_cast.h4m_1))
      return false;
    if (!(this.i4m_1 === tmp0_other_with_cast.i4m_1))
      return false;
    if (!(this.j4m_1 === tmp0_other_with_cast.j4m_1))
      return false;
    if (!equals(this.k4m_1, tmp0_other_with_cast.k4m_1))
      return false;
    return true;
  };
  function NewSDF() {
    NewSDF_instance = this;
    this.l4m_1 = 1.0E10;
  }
  protoOf(NewSDF).m4m = function (bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = new Bitmap32(bmp.r46_1 + imul(buffer, 2) | 0, bmp.s46_1 + imul(buffer, 2) | 0);
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var tmp0_invoke = Companion_getInstance_5();
    var tmp1_invoke = out.r46_1;
    var tmp2_invoke = out.s46_1;
    var tmp3_invoke = 1.0E10;
    var tmp = 0;
    var tmp_0 = imul(tmp1_invoke, tmp2_invoke);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.Companion.invoke.<anonymous>' call
      tmp$ret$1 = tmp3_invoke;
      tmp_1[tmp_2] = tmp$ret$1;
      tmp = tmp + 1 | 0;
    }
    var tmp_3 = tmp_1;
    tmp$ret$2 = new FloatArray2(tmp1_invoke, tmp2_invoke, isFloatArray(tmp_3) ? tmp_3 : THROW_CCE());
    var gridOuter = tmp$ret$2;
    var tmp$ret$4;
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var tmp4_invoke = Companion_getInstance_5();
    var tmp5_invoke = out.r46_1;
    var tmp6_invoke = out.s46_1;
    var tmp_4 = 0;
    var tmp_5 = imul(tmp5_invoke, tmp6_invoke);
    var tmp_6 = new Float32Array(tmp_5);
    while (tmp_4 < tmp_5) {
      var tmp_7 = tmp_4;
      var tmp$ret$3;
      // Inline function 'korlibs.datastructure.Companion.invoke.<anonymous>' call
      tmp$ret$3 = 0.0;
      tmp_6[tmp_7] = tmp$ret$3;
      tmp_4 = tmp_4 + 1 | 0;
    }
    var tmp_8 = tmp_6;
    tmp$ret$4 = new FloatArray2(tmp5_invoke, tmp6_invoke, isFloatArray(tmp_8) ? tmp_8 : THROW_CCE());
    var gridInner = tmp$ret$4;
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.s46_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.r46_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.i4h(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            var tmp2_subject = a;
            switch (tmp2_subject) {
              case 0.0:
                gridOuter.mk(x0, y0, 1.0E10);
                gridInner.mk(x0, y0, 0.0);
                ;
                break;
              case 1.0:
                gridOuter.mk(x0, y0, 0.0);
                gridInner.mk(x0, y0, 1.0E10);
                ;
                break;
              default:
                var d = 0.5 - a;
                gridOuter.mk(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.mk(x0, y0, d < 0.0 ? d * d : 0.0);
                ;
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.n4m(gridOuter.lk_1, 0, 0, out.r46_1, out.s46_1, gridOuter.jk_1, f, v, z);
    this.n4m(gridInner.lk_1, buffer, buffer, bmp.r46_1, bmp.s46_1, gridInner.jk_1, f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.s46_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.r46_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.fk(x_0, y_0);
            var gin = gridInner.fk(x_0, y_0);
            var tmp$ret$5;
            // Inline function 'kotlin.math.sqrt' call
            tmp$ret$5 = Math.sqrt(gout);
            var tmp_9 = tmp$ret$5;
            var tmp$ret$6;
            // Inline function 'kotlin.math.sqrt' call
            tmp$ret$6 = Math.sqrt(gin);
            var d_0 = tmp_9 - tmp$ret$6;
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.g4h(x_0, y_0, Companion_getInstance_28().g4m(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  };
  protoOf(NewSDF).o4m = function (bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.math.max' call
      var tmp0_max = bmp.r46_1;
      var tmp1_max = bmp.s46_1;
      tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.m4m(bmp, maxSide, buffer, radius, cutoff) : $super.m4m.call(this, bmp, maxSide, buffer, radius, cutoff);
  };
  protoOf(NewSDF).n4m = function (data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.p4m(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.p4m(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  };
  protoOf(NewSDF).p4m = function (grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        var tmp1 = k;
        k = tmp1 + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          var tmp3 = k;
          k = tmp3 + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  };
  var NewSDF_instance;
  function NewSDF_getInstance() {
    if (NewSDF_instance == null)
      new NewSDF();
    return NewSDF_instance;
  }
  function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
    littleEndian = littleEndian === VOID ? true : littleEndian;
    var tmp0_subject = _this__u8e3s4.q4m();
    var tmp;
    switch (tmp0_subject) {
      case 16:
        var tmp_0;
        if (littleEndian) {
          tmp_0 = readU16LE$ref();
        } else {
          tmp_0 = readU16BE$ref();
        }

        tmp = tmp_0;
        break;
      case 24:
        var tmp_1;
        if (littleEndian) {
          tmp_1 = readU24LE$ref();
        } else {
          tmp_1 = readU24BE$ref();
        }

        tmp = tmp_1;
        break;
      case 32:
        var tmp_2;
        if (littleEndian) {
          tmp_2 = readS32LE$ref();
        } else {
          tmp_2 = readS32BE$ref();
        }

        tmp = tmp_2;
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Unsupported bpp ' + _this__u8e3s4.q4m());
    }
    var readFunc = tmp;
    // Inline function 'korlibs.image.color.decodeInternal' call
    var io = dataOffset;
    var oo = outOffset;
    var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
    var outdata = out;
    var Bpp = numberToInt(bytesPerPixel);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = readFunc(data, io);
        io = io + Bpp | 0;
        var tmp1 = oo;
        oo = tmp1 + 1 | 0;
        RgbaArray__set_impl_epw2wg(outdata, tmp1, Companion_getInstance_28().g4m(_this__u8e3s4.r4m(c), _this__u8e3s4.s4m(c), _this__u8e3s4.t4m(c), _this__u8e3s4.u4m(c)));
      }
       while (inductionVariable < size);
  }
  function get_bytesPerPixel(_this__u8e3s4) {
    return _this__u8e3s4.q4m() / 8;
  }
  function ColorFormat32() {
    this.v4m_1 = 32;
  }
  protoOf(ColorFormat32).q4m = function () {
    return this.v4m_1;
  };
  function ColorFormat24() {
    this.w4m_1 = 24;
  }
  protoOf(ColorFormat24).q4m = function () {
    return this.w4m_1;
  };
  function readU16LE$ref() {
    var l = function (p0, p1) {
      return readU16LE(p0, p1);
    };
    l.callableName = 'readU16LE';
    return l;
  }
  function readU16BE$ref() {
    var l = function (p0, p1) {
      return readU16BE(p0, p1);
    };
    l.callableName = 'readU16BE';
    return l;
  }
  function readU24LE$ref() {
    var l = function (p0, p1) {
      return readU24LE(p0, p1);
    };
    l.callableName = 'readU24LE';
    return l;
  }
  function readU24BE$ref() {
    var l = function (p0, p1) {
      return readU24BE(p0, p1);
    };
    l.callableName = 'readU24BE';
    return l;
  }
  function readS32LE$ref() {
    var l = function (p0, p1) {
      return readS32LE(p0, p1);
    };
    l.callableName = 'readS32LE';
    return l;
  }
  function readS32BE$ref() {
    var l = function (p0, p1) {
      return readS32BE(p0, p1);
    };
    l.callableName = 'readS32BE';
    return l;
  }
  function ColorTransformMul(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.x4m_1 = _r;
    this.y4m_1 = _g;
    this.z4m_1 = _b;
    this.a4n_1 = _a;
    this.b4n_1 = true;
    this.c4n_1 = Colors_getInstance().j48_1;
  }
  protoOf(ColorTransformMul).d4n = function () {
    return this.x4m_1;
  };
  protoOf(ColorTransformMul).e4n = function () {
    return this.y4m_1;
  };
  protoOf(ColorTransformMul).f4n = function () {
    return this.z4m_1;
  };
  protoOf(ColorTransformMul).g4n = function (value) {
    this.a4n_1 = value;
    this.b4n_1 = true;
  };
  protoOf(ColorTransformMul).h4n = function () {
    return this.a4n_1;
  };
  protoOf(ColorTransformMul).i4n = function (v) {
    this.j4n(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.c4n_1 = v;
    this.b4n_1 = false;
  };
  protoOf(ColorTransformMul).k4n = function () {
    if (this.b4n_1) {
      this.b4n_1 = false;
      this.c4n_1 = Companion_getInstance_28().l4k(this.x4m_1, this.y4m_1, this.z4m_1, this.a4n_1);
    }
    return this.c4n_1;
  };
  protoOf(ColorTransformMul).j4n = function (r, g, b, a) {
    this.x4m_1 = r;
    this.y4m_1 = g;
    this.z4m_1 = b;
    this.a4n_1 = a;
    this.b4n_1 = true;
  };
  protoOf(ColorTransformMul).l4n = function (other) {
    return this.j4n(other.x4m_1, other.y4m_1, other.z4m_1, other.a4n_1);
  };
  protoOf(ColorTransformMul).m4n = function (a, b) {
    return this.j4n(a.d4n() * b.d4n(), a.e4n() * b.e4n(), a.f4n() * b.f4n(), a.h4n() * b.h4n());
  };
  protoOf(ColorTransformMul).toString = function () {
    return 'ColorTransformMul(_r=' + this.x4m_1 + ', _g=' + this.y4m_1 + ', _b=' + this.z4m_1 + ', _a=' + this.a4n_1 + ')';
  };
  protoOf(ColorTransformMul).hashCode = function () {
    var result = getNumberHashCode(this.x4m_1);
    result = imul(result, 31) + getNumberHashCode(this.y4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a4n_1) | 0;
    return result;
  };
  protoOf(ColorTransformMul).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.x4m_1, tmp0_other_with_cast.x4m_1))
      return false;
    if (!equals(this.y4m_1, tmp0_other_with_cast.y4m_1))
      return false;
    if (!equals(this.z4m_1, tmp0_other_with_cast.z4m_1))
      return false;
    if (!equals(this.a4n_1, tmp0_other_with_cast.a4n_1))
      return false;
    return true;
  };
  function Colors() {
    Colors_instance = this;
    this.j48_1 = Companion_getInstance_28().g4m(255, 255, 255, 255);
    this.k48_1 = Companion_getInstance_28().g4m(0, 0, 0, 255);
    this.l48_1 = Companion_getInstance_28().g4m(255, 0, 0, 255);
    this.m48_1 = Companion_getInstance_28().g4m(0, 255, 0, 255);
    this.n48_1 = Companion_getInstance_28().g4m(0, 0, 255, 255);
    this.o48_1 = Companion_getInstance_28().g4m(0, 0, 0, 0);
    this.p48_1 = Companion_getInstance_28().g4m(255, 255, 255, 0);
    this.q48_1 = Companion_getInstance_28().n4n(240, 248, 255);
    this.r48_1 = Companion_getInstance_28().n4n(250, 235, 215);
    this.s48_1 = Companion_getInstance_28().n4n(0, 255, 255);
    this.t48_1 = Companion_getInstance_28().n4n(127, 255, 212);
    this.u48_1 = Companion_getInstance_28().n4n(240, 255, 255);
    this.v48_1 = Companion_getInstance_28().n4n(245, 245, 220);
    this.w48_1 = Companion_getInstance_28().n4n(255, 228, 196);
    this.x48_1 = Companion_getInstance_28().n4n(255, 235, 205);
    this.y48_1 = Companion_getInstance_28().n4n(138, 43, 226);
    this.z48_1 = Companion_getInstance_28().n4n(165, 42, 42);
    this.a49_1 = Companion_getInstance_28().n4n(222, 184, 135);
    this.b49_1 = Companion_getInstance_28().n4n(95, 158, 160);
    this.c49_1 = Companion_getInstance_28().n4n(127, 255, 0);
    this.d49_1 = Companion_getInstance_28().n4n(210, 105, 30);
    this.e49_1 = Companion_getInstance_28().n4n(255, 127, 80);
    this.f49_1 = Companion_getInstance_28().n4n(100, 149, 237);
    this.g49_1 = Companion_getInstance_28().n4n(255, 248, 220);
    this.h49_1 = Companion_getInstance_28().n4n(220, 20, 60);
    this.i49_1 = Companion_getInstance_28().n4n(0, 0, 139);
    this.j49_1 = Companion_getInstance_28().n4n(0, 255, 255);
    this.k49_1 = Companion_getInstance_28().n4n(0, 139, 139);
    this.l49_1 = Companion_getInstance_28().n4n(184, 134, 11);
    this.m49_1 = Companion_getInstance_28().n4n(169, 169, 169);
    this.n49_1 = Companion_getInstance_28().n4n(0, 100, 0);
    this.o49_1 = Companion_getInstance_28().n4n(169, 169, 169);
    this.p49_1 = Companion_getInstance_28().n4n(189, 183, 107);
    this.q49_1 = Companion_getInstance_28().n4n(255, 0, 255);
    this.r49_1 = Companion_getInstance_28().n4n(139, 0, 139);
    this.s49_1 = Companion_getInstance_28().n4n(85, 107, 47);
    this.t49_1 = Companion_getInstance_28().n4n(255, 140, 0);
    this.u49_1 = Companion_getInstance_28().n4n(153, 50, 204);
    this.v49_1 = Companion_getInstance_28().n4n(139, 0, 0);
    this.w49_1 = Companion_getInstance_28().n4n(233, 150, 122);
    this.x49_1 = Companion_getInstance_28().n4n(143, 188, 143);
    this.y49_1 = Companion_getInstance_28().n4n(72, 61, 139);
    this.z49_1 = Companion_getInstance_28().n4n(47, 79, 79);
    this.a4a_1 = Companion_getInstance_28().n4n(47, 79, 79);
    this.b4a_1 = Companion_getInstance_28().n4n(0, 206, 209);
    this.c4a_1 = Companion_getInstance_28().n4n(148, 0, 211);
    this.d4a_1 = Companion_getInstance_28().n4n(255, 20, 147);
    this.e4a_1 = Companion_getInstance_28().n4n(0, 191, 255);
    this.f4a_1 = Companion_getInstance_28().n4n(105, 105, 105);
    this.g4a_1 = Companion_getInstance_28().n4n(105, 105, 105);
    this.h4a_1 = Companion_getInstance_28().n4n(30, 144, 255);
    this.i4a_1 = Companion_getInstance_28().n4n(178, 34, 34);
    this.j4a_1 = Companion_getInstance_28().n4n(255, 250, 240);
    this.k4a_1 = Companion_getInstance_28().n4n(34, 139, 34);
    this.l4a_1 = Companion_getInstance_28().n4n(255, 0, 255);
    this.m4a_1 = Companion_getInstance_28().n4n(220, 220, 220);
    this.n4a_1 = Companion_getInstance_28().n4n(248, 248, 255);
    this.o4a_1 = Companion_getInstance_28().n4n(255, 215, 0);
    this.p4a_1 = Companion_getInstance_28().n4n(218, 165, 32);
    this.q4a_1 = Companion_getInstance_28().n4n(173, 255, 47);
    this.r4a_1 = Companion_getInstance_28().n4n(240, 255, 240);
    this.s4a_1 = Companion_getInstance_28().n4n(255, 105, 180);
    this.t4a_1 = Companion_getInstance_28().n4n(205, 92, 92);
    this.u4a_1 = Companion_getInstance_28().n4n(75, 0, 130);
    this.v4a_1 = Companion_getInstance_28().n4n(255, 255, 240);
    this.w4a_1 = Companion_getInstance_28().n4n(240, 230, 140);
    this.x4a_1 = Companion_getInstance_28().n4n(230, 230, 250);
    this.y4a_1 = Companion_getInstance_28().n4n(255, 240, 245);
    this.z4a_1 = Companion_getInstance_28().n4n(124, 252, 0);
    this.a4b_1 = Companion_getInstance_28().n4n(255, 250, 205);
    this.b4b_1 = Companion_getInstance_28().n4n(173, 216, 230);
    this.c4b_1 = Companion_getInstance_28().n4n(240, 128, 128);
    this.d4b_1 = Companion_getInstance_28().n4n(224, 255, 255);
    this.e4b_1 = Companion_getInstance_28().n4n(250, 250, 210);
    this.f4b_1 = Companion_getInstance_28().n4n(211, 211, 211);
    this.g4b_1 = Companion_getInstance_28().n4n(144, 238, 144);
    this.h4b_1 = Companion_getInstance_28().n4n(211, 211, 211);
    this.i4b_1 = Companion_getInstance_28().n4n(255, 182, 193);
    this.j4b_1 = Companion_getInstance_28().n4n(255, 160, 122);
    this.k4b_1 = Companion_getInstance_28().n4n(32, 178, 170);
    this.l4b_1 = Companion_getInstance_28().n4n(135, 206, 250);
    this.m4b_1 = Companion_getInstance_28().n4n(119, 136, 153);
    this.n4b_1 = Companion_getInstance_28().n4n(119, 136, 153);
    this.o4b_1 = Companion_getInstance_28().n4n(176, 196, 222);
    this.p4b_1 = Companion_getInstance_28().n4n(255, 255, 224);
    this.q4b_1 = Companion_getInstance_28().n4n(0, 255, 0);
    this.r4b_1 = Companion_getInstance_28().n4n(50, 205, 50);
    this.s4b_1 = Companion_getInstance_28().n4n(250, 240, 230);
    this.t4b_1 = Companion_getInstance_28().n4n(128, 0, 0);
    this.u4b_1 = Companion_getInstance_28().n4n(102, 205, 170);
    this.v4b_1 = Companion_getInstance_28().n4n(0, 0, 205);
    this.w4b_1 = Companion_getInstance_28().n4n(186, 85, 211);
    this.x4b_1 = Companion_getInstance_28().n4n(147, 112, 219);
    this.y4b_1 = Companion_getInstance_28().n4n(60, 179, 113);
    this.z4b_1 = Companion_getInstance_28().n4n(123, 104, 238);
    this.a4c_1 = Companion_getInstance_28().n4n(0, 250, 154);
    this.b4c_1 = Companion_getInstance_28().n4n(72, 209, 204);
    this.c4c_1 = Companion_getInstance_28().n4n(199, 21, 133);
    this.d4c_1 = Companion_getInstance_28().n4n(25, 25, 112);
    this.e4c_1 = Companion_getInstance_28().n4n(245, 255, 250);
    this.f4c_1 = Companion_getInstance_28().n4n(255, 228, 225);
    this.g4c_1 = Companion_getInstance_28().n4n(255, 228, 181);
    this.h4c_1 = Companion_getInstance_28().n4n(255, 222, 173);
    this.i4c_1 = Companion_getInstance_28().n4n(0, 0, 128);
    this.j4c_1 = Companion_getInstance_28().n4n(253, 245, 230);
    this.k4c_1 = Companion_getInstance_28().n4n(128, 128, 0);
    this.l4c_1 = Companion_getInstance_28().n4n(107, 142, 35);
    this.m4c_1 = Companion_getInstance_28().n4n(255, 165, 0);
    this.n4c_1 = Companion_getInstance_28().n4n(255, 69, 0);
    this.o4c_1 = Companion_getInstance_28().n4n(218, 112, 214);
    this.p4c_1 = Companion_getInstance_28().n4n(238, 232, 170);
    this.q4c_1 = Companion_getInstance_28().n4n(152, 251, 152);
    this.r4c_1 = Companion_getInstance_28().n4n(175, 238, 238);
    this.s4c_1 = Companion_getInstance_28().n4n(219, 112, 147);
    this.t4c_1 = Companion_getInstance_28().n4n(255, 239, 213);
    this.u4c_1 = Companion_getInstance_28().n4n(255, 218, 185);
    this.v4c_1 = Companion_getInstance_28().n4n(205, 133, 63);
    this.w4c_1 = Companion_getInstance_28().n4n(255, 192, 203);
    this.x4c_1 = Companion_getInstance_28().n4n(221, 160, 221);
    this.y4c_1 = Companion_getInstance_28().n4n(176, 224, 230);
    this.z4c_1 = Companion_getInstance_28().n4n(128, 0, 128);
    this.a4d_1 = Companion_getInstance_28().n4n(188, 143, 143);
    this.b4d_1 = Companion_getInstance_28().n4n(65, 105, 225);
    this.c4d_1 = Companion_getInstance_28().n4n(139, 69, 19);
    this.d4d_1 = Companion_getInstance_28().n4n(250, 128, 114);
    this.e4d_1 = Companion_getInstance_28().n4n(244, 164, 96);
    this.f4d_1 = Companion_getInstance_28().n4n(46, 139, 87);
    this.g4d_1 = Companion_getInstance_28().n4n(255, 245, 238);
    this.h4d_1 = Companion_getInstance_28().n4n(160, 82, 45);
    this.i4d_1 = Companion_getInstance_28().n4n(192, 192, 192);
    this.j4d_1 = Companion_getInstance_28().n4n(135, 206, 235);
    this.k4d_1 = Companion_getInstance_28().n4n(106, 90, 205);
    this.l4d_1 = Companion_getInstance_28().n4n(112, 128, 144);
    this.m4d_1 = Companion_getInstance_28().n4n(112, 128, 144);
    this.n4d_1 = Companion_getInstance_28().n4n(255, 250, 250);
    this.o4d_1 = Companion_getInstance_28().n4n(0, 255, 127);
    this.p4d_1 = Companion_getInstance_28().n4n(70, 130, 180);
    this.q4d_1 = Companion_getInstance_28().n4n(210, 180, 140);
    this.r4d_1 = Companion_getInstance_28().n4n(0, 128, 128);
    this.s4d_1 = Companion_getInstance_28().n4n(216, 191, 216);
    this.t4d_1 = Companion_getInstance_28().n4n(255, 99, 71);
    this.u4d_1 = Companion_getInstance_28().n4n(64, 224, 208);
    this.v4d_1 = Companion_getInstance_28().n4n(238, 130, 238);
    this.w4d_1 = Companion_getInstance_28().n4n(245, 222, 179);
    this.x4d_1 = Companion_getInstance_28().n4n(245, 245, 245);
    this.y4d_1 = Companion_getInstance_28().n4n(154, 205, 50);
    this.z4d_1 = Companion_getInstance_28().n4n(255, 255, 0);
    this.a4e_1 = mapOf([to('black', new RGBA(this.k48_1)), to('white', new RGBA(this.j48_1)), to('red', new RGBA(this.l48_1)), to('green', new RGBA(this.m48_1)), to('blue', new RGBA(this.n48_1)), to('aliceblue', new RGBA(this.q48_1)), to('antiquewhite', new RGBA(this.r48_1)), to('aqua', new RGBA(this.s48_1)), to('aquamarine', new RGBA(this.t48_1)), to('azure', new RGBA(this.u48_1)), to('beige', new RGBA(this.v48_1)), to('bisque', new RGBA(this.w48_1)), to('blanchedalmond', new RGBA(this.x48_1)), to('blueviolet', new RGBA(this.y48_1)), to('brown', new RGBA(this.z48_1)), to('burlywood', new RGBA(this.a49_1)), to('cadetblue', new RGBA(this.b49_1)), to('chartreuse', new RGBA(this.c49_1)), to('chocolate', new RGBA(this.d49_1)), to('coral', new RGBA(this.e49_1)), to('cornflowerblue', new RGBA(this.f49_1)), to('cornsilk', new RGBA(this.g49_1)), to('crimson', new RGBA(this.h49_1)), to('cyan', new RGBA(this.j49_1)), to('darkblue', new RGBA(this.i49_1)), to('darkcyan', new RGBA(this.k49_1)), to('darkgoldenrod', new RGBA(this.l49_1)), to('darkgray', new RGBA(this.m49_1)), to('darkgreen', new RGBA(this.n49_1)), to('darkgrey', new RGBA(this.o49_1)), to('darkkhaki', new RGBA(this.p49_1)), to('darkmagenta', new RGBA(this.r49_1)), to('darkolivegreen', new RGBA(this.s49_1)), to('darkorange', new RGBA(this.t49_1)), to('darkorchid', new RGBA(this.u49_1)), to('darkred', new RGBA(this.v49_1)), to('darksalmon', new RGBA(this.w49_1)), to('darkseagreen', new RGBA(this.x49_1)), to('darkslateblue', new RGBA(this.y49_1)), to('darkslategray', new RGBA(this.z49_1)), to('darkslategrey', new RGBA(this.a4a_1)), to('darkturquoise', new RGBA(this.b4a_1)), to('darkviolet', new RGBA(this.c4a_1)), to('deeppink', new RGBA(this.d4a_1)), to('deepskyblue', new RGBA(this.e4a_1)), to('dimgray', new RGBA(this.f4a_1)), to('dimgrey', new RGBA(this.g4a_1)), to('dodgerblue', new RGBA(this.h4a_1)), to('firebrick', new RGBA(this.i4a_1)), to('floralwhite', new RGBA(this.j4a_1)), to('forestgreen', new RGBA(this.k4a_1)), to('fuchsia', new RGBA(this.l4a_1)), to('gainsboro', new RGBA(this.m4a_1)), to('ghostwhite', new RGBA(this.n4a_1)), to('gold', new RGBA(this.o4a_1)), to('goldenrod', new RGBA(this.p4a_1)), to('greenyellow', new RGBA(this.q4a_1)), to('honeydew', new RGBA(this.r4a_1)), to('hotpink', new RGBA(this.s4a_1)), to('indianred', new RGBA(this.t4a_1)), to('indigo', new RGBA(this.u4a_1)), to('ivory', new RGBA(this.v4a_1)), to('khaki', new RGBA(this.w4a_1)), to('lavender', new RGBA(this.x4a_1)), to('lavenderblush', new RGBA(this.y4a_1)), to('lawngreen', new RGBA(this.z4a_1)), to('lemonchiffon', new RGBA(this.a4b_1)), to('lightblue', new RGBA(this.b4b_1)), to('lightcoral', new RGBA(this.c4b_1)), to('lightcyan', new RGBA(this.d4b_1)), to('lightgoldenrodyellow', new RGBA(this.e4b_1)), to('lightgray', new RGBA(this.f4b_1)), to('lightgreen', new RGBA(this.g4b_1)), to('lightgrey', new RGBA(this.h4b_1)), to('lightpink', new RGBA(this.i4b_1)), to('lightsalmon', new RGBA(this.j4b_1)), to('lightseagreen', new RGBA(this.k4b_1)), to('lightskyblue', new RGBA(this.l4b_1)), to('lightslategray', new RGBA(this.m4b_1)), to('lightslategrey', new RGBA(this.n4b_1)), to('lightsteelblue', new RGBA(this.o4b_1)), to('lightyellow', new RGBA(this.p4b_1)), to('lime', new RGBA(this.q4b_1)), to('limegreen', new RGBA(this.r4b_1)), to('linen', new RGBA(this.s4b_1)), to('magenta', new RGBA(this.q49_1)), to('maroon', new RGBA(this.t4b_1)), to('mediumaquamarine', new RGBA(this.u4b_1)), to('mediumblue', new RGBA(this.v4b_1)), to('mediumorchid', new RGBA(this.w4b_1)), to('mediumpurple', new RGBA(this.x4b_1)), to('mediumseagreen', new RGBA(this.y4b_1)), to('mediumslateblue', new RGBA(this.z4b_1)), to('mediumspringgreen', new RGBA(this.a4c_1)), to('mediumturquoise', new RGBA(this.b4c_1)), to('mediumvioletred', new RGBA(this.c4c_1)), to('midnightblue', new RGBA(this.d4c_1)), to('mintcream', new RGBA(this.e4c_1)), to('mistyrose', new RGBA(this.f4c_1)), to('moccasin', new RGBA(this.g4c_1)), to('navajowhite', new RGBA(this.h4c_1)), to('navy', new RGBA(this.i4c_1)), to('oldlace', new RGBA(this.j4c_1)), to('olive', new RGBA(this.k4c_1)), to('olivedrab', new RGBA(this.l4c_1)), to('orange', new RGBA(this.m4c_1)), to('orangered', new RGBA(this.n4c_1)), to('orchid', new RGBA(this.o4c_1)), to('palegoldenrod', new RGBA(this.p4c_1)), to('palegreen', new RGBA(this.q4c_1)), to('paleturquoise', new RGBA(this.r4c_1)), to('palevioletred', new RGBA(this.s4c_1)), to('papayawhip', new RGBA(this.t4c_1)), to('peachpuff', new RGBA(this.u4c_1)), to('peru', new RGBA(this.v4c_1)), to('pink', new RGBA(this.w4c_1)), to('plum', new RGBA(this.x4c_1)), to('powderblue', new RGBA(this.y4c_1)), to('purple', new RGBA(this.z4c_1)), to('rosybrown', new RGBA(this.a4d_1)), to('royalblue', new RGBA(this.b4d_1)), to('saddlebrown', new RGBA(this.c4d_1)), to('salmon', new RGBA(this.d4d_1)), to('sandybrown', new RGBA(this.e4d_1)), to('seagreen', new RGBA(this.f4d_1)), to('seashell', new RGBA(this.g4d_1)), to('sienna', new RGBA(this.h4d_1)), to('silver', new RGBA(this.i4d_1)), to('skyblue', new RGBA(this.j4d_1)), to('slateblue', new RGBA(this.k4d_1)), to('slategray', new RGBA(this.l4d_1)), to('slategrey', new RGBA(this.m4d_1)), to('snow', new RGBA(this.n4d_1)), to('springgreen', new RGBA(this.o4d_1)), to('steelblue', new RGBA(this.p4d_1)), to('tan', new RGBA(this.q4d_1)), to('teal', new RGBA(this.r4d_1)), to('thistle', new RGBA(this.s4d_1)), to('tomato', new RGBA(this.t4d_1)), to('turquoise', new RGBA(this.u4d_1)), to('violet', new RGBA(this.v4d_1)), to('wheat', new RGBA(this.w4d_1)), to('whitesmoke', new RGBA(this.x4d_1)), to('yellowgreen', new RGBA(this.y4d_1)), to('yellow', new RGBA(this.z4d_1))]);
  }
  protoOf(Colors).o4n = function (str) {
    return this.p4n(str, this.o48_1, true);
  };
  protoOf(Colors).p4n = function (str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).g1(hex.length))
          return this.k48_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 17.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt_0(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt_0(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt_0(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt_0(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_28().g4m(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        var tmp$ret$1;
        // Inline function 'kotlin.text.toUpperCase' call
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = str;
        tmp$ret$1 = tmp$ret$0.toUpperCase();
        var parts = split_0(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        var tmp$ret$3;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp;
        if (0 <= get_lastIndex(parts)) {
          tmp = parts.k(0);
        } else {
          var tmp$ret$2;
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp$ret$2 = '0';
          tmp = tmp$ret$2;
        }
        tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        var tmp$ret$5;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_0;
        if (1 <= get_lastIndex(parts)) {
          tmp_0 = parts.k(1);
        } else {
          var tmp$ret$4;
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp$ret$4 = '0';
          tmp_0 = tmp$ret$4;
        }
        tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var tmp$ret$7;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_1;
        if (2 <= get_lastIndex(parts)) {
          tmp_1 = parts.k(2);
        } else {
          var tmp$ret$6;
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp$ret$6 = '0';
          tmp_1 = tmp$ret$6;
        }
        tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        var tmp$ret$9;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp_2;
        if (3 <= get_lastIndex(parts)) {
          tmp_2 = parts.k(3);
        } else {
          var tmp$ret$8;
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp$ret$8 = '1.0';
          tmp_2 = tmp$ret$8;
        }
        tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_28().g4m(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        var tmp$ret$11;
        // Inline function 'kotlin.text.toLowerCase' call
        var tmp$ret$10;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$10 = str;
        tmp$ret$11 = tmp$ret$10.toLowerCase();
        var tmp_3 = this.a4e_1.z1(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.q4n_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.r4n('#' + str, default_0);
        var tmp4_elvis_lhs = col;
        var tmp_6;
        var tmp_7 = tmp4_elvis_lhs;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = tmp4_elvis_lhs;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().l48_1;
      } else {
        throw $p;
      }
    }
  };
  protoOf(Colors).r4n = function (str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.p4n(str, default_0, errorOnDefault) : $super.p4n.call(this, str, new RGBA(default_0), errorOnDefault).q4n_1;
  };
  var Colors_instance;
  function Colors_getInstance() {
    if (Colors_instance == null)
      new Colors();
    return Colors_instance;
  }
  function Companion_6() {
    Companion_instance_6 = this;
    RGB.call(this, 0, 8, 16);
  }
  var Companion_instance_6;
  function Companion_getInstance_26() {
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function RGB(rOffset, gOffset, bOffset) {
    Companion_getInstance_26();
    ColorFormat24.call(this);
    this.t4n_1 = rOffset;
    this.u4n_1 = gOffset;
    this.v4n_1 = bOffset;
  }
  protoOf(RGB).r4m = function (v) {
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = this.t4n_1;
    tmp$ret$0 = (v >>> tmp0_extract8 | 0) & 255;
    return tmp$ret$0;
  };
  protoOf(RGB).s4m = function (v) {
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = this.u4n_1;
    tmp$ret$0 = (v >>> tmp0_extract8 | 0) & 255;
    return tmp$ret$0;
  };
  protoOf(RGB).t4m = function (v) {
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = this.v4n_1;
    tmp$ret$0 = (v >>> tmp0_extract8 | 0) & 255;
    return tmp$ret$0;
  };
  protoOf(RGB).u4m = function (v) {
    return 255;
  };
  function _RgbaArray___init__impl__oib4y4(ints) {
    return ints;
  }
  function _RgbaArray___get_ints__impl__u2kps1($this) {
    return $this;
  }
  function Companion_7() {
    Companion_instance_7 = this;
  }
  protoOf(Companion_7).g4i = function (size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  };
  var Companion_instance_7;
  function Companion_getInstance_27() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function RgbaArray__contains_impl_ofn00n($this, element) {
    return contains_0(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
  }
  function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.l();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i().q4n_1;
        var tmp$ret$1;
        // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
        tmp$ret$1 = RgbaArray__contains_impl_ofn00n($this, element);
        if (!tmp$ret$1) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
    return RgbaArray__containsAll_impl_l6gz5c($this.w4n_1, elements);
  }
  function RgbaArray__isEmpty_impl_nch3ip($this) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.isEmpty' call
    var tmp0_isEmpty = _RgbaArray___get_ints__impl__u2kps1($this);
    tmp$ret$0 = tmp0_isEmpty.length === 0;
    return tmp$ret$0;
  }
  function RgbaArray__iterator_impl_5wfwsm($this) {
    return RgbaArray__listIterator_impl_m4kjt0($this, 0);
  }
  function RgbaArray__listIterator_impl_m4kjt0($this, index) {
    return new GenericListIterator(new RgbaArray($this), index);
  }
  function _RgbaArray___get_size__impl__imxef8($this) {
    return _RgbaArray___get_ints__impl__u2kps1($this).length;
  }
  function RgbaArray__get_impl_nzyo1o($this, index) {
    return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
  }
  function RgbaArray__get_impl_nzyo1o_0($this, index) {
    return new RGBA(RgbaArray__get_impl_nzyo1o($this.w4n_1, index));
  }
  function RgbaArray__set_impl_epw2wg($this, index, color) {
    _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
  }
  function RgbaArray__toString_impl_vgvk04($this) {
    return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
  }
  function RgbaArray__hashCode_impl_ht2l65($this) {
    return hashCode($this);
  }
  function RgbaArray__equals_impl_6qvuf($this, other) {
    if (!(other instanceof RgbaArray))
      return false;
    var tmp0_other_with_cast = other instanceof RgbaArray ? other.w4n_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function RgbaArray(ints) {
    Companion_getInstance_27();
    this.w4n_1 = ints;
  }
  protoOf(RgbaArray).x4n = function (elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.w4n_1, elements);
  };
  protoOf(RgbaArray).h1 = function (elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  };
  protoOf(RgbaArray).l = function () {
    return RgbaArray__isEmpty_impl_nch3ip(this.w4n_1);
  };
  protoOf(RgbaArray).g = function () {
    return RgbaArray__iterator_impl_5wfwsm(this.w4n_1);
  };
  protoOf(RgbaArray).z2 = function (index) {
    return RgbaArray__listIterator_impl_m4kjt0(this.w4n_1, index);
  };
  protoOf(RgbaArray).j = function () {
    return _RgbaArray___get_size__impl__imxef8(this.w4n_1);
  };
  protoOf(RgbaArray).y4n = function (index) {
    return RgbaArray__get_impl_nzyo1o(this.w4n_1, index);
  };
  protoOf(RgbaArray).k = function (index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  };
  protoOf(RgbaArray).toString = function () {
    return RgbaArray__toString_impl_vgvk04(this.w4n_1);
  };
  protoOf(RgbaArray).hashCode = function () {
    return RgbaArray__hashCode_impl_ht2l65(this.w4n_1);
  };
  protoOf(RgbaArray).equals = function (other) {
    return RgbaArray__equals_impl_6qvuf(this.w4n_1, other);
  };
  function blendComponent($this, c1, c2, factor) {
    return numberToInt(c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor)) & 255;
  }
  function _RGBA___init__impl__lqpay5(value) {
    return value;
  }
  function _RGBA___get_value__impl__hhco8v($this) {
    return $this;
  }
  function RGBA__clone_impl_w007z0($this) {
    return new RGBA($this);
  }
  function _RGBA___get_color__impl__8x3sb3($this) {
    return $this;
  }
  function _RGBA___get_r__impl__duz7mo($this) {
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = _RGBA___get_value__impl__hhco8v($this);
    Companion_getInstance_28();
    var tmp1_extract8 = 0;
    tmp$ret$0 = (tmp0_extract8 >>> tmp1_extract8 | 0) & 255;
    return tmp$ret$0;
  }
  function _RGBA___get_g__impl__o8pukr($this) {
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = _RGBA___get_value__impl__hhco8v($this);
    Companion_getInstance_28();
    var tmp1_extract8 = 8;
    tmp$ret$0 = (tmp0_extract8 >>> tmp1_extract8 | 0) & 255;
    return tmp$ret$0;
  }
  function _RGBA___get_b__impl__m6tl80($this) {
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = _RGBA___get_value__impl__hhco8v($this);
    Companion_getInstance_28();
    var tmp1_extract8 = 16;
    tmp$ret$0 = (tmp0_extract8 >>> tmp1_extract8 | 0) & 255;
    return tmp$ret$0;
  }
  function _RGBA___get_a__impl__6msvu7($this) {
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = _RGBA___get_value__impl__hhco8v($this);
    Companion_getInstance_28();
    var tmp1_extract8 = 24;
    tmp$ret$0 = (tmp0_extract8 >>> tmp1_extract8 | 0) & 255;
    return tmp$ret$0;
  }
  function _RGBA___get_rf__impl__kvz75k($this) {
    return _RGBA___get_r__impl__duz7mo($this) / 255.0;
  }
  function _RGBA___get_gf__impl__5gcu1f($this) {
    return _RGBA___get_g__impl__o8pukr($this) / 255.0;
  }
  function _RGBA___get_bf__impl__1xz5yg($this) {
    return _RGBA___get_b__impl__m6tl80($this) / 255.0;
  }
  function _RGBA___get_af__impl__vu36qv($this) {
    return _RGBA___get_a__impl__6msvu7($this) / 255.0;
  }
  function _RGBA___get_rgb__impl__tijaqt($this) {
    return _RGBA___get_value__impl__hhco8v($this) & 16777215;
  }
  function RGBA__withA_impl_vogscm($this, v) {
    var tmp = _RGBA___get_value__impl__hhco8v($this) & 16777215;
    var tmp_0 = clampUByte(v);
    Companion_getInstance_28();
    return _RGBA___init__impl__lqpay5(tmp | tmp_0 << 24);
  }
  function RGBA__withAf_impl_dpdu32($this, v) {
    return RGBA__withA_impl_vogscm($this, f2i(v));
  }
  function RGBA__concatAd_impl_gwhfm($this, v) {
    return RGBA__withA_impl_vogscm($this, numberToInt(_RGBA___get_a__impl__6msvu7($this) * v));
  }
  function _RGBA___get_hexString__impl__kocngm($this) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
    tmp0_apply.f7(_Char___init__impl__6a9atx(35));
    appendHexByte(tmp0_apply, _RGBA___get_r__impl__duz7mo($this));
    appendHexByte(tmp0_apply, _RGBA___get_g__impl__o8pukr($this));
    appendHexByte(tmp0_apply, _RGBA___get_b__impl__m6tl80($this));
    appendHexByte(tmp0_apply, _RGBA___get_a__impl__6msvu7($this));
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  }
  function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
    tmp0_apply.f7(_Char___init__impl__6a9atx(35));
    appendHexByte(tmp0_apply, _RGBA___get_r__impl__duz7mo($this));
    appendHexByte(tmp0_apply, _RGBA___get_g__impl__o8pukr($this));
    appendHexByte(tmp0_apply, _RGBA___get_b__impl__m6tl80($this));
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  }
  function _RGBA___get_htmlColor__impl__bzw5k6($this) {
    return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
  }
  function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
    return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
  }
  function RGBA__toString_impl_4lw6dp($this) {
    return _RGBA___get_hexString__impl__kocngm($this);
  }
  function RGBA__compareTo_impl_lrfjc1($this, other) {
    return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
  }
  function RGBA__compareTo_impl_lrfjc1_0($this, other) {
    var tmp = $this.q4n_1;
    return RGBA__compareTo_impl_lrfjc1(tmp, other instanceof RGBA ? other.q4n_1 : THROW_CCE());
  }
  function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
    return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
  }
  function _RGBA___get_premultiplied__impl__3bulqc($this) {
    return _RGBA___get_premultipliedFast__impl__qiau4g($this);
  }
  function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
    var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
    if (A >= 255)
      return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
    if (A <= 1)
      return _RGBAPremultiplied___init__impl__uos02x(0);
    var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
    var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
  }
  function Companion_8() {
    Companion_instance_8 = this;
    ColorFormat32.call(this);
    this.f4e_1 = 0;
    this.g4e_1 = 8;
    this.h4e_1 = 16;
    this.i4e_1 = 24;
  }
  protoOf(Companion_8).l4k = function (r, g, b, a) {
    return this.z4n(f2i(r), f2i(g), f2i(b), f2i(a));
  };
  protoOf(Companion_8).z4n = function (r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  };
  protoOf(Companion_8).g4m = function (r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  };
  protoOf(Companion_8).n4n = function (r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  };
  protoOf(Companion_8).a4o = function (rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  };
  protoOf(Companion_8).r4m = function (v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  };
  protoOf(Companion_8).s4m = function (v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  };
  protoOf(Companion_8).t4m = function (v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  };
  protoOf(Companion_8).u4m = function (v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  };
  protoOf(Companion_8).b4o = function (c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.c4o(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  };
  protoOf(Companion_8).c4o = function (c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  };
  protoOf(Companion_8).d4o = function (c1, c2, factor) {
    return this.b4o(c1, c2, numberToInt(Ratio__toFloat_impl_1ftup5(factor) * 256));
  };
  protoOf(Companion_8).e4o = function (c1, c2, factor) {
    return Companion_getInstance_28().a4o(_RGBA___get_rgb__impl__tijaqt(this.d4o(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  };
  protoOf(Companion_8).j4e = function (c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.e4o(c00, c10, factorX);
    var c2 = this.e4o(c01, c11, factorX);
    return this.e4o(c1, c2, factorY);
  };
  protoOf(Companion_8).f4m = function (dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    var tmp0_subject = srcA;
    switch (tmp0_subject) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_28().a4o(_RGBA___get_rgb__impl__tijaqt(this.b4o(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  };
  protoOf(Companion_8).f4o = function (src, dst, ratio) {
    return Companion_getInstance_28().g4m(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  };
  var Companion_instance_8;
  function Companion_getInstance_28() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function RGBA__hashCode_impl_h59qf6($this) {
    return $this;
  }
  function RGBA__equals_impl_4vjmca($this, other) {
    if (!(other instanceof RGBA))
      return false;
    var tmp0_other_with_cast = other instanceof RGBA ? other.q4n_1 : THROW_CCE();
    if (!($this === tmp0_other_with_cast))
      return false;
    return true;
  }
  function RGBA(value) {
    Companion_getInstance_28();
    this.q4n_1 = value;
  }
  protoOf(RGBA).dn = function () {
    return RGBA__clone_impl_w007z0(this.q4n_1);
  };
  protoOf(RGBA).toString = function () {
    return RGBA__toString_impl_4lw6dp(this.q4n_1);
  };
  protoOf(RGBA).g4o = function (other) {
    return RGBA__compareTo_impl_lrfjc1(this.q4n_1, other);
  };
  protoOf(RGBA).n8 = function (other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  };
  protoOf(RGBA).hashCode = function () {
    return RGBA__hashCode_impl_h59qf6(this.q4n_1);
  };
  protoOf(RGBA).equals = function (other) {
    return RGBA__equals_impl_4vjmca(this.q4n_1, other);
  };
  function _RGBAPremultiplied___init__impl__uos02x(value) {
    return value;
  }
  function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
    return $this;
  }
  function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
    var tmp = _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
    return tmp;
  }
  function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
    return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
  }
  function _RGBAPremultiplied___get_g__impl__fv131x($this) {
    return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
  }
  function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
    return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
  }
  function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
    return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
  }
  function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
    return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
  }
  function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
    return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
  }
  function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
    return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
  }
  function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
    return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
  }
  function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
    var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
    var tmp0_subject = alpha;
    var tmp;
    if (tmp0_subject === 0) {
      tmp = Colors_getInstance().o48_1;
    } else {
      var ialpha = 255.0 / alpha;
      tmp = Companion_getInstance_28().g4m(numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha), numberToInt(_RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha), numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha), alpha);
    }
    return tmp;
  }
  function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
    var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
    var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
    var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
    return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
  }
  function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
    return RGBAPremultiplied__scaled256_impl_hjm9ii($this, numberToInt(clamp01_0(alpha) * 256));
  }
  function Companion_9() {
    Companion_instance_9 = this;
    this.h4o_1 = 16711935;
    this.i4o_1 = -16711936;
  }
  protoOf(Companion_9).j4o = function (dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  };
  var Companion_instance_9;
  function Companion_getInstance_29() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function mix(_this__u8e3s4, src) {
    var dst = _this__u8e3s4;
    var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
    var oneMSrcAf = 1.0 - srcAf;
    var outA = numberToInt(_RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf);
    var outR = numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf);
    var outG = numberToInt(_RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf);
    var outB = numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf);
    return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
  }
  function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
    return ints;
  }
  function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
    return $this;
  }
  function Companion_10() {
    Companion_instance_10 = this;
  }
  protoOf(Companion_10).k4o = function (size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  };
  var Companion_instance_10;
  function Companion_getInstance_30() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
    return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
  }
  function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
    return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
  }
  function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
    _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
  }
  function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
    return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
  }
  function RgbaPremultipliedArray__toString_impl_seal6e($this) {
    return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
  }
  function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
    return hashCode($this);
  }
  function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
    if (!(other instanceof RgbaPremultipliedArray))
      return false;
    var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.l4o_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function RgbaPremultipliedArray(ints) {
    Companion_getInstance_30();
    this.l4o_1 = ints;
  }
  protoOf(RgbaPremultipliedArray).toString = function () {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.l4o_1);
  };
  protoOf(RgbaPremultipliedArray).hashCode = function () {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.l4o_1);
  };
  protoOf(RgbaPremultipliedArray).equals = function (other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.l4o_1, other);
  };
  function scale(color, colorOffset, alpha, alphaOffset, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = clamp01_0(alpha[alphaOffset + n | 0]);
        if (a === 1.0)
          continue $l$loop;
        RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
      }
       while (inductionVariable < count);
  }
  function premultiply(src, srcN, dst, dstN, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
      }
       while (inductionVariable < count);
  }
  function depremultiply(src, srcN, dst, dstN, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = dstN + n | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var tmp0__get_depremultiplied__z56aq2 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
        tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(tmp0__get_depremultiplied__z56aq2);
        RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
      }
       while (inductionVariable < count);
  }
  function mix_0(dst, dstX, src, srcX, count) {
    return mix_1(dst, dstX, dst, dstX, src, srcX, count);
  }
  function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
        RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_getInstance_29().j4o(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
      }
       while (inductionVariable < count);
  }
  function _RGBAf___init__impl__idjpgn(data) {
    return data;
  }
  function _RGBAf___get_data__impl__yt2t4($this) {
    return $this;
  }
  function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
    r = r === VOID ? 1.0 : r;
    g = g === VOID ? 1.0 : g;
    b = b === VOID ? 1.0 : b;
    a = a === VOID ? 1.0 : a;
    var tmp$ret$0;
    // Inline function 'kotlin.floatArrayOf' call
    tmp$ret$0 = new Float32Array([r, g, b, a]);
    var tmp = _RGBAf___init__impl__idjpgn(tmp$ret$0);
    return tmp;
  }
  function _RGBAf___set_r__impl__pz5j5e($this, v) {
    _RGBAf___get_data__impl__yt2t4($this)[0] = v;
  }
  function _RGBAf___get_r__impl__jfq8gq($this) {
    return _RGBAf___get_data__impl__yt2t4($this)[0];
  }
  function _RGBAf___set_g__impl__c4jj21($this, v) {
    _RGBAf___get_data__impl__yt2t4($this)[1] = v;
  }
  function _RGBAf___get_g__impl__dhoraz($this) {
    return _RGBAf___get_data__impl__yt2t4($this)[1];
  }
  function _RGBAf___set_b__impl__a2n9pa($this, v) {
    _RGBAf___get_data__impl__yt2t4($this)[2] = v;
  }
  function _RGBAf___get_b__impl__fjl0nq($this) {
    return _RGBAf___get_data__impl__yt2t4($this)[2];
  }
  function _RGBAf___set_a__impl__iqz7cx($this, v) {
    _RGBAf___get_data__impl__yt2t4($this)[3] = v;
  }
  function _RGBAf___get_a__impl__qnwk97($this) {
    return _RGBAf___get_data__impl__yt2t4($this)[3];
  }
  function Companion_11() {
    Companion_instance_11 = this;
  }
  protoOf(Companion_11).m4o = function (f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  };
  var Companion_instance_11;
  function Companion_getInstance_31() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
    return function () {
      return extract_0(this$0.p4o_1).e47();
    };
  }
  function Companion_12() {
    Companion_instance_12 = this;
  }
  protoOf(Companion_12).v4o = function (fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    return new BitmapFontImpl(fontSize, lineHeight, base, glyphs, kernings, name, distanceField);
  };
  protoOf(Companion_12).w4o = function (fontSize, lineHeight, base, glyphs, kernings, name, distanceField, $super) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    return $super === VOID ? this.v4o(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) : $super.v4o.call(this, fontSize, lineHeight, base, glyphs, kernings, name, distanceField);
  };
  var Companion_instance_12;
  function Companion_getInstance_32() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function Kerning(first, second, amount) {
    Companion_getInstance_31();
    this.x4o_1 = first;
    this.y4o_1 = second;
    this.z4o_1 = amount;
  }
  function Glyph(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.n4o_1 = fontSize;
    this.o4o_1 = id;
    this.p4o_1 = texture;
    this.q4o_1 = xoffset;
    this.r4o_1 = yoffset;
    this.s4o_1 = xadvance;
    var tmp = this;
    tmp.t4o_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.u4o_1 = new GlyphMetrics(this.n4o_1, true, -1, Companion_getInstance_6().n3i(this.q4o_1, this.r4o_1, this.p4o_1.s3r_1, this.p4o_1.t3r_1), this.s4o_1);
  }
  protoOf(Glyph).a4p = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = bmp$factory();
    tmp$ret$0 = this.t4o_1.q();
    return tmp$ret$0;
  };
  protoOf(Glyph).toString = function () {
    return 'Glyph(fontSize=' + this.n4o_1 + ', id=' + this.o4o_1 + ', texture=' + this.p4o_1 + ', xoffset=' + this.q4o_1 + ', yoffset=' + this.r4o_1 + ', xadvance=' + this.s4o_1 + ')';
  };
  protoOf(Glyph).hashCode = function () {
    var result = getNumberHashCode(this.n4o_1);
    result = imul(result, 31) + this.o4o_1 | 0;
    result = imul(result, 31) + this.p4o_1.hashCode() | 0;
    result = imul(result, 31) + this.q4o_1 | 0;
    result = imul(result, 31) + this.r4o_1 | 0;
    result = imul(result, 31) + this.s4o_1 | 0;
    return result;
  };
  protoOf(Glyph).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.n4o_1, tmp0_other_with_cast.n4o_1))
      return false;
    if (!(this.o4o_1 === tmp0_other_with_cast.o4o_1))
      return false;
    if (!this.p4o_1.equals(tmp0_other_with_cast.p4o_1))
      return false;
    if (!(this.q4o_1 === tmp0_other_with_cast.q4o_1))
      return false;
    if (!(this.r4o_1 === tmp0_other_with_cast.r4o_1))
      return false;
    if (!(this.s4o_1 === tmp0_other_with_cast.s4o_1))
      return false;
    return true;
  };
  function BitmapFont() {
  }
  function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
    return function () {
      var ascent = this$0.j4r_1;
      var baseline = 0.0;
      var tmp = -this$0.p4r_1;
      var tmp_0 = -this$0.p4r_1;
      var tmp$ret$2;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$1;
      // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
      var width = 0.0;
      var tmp0_iterator = this$0.k4r_1.eb().g();
      while (tmp0_iterator.h()) {
        var glyph = tmp0_iterator.i();
        if (!(glyph == null)) {
          var tmp$ret$0;
          // Inline function 'kotlin.math.max' call
          var tmp0_max = width;
          var tmp1_max = glyph.p4o_1.s3r_1;
          tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
          width = tmp$ret$0;
        }
      }
      tmp$ret$1 = width;
      tmp$ret$2 = tmp$ret$1;
      return new FontMetrics(this$0.h4r_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
    };
  }
  function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.k4r_1.k(this$0.k4r_1.a2().g().i());
      return tmp0_elvis_lhs == null ? this$0.u4r() : tmp0_elvis_lhs;
    };
  }
  function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$0;
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
      tmp$ret$0 = get_Bitmaps_transparent();
      return new Glyph(this$0.h4r_1, -1, tmp$ret$0, 0, 0, 0);
    };
  }
  function BitmapFontImpl(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.h4r_1 = fontSize;
    this.i4r_1 = lineHeight;
    this.j4r_1 = base;
    this.k4r_1 = glyphs;
    this.l4r_1 = kernings;
    this.m4r_1 = name;
    this.n4r_1 = distanceField;
    this.o4r_1 = new Mixin();
    this.p4r_1 = this.i4r_1 - this.j4r_1;
    var tmp = this;
    tmp.q4r_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.r4r_1 = new GlyphMetrics(this.h4r_1, false, 0, Companion_getInstance_6().p3i(), 0.0);
    var tmp_0 = this;
    tmp_0.s4r_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.t4r_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  protoOf(BitmapFontImpl).b4p = function () {
    return this.h4r_1;
  };
  protoOf(BitmapFontImpl).c4p = function () {
    return this.i4r_1;
  };
  protoOf(BitmapFontImpl).l3s = function () {
    return this.j4r_1;
  };
  protoOf(BitmapFontImpl).e4p = function () {
    return this.k4r_1;
  };
  protoOf(BitmapFontImpl).f4p = function () {
    return this.l4r_1;
  };
  protoOf(BitmapFontImpl).qg = function () {
    return this.m4r_1;
  };
  protoOf(BitmapFontImpl).d4p = function () {
    return this.n4r_1;
  };
  protoOf(BitmapFontImpl).lu = function (_set____db54di) {
    this.o4r_1.lu(_set____db54di);
  };
  protoOf(BitmapFontImpl).mu = function () {
    return this.o4r_1.mu();
  };
  protoOf(BitmapFontImpl).t2g = function () {
    return this;
  };
  protoOf(BitmapFontImpl).i4p = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = naturalFontMetrics$factory();
    tmp$ret$0 = this.q4r_1.q();
    return tmp$ret$0;
  };
  protoOf(BitmapFontImpl).j4p = function () {
    return this.r4r_1;
  };
  protoOf(BitmapFontImpl).d4q = function (first, second) {
    return this.l4r_1.k(Companion_getInstance_31().m4o(first, second));
  };
  protoOf(BitmapFontImpl).w4p = function (codePoint) {
    return this.k4r_1.k(codePoint);
  };
  protoOf(BitmapFontImpl).h4p = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = anyGlyph$factory();
    tmp$ret$0 = this.s4r_1.q();
    return tmp$ret$0;
  };
  protoOf(BitmapFontImpl).u4r = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = invalidGlyph$factory();
    tmp$ret$0 = this.t4r_1.q();
    return tmp$ret$0;
  };
  function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapFontCOROUTINE$1(_this__u8e3s4, props, mipmaps, atlas, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapFontXmlCOROUTINE$2(content, fntFile, textures, props, mipmaps, atlas, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapFontJsonCOROUTINE$3(content, fntFile, textures, props, mipmaps, atlas, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    atlas = atlas === VOID ? null : atlas;
    var tmp = new $readBitmapFontTxtCOROUTINE$4(content, fntFile, textures, props, mipmaps, atlas, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function readBitmapFontTxt$lambda(_anonymous_parameter_0__qggqh8, it) {
    return Companion_getInstance_31().m4o(it.x4o_1, it.y4o_1);
  }
  function $readBitmapFontCOROUTINE$1(_this__u8e3s4, props, mipmaps, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g4s_1 = _this__u8e3s4;
    this.h4s_1 = props;
    this.i4s_1 = mipmaps;
    this.j4s_1 = atlas;
  }
  protoOf($readBitmapFontCOROUTINE$1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 6;
            this.k4s_1 = this.g4s_1;
            this.hh_1 = 1;
            suspendResult = this.k4s_1.a1z(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.l4s_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1 = this.l4s_1;
            tmp_0.m4s_1 = toString(trim(isCharSequence(tmp_1) ? tmp_1 : THROW_CCE()));
            var tmp_2 = this;
            tmp_2.n4s_1 = HashMap_init_$Create$();
            if (startsWith_0(this.m4s_1, _Char___init__impl__6a9atx(60))) {
              this.hh_1 = 4;
              suspendResult = readBitmapFontXml(this.m4s_1, this.k4s_1, this.n4s_1, this.h4s_1, this.i4s_1, this.j4s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (startsWith_0(this.m4s_1, _Char___init__impl__6a9atx(123))) {
                this.hh_1 = 3;
                suspendResult = readBitmapFontJson(this.m4s_1, this.k4s_1, this.n4s_1, this.h4s_1, this.i4s_1, this.j4s_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (startsWith(this.m4s_1, 'info')) {
                  this.hh_1 = 2;
                  suspendResult = readBitmapFontTxt(this.m4s_1, this.k4s_1, this.n4s_1, this.h4s_1, this.i4s_1, this.j4s_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_3 = this;
                  var tmp1_TODO = 'Unsupported font type starting with ' + substr_0(this.m4s_1, 0, 16);
                  throw new NotImplementedError('An operation is not implemented: ' + tmp1_TODO);
                }
              }
            }

            break;
          case 2:
            this.o4s_1 = suspendResult;
            this.hh_1 = 5;
            continue $sm;
          case 3:
            this.o4s_1 = suspendResult;
            this.hh_1 = 5;
            continue $sm;
          case 4:
            this.o4s_1 = suspendResult;
            this.hh_1 = 5;
            continue $sm;
          case 5:
            return this.o4s_1;
          case 6:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 6) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $readBitmapFontXmlCOROUTINE$2(content, fntFile, textures, props, mipmaps, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x4s_1 = content;
    this.y4s_1 = fntFile;
    this.z4s_1 = textures;
    this.a4t_1 = props;
    this.b4t_1 = mipmaps;
    this.c4t_1 = atlas;
  }
  protoOf($readBitmapFontXmlCOROUTINE$2).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.d4t_1 = Xml(this.x4s_1);
            var tmp_0 = this;
            var tmp0_safe_receiver = firstOrNull_0(this.d4t_1.ro('info'));
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k2k('size');
            tmp_0.e4t_1 = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
            var tmp_1 = this;
            var tmp2_safe_receiver = firstOrNull_0(this.d4t_1.ro('common'));
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.k2k('lineHeight');
            tmp_1.f4t_1 = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
            var tmp_2 = this;
            var tmp4_safe_receiver = firstOrNull_0(this.d4t_1.ro('common'));
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.k2k('base');
            tmp_2.g4t_1 = tmp5_elvis_lhs == null ? 16.0 : tmp5_elvis_lhs;
            var tmp_3 = this;
            var tmp6_safe_receiver = firstOrNull_0(this.d4t_1.ro('distanceField'));
            tmp_3.h4t_1 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.m2k('fieldType');
            this.i4t_1 = get(this.d4t_1.ro('pages'), 'page').g();
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (!this.i4t_1.h()) {
              this.hh_1 = 3;
              continue $sm;
            }

            this.j4t_1 = this.i4t_1.i();
            this.k4t_1 = this.j4t_1.i2k('id');
            this.l4t_1 = this.j4t_1.g2k('file');
            this.m4t_1 = this.y4s_1.u1y().ro(this.l4t_1);
            this.hh_1 = 2;
            suspendResult = readBitmap_1(this.m4t_1, this.a4t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this.b4t_1);
            var tex = slice(ARGUMENT_0);
            this.z4s_1.x3(this.k4t_1, tex);
            ;
            this.hh_1 = 1;
            continue $sm;
          case 3:
            var tmp1_map = get(this.d4t_1.ro('chars'), 'char');
            var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
            var tmp0_iterator = tmp1_map.g();
            while (tmp0_iterator.h()) {
              var item = tmp0_iterator.i();
              var page = item.i2k('page');
              var tmp0_elvis_lhs = this.z4s_1.z1(page);
              var texture = tmp0_elvis_lhs == null ? first_0(this.z4s_1.eb()) : tmp0_elvis_lhs;
              var tmp_4 = item.i2k('id');
              var tmp1_safe_receiver = this.c4t_1;
              var tmp_5;
              if (tmp1_safe_receiver == null) {
                tmp_5 = null;
              } else {
                var tmp_6 = texture.t3s(item.i2k('x'), item.i2k('y'), item.i2k('width'), item.i2k('height'));
                tmp_5 = tmp1_safe_receiver.y47(tmp_6 instanceof RectSlice ? tmp_6 : THROW_CCE(), Unit_getInstance());
              }
              var tmp2_safe_receiver_0 = tmp_5;
              var tmp3_elvis_lhs_0 = tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.b46_1;
              tmp0_mapTo.b(new Glyph(this.e4t_1, tmp_4, tmp3_elvis_lhs_0 == null ? texture.t3s(item.i2k('x'), item.i2k('y'), item.i2k('width'), item.i2k('height')) : tmp3_elvis_lhs_0, item.i2k('xoffset'), item.i2k('yoffset'), item.i2k('xadvance')));
            }

            var glyphs = tmp0_mapTo;
            var tmp3_map = get(this.d4t_1.ro('kernings'), 'kerning');
            var tmp2_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map, 10));
            var tmp0_iterator_0 = tmp3_map.g();
            while (tmp0_iterator_0.h()) {
              var item_0 = tmp0_iterator_0.i();
              tmp2_mapTo.b(new Kerning(item_0.i2k('first'), item_0.i2k('second'), item_0.i2k('amount')));
            }

            var kernings = tmp2_mapTo;
            var tmp_7 = Companion_getInstance_32();
            var tmp4_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(glyphs, 10));
            var tmp0_iterator_1 = glyphs.g();
            while (tmp0_iterator_1.h()) {
              var item_1 = tmp0_iterator_1.i();
              tmp4_mapTo.b(to(item_1.o4o_1, item_1));
            }

            var tmp_8 = toIntMap(toMap(tmp4_mapTo));
            var tmp5_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(kernings, 10));
            var tmp0_iterator_2 = kernings.g();
            while (tmp0_iterator_2.h()) {
              var item_2 = tmp0_iterator_2.i();
              tmp5_mapTo.b(to(Companion_getInstance_31().m4o(item_2.x4o_1, item_2.y4o_1), item_2));
            }

            return tmp_7.w4o(this.e4t_1, this.f4t_1, this.g4t_1, tmp_8, toIntMap(toMap(tmp5_mapTo)), VOID, this.h4t_1);
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $readBitmapFontJsonCOROUTINE$3(content, fntFile, textures, props, mipmaps, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v4t_1 = content;
    this.w4t_1 = fntFile;
    this.x4t_1 = textures;
    this.y4t_1 = props;
    this.z4t_1 = mipmaps;
    this.a4u_1 = atlas;
  }
  protoOf($readBitmapFontJsonCOROUTINE$3).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.b4u_1 = Json_getInstance().o2h(this.v4t_1);
            this.c4u_1 = Dyn__toFloatDefault_impl_tuvm0c(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(this.b4u_1, 'info'), 'size'), 16.0);
            this.d4u_1 = Dyn__toFloatDefault_impl_tuvm0c(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(this.b4u_1, 'common'), 'lineHeight'), 16.0);
            this.e4u_1 = Dyn__toFloatDefault_impl_tuvm0c(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(this.b4u_1, 'common'), 'base'), 16.0);
            this.f4u_1 = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(this.b4u_1, 'distanceField'), 'fieldType'));
            var tmp_0 = this;
            tmp_0.g4u_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(this.b4u_1, 'pages'));
            this.h4u_1 = 0;
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (!(this.h4u_1 < this.g4u_1.j())) {
              this.hh_1 = 3;
              continue $sm;
            }

            var tmp_1 = this;
            tmp_1.i4u_1 = this.h4u_1;
            var tmp_2 = this;
            tmp_2.j4u_1 = this.g4u_1.k(this.h4u_1).t1r_1;
            this.k4u_1 = Dyn__toString_impl_9l0v3s(this.j4u_1);
            this.l4u_1 = this.w4t_1.u1y().ro(this.k4u_1);
            this.hh_1 = 2;
            suspendResult = readBitmap_1(this.l4u_1, this.y4t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this.z4t_1);
            var tex = slice(ARGUMENT_0);
            this.x4t_1.x3(this.i4u_1, tex);
            ;
            var tmp0 = this.h4u_1;
            this.h4u_1 = tmp0 + 1 | 0;
            ;
            this.hh_1 = 1;
            continue $sm;
          case 3:
            var tmp4_map = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(this.b4u_1, 'chars'));
            var tmp3_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp4_map, 10));
            var tmp0_iterator = tmp4_map.g();
            while (tmp0_iterator.h()) {
              var item = tmp0_iterator.i().t1r_1;
              var page = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'page'));
              var tmp0_elvis_lhs = this.x4t_1.z1(page);
              var texture = tmp0_elvis_lhs == null ? first_0(this.x4t_1.eb()) : tmp0_elvis_lhs;
              var tmp_3 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'id'));
              var tmp1_safe_receiver = this.a4u_1;
              var tmp_4;
              if (tmp1_safe_receiver == null) {
                tmp_4 = null;
              } else {
                var tmp_5 = texture.t3s(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'height')));
                tmp_4 = tmp1_safe_receiver.y47(tmp_5 instanceof RectSlice ? tmp_5 : THROW_CCE(), Unit_getInstance());
              }
              var tmp2_safe_receiver = tmp_4;
              var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b46_1;
              tmp3_mapTo.b(new Glyph(this.c4u_1, tmp_3, tmp3_elvis_lhs == null ? texture.t3s(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'height'))) : tmp3_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item, 'xadvance'))));
            }

            var glyphs = tmp3_mapTo;
            var tmp6_map = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(this.b4u_1, 'kernings'));
            var tmp5_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp6_map, 10));
            var tmp0_iterator_0 = tmp6_map.g();
            while (tmp0_iterator_0.h()) {
              var item_0 = tmp0_iterator_0.i().t1r_1;
              tmp5_mapTo.b(new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(item_0, 'amount'))));
            }

            var kernings = tmp5_mapTo;
            var tmp_6 = Companion_getInstance_32();
            var tmp7_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(glyphs, 10));
            var tmp0_iterator_1 = glyphs.g();
            while (tmp0_iterator_1.h()) {
              var item_1 = tmp0_iterator_1.i();
              tmp7_mapTo.b(to(item_1.o4o_1, item_1));
            }

            var tmp_7 = toIntMap(toMap(tmp7_mapTo));
            var tmp8_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(kernings, 10));
            var tmp0_iterator_2 = kernings.g();
            while (tmp0_iterator_2.h()) {
              var item_2 = tmp0_iterator_2.i();
              tmp8_mapTo.b(to(Companion_getInstance_31().m4o(item_2.x4o_1, item_2.y4o_1), item_2));
            }

            return tmp_6.w4o(this.c4u_1, this.d4u_1, this.e4u_1, tmp_7, toIntMap(toMap(tmp8_mapTo)), VOID, this.f4u_1);
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $readBitmapFontTxtCOROUTINE$4(content, fntFile, textures, props, mipmaps, atlas, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u4u_1 = content;
    this.v4u_1 = fntFile;
    this.w4u_1 = textures;
    this.x4u_1 = props;
    this.y4u_1 = mipmaps;
    this.z4u_1 = atlas;
  }
  protoOf($readBitmapFontTxtCOROUTINE$4).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 5;
            var tmp_0 = this;
            tmp_0.a4v_1 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1.b4v_1 = ArrayList_init_$Create$();
            this.c4v_1 = 16.0;
            this.d4v_1 = 16.0;
            this.e4v_1 = null;
            this.f4v_1 = lines(this.u4u_1).g();
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (!this.f4v_1.h()) {
              this.hh_1 = 4;
              continue $sm;
            }

            this.g4v_1 = this.f4v_1.i();
            var tmp_2 = this;
            var tmp_3 = this.g4v_1;
            tmp_2.h4v_1 = toString(trim(isCharSequence(tmp_3) ? tmp_3 : THROW_CCE()));
            this.i4v_1 = LinkedHashMap_init_$Create$_0();
            var tmp1_iterator = split(this.h4v_1, charArrayOf([_Char___init__impl__6a9atx(32)])).g();
            while (tmp1_iterator.h()) {
              var part = tmp1_iterator.i();
              var tmp2_container = plus_0(split(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf_0(['', '']));
              var key = tmp2_container.k(0);
              var value = tmp2_container.k(1);
              this.i4v_1.x3(key, value);
            }

            if (startsWith(this.h4v_1, 'info')) {
              var tmp_4 = this;
              var tmp3_safe_receiver = this.i4v_1.z1('size');
              var tmp_5;
              if (tmp3_safe_receiver == null) {
                tmp_5 = null;
              } else {
                var tmp0_unsafeCast = toDouble(tmp3_safe_receiver);
                tmp_5 = tmp0_unsafeCast;
              }
              var tmp4_elvis_lhs = tmp_5;
              tmp_4.d4v_1 = tmp4_elvis_lhs == null ? 16.0 : tmp4_elvis_lhs;
              this.hh_1 = 3;
              continue $sm;
            } else {
              if (startsWith(this.h4v_1, 'page')) {
                var tmp_6 = this;
                var tmp5_safe_receiver = this.i4v_1.z1('id');
                var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : toInt(tmp5_safe_receiver);
                tmp_6.j4v_1 = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
                var tmp_7 = this;
                var tmp7_safe_receiver = this.i4v_1.z1('file');
                var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : unquote(tmp7_safe_receiver);
                var tmp_8;
                if (tmp8_elvis_lhs == null) {
                  throw IllegalStateException_init_$Create$('page without file');
                } else {
                  tmp_8 = tmp8_elvis_lhs;
                }
                tmp_7.k4v_1 = tmp_8;
                this.hh_1 = 2;
                suspendResult = readBitmap_1(this.v4u_1.u1y().ro(this.k4v_1), this.x4u_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (startsWith(this.h4v_1, 'common ')) {
                  var tmp_9 = this;
                  var tmp9_safe_receiver = this.i4v_1.z1('lineHeight');
                  var tmp_10;
                  if (tmp9_safe_receiver == null) {
                    tmp_10 = null;
                  } else {
                    var tmp2_unsafeCast = toDoubleOrNull(tmp9_safe_receiver);
                    tmp_10 = tmp2_unsafeCast;
                  }
                  var tmp10_elvis_lhs = tmp_10;
                  tmp_9.c4v_1 = tmp10_elvis_lhs == null ? 16.0 : tmp10_elvis_lhs;
                  var tmp_11 = this;
                  var tmp11_safe_receiver = this.i4v_1.z1('base');
                  var tmp_12;
                  if (tmp11_safe_receiver == null) {
                    tmp_12 = null;
                  } else {
                    var tmp3_unsafeCast = toDoubleOrNull(tmp11_safe_receiver);
                    tmp_12 = tmp3_unsafeCast;
                  }
                  tmp_11.e4v_1 = tmp_12;
                  this.hh_1 = 3;
                  continue $sm;
                } else {
                  if (startsWith(this.h4v_1, 'char ')) {
                    var tmp12_safe_receiver = this.i4v_1.z1('page');
                    var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : toIntOrNull(tmp12_safe_receiver);
                    var page = tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs;
                    var tmp14_elvis_lhs = this.w4u_1.z1(page);
                    var texture = tmp14_elvis_lhs == null ? first_0(this.w4u_1.eb()) : tmp14_elvis_lhs;
                    var dmap = get_dyn(this.i4v_1);
                    var id = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
                    var tmp18_fontSize = this.d4v_1;
                    var tmp19_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
                    var tmp20_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
                    var tmp21_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
                    var tmp15_safe_receiver = this.z4u_1;
                    var tmp_13;
                    if (tmp15_safe_receiver == null) {
                      tmp_13 = null;
                    } else {
                      var tmp_14 = texture.t3s(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + new Char(numberToChar(id)));
                      tmp_13 = tmp15_safe_receiver.y47(tmp_14 instanceof RectSlice ? tmp_14 : THROW_CCE(), Unit_getInstance());
                    }
                    var tmp16_safe_receiver = tmp_13;
                    var tmp17_elvis_lhs = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.b46_1;
                    var tmp22_texture = tmp17_elvis_lhs == null ? texture.t3s(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + new Char(numberToChar(id))) : tmp17_elvis_lhs;
                    var tmp4_plusAssign = new Glyph(tmp18_fontSize, id, tmp22_texture, tmp19_xoffset, tmp20_yoffset, tmp21_xadvance);
                    this.b4v_1.b(tmp4_plusAssign);
                    this.hh_1 = 3;
                    continue $sm;
                  } else {
                    if (startsWith(this.h4v_1, 'kerning ')) {
                      var tmp23_safe_receiver = this.i4v_1.z1('first');
                      var tmp24_elvis_lhs = tmp23_safe_receiver == null ? null : toIntOrNull(tmp23_safe_receiver);
                      var tmp_15 = tmp24_elvis_lhs == null ? 0 : tmp24_elvis_lhs;
                      var tmp25_safe_receiver = this.i4v_1.z1('second');
                      var tmp26_elvis_lhs = tmp25_safe_receiver == null ? null : toIntOrNull(tmp25_safe_receiver);
                      var tmp_16 = tmp26_elvis_lhs == null ? 0 : tmp26_elvis_lhs;
                      var tmp27_safe_receiver = this.i4v_1.z1('amount');
                      var tmp28_elvis_lhs = tmp27_safe_receiver == null ? null : toIntOrNull(tmp27_safe_receiver);
                      var tmp5_plusAssign = new Kerning(tmp_15, tmp_16, tmp28_elvis_lhs == null ? 0 : tmp28_elvis_lhs);
                      this.a4v_1.b(tmp5_plusAssign);
                      this.hh_1 = 3;
                      continue $sm;
                    } else {
                      this.hh_1 = 3;
                      continue $sm;
                    }
                  }
                }
              }
            }

            break;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this.y4u_1);
            var tmp1_set = slice(ARGUMENT_0);
            this.w4u_1.x3(this.j4v_1, tmp1_set);
            ;
            this.hh_1 = 3;
            continue $sm;
          case 3:
            this.hh_1 = 1;
            continue $sm;
          case 4:
            var tmp_17 = Companion_getInstance_32();
            var tmp_18 = this.d4v_1;
            var tmp_19 = this.c4v_1;
            var tmp29_elvis_lhs = this.e4v_1;
            var tmp_20 = tmp29_elvis_lhs == null ? this.c4v_1 : tmp29_elvis_lhs;
            var tmp6_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(this.b4v_1, 10));
            var tmp0_iterator = this.b4v_1.g();
            while (tmp0_iterator.h()) {
              var item = tmp0_iterator.i();
              tmp6_mapTo.b(to(item.o4o_1, item));
            }

            var tmp_21 = toIntMap(toMap(tmp6_mapTo));
            return tmp_17.w4o(tmp_18, tmp_19, tmp_20, tmp_21, associateByInt(this.a4v_1, readBitmapFontTxt$lambda));
          case 5:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 5) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function bmp$factory() {
    return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
      return receiver.a4p();
    }, null);
  }
  function naturalFontMetrics$factory() {
    return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
      return receiver.i4p();
    }, null);
  }
  function anyGlyph$factory() {
    return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
      return receiver.h4p();
    }, null);
  }
  function invalidGlyph$factory() {
    return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
      return receiver.u4r();
    }, null);
  }
  var DefaultTtfFontOrNull;
  function get_DefaultTtfFont() {
    if (DefaultTtfFontOrNull == null) {
      var tmp$ret$2;
      // Inline function 'korlibs.time.measureTimeWithResult' call
      var start = PerformanceCounter_getInstance().ij();
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
      tmp$ret$0 = new TtfFont(DefaultTtfFontBytes(), 'Default Font');
      var result = tmp$ret$0;
      var end = PerformanceCounter_getInstance().ij();
      var tmp$ret$1;
      // Inline function 'korlibs.time.microseconds' call
      var tmp0__get_microseconds__mq1imi = end - start;
      tmp$ret$1 = Companion_getInstance_7().nj(tmp0__get_microseconds__mq1imi);
      var elapsed = tmp$ret$1;
      tmp$ret$2 = new TimedResult(result, elapsed);
      var res = tmp$ret$2;
      DefaultTtfFontOrNull = res.fj_1;
    }
    return ensureNotNull(DefaultTtfFontOrNull);
  }
  function DefaultTtfFontBytes() {
    return uncompress(fromBase64('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'), Companion_getInstance_8());
  }
  function get_DefaultTtfFontAsBitmap() {
    return get_lazyBitmapSDF(get_DefaultTtfFont());
  }
  function Font() {
  }
  function TextToBitmapResult(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.l4v_1 = bmp;
    this.m4v_1 = fmetrics;
    this.n4v_1 = metrics;
    this.o4v_1 = glyphs;
    this.p4v_1 = glyphsPerLine;
    this.q4v_1 = shape;
  }
  protoOf(TextToBitmapResult).toString = function () {
    return 'TextToBitmapResult(bmp=' + this.l4v_1 + ', fmetrics=' + this.m4v_1 + ', metrics=' + this.n4v_1 + ', glyphs=' + this.o4v_1 + ', glyphsPerLine=' + this.p4v_1 + ', shape=' + this.q4v_1 + ')';
  };
  protoOf(TextToBitmapResult).hashCode = function () {
    var result = hashCode(this.l4v_1);
    result = imul(result, 31) + this.m4v_1.hashCode() | 0;
    result = imul(result, 31) + this.n4v_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.o4v_1) | 0;
    result = imul(result, 31) + hashCode(this.p4v_1) | 0;
    result = imul(result, 31) + (this.q4v_1 == null ? 0 : hashCode(this.q4v_1)) | 0;
    return result;
  };
  protoOf(TextToBitmapResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.l4v_1, tmp0_other_with_cast.l4v_1))
      return false;
    if (!this.m4v_1.equals(tmp0_other_with_cast.m4v_1))
      return false;
    if (!this.n4v_1.equals(tmp0_other_with_cast.n4v_1))
      return false;
    if (!equals(this.o4v_1, tmp0_other_with_cast.o4v_1))
      return false;
    if (!equals(this.p4v_1, tmp0_other_with_cast.p4v_1))
      return false;
    if (!equals(this.q4v_1, tmp0_other_with_cast.q4v_1))
      return false;
    return true;
  };
  function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
    paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
    fill = fill === VOID ? true : fill;
    effect = effect === VOID ? null : effect;
    border = border === VOID ? 1 : border;
    nativeRendering = nativeRendering === VOID ? true : nativeRendering;
    reader = reader === VOID ? null : reader;
    var font = _this__u8e3s4;
    var fmetrics = _this__u8e3s4.v4r(size);
    var gmetrics = _this__u8e3s4.w4r(size, codePoint, VOID, reader);
    var gx = -gmetrics.k3f();
    var gy = gmetrics.dk() + gmetrics.l3f();
    var border2 = imul(border, 2);
    var iwidth = toIntCeil(gmetrics.ck()) + border2 | 0;
    var iheight = toIntCeil(gmetrics.dk()) + border2 | 0;
    var image = nativeRendering ? NativeImage_0(iwidth, iheight) : new Bitmap32(iwidth, iheight, VOID, true);
    var tmp$ret$1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var tmp0_lock = image.w46_1;
    {
      image.f47();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.b4f(true);
      try {
        // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
        renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
      }finally {
        ctx.p13();
      }
    }finally {
      result = image.x47(tmp0_lock);
    }
    tmp$ret$0 = result;
    tmp$ret$1 = image;
    var imageOut = applyEffect(image.c4f(), effect);
    var glyph = new PlacedGlyphMetrics(codePoint, _Vector2___init__impl__67w0ru_0(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_9().v3f_1, 0, 0);
    var tmp = new TextMetrics();
    var tmp_0 = listOf(glyph);
    var tmp_1 = listOf(listOf(glyph));
    var tmp$ret$3;
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$2;
    // Inline function 'kotlin.apply' call
    var tmp1_apply = new ShapeBuilder(iwidth, iheight);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
    renderGlyphToBitmap$renderGlyph(tmp1_apply, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    tmp$ret$2 = tmp1_apply;
    tmp$ret$3 = tmp$ret$2.b4w();
    return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$1;
      // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
      var tmp0_buildVectorPath = new VectorPath();
      var tmp$ret$0;
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
      tmp0_buildVectorPath.c3o_1 = false;
      tmp0_buildVectorPath.r3y(this$0.e4w_1.k3f(), -this$0.f4w_1.n4p_1, this$0.e4w_1.b4q_1, this$0.f4w_1.c4p());
      tmp$ret$0 = tmp0_buildVectorPath;
      tmp$ret$1 = tmp$ret$0;
      return applyTransform(tmp$ret$1, Matrix__premultiplied_impl_rsndx4(Matrix__translated_impl_3xg5y(Companion_getInstance_9().g3g(), this$0.d4w_1), this$0.g4w_1));
    };
  }
  function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
    return function () {
      var curves = getCurves(this$0.n4w());
      var tmp;
      if (!(curves.n3n_1.j() === 4)) {
        println('curves=' + curves.n3n_1.j());
        tmp = Unit_getInstance();
      }
      return curves;
    };
  }
  function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$0;
      // Inline function 'korlibs.math.geom.Line.flipped' call
      var tmp0_flipped = this$0.o4w().n3n_1.k(3).e3n();
      tmp$ret$0 = _Line___init__impl__emhr1v(_Line___get_b__impl__d23fm8(tmp0_flipped), _Line___get_a__impl__frj1fz(tmp0_flipped));
      return Line__toBezier_impl_tok61t(tmp$ret$0);
    };
  }
  function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
    return function () {
      return this$0.o4w().n3n_1.k(1);
    };
  }
  function PlacedGlyphMetrics(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.c4w_1 = codePoint;
    this.d4w_1 = pos;
    this.e4w_1 = metrics;
    this.f4w_1 = fontMetrics;
    this.g4w_1 = transform;
    this.h4w_1 = index;
    this.i4w_1 = nline;
    var tmp = this;
    tmp.j4w_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.k4w_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.l4w_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.m4w_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  protoOf(PlacedGlyphMetrics).n4w = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = boundsPath$factory();
    tmp$ret$0 = this.j4w_1.q();
    return tmp$ret$0;
  };
  protoOf(PlacedGlyphMetrics).o4w = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = boundsPathCurves$factory();
    tmp$ret$0 = this.k4w_1.q();
    return tmp$ret$0;
  };
  protoOf(PlacedGlyphMetrics).toString = function () {
    return 'PlacedGlyphMetrics(codePoint=' + this.c4w_1 + ', pos=' + new Vector2(this.d4w_1) + ', metrics=' + this.e4w_1 + ', fontMetrics=' + this.f4w_1 + ', transform=' + new Matrix(this.g4w_1) + ', index=' + this.h4w_1 + ', nline=' + this.i4w_1 + ')';
  };
  protoOf(PlacedGlyphMetrics).hashCode = function () {
    var result = this.c4w_1;
    result = imul(result, 31) + Vector2__hashCode_impl_uqm9wj(this.d4w_1) | 0;
    result = imul(result, 31) + this.e4w_1.hashCode() | 0;
    result = imul(result, 31) + this.f4w_1.hashCode() | 0;
    result = imul(result, 31) + Matrix__hashCode_impl_s9ntm9(this.g4w_1) | 0;
    result = imul(result, 31) + this.h4w_1 | 0;
    result = imul(result, 31) + this.i4w_1 | 0;
    return result;
  };
  protoOf(PlacedGlyphMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.c4w_1 === tmp0_other_with_cast.c4w_1))
      return false;
    if (!equals(this.d4w_1, tmp0_other_with_cast.d4w_1))
      return false;
    if (!this.e4w_1.equals(tmp0_other_with_cast.e4w_1))
      return false;
    if (!this.f4w_1.equals(tmp0_other_with_cast.f4w_1))
      return false;
    if (!equals(this.g4w_1, tmp0_other_with_cast.g4w_1))
      return false;
    if (!(this.h4w_1 === tmp0_other_with_cast.h4w_1))
      return false;
    if (!(this.i4w_1 === tmp0_other_with_cast.i4w_1))
      return false;
    return true;
  };
  function TextMetricsResult(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.p4w_1 = fmetrics;
    this.q4w_1 = metrics;
    this.r4w_1 = glyphs;
    this.s4w_1 = glyphsPerLine;
  }
  protoOf(TextMetricsResult).toString = function () {
    return 'TextMetricsResult(fmetrics=' + this.p4w_1 + ', metrics=' + this.q4w_1 + ', glyphs=' + this.r4w_1 + ', glyphsPerLine=' + this.s4w_1 + ')';
  };
  protoOf(TextMetricsResult).hashCode = function () {
    var result = this.p4w_1.hashCode();
    result = imul(result, 31) + this.q4w_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.r4w_1) | 0;
    result = imul(result, 31) + hashCode(this.s4w_1) | 0;
    return result;
  };
  protoOf(TextMetricsResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.p4w_1.equals(tmp0_other_with_cast.p4w_1))
      return false;
    if (!this.q4w_1.equals(tmp0_other_with_cast.q4w_1))
      return false;
    if (!equals(this.r4w_1, tmp0_other_with_cast.r4w_1))
      return false;
    if (!equals(this.s4w_1, tmp0_other_with_cast.s4w_1))
      return false;
    return true;
  };
  function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
    pos = pos === VOID ? Companion_getInstance_0().h3b_1 : pos;
    fill = fill === VOID ? true : fill;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? Companion_getInstance_51().d4x_1 : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? IntCompanionObject_getInstance().MAX_VALUE : textRangeEnd;
    placed = placed === VOID ? null : placed;
    var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
    var fnt = _this__u8e3s4;
    var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
    var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
    var tmp0_safe_receiver = ctx;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t4x();
    }
    invoke(renderer, actions, text, size, _this__u8e3s4);
    doRender();
    if (!(outMetrics == null)) {
      ensureNotNull(glyphs);
      outMetrics.r4w_1 = glyphs.u4x_1;
      outMetrics.s4w_1 = glyphs.v4x_1;
      {
        var fmetrics = _this__u8e3s4.v4r(size);
        outMetrics.p4w_1 = fmetrics;
        var metrics = outMetrics.q4w_1;
        metrics.y4x_1.a4y(fmetrics);
        metrics.z4x_1 = glyphs.v4x_1.j();
        var tmp_1 = metrics;
        var tmp$ret$2;
        // Inline function 'kotlin.collections.map' call
        var tmp1_map = glyphs.v4x_1;
        var tmp$ret$1;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
        var tmp0_iterator = tmp1_map.g();
        while (tmp0_iterator.h()) {
          var item = tmp0_iterator.i();
          var tmp$ret$0;
          // Inline function 'korlibs.image.font.drawText.<anonymous>' call
          var bb = Companion_getInstance_10().f3b();
          var tmp0_iterator_0 = item.g();
          while (tmp0_iterator_0.h()) {
            var g = tmp0_iterator_0.i();
            bb = plus_1(bb, g.n4w());
          }
          tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
          tmp0_mapTo.b(new Rectangle(tmp$ret$0));
        }
        tmp$ret$1 = tmp0_mapTo;
        tmp$ret$2 = tmp$ret$1;
        tmp_1.x4x_1 = tmp$ret$2;
        metrics.w4x_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_10().f3b(), metrics.x4x_1));
      }
    }
    return outMetrics;
  }
  function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
    out = out === VOID ? new TextMetrics() : out;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? Companion_getInstance_51().z4w_1 : align;
    var actions = new BoundBuilderTextRendererActions();
    invoke(renderer, actions, text, size, _this__u8e3s4);
    _this__u8e3s4.k4p(size, out.y4x_1);
    out.z4x_1 = actions.q4y();
    var bb = Companion_getInstance_10().f3b();
    var dy = 0.0;
    var lineBounds = FastArrayList_init_$Create$();
    var offsetY = actions.u4y(align.s4y_1, out.y4x_1);
    var tmp0_iterator = actions.o4y_1.g();
    while (tmp0_iterator.h()) {
      var line = tmp0_iterator.i();
      var offsetX = line.y4y(align.r4y_1);
      var rect = Companion_getInstance_6().o3i(-offsetX, +offsetY + dy - out.z4y(), line.w4y_1, line.v4y_1);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
      lineBounds.b(new Rectangle(rect));
      dy = dy + line.v4y_1;
    }
    out.x4x_1 = lineBounds;
    out.w4x_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
    return out;
  }
  function MultiplePlacedGlyphMetrics() {
    this.u4x_1 = FastArrayList_init_$Create$();
    this.v4x_1 = FastArrayList_init_$Create$();
  }
  protoOf(MultiplePlacedGlyphMetrics).j = function () {
    return this.u4x_1.j();
  };
  protoOf(MultiplePlacedGlyphMetrics).a4z = function (glyph) {
    var tmp0_this = this;
    // Inline function 'kotlin.collections.plusAssign' call
    var tmp0_plusAssign = tmp0_this.u4x_1;
    tmp0_plusAssign.b(glyph);
    while (this.v4x_1.j() <= glyph.i4w_1) {
      this.v4x_1.b(FastArrayList_init_$Create$());
    }
    this.v4x_1.k(glyph.i4w_1).b(glyph);
  };
  function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
    _this__u8e3s4.d4r($paint);
    font.x4r(_this__u8e3s4, $size, $codePoint, _Vector2___init__impl__67w0ru_0(gx + $border, gy + $border), true, gmetrics);
    if ($fill) {
      _this__u8e3s4.c4z();
    } else {
      _this__u8e3s4.b4z();
    }
  }
  function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
    return function () {
      var tmp;
      if (!($fillStyle == null) ? true : !($stroke == null)) {
        var tmp0_safe_receiver = $ctx;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
          // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
          var tmp0_safe_receiver_0 = $stroke;
          var tmp12_fillStroke = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d4z_1;
          var tmp1_safe_receiver = $stroke;
          var tmp13_fillStroke = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e4z_1;
          var tmp$ret$0;
          // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
          tmp$ret$0 = Unit_getInstance();
          if (!($fillStyle == null)) {
            tmp0_safe_receiver.f4z($fillStyle);
          }
          if (!(tmp12_fillStroke == null)) {
            if (!(tmp13_fillStroke == null)) {
              var tmp$ret$1;
              $l$block: {
                // Inline function 'korlibs.image.vector.Context2d.stroke' call
                if (tmp12_fillStroke == null ? true : tmp13_fillStroke == null) {
                  tmp$ret$1 = Unit_getInstance();
                  break $l$block;
                }
                // Inline function 'korlibs.image.vector.Context2d.stroke' call
                var tmp0_stroke = tmp13_fillStroke.m3o_1;
                var tmp1_stroke = tmp13_fillStroke.p3o_1;
                var tmp2_stroke = tmp13_fillStroke.r3o_1;
                var tmp3_stroke = tmp13_fillStroke.s3o_1;
                var tmp4_stroke = tmp13_fillStroke.t3o_1;
                var tmp5_stroke = tmp13_fillStroke.u3o_1;
                if (false) {
                  tmp0_safe_receiver.t4x();
                }
                var tmp$ret$2;
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp$ret$2 = Unit_getInstance();
                // Inline function 'korlibs.image.vector.Context2d.keep' call
                tmp0_safe_receiver.m4z();
                try {
                  // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                  tmp0_safe_receiver.n4z(tmp0_stroke);
                  tmp0_safe_receiver.o4z(tmp1_stroke);
                  tmp0_safe_receiver.p4z(tmp2_stroke);
                  tmp0_safe_receiver.q4z(tmp3_stroke);
                  tmp0_safe_receiver.r4z(tmp4_stroke);
                  tmp0_safe_receiver.s4z(tmp5_stroke);
                  tmp0_safe_receiver.t4z(tmp12_fillStroke);
                }finally {
                  tmp0_safe_receiver.u4z();
                }
              }
            } else {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var tmp6_stroke = tmp0_safe_receiver.g4z();
              var tmp7_stroke = tmp0_safe_receiver.h4z();
              var tmp8_stroke = tmp0_safe_receiver.i4z();
              var tmp9_stroke = tmp0_safe_receiver.j4z();
              var tmp10_stroke = tmp0_safe_receiver.k4z();
              var tmp11_stroke = tmp0_safe_receiver.l4z();
              if (false) {
                tmp0_safe_receiver.t4x();
              }
              var tmp$ret$3;
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              tmp$ret$3 = Unit_getInstance();
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp0_safe_receiver.m4z();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp0_safe_receiver.n4z(tmp6_stroke);
                tmp0_safe_receiver.o4z(tmp7_stroke);
                tmp0_safe_receiver.p4z(tmp8_stroke);
                tmp0_safe_receiver.q4z(tmp9_stroke);
                tmp0_safe_receiver.r4z(tmp10_stroke);
                tmp0_safe_receiver.s4z(tmp11_stroke);
                tmp0_safe_receiver.t4z(tmp12_fillStroke);
              }finally {
                tmp0_safe_receiver.u4z();
              }
            }
          }
        }
        tmp = Unit_getInstance();
      } else {
        var tmp_0;
        if ($fill) {
          var tmp1_safe_receiver_0 = $ctx;
          if (tmp1_safe_receiver_0 == null)
            null;
          else {
            tmp1_safe_receiver_0.c4z();
          }
          tmp_0 = Unit_getInstance();
        } else {
          var tmp2_safe_receiver = $ctx;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.b4z();
          }
          tmp_0 = Unit_getInstance();
        }
        tmp = tmp_0;
      }
      var tmp3_safe_receiver = $ctx;
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.t4x();
      }
      return Unit_getInstance();
    };
  }
  function drawText$actions$1($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed) {
    this.h50_1 = $size;
    this.i50_1 = $align;
    this.j50_1 = $pos;
    this.k50_1 = $ctx;
    this.l50_1 = $paint;
    this.m50_1 = $textRangeStart;
    this.n50_1 = $textRangeEnd;
    this.o50_1 = $doRender;
    this.p50_1 = $glyphs;
    this.q50_1 = $placed;
    TextRendererActions.call(this);
    this.f50_1 = measure($renderer, $text, $size, $fnt);
    this.g50_1 = 0;
  }
  protoOf(drawText$actions$1).r50 = function (reader, codePoint) {
    var nline = this.c51();
    var dx = this.f50_1.d51(this.i50_1.r4y_1, nline);
    var dy = this.f50_1.u4y(this.i50_1.s4y_1, this.u50_1);
    var px = _Vector2___get_x__impl__zywdz(this.e51()) + _Vector2___get_x__impl__zywdz(this.j50_1) - dx;
    var py = _Vector2___get_y__impl__ttldg6(this.e51()) + _Vector2___get_y__impl__ttldg6(this.j50_1) + dy;
    var tmp0_safe_receiver = this.k50_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp0_safe_receiver.g4f_1.g4q_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        var tmp$ret$0;
        // Inline function 'korlibs.image.vector.Context2d.translate' call
        this.k50_1.f51(numberToDouble(px), numberToDouble(py));
        tmp$ret$0 = Unit_getInstance();
        this.k50_1.h51(_Matrix___get_immutable__impl__k08qr(this.g51()));
        var tmp0_elvis_lhs = this.a51_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.l50_1 : tmp0_elvis_lhs;
        this.k50_1.d4r(tmp1_elvis_lhs == null ? NonePaint_getInstance() : tmp1_elvis_lhs);
        var containsLower = this.m50_1;
        var containsUpper = this.n50_1;
        var containsArg = this.g50_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.i51().f4q(this.k50_1, this.h50_1, codePoint, Companion_getInstance_0().h3b_1, null, this.t50_1, reader, this.o50_1);
        }
        var tmp2_this = this;
        var tmp3 = tmp2_this.g50_1;
        tmp2_this.g50_1 = tmp3 + 1 | 0;
      }finally {
        tmp0_safe_receiver.g4f_1.g4q_1 = t;
      }
    }
    if (!(this.p50_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, _Vector2___init__impl__67w0ru_0(px, py), this.t50_1.dn(), this.u50_1.dn(), this.g51(), this.p50_1.j(), nline);
      this.p50_1.a4z(glyph);
    }
    var tmp1_safe_receiver = this.q50_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver(this, codePoint, new Vector2(_Vector2___init__impl__67w0ru_0(px, py)), this.h50_1, this.t50_1, this.u50_1, new Matrix(this.g51()));
    return this.t50_1;
  };
  function boundsPath$factory() {
    return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
      return receiver.n4w();
    }, null);
  }
  function boundsPathCurves$factory() {
    return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
      return receiver.o4w();
    }, null);
  }
  function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
    preload = preload === VOID ? false : preload;
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    var tmp = new $readFontCOROUTINE$5(_this__u8e3s4, preload, props, mipmaps, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function $readFontCOROUTINE$5(_this__u8e3s4, preload, props, mipmaps, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y51_1 = _this__u8e3s4;
    this.z51_1 = preload;
    this.a52_1 = props;
    this.b52_1 = mipmaps;
  }
  protoOf($readFontCOROUTINE$5).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 5;
            this.hh_1 = 1;
            suspendResult = this.y51_1.w1y(until(0, 16), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.c52_1 = suspendResult;
            this.d52_1 = readS32BE(this.c52_1, 0);
            if ((this.d52_1 === 1953784678 ? true : this.d52_1 === 1330926671) ? true : this.d52_1 === 65536) {
              this.hh_1 = 3;
              suspendResult = readTtfFont(this.y51_1, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 2;
              suspendResult = readBitmapFont(this.y51_1, this.a52_1, this.b52_1, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 2:
            this.e52_1 = suspendResult;
            this.hh_1 = 4;
            continue $sm;
          case 3:
            this.e52_1 = suspendResult;
            this.hh_1 = 4;
            continue $sm;
          case 4:
            return this.e52_1;
          case 5:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 5) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  var SystemFontRegistryOrNull;
  function GlyphPath(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? _Vector2___init__impl__67w0ru(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? _Scale___init__impl__ov1qs1(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_9().g3g() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.f52_1 = path;
    this.g52_1 = colorShape;
    this.h52_1 = bitmap;
    this.i52_1 = bitmapOffset;
    this.j52_1 = bitmapScale;
    this.k52_1 = transform;
    this.l52_1 = scale;
  }
  protoOf(GlyphPath).m52 = function () {
    return this.h52_1 == null ? this.g52_1 == null : false;
  };
  protoOf(GlyphPath).n52 = function (c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.g4f_1.g4q_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.h51(this.k52_1);
      if (!(this.h52_1 == null)) {
        c.f4r(ensureNotNull(this.h52_1), this.i52_1, Size__times_impl_fnp4nc(toFloat(ensureNotNull(this.h52_1).k3s()), this.j52_1));
      } else if (!(this.g52_1 == null)) {
        c.o52(ensureNotNull(this.g52_1));
        c.t4x();
      } else {
        draw_1(c, this.f52_1);
      }
    }finally {
      c.g4f_1.g4q_1 = t;
    }
  };
  protoOf(GlyphPath).toString = function () {
    return 'GlyphPath(path=' + this.f52_1 + ', colorShape=' + this.g52_1 + ', bitmap=' + this.h52_1 + ', bitmapOffset=' + new Vector2(this.i52_1) + ', bitmapScale=' + new Scale(this.j52_1) + ', transform=' + new Matrix(this.k52_1) + ', scale=' + this.l52_1 + ')';
  };
  protoOf(GlyphPath).hashCode = function () {
    var result = this.f52_1.hashCode();
    result = imul(result, 31) + (this.g52_1 == null ? 0 : hashCode(this.g52_1)) | 0;
    result = imul(result, 31) + (this.h52_1 == null ? 0 : hashCode(this.h52_1)) | 0;
    result = imul(result, 31) + Vector2__hashCode_impl_uqm9wj(this.i52_1) | 0;
    result = imul(result, 31) + Scale__hashCode_impl_uultfs(this.j52_1) | 0;
    result = imul(result, 31) + Matrix__hashCode_impl_s9ntm9(this.k52_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l52_1) | 0;
    return result;
  };
  protoOf(GlyphPath).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.f52_1.equals(tmp0_other_with_cast.f52_1))
      return false;
    if (!equals(this.g52_1, tmp0_other_with_cast.g52_1))
      return false;
    if (!equals(this.h52_1, tmp0_other_with_cast.h52_1))
      return false;
    if (!equals(this.i52_1, tmp0_other_with_cast.i52_1))
      return false;
    if (!equals(this.j52_1, tmp0_other_with_cast.j52_1))
      return false;
    if (!equals(this.k52_1, tmp0_other_with_cast.k52_1))
      return false;
    if (!equals(this.l52_1, tmp0_other_with_cast.l52_1))
      return false;
    return true;
  };
  var lazyBitmap$delegate;
  function get_lazyBitmapSDF(_this__u8e3s4) {
    _init_properties_LazyBitmapFont_kt__76ptri();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var tmp0_getValue = lazyBitmapSDF$factory();
      var tmp0_elvis_lhs = lazyBitmapSDF$delegate.pu_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp0_getValue.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = lazyBitmapSDF$delegate.qu_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = lazyBitmapSDF$delegate.pu_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp0_getValue.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var lazyBitmapSDF$delegate;
  function Companion_13() {
    Companion_instance_13 = this;
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$0;
    // Inline function 'kotlin.code' call
    tmp$ret$0 = 32;
    var tmp0_intArrayOf = new Int32Array([tmp$ret$0]);
    tmp$ret$1 = tmp0_intArrayOf;
    tmp.p52_1 = tmp$ret$1;
  }
  var Companion_instance_13;
  function Companion_getInstance_33() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.y52_1.k(this$0.y52_1.a2().g().i());
      return tmp0_elvis_lhs == null ? this$0.u4r() : tmp0_elvis_lhs;
    };
  }
  function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$0;
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
      tmp$ret$0 = get_Bitmaps_transparent();
      return new Glyph(this$0.r52_1, -1, tmp$ret$0, 0, 0, 0);
    };
  }
  function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
    return function () {
      var descent = this$0.v52_1.p4p_1 - this$0.v52_1.r4p_1;
      var tmp0_size = this$0.v52_1.l4p_1;
      var tmp1_top = this$0.v52_1.m4p_1;
      var tmp2_ascent = this$0.v52_1.n4p_1;
      var tmp3_baseline = this$0.v52_1.o4p_1;
      var tmp4_maxWidth = this$0.v52_1.s4p_1;
      return new FontMetrics(tmp0_size, tmp1_top, tmp2_ascent, tmp3_baseline, descent, descent, 0.0, tmp4_maxWidth, 0.0);
    };
  }
  function LazyBitmapFont(font, fontSize, distanceField) {
    Companion_getInstance_33();
    distanceField = distanceField === VOID ? null : distanceField;
    this.q52_1 = font;
    this.r52_1 = fontSize;
    this.s52_1 = distanceField;
    this.t52_1 = new Mixin();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = MutableAtlas_init_$Create$(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.s52_1 == null)) {
    } else {
      mipmaps(tmp0_also.j46_1);
    }
    tmp$ret$0 = tmp0_also;
    tmp.u52_1 = tmp$ret$0;
    this.v52_1 = this.q52_1.v4r(this.r52_1);
    this.w52_1 = this.v52_1.c4p();
    this.x52_1 = this.v52_1.o4p_1;
    this.y52_1 = IntMap_init_$Create$();
    this.z52_1 = IntMap_init_$Create$();
    var tmp_0 = this;
    tmp_0.a53_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.b53_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.c53_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.d53_1 = new GlyphMetrics(this.r52_1, false, 0, Companion_getInstance_6().p3i(), 0.0);
  }
  protoOf(LazyBitmapFont).b4p = function () {
    return this.r52_1;
  };
  protoOf(LazyBitmapFont).d4p = function () {
    return this.s52_1;
  };
  protoOf(LazyBitmapFont).lu = function (_set____db54di) {
    this.t52_1.lu(_set____db54di);
  };
  protoOf(LazyBitmapFont).mu = function () {
    return this.t52_1.mu();
  };
  protoOf(LazyBitmapFont).c4p = function () {
    return this.w52_1;
  };
  protoOf(LazyBitmapFont).l3s = function () {
    return this.x52_1;
  };
  protoOf(LazyBitmapFont).e4p = function () {
    return this.y52_1;
  };
  protoOf(LazyBitmapFont).f4p = function () {
    return this.z52_1;
  };
  protoOf(LazyBitmapFont).h4p = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = anyGlyph$factory_0();
    tmp$ret$0 = this.a53_1.q();
    return tmp$ret$0;
  };
  protoOf(LazyBitmapFont).u4r = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = invalidGlyph$factory_0();
    tmp$ret$0 = this.b53_1.q();
    return tmp$ret$0;
  };
  protoOf(LazyBitmapFont).qg = function () {
    return this.q52_1.qg();
  };
  protoOf(LazyBitmapFont).i4p = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = naturalFontMetrics$factory_0();
    tmp$ret$0 = this.c53_1.q();
    return tmp$ret$0;
  };
  protoOf(LazyBitmapFont).j4p = function () {
    return this.d53_1;
  };
  protoOf(LazyBitmapFont).d4q = function (first, second) {
    var kerning = this.q52_1.g4r(this.r52_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var tmp0_getOrPut = this.z52_1;
      var tmp1_getOrPut = Companion_getInstance_31().m4o(first, second);
      var res = tmp0_getOrPut.k(tmp1_getOrPut);
      if (res == null) {
        var tmp$ret$0;
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        tmp0_getOrPut.wr(tmp1_getOrPut, tmp$ret$0);
      }
      tmp$ret$1 = ensureNotNull(tmp0_getOrPut.k(tmp1_getOrPut));
      tmp = tmp$ret$1;
    }
    return tmp;
  };
  protoOf(LazyBitmapFont).w4p = function (codePoint) {
    if (this.y52_1.k(codePoint) == null) {
      var tmp$ret$0;
      // Inline function 'kotlin.code' call
      tmp$ret$0 = 97;
      var tmp = tmp$ret$0;
      var tmp$ret$1;
      // Inline function 'kotlin.code' call
      tmp$ret$1 = 122;
      this.e53(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      var tmp$ret$2;
      // Inline function 'kotlin.code' call
      tmp$ret$2 = 65;
      var tmp_0 = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.code' call
      tmp$ret$3 = 90;
      this.e53(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      var tmp$ret$4;
      // Inline function 'kotlin.code' call
      tmp$ret$4 = 48;
      var tmp_1 = tmp$ret$4;
      var tmp$ret$5;
      // Inline function 'kotlin.code' call
      tmp$ret$5 = 57;
      this.e53(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      var tmp$ret$6;
      // Inline function 'kotlin.intArrayOf' call
      tmp$ret$6 = new Int32Array([codePoint]);
      this.f53(tmp$ret$6);
    }
    return this.y52_1.k(codePoint);
  };
  protoOf(LazyBitmapFont).e53 = function (codePoint, range) {
    var containsLower = range.a1_1;
    if (codePoint <= range.b1_1 ? containsLower <= codePoint : false) {
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.toIntList' call
      var tmp$ret$0;
      // Inline function 'kotlin.also' call
      var tmp0_also = new IntArrayList(coerceAtLeast(range.k6() - range.j6() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.j6();
      var last = range.k6();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tmp0_also.un(v);
        }
         while (!(v === last));
      tmp$ret$0 = tmp0_also;
      tmp$ret$1 = tmp$ret$0;
      this.f53(tmp$ret$1.eo());
    }
  };
  protoOf(LazyBitmapFont).f53 = function (codePoints) {
    var tmp$ret$3;
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var tmp0_lock = this.u52_1.j46_1;
    var tmp1_lock = tmp0_lock.w46_1;
    {
      tmp0_lock.f47();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp0__anonymous__q1qw7t = codePoints[tmp0];
        var tmp$ret$2;
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var tmp0_getOrPut = this.y52_1;
        var res = tmp0_getOrPut.k(tmp0__anonymous__q1qw7t);
        if (res == null) {
          var tmp$ret$1;
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.s52_1 == null)) {
            var tmp$ret$0;
            // Inline function 'kotlin.math.max' call
            var tmp0_max = toIntCeil_0(this.r52_1 / 8.0);
            tmp$ret$0 = Math.max(4, tmp0_max);
            tmp = tmp$ret$0;
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp0_$receiver = this.q52_1;
          var tmp1_size = this.r52_1;
          var tmp2_paint = Colors_getInstance().j48_1;
          var result_0 = renderGlyphToBitmap(tmp0_$receiver, tmp1_size, tmp0__anonymous__q1qw7t, new RGBA(tmp2_paint), true, null, border);
          var bmp = result_0.l4v_1.e47();
          var tmp3_subject = this.s52_1;
          {
            var rbmp;
            switch (tmp3_subject) {
              case 'msdf':
                rbmp = msdfBmp(ensureNotNull(result_0.q4v_1).g53(), bmp.r46_1, bmp.s46_1);
                break;
              case 'sdf':
                rbmp = sdfBmp(ensureNotNull(result_0.q4v_1).g53(), bmp.r46_1, bmp.s46_1);
                break;
              default:
                rbmp = bmp;
                break;
            }
          }
          var entry = this.u52_1.q46(rbmp, Unit_getInstance());
          var slice = entry.b46_1.r3s(border, border, entry.b46_1.s3r_1 - border | 0, entry.b46_1.t3r_1 - border | 0);
          var g = first(result_0.o4v_1);
          var m = g.e4w_1;
          var xadvance = m.b4q_1;
          tmp$ret$1 = new Glyph(this.r52_1, tmp0__anonymous__q1qw7t, slice, -toIntRound_0(_Vector2___get_x__impl__zywdz(g.d4w_1)) | 0, -toIntRound_0(_Vector2___get_y__impl__ttldg6(g.d4w_1)) | 0, toIntRound_0(xadvance));
          tmp0_getOrPut.wr(tmp0__anonymous__q1qw7t, tmp$ret$1);
        }
        tmp$ret$2 = ensureNotNull(tmp0_getOrPut.k(tmp0__anonymous__q1qw7t));
      }
    }finally {
      result = tmp0_lock.x47(tmp1_lock);
    }
    tmp$ret$3 = result;
  };
  function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
    distanceField = distanceField === VOID ? null : distanceField;
    _init_properties_LazyBitmapFont_kt__76ptri();
    return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
  }
  function lazyBitmap$delegate$lambda($this$$receiver) {
    _init_properties_LazyBitmapFont_kt__76ptri();
    return toLazyBitmapFont($this$$receiver, 32.0, null);
  }
  function lazyBitmapSDF$delegate$lambda($this$$receiver) {
    _init_properties_LazyBitmapFont_kt__76ptri();
    return toLazyBitmapFont($this$$receiver, 32.0, 'sdf');
  }
  function lazyBitmapSDF$factory() {
    return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
      return get_lazyBitmapSDF(receiver);
    }, null);
  }
  function anyGlyph$factory_0() {
    return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
      return receiver.h4p();
    }, null);
  }
  function invalidGlyph$factory_0() {
    return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
      return receiver.u4r();
    }, null);
  }
  function naturalFontMetrics$factory_0() {
    return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
      return receiver.i4p();
    }, null);
  }
  var properties_initialized_LazyBitmapFont_kt_c74u44;
  function _init_properties_LazyBitmapFont_kt__76ptri() {
    if (properties_initialized_LazyBitmapFont_kt_c74u44) {
    } else {
      properties_initialized_LazyBitmapFont_kt_c74u44 = true;
      lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
      lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
    }
  }
  function FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.l4p_1 = size;
    this.m4p_1 = top;
    this.n4p_1 = ascent;
    this.o4p_1 = baseline;
    this.p4p_1 = descent;
    this.q4p_1 = bottom;
    this.r4p_1 = lineGap;
    this.s4p_1 = maxWidth;
    this.t4p_1 = unitsPerEm;
  }
  protoOf(FontMetrics).h53 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    var tmp0_max = this.n4p_1;
    var tmp1_max = this.m4p_1;
    tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
    return tmp$ret$0;
  };
  protoOf(FontMetrics).i53 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.p4p_1;
    var tmp1_min = this.q4p_1;
    tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
    return tmp$ret$0;
  };
  protoOf(FontMetrics).j53 = function () {
    return this.h53() - this.i53();
  };
  protoOf(FontMetrics).c4p = function () {
    return this.j53() + this.r4p_1;
  };
  protoOf(FontMetrics).a4y = function (other) {
    return this.k53(other, 1.0);
  };
  protoOf(FontMetrics).u4p = function (other, size) {
    return this.k53(other, size / other.l4p_1);
  };
  protoOf(FontMetrics).k53 = function (other, scale) {
    this.l4p_1 = other.l4p_1 * scale;
    this.m4p_1 = other.m4p_1 * scale;
    this.n4p_1 = other.n4p_1 * scale;
    this.o4p_1 = other.o4p_1 * scale;
    this.p4p_1 = other.p4p_1 * scale;
    this.q4p_1 = other.q4p_1 * scale;
    this.r4p_1 = other.r4p_1 * scale;
    this.t4p_1 = other.t4p_1 * scale;
    this.s4p_1 = other.s4p_1 * scale;
    return this;
  };
  protoOf(FontMetrics).toString = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    tmp0_apply.ve('FontMetrics(');
    tmp0_apply.ve('size=' + niceStr(this.l4p_1, 1) + ', ');
    tmp0_apply.ve('top=' + niceStr(this.m4p_1, 1) + ', ');
    tmp0_apply.ve('ascent=' + niceStr(this.n4p_1, 1) + ', ');
    tmp0_apply.ve('baseline=' + niceStr(this.o4p_1, 1) + ', ');
    tmp0_apply.ve('descent=' + niceStr(this.p4p_1, 1) + ', ');
    tmp0_apply.ve('bottom=' + niceStr(this.q4p_1, 1) + ', ');
    tmp0_apply.ve('lineGap=' + niceStr(this.r4p_1, 1) + ', ');
    tmp0_apply.ve('unitsPerEm=' + niceStr(this.t4p_1, 1) + ', ');
    tmp0_apply.ve('maxWidth=' + niceStr(this.s4p_1, 1) + ', ');
    tmp0_apply.ve('lineHeight=' + niceStr(this.c4p(), 1));
    tmp0_apply.ve(')');
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  protoOf(FontMetrics).dn = function () {
    return this.l53();
  };
  protoOf(FontMetrics).m53 = function (size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  };
  protoOf(FontMetrics).l53 = function (size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.l4p_1 : size;
    top = top === VOID ? this.m4p_1 : top;
    ascent = ascent === VOID ? this.n4p_1 : ascent;
    baseline = baseline === VOID ? this.o4p_1 : baseline;
    descent = descent === VOID ? this.p4p_1 : descent;
    bottom = bottom === VOID ? this.q4p_1 : bottom;
    lineGap = lineGap === VOID ? this.r4p_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.s4p_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.t4p_1 : unitsPerEm;
    return $super === VOID ? this.m53(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.m53.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  };
  protoOf(FontMetrics).hashCode = function () {
    var result = getNumberHashCode(this.l4p_1);
    result = imul(result, 31) + getNumberHashCode(this.m4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s4p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t4p_1) | 0;
    return result;
  };
  protoOf(FontMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.l4p_1, tmp0_other_with_cast.l4p_1))
      return false;
    if (!equals(this.m4p_1, tmp0_other_with_cast.m4p_1))
      return false;
    if (!equals(this.n4p_1, tmp0_other_with_cast.n4p_1))
      return false;
    if (!equals(this.o4p_1, tmp0_other_with_cast.o4p_1))
      return false;
    if (!equals(this.p4p_1, tmp0_other_with_cast.p4p_1))
      return false;
    if (!equals(this.q4p_1, tmp0_other_with_cast.q4p_1))
      return false;
    if (!equals(this.r4p_1, tmp0_other_with_cast.r4p_1))
      return false;
    if (!equals(this.s4p_1, tmp0_other_with_cast.s4p_1))
      return false;
    if (!equals(this.t4p_1, tmp0_other_with_cast.t4p_1))
      return false;
    return true;
  };
  function GlyphMetrics(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_6().p3i() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.x4p_1 = size;
    this.y4p_1 = existing;
    this.z4p_1 = codePoint;
    this.a4q_1 = bounds;
    this.b4q_1 = xadvance;
  }
  protoOf(GlyphMetrics).n3f = function () {
    return _Rectangle___get_bottom__impl__1duj44(this.a4q_1);
  };
  protoOf(GlyphMetrics).k3f = function () {
    return _Rectangle___get_left__impl__sgtjiw(this.a4q_1);
  };
  protoOf(GlyphMetrics).l3f = function () {
    return _Rectangle___get_top__impl__3kuxui(this.a4q_1);
  };
  protoOf(GlyphMetrics).ck = function () {
    return _Rectangle___get_width__impl__y1u79l(this.a4q_1);
  };
  protoOf(GlyphMetrics).dk = function () {
    return _Rectangle___get_height__impl__kro6o8(this.a4q_1);
  };
  protoOf(GlyphMetrics).dn = function () {
    return this.n53(VOID, VOID, VOID, Rectangle__clone_impl_pibhs1(this.a4q_1));
  };
  protoOf(GlyphMetrics).c4q = function (other, size, codePoint) {
    return this.o53(other, size / other.x4p_1, codePoint);
  };
  protoOf(GlyphMetrics).o53 = function (other, scale, codePoint) {
    this.x4p_1 = other.x4p_1;
    this.y4p_1 = other.y4p_1;
    this.z4p_1 = codePoint;
    this.a4q_1 = Rectangle__times_impl_w4xjii(other.a4q_1, scale);
    this.b4q_1 = other.b4q_1 * scale;
    return this;
  };
  protoOf(GlyphMetrics).toString = function () {
    var tmp$ret$2;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    tmp0_apply.ve('GlyphMetrics(');
    tmp0_apply.ve('codePoint=' + this.z4p_1 + " ('" + new Char(numberToChar(this.z4p_1)) + "'), ");
    tmp0_apply.ve('existing=' + this.y4p_1 + ', ');
    var tmp$ret$0;
    // Inline function 'kotlin.math.roundToInt' call
    var tmp0_roundToInt = this.b4q_1;
    tmp$ret$0 = roundToInt(tmp0_roundToInt);
    tmp0_apply.ve('xadvance=' + tmp$ret$0 + ', ');
    tmp0_apply.ve('bounds=' + new RectangleInt(Rectangle__toInt_impl_jycbk8(this.a4q_1)));
    tmp0_apply.ve(')');
    tmp$ret$1 = tmp0_apply;
    tmp$ret$2 = tmp$ret$1.toString();
    return tmp$ret$2;
  };
  protoOf(GlyphMetrics).p53 = function (size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  };
  protoOf(GlyphMetrics).n53 = function (size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.x4p_1 : size;
    existing = existing === VOID ? this.y4p_1 : existing;
    codePoint = codePoint === VOID ? this.z4p_1 : codePoint;
    bounds = bounds === VOID ? this.a4q_1 : bounds;
    xadvance = xadvance === VOID ? this.b4q_1 : xadvance;
    return $super === VOID ? this.p53(size, existing, codePoint, bounds, xadvance) : $super.p53.call(this, size, existing, codePoint, new Rectangle(bounds), xadvance);
  };
  protoOf(GlyphMetrics).hashCode = function () {
    var result = getNumberHashCode(this.x4p_1);
    result = imul(result, 31) + (this.y4p_1 | 0) | 0;
    result = imul(result, 31) + this.z4p_1 | 0;
    result = imul(result, 31) + Rectangle__hashCode_impl_j3wwhv(this.a4q_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b4q_1) | 0;
    return result;
  };
  protoOf(GlyphMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.x4p_1, tmp0_other_with_cast.x4p_1))
      return false;
    if (!(this.y4p_1 === tmp0_other_with_cast.y4p_1))
      return false;
    if (!(this.z4p_1 === tmp0_other_with_cast.z4p_1))
      return false;
    if (!equals(this.a4q_1, tmp0_other_with_cast.a4q_1))
      return false;
    if (!equals(this.b4q_1, tmp0_other_with_cast.b4q_1))
      return false;
    return true;
  };
  function TextMetrics(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_6().p3i() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.w4x_1 = bounds;
    this.x4x_1 = lineBounds;
    this.y4x_1 = fontMetrics;
    this.z4x_1 = nlines;
  }
  protoOf(TextMetrics).q53 = function () {
    var tmp = firstOrNull_1(this.x4x_1);
    var tmp0_elvis_lhs = tmp == null ? null : tmp.q3b_1;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new Rectangle(tmp_1)) == null) {
      tmp_0 = Companion_getInstance_6().b3b_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(TextMetrics).k3f = function () {
    return _Rectangle___get_left__impl__sgtjiw(this.w4x_1);
  };
  protoOf(TextMetrics).l3f = function () {
    return _Rectangle___get_top__impl__3kuxui(this.w4x_1);
  };
  protoOf(TextMetrics).ck = function () {
    return _Rectangle___get_width__impl__y1u79l(this.w4x_1);
  };
  protoOf(TextMetrics).dk = function () {
    return _Rectangle___get_height__impl__kro6o8(this.w4x_1);
  };
  protoOf(TextMetrics).r53 = function () {
    return -this.k3f();
  };
  protoOf(TextMetrics).s53 = function () {
    return _Rectangle___get_height__impl__kro6o8(this.q53()) + _Rectangle___get_top__impl__3kuxui(this.q53());
  };
  protoOf(TextMetrics).z4y = function () {
    return this.y4x_1.n4p_1;
  };
  protoOf(TextMetrics).toString = function () {
    return 'TextMetrics[' + get_niceStr(this.k3f()) + ', ' + get_niceStr(this.l3f()) + ', ' + get_niceStr(this.ck()) + ', ' + get_niceStr(this.dk()) + '][' + get_niceStr(this.r53()) + ', ' + get_niceStr(this.s53()) + ']';
  };
  protoOf(TextMetrics).hashCode = function () {
    var result = Rectangle__hashCode_impl_j3wwhv(this.w4x_1);
    result = imul(result, 31) + hashCode(this.x4x_1) | 0;
    result = imul(result, 31) + this.y4x_1.hashCode() | 0;
    result = imul(result, 31) + this.z4x_1 | 0;
    return result;
  };
  protoOf(TextMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!equals(this.w4x_1, tmp0_other_with_cast.w4x_1))
      return false;
    if (!equals(this.x4x_1, tmp0_other_with_cast.x4x_1))
      return false;
    if (!this.y4x_1.equals(tmp0_other_with_cast.y4x_1))
      return false;
    if (!(this.z4x_1 === tmp0_other_with_cast.z4x_1))
      return false;
    return true;
  };
  var _nativeSystemFontProvider;
  function DataIndex_init_$Init$($this) {
    var tmp$ret$0;
    // Inline function 'kotlin.intArrayOf' call
    tmp$ret$0 = new Int32Array([0]);
    var tmp = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.byteArrayOf' call
    tmp$ret$1 = new Int8Array([]);
    DataIndex.call($this, tmp, tmp$ret$1);
    return $this;
  }
  function DataIndex_init_$Create$() {
    return DataIndex_init_$Init$(objectCreate(protoOf(DataIndex)));
  }
  var Op_version_instance;
  var Op_Copyright_instance;
  var Op_Notice_instance;
  var Op_isFixedPitch_instance;
  var Op_FullName_instance;
  var Op_ItalicAngle_instance;
  var Op_FamilyName_instance;
  var Op_UnderlinePosition_instance;
  var Op_Weight_instance;
  var Op_UnderlineThickness_instance;
  var Op_FontBBox_instance;
  var Op_PaintType_instance;
  var Op_BlueValues_instance;
  var Op_CharstringType_instance;
  var Op_OtherBlues_instance;
  var Op_FontMatrix_instance;
  var Op_FamilyBlues_instance;
  var Op_StrokeWidth_instance;
  var Op_FamilyOtherBlues_instance;
  var Op_BlueScale_instance;
  var Op_StdHW_instance;
  var Op_BlueShift_instance;
  var Op_StdVW_instance;
  var Op_BlueFuzz_instance;
  var Op_StemSnapH_instance;
  var Op_UniqueID_instance;
  var Op_StemSnapV_instance;
  var Op_XUID_instance;
  var Op_ForceBold_instance;
  var Op_charset_instance;
  var Op_Encoding_instance;
  var Op_CharStrings_instance;
  var Op_LanguageGroup_instance;
  var Op_Private_instance;
  var Op_ExpansionFactor_instance;
  var Op_Subrs_instance;
  var Op_initialRandomSeed_instance;
  var Op_defaultWidthX_instance;
  var Op_SyntheicBase_instance;
  var Op_nominalWidthX_instance;
  var Op_PostScript_instance;
  var Op_vsindex_instance;
  var Op_BaseFontName_instance;
  var Op_blend_instance;
  var Op_BaseFontBlend_instance;
  var Op_vstore_instance;
  var Op_maxstack_instance;
  var Op_ROS_instance;
  var Op_CIDFontVersion_instance;
  var Op_CIDFontRevision_instance;
  var Op_CIDFontType_instance;
  var Op_CIDCount_instance;
  var Op_UIDBase_instance;
  var Op_FDArray_instance;
  var Op_FDSelect_instance;
  var Op_FontName_instance;
  function Companion_14() {
    Companion_instance_14 = this;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy = values_0();
    var capacity = coerceAtLeast(mapCapacity(tmp1_associateBy.length), 16);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap_init_$Create$(capacity);
    var indexedObject = tmp1_associateBy;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      tmp$ret$0 = element.v53_1;
      tmp0_associateByTo.x3(tmp$ret$0, element);
    }
    tmp$ret$1 = tmp0_associateByTo;
    tmp$ret$2 = tmp$ret$1;
    tmp.w53_1 = toIntMap(tmp$ret$2);
  }
  protoOf(Companion_14).k = function (id) {
    return this.w53_1.k(id);
  };
  var Companion_instance_14;
  function Companion_getInstance_34() {
    Op_initEntries();
    if (Companion_instance_14 == null)
      new Companion_14();
    return Companion_instance_14;
  }
  function values_0() {
    return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
  }
  var Op_entriesInitialized;
  function Op_initEntries() {
    if (Op_entriesInitialized)
      return Unit_getInstance();
    Op_entriesInitialized = true;
    Op_version_instance = new Op('version', 0, 0);
    Op_Copyright_instance = new Op('Copyright', 1, 3072);
    Op_Notice_instance = new Op('Notice', 2, 1);
    Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
    Op_FullName_instance = new Op('FullName', 4, 2);
    Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
    Op_FamilyName_instance = new Op('FamilyName', 6, 3);
    Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
    Op_Weight_instance = new Op('Weight', 8, 4);
    Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
    Op_FontBBox_instance = new Op('FontBBox', 10, 5);
    Op_PaintType_instance = new Op('PaintType', 11, 3077);
    Op_BlueValues_instance = new Op('BlueValues', 12, 6);
    Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
    Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
    Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
    Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
    Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
    Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
    Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
    Op_StdHW_instance = new Op('StdHW', 20, 10);
    Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
    Op_StdVW_instance = new Op('StdVW', 22, 11);
    Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
    Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
    Op_UniqueID_instance = new Op('UniqueID', 25, 13);
    Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
    Op_XUID_instance = new Op('XUID', 27, 14);
    Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
    Op_charset_instance = new Op('charset', 29, 15);
    Op_Encoding_instance = new Op('Encoding', 30, 16);
    Op_CharStrings_instance = new Op('CharStrings', 31, 17);
    Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
    Op_Private_instance = new Op('Private', 33, 18);
    Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
    Op_Subrs_instance = new Op('Subrs', 35, 19);
    Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
    Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
    Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
    Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
    Op_PostScript_instance = new Op('PostScript', 40, 3093);
    Op_vsindex_instance = new Op('vsindex', 41, 22);
    Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
    Op_blend_instance = new Op('blend', 43, 23);
    Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
    Op_vstore_instance = new Op('vstore', 45, 24);
    Op_maxstack_instance = new Op('maxstack', 46, 25);
    Op_ROS_instance = new Op('ROS', 47, 3102);
    Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
    Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
    Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
    Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
    Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
    Op_FDArray_instance = new Op('FDArray', 53, 3108);
    Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
    Op_FontName_instance = new Op('FontName', 55, 3110);
    Companion_getInstance_34();
  }
  function GlyphPath_0(path, advanceWidth) {
    this.x53_1 = path;
    this.y53_1 = advanceWidth;
  }
  protoOf(GlyphPath_0).toString = function () {
    return 'GlyphPath(path=' + this.x53_1 + ', advanceWidth=' + this.y53_1 + ')';
  };
  protoOf(GlyphPath_0).hashCode = function () {
    var result = this.x53_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.y53_1) | 0;
    return result;
  };
  protoOf(GlyphPath_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.x53_1.equals(tmp0_other_with_cast.x53_1))
      return false;
    if (!equals(this.y53_1, tmp0_other_with_cast.y53_1))
      return false;
    return true;
  };
  function CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.z53_1 = charstringsIndex;
    this.a54_1 = globalSubrIndex;
    this.b54_1 = localSubrsIndex;
    this.c54_1 = privateDict;
    var tmp = this;
    var tmp0_safe_receiver = this.c54_1.z1(Op_defaultWidthX_getInstance());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : firstOrNull_1(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : numberToDouble(tmp1_safe_receiver);
    tmp.d54_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
    var tmp_0 = this;
    var tmp0_safe_receiver_0 = this.c54_1.z1(Op_nominalWidthX_getInstance());
    var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : firstOrNull_1(tmp0_safe_receiver_0);
    var tmp2_elvis_lhs_0 = tmp1_safe_receiver_0 == null ? null : numberToDouble(tmp1_safe_receiver_0);
    tmp_0.e54_1 = tmp2_elvis_lhs_0 == null ? 0.0 : tmp2_elvis_lhs_0;
  }
  protoOf(CFFResult).f54 = function (index, flipY) {
    var evalCtx = new EvalContext(this.a54_1, this.b54_1, this.d54_1, this.e54_1, index);
    var vp = new VectorPath();
    var bytes = this.z53_1.k(index);
    CharStringType2_getInstance().i54(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.k3z(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.s54_1);
  };
  protoOf(CFFResult).u54 = function (index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.f54(index, flipY) : $super.f54.call(this, index, flipY);
  };
  function DataIndex(offsets, bytes) {
    this.g54_1 = offsets;
    this.h54_1 = bytes;
  }
  protoOf(DataIndex).j = function () {
    return this.g54_1.length - 1 | 0;
  };
  protoOf(DataIndex).v54 = function (index) {
    return this.g54_1[index + 1 | 0] - this.g54_1[index] | 0;
  };
  protoOf(DataIndex).k = function (index) {
    return copyOfRange(this.h54_1, this.g54_1[index], this.g54_1[index + 1 | 0]);
  };
  protoOf(DataIndex).w54 = function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map = until(0, this.j());
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
    var inductionVariable = tmp1_map.a1_1;
    var last = tmp1_map.b1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
        tmp$ret$0 = this.k(item);
        tmp0_mapTo.b(tmp$ret$0);
      }
       while (!(item === last));
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  protoOf(DataIndex).g = function () {
    return this.w54().g();
  };
  protoOf(DataIndex).toString = function () {
    var tmp = this.j();
    var tmp_0 = toList_0(this.g54_1);
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map = until(0, this.j());
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
    var inductionVariable = tmp1_map.a1_1;
    var last = tmp1_map.b1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
        tmp$ret$0 = this.v54(item);
        tmp0_mapTo.b(tmp$ret$0);
      }
       while (!(item === last));
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + tmp$ret$2 + ')';
  };
  function Op(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.v53_1 = id;
  }
  function Op_version_getInstance() {
    Op_initEntries();
    return Op_version_instance;
  }
  function Op_Copyright_getInstance() {
    Op_initEntries();
    return Op_Copyright_instance;
  }
  function Op_Notice_getInstance() {
    Op_initEntries();
    return Op_Notice_instance;
  }
  function Op_isFixedPitch_getInstance() {
    Op_initEntries();
    return Op_isFixedPitch_instance;
  }
  function Op_FullName_getInstance() {
    Op_initEntries();
    return Op_FullName_instance;
  }
  function Op_ItalicAngle_getInstance() {
    Op_initEntries();
    return Op_ItalicAngle_instance;
  }
  function Op_FamilyName_getInstance() {
    Op_initEntries();
    return Op_FamilyName_instance;
  }
  function Op_UnderlinePosition_getInstance() {
    Op_initEntries();
    return Op_UnderlinePosition_instance;
  }
  function Op_Weight_getInstance() {
    Op_initEntries();
    return Op_Weight_instance;
  }
  function Op_UnderlineThickness_getInstance() {
    Op_initEntries();
    return Op_UnderlineThickness_instance;
  }
  function Op_FontBBox_getInstance() {
    Op_initEntries();
    return Op_FontBBox_instance;
  }
  function Op_PaintType_getInstance() {
    Op_initEntries();
    return Op_PaintType_instance;
  }
  function Op_BlueValues_getInstance() {
    Op_initEntries();
    return Op_BlueValues_instance;
  }
  function Op_CharstringType_getInstance() {
    Op_initEntries();
    return Op_CharstringType_instance;
  }
  function Op_OtherBlues_getInstance() {
    Op_initEntries();
    return Op_OtherBlues_instance;
  }
  function Op_FontMatrix_getInstance() {
    Op_initEntries();
    return Op_FontMatrix_instance;
  }
  function Op_FamilyBlues_getInstance() {
    Op_initEntries();
    return Op_FamilyBlues_instance;
  }
  function Op_StrokeWidth_getInstance() {
    Op_initEntries();
    return Op_StrokeWidth_instance;
  }
  function Op_FamilyOtherBlues_getInstance() {
    Op_initEntries();
    return Op_FamilyOtherBlues_instance;
  }
  function Op_BlueScale_getInstance() {
    Op_initEntries();
    return Op_BlueScale_instance;
  }
  function Op_StdHW_getInstance() {
    Op_initEntries();
    return Op_StdHW_instance;
  }
  function Op_BlueShift_getInstance() {
    Op_initEntries();
    return Op_BlueShift_instance;
  }
  function Op_StdVW_getInstance() {
    Op_initEntries();
    return Op_StdVW_instance;
  }
  function Op_BlueFuzz_getInstance() {
    Op_initEntries();
    return Op_BlueFuzz_instance;
  }
  function Op_StemSnapH_getInstance() {
    Op_initEntries();
    return Op_StemSnapH_instance;
  }
  function Op_UniqueID_getInstance() {
    Op_initEntries();
    return Op_UniqueID_instance;
  }
  function Op_StemSnapV_getInstance() {
    Op_initEntries();
    return Op_StemSnapV_instance;
  }
  function Op_XUID_getInstance() {
    Op_initEntries();
    return Op_XUID_instance;
  }
  function Op_ForceBold_getInstance() {
    Op_initEntries();
    return Op_ForceBold_instance;
  }
  function Op_charset_getInstance() {
    Op_initEntries();
    return Op_charset_instance;
  }
  function Op_Encoding_getInstance() {
    Op_initEntries();
    return Op_Encoding_instance;
  }
  function Op_CharStrings_getInstance() {
    Op_initEntries();
    return Op_CharStrings_instance;
  }
  function Op_LanguageGroup_getInstance() {
    Op_initEntries();
    return Op_LanguageGroup_instance;
  }
  function Op_Private_getInstance() {
    Op_initEntries();
    return Op_Private_instance;
  }
  function Op_ExpansionFactor_getInstance() {
    Op_initEntries();
    return Op_ExpansionFactor_instance;
  }
  function Op_Subrs_getInstance() {
    Op_initEntries();
    return Op_Subrs_instance;
  }
  function Op_initialRandomSeed_getInstance() {
    Op_initEntries();
    return Op_initialRandomSeed_instance;
  }
  function Op_defaultWidthX_getInstance() {
    Op_initEntries();
    return Op_defaultWidthX_instance;
  }
  function Op_SyntheicBase_getInstance() {
    Op_initEntries();
    return Op_SyntheicBase_instance;
  }
  function Op_nominalWidthX_getInstance() {
    Op_initEntries();
    return Op_nominalWidthX_instance;
  }
  function Op_PostScript_getInstance() {
    Op_initEntries();
    return Op_PostScript_instance;
  }
  function Op_vsindex_getInstance() {
    Op_initEntries();
    return Op_vsindex_instance;
  }
  function Op_BaseFontName_getInstance() {
    Op_initEntries();
    return Op_BaseFontName_instance;
  }
  function Op_blend_getInstance() {
    Op_initEntries();
    return Op_blend_instance;
  }
  function Op_BaseFontBlend_getInstance() {
    Op_initEntries();
    return Op_BaseFontBlend_instance;
  }
  function Op_vstore_getInstance() {
    Op_initEntries();
    return Op_vstore_instance;
  }
  function Op_maxstack_getInstance() {
    Op_initEntries();
    return Op_maxstack_instance;
  }
  function Op_ROS_getInstance() {
    Op_initEntries();
    return Op_ROS_instance;
  }
  function Op_CIDFontVersion_getInstance() {
    Op_initEntries();
    return Op_CIDFontVersion_instance;
  }
  function Op_CIDFontRevision_getInstance() {
    Op_initEntries();
    return Op_CIDFontRevision_instance;
  }
  function Op_CIDFontType_getInstance() {
    Op_initEntries();
    return Op_CIDFontType_instance;
  }
  function Op_CIDCount_getInstance() {
    Op_initEntries();
    return Op_CIDCount_instance;
  }
  function Op_UIDBase_getInstance() {
    Op_initEntries();
    return Op_UIDBase_instance;
  }
  function Op_FDArray_getInstance() {
    Op_initEntries();
    return Op_FDArray_instance;
  }
  function Op_FDSelect_getInstance() {
    Op_initEntries();
    return Op_FDSelect_instance;
  }
  function Op_FontName_getInstance() {
    Op_initEntries();
    return Op_FontName_instance;
  }
  var Op_hstem_instance;
  var Op_vstem_instance;
  var Op_and_instance;
  var Op_vmoveto_instance;
  var Op_or_instance;
  var Op_rlineto_instance;
  var Op_not_instance;
  var Op_hlineto_instance;
  var Op_vlineto_instance;
  var Op_rrcurveto_instance;
  var Op_abs_instance;
  var Op_callsubr_instance;
  var Op_add_instance;
  var Op_return_instance;
  var Op_sub_instance;
  var Op_div_instance;
  var Op_endchar_instance;
  var Op_neg_instance;
  var Op_cff2vsidx_instance;
  var Op_eq_instance;
  var Op_cff2blend_instance;
  var Op_hstemhm_instance;
  var Op_drop_instance;
  var Op_hintmask_instance;
  var Op_cntrmask_instance;
  var Op_put_instance;
  var Op_rmoveto_instance;
  var Op_get_instance;
  var Op_hmoveto_instance;
  var Op_ifelse_instance;
  var Op_vstemhm_instance;
  var Op_random_instance;
  var Op_rcurveline_instance;
  var Op_mul_instance;
  var Op_rlinecurve_instance;
  var Op_vvcurveto_instance;
  var Op_sqrt_instance;
  var Op_hhcurveto_instance;
  var Op_dup_instance;
  var Op_exch_instance;
  var Op_callgsubr_instance;
  var Op_index_instance;
  var Op_vhcurveto_instance;
  var Op_roll_instance;
  var Op_hvcurveto_instance;
  var Op_hflex_instance;
  var Op_flex_instance;
  var Op_hflex1_instance;
  var Op_flex1_instance;
  function Companion_15() {
    Companion_instance_15 = this;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy = values_1();
    var capacity = coerceAtLeast(mapCapacity(tmp1_associateBy.length), 16);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap_init_$Create$(capacity);
    var indexedObject = tmp1_associateBy;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      tmp$ret$0 = element.z54_1;
      tmp0_associateByTo.x3(tmp$ret$0, element);
    }
    tmp$ret$1 = tmp0_associateByTo;
    tmp$ret$2 = tmp$ret$1;
    tmp.a55_1 = toIntMap(tmp$ret$2);
  }
  protoOf(Companion_15).k = function (id) {
    var tmp0_elvis_lhs = this.a55_1.k(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException_init_$Create$(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var Companion_instance_15;
  function Companion_getInstance_35() {
    Op_initEntries_0();
    if (Companion_instance_15 == null)
      new Companion_15();
    return Companion_instance_15;
  }
  function values_1() {
    return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
  }
  var Op_entriesInitialized_0;
  function Op_initEntries_0() {
    if (Op_entriesInitialized_0)
      return Unit_getInstance();
    Op_entriesInitialized_0 = true;
    Op_hstem_instance = new Op_0('hstem', 0, 1);
    Op_vstem_instance = new Op_0('vstem', 1, 3);
    Op_and_instance = new Op_0('and', 2, 3075);
    Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
    Op_or_instance = new Op_0('or', 4, 3076);
    Op_rlineto_instance = new Op_0('rlineto', 5, 5);
    Op_not_instance = new Op_0('not', 6, 3077);
    Op_hlineto_instance = new Op_0('hlineto', 7, 6);
    Op_vlineto_instance = new Op_0('vlineto', 8, 7);
    Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
    Op_abs_instance = new Op_0('abs', 10, 3081);
    Op_callsubr_instance = new Op_0('callsubr', 11, 10);
    Op_add_instance = new Op_0('add', 12, 3082);
    Op_return_instance = new Op_0('return', 13, 11);
    Op_sub_instance = new Op_0('sub', 14, 3083);
    Op_div_instance = new Op_0('div', 15, 3084);
    Op_endchar_instance = new Op_0('endchar', 16, 14);
    Op_neg_instance = new Op_0('neg', 17, 3086);
    Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
    Op_eq_instance = new Op_0('eq', 19, 3087);
    Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
    Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
    Op_drop_instance = new Op_0('drop', 22, 3090);
    Op_hintmask_instance = new Op_0('hintmask', 23, 19);
    Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
    Op_put_instance = new Op_0('put', 25, 3092);
    Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
    Op_get_instance = new Op_0('get', 27, 3093);
    Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
    Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
    Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
    Op_random_instance = new Op_0('random', 31, 3095);
    Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
    Op_mul_instance = new Op_0('mul', 33, 3096);
    Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
    Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
    Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
    Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
    Op_dup_instance = new Op_0('dup', 38, 3099);
    Op_exch_instance = new Op_0('exch', 39, 3100);
    Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
    Op_index_instance = new Op_0('index', 41, 3101);
    Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
    Op_roll_instance = new Op_0('roll', 43, 3102);
    Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
    Op_hflex_instance = new Op_0('hflex', 45, 3106);
    Op_flex_instance = new Op_0('flex', 46, 3107);
    Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
    Op_flex1_instance = new Op_0('flex1', 48, 3109);
    Companion_getInstance_35();
  }
  function EvalContext(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex_init_$Create$() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex_init_$Create$() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.j54_1 = globalSubrIndex;
    this.k54_1 = localSubrsIndex;
    this.l54_1 = defaultWidthX;
    this.m54_1 = nominalWidthX;
    this.n54_1 = index;
    this.o54_1 = heap;
    this.p54_1 = computeSubrBias(CharStringType2_getInstance(), this.j54_1.j());
    this.q54_1 = computeSubrBias(CharStringType2_getInstance(), this.k54_1.j());
    this.r54_1 = 0;
    this.s54_1 = this.l54_1;
    this.t54_1 = false;
  }
  function computeSubrBias($this, count) {
    return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
  }
  function Op_0(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.z54_1 = id;
  }
  function Op_hstem_getInstance() {
    Op_initEntries_0();
    return Op_hstem_instance;
  }
  function Op_vstem_getInstance() {
    Op_initEntries_0();
    return Op_vstem_instance;
  }
  function Op_and_getInstance() {
    Op_initEntries_0();
    return Op_and_instance;
  }
  function Op_vmoveto_getInstance() {
    Op_initEntries_0();
    return Op_vmoveto_instance;
  }
  function Op_or_getInstance() {
    Op_initEntries_0();
    return Op_or_instance;
  }
  function Op_rlineto_getInstance() {
    Op_initEntries_0();
    return Op_rlineto_instance;
  }
  function Op_not_getInstance() {
    Op_initEntries_0();
    return Op_not_instance;
  }
  function Op_hlineto_getInstance() {
    Op_initEntries_0();
    return Op_hlineto_instance;
  }
  function Op_vlineto_getInstance() {
    Op_initEntries_0();
    return Op_vlineto_instance;
  }
  function Op_rrcurveto_getInstance() {
    Op_initEntries_0();
    return Op_rrcurveto_instance;
  }
  function Op_abs_getInstance() {
    Op_initEntries_0();
    return Op_abs_instance;
  }
  function Op_callsubr_getInstance() {
    Op_initEntries_0();
    return Op_callsubr_instance;
  }
  function Op_add_getInstance() {
    Op_initEntries_0();
    return Op_add_instance;
  }
  function Op_return_getInstance() {
    Op_initEntries_0();
    return Op_return_instance;
  }
  function Op_sub_getInstance() {
    Op_initEntries_0();
    return Op_sub_instance;
  }
  function Op_div_getInstance() {
    Op_initEntries_0();
    return Op_div_instance;
  }
  function Op_endchar_getInstance() {
    Op_initEntries_0();
    return Op_endchar_instance;
  }
  function Op_neg_getInstance() {
    Op_initEntries_0();
    return Op_neg_instance;
  }
  function Op_cff2vsidx_getInstance() {
    Op_initEntries_0();
    return Op_cff2vsidx_instance;
  }
  function Op_eq_getInstance() {
    Op_initEntries_0();
    return Op_eq_instance;
  }
  function Op_cff2blend_getInstance() {
    Op_initEntries_0();
    return Op_cff2blend_instance;
  }
  function Op_hstemhm_getInstance() {
    Op_initEntries_0();
    return Op_hstemhm_instance;
  }
  function Op_drop_getInstance() {
    Op_initEntries_0();
    return Op_drop_instance;
  }
  function Op_hintmask_getInstance() {
    Op_initEntries_0();
    return Op_hintmask_instance;
  }
  function Op_cntrmask_getInstance() {
    Op_initEntries_0();
    return Op_cntrmask_instance;
  }
  function Op_put_getInstance() {
    Op_initEntries_0();
    return Op_put_instance;
  }
  function Op_rmoveto_getInstance() {
    Op_initEntries_0();
    return Op_rmoveto_instance;
  }
  function Op_get_getInstance() {
    Op_initEntries_0();
    return Op_get_instance;
  }
  function Op_hmoveto_getInstance() {
    Op_initEntries_0();
    return Op_hmoveto_instance;
  }
  function Op_ifelse_getInstance() {
    Op_initEntries_0();
    return Op_ifelse_instance;
  }
  function Op_vstemhm_getInstance() {
    Op_initEntries_0();
    return Op_vstemhm_instance;
  }
  function Op_random_getInstance() {
    Op_initEntries_0();
    return Op_random_instance;
  }
  function Op_rcurveline_getInstance() {
    Op_initEntries_0();
    return Op_rcurveline_instance;
  }
  function Op_mul_getInstance() {
    Op_initEntries_0();
    return Op_mul_instance;
  }
  function Op_rlinecurve_getInstance() {
    Op_initEntries_0();
    return Op_rlinecurve_instance;
  }
  function Op_vvcurveto_getInstance() {
    Op_initEntries_0();
    return Op_vvcurveto_instance;
  }
  function Op_sqrt_getInstance() {
    Op_initEntries_0();
    return Op_sqrt_instance;
  }
  function Op_hhcurveto_getInstance() {
    Op_initEntries_0();
    return Op_hhcurveto_instance;
  }
  function Op_dup_getInstance() {
    Op_initEntries_0();
    return Op_dup_instance;
  }
  function Op_exch_getInstance() {
    Op_initEntries_0();
    return Op_exch_instance;
  }
  function Op_callgsubr_getInstance() {
    Op_initEntries_0();
    return Op_callgsubr_instance;
  }
  function Op_index_getInstance() {
    Op_initEntries_0();
    return Op_index_instance;
  }
  function Op_vhcurveto_getInstance() {
    Op_initEntries_0();
    return Op_vhcurveto_instance;
  }
  function Op_roll_getInstance() {
    Op_initEntries_0();
    return Op_roll_instance;
  }
  function Op_hvcurveto_getInstance() {
    Op_initEntries_0();
    return Op_hvcurveto_instance;
  }
  function Op_hflex_getInstance() {
    Op_initEntries_0();
    return Op_hflex_instance;
  }
  function Op_flex_getInstance() {
    Op_initEntries_0();
    return Op_flex_instance;
  }
  function Op_hflex1_getInstance() {
    Op_initEntries_0();
    return Op_hflex1_instance;
  }
  function Op_flex1_getInstance() {
    Op_initEntries_0();
    return Op_flex1_instance;
  }
  function CFF() {
    CFF_instance = this;
  }
  protoOf(CFF).b55 = function (_this__u8e3s4) {
    this.c55(_this__u8e3s4);
    var nameIndex = this.d55(_this__u8e3s4);
    var topDictIndex = this.d55(_this__u8e3s4);
    var topDictByte = topDictIndex.k(0)[1];
    var topDict = this.e55(openFastStream(topDictIndex.k(0)));
    var stringIndex = this.d55(_this__u8e3s4);
    var globalSubrIndex = this.d55(_this__u8e3s4);
    var privateSizeOffset = topDict.z1(Op_Private_getInstance());
    var localSubrsIndex = DataIndex_init_$Create$();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        tmp$ret$0 = numberToInt(item);
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var tmp0_container = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.collections.component1' call
      tmp$ret$3 = tmp0_container.k(0);
      var privateSize = tmp$ret$3;
      var tmp$ret$4;
      // Inline function 'kotlin.collections.component2' call
      tmp$ret$4 = tmp0_container.k(1);
      var privateOffset = tmp$ret$4;
      privateDict = this.e55(_this__u8e3s4.b33(privateOffset, privateSize));
      var localSubrs = privateDict.z1(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.d55(_this__u8e3s4.c33(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.z1(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.d55(_this__u8e3s4.c33(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  };
  protoOf(CFF).c55 = function (_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.h33();
    var versionMinor = _this__u8e3s4.h33();
    var headerSize = _this__u8e3s4.h33();
    var offsetSize = _this__u8e3s4.h33();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$('Only supported CFF version 1');
    }
    var tmp$ret$1;
    // Inline function 'korlibs.logger.Logger.debug' call
    var tmp1_debug = TtfCIDFont_getInstance().f55_1;
    var tmp0_log = Level_DEBUG_getInstance();
    var tmp;
    if (tmp1_debug.zz(tmp0_log)) {
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      tmp1_debug.a10(tmp0_log, tmp$ret$0);
      tmp = Unit_getInstance();
    }
    tmp$ret$1 = tmp;
  };
  protoOf(CFF).g55 = function (_this__u8e3s4) {
    return _this__u8e3s4.h33();
  };
  protoOf(CFF).h55 = function (_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.g55(_this__u8e3s4) : offSize;
    var tmp0_subject = roffSize;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = _this__u8e3s4.h33();
        break;
      case 2:
        tmp = _this__u8e3s4.j33();
        break;
      case 3:
        tmp = _this__u8e3s4.k33();
        break;
      case 4:
        tmp = _this__u8e3s4.l33();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  };
  protoOf(CFF).d55 = function (_this__u8e3s4) {
    var count = _this__u8e3s4.j33();
    if (count === 0)
      return DataIndex_init_$Create$();
    var offSize = this.g55(_this__u8e3s4);
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.mapInt' call
    var tmp1_mapInt = until(0, count + 1 | 0);
    var tmp$ret$1;
    // Inline function 'kotlin.also' call
    var tmp0_also = new IntArrayList((coerceAtLeast(tmp1_mapInt.k6() - tmp1_mapInt.j6() | 0, 0) / tmp1_mapInt.c1_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = tmp1_mapInt.j6();
    var nestedLast = tmp1_mapInt.k6();
    var stepArg = tmp1_mapInt.c1_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    var step = stepArg;
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + step | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        tmp$ret$0 = CFF_getInstance().h55(_this__u8e3s4, offSize) - 1 | 0;
        tmp0_also.un(tmp$ret$0);
      }
       while (!(v === last));
    tmp$ret$1 = tmp0_also;
    tmp$ret$2 = tmp$ret$1;
    var offsets = tmp$ret$2;
    var bytes = _this__u8e3s4.f33(offsets.co());
    return new DataIndex(offsets.eo(), bytes);
  };
  protoOf(CFF).e55 = function (_this__u8e3s4) {
    var map = LinkedHashMap_init_$Create$_0();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    var values = tmp$ret$0;
    while (_this__u8e3s4.gs()) {
      var item = this.i55(_this__u8e3s4);
      var tmp0_subject = item;
      if (tmp0_subject instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var tmp0_set = item;
        var tmp1_set = toList(values);
        map.x3(tmp0_set, tmp1_set);
        values.v2();
      } else {
        if (isNumber(tmp0_subject)) {
          values.b(item);
        }
      }
    }
    return map;
  };
  protoOf(CFF).i55 = function (_this__u8e3s4) {
    var b0 = _this__u8e3s4.h33();
    var tmp0_subject = b0;
    var tmp;
    if (0 <= tmp0_subject ? tmp0_subject <= 21 : false) {
      var tmp_0 = Companion_getInstance_34();
      var tmp1_subject = b0;
      tmp = tmp_0.k(tmp1_subject === 12 ? b0 << 8 | _this__u8e3s4.h33() : b0);
    } else if (22 <= tmp0_subject ? tmp0_subject <= 27 : false) {
      get_reserved();
    } else if (tmp0_subject === 28) {
      tmp = toShort(_this__u8e3s4.h33() << 8 | _this__u8e3s4.h33());
    } else if (tmp0_subject === 29) {
      tmp = _this__u8e3s4.h33() << 24 | _this__u8e3s4.h33() << 16 | _this__u8e3s4.h33() << 8 | _this__u8e3s4.h33();
    } else if (tmp0_subject === 30) {
      tmp = this.j55(_this__u8e3s4, false);
    } else if (tmp0_subject === 31) {
      get_reserved();
    } else if (32 <= tmp0_subject ? tmp0_subject <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= tmp0_subject ? tmp0_subject <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.h33() | 0) + 108 | 0;
    } else if (251 <= tmp0_subject ? tmp0_subject <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.h33() | 0) - 108 | 0;
    } else if (tmp0_subject === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  };
  protoOf(CFF).k55 = function (_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'korlibs.io.lang.assert' call
      var tmp0_assert = _this__u8e3s4.h33() === 30;
      if (!tmp0_assert)
        throw AssertionError_init_$Create$();
    }
    var str = StringBuilder_init_$Create$();
    end: while (true) {
      var byte = _this__u8e3s4.h33();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          var tmp1_subject = nibble;
          switch (tmp1_subject) {
            case 15:
              break end;
            case 12:
              str.ve('E-');
              ;
              break;
            default:
              var tmp2_subject = nibble;
              str.f7((0 <= tmp2_subject ? tmp2_subject <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : tmp2_subject === 10 ? _Char___init__impl__6a9atx(46) : tmp2_subject === 11 ? _Char___init__impl__6a9atx(69) : tmp2_subject === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              ;
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  };
  protoOf(CFF).j55 = function (_this__u8e3s4, readHeader) {
    return toDouble(this.k55(_this__u8e3s4, readHeader));
  };
  var CFF_instance;
  function CFF_getInstance() {
    if (CFF_instance == null)
      new CFF();
    return CFF_instance;
  }
  function CharStringType2() {
    CharStringType2_instance = this;
  }
  protoOf(CharStringType2).l55 = function (_this__u8e3s4, value) {
    _this__u8e3s4.um(_this__u8e3s4.j() - 1 | 0, value);
  };
  protoOf(CharStringType2).m55 = function (_this__u8e3s4) {
    return _this__u8e3s4.k(_this__u8e3s4.j() - 1 | 0);
  };
  protoOf(CharStringType2).n55 = function (_this__u8e3s4) {
    return _this__u8e3s4.u2(_this__u8e3s4.j() - 1 | 0);
  };
  protoOf(CharStringType2).o55 = function (_this__u8e3s4, value) {
    _this__u8e3s4.rm(value);
  };
  protoOf(CharStringType2).p55 = function (_this__u8e3s4, value) {
    _this__u8e3s4.rm(value);
  };
  protoOf(CharStringType2).q55 = function (_this__u8e3s4) {
    _this__u8e3s4.c1c();
  };
  protoOf(CharStringType2).r55 = function (_this__u8e3s4, x, y) {
    _this__u8e3s4.u3y(_Vector2___init__impl__67w0ru_1(x, y));
  };
  protoOf(CharStringType2).s55 = function (_this__u8e3s4, x, y) {
    _this__u8e3s4.v3y(_Vector2___init__impl__67w0ru_1(x, y));
  };
  protoOf(CharStringType2).t55 = function (_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.f3k(_Vector2___init__impl__67w0ru_1(fcx1, fcy1), _Vector2___init__impl__67w0ru_1(fcx2, fcy2), _Vector2___init__impl__67w0ru_1(fax, fay));
  };
  protoOf(CharStringType2).u55 = function (_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _Vector2___get_xD__impl__1832jh(_this__u8e3s4.m3y()) + cx1;
    var fcy1 = _Vector2___get_yD__impl__v473bw(_this__u8e3s4.m3y()) + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.t55(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  };
  protoOf(CharStringType2).v55 = function (_this__u8e3s4, v, horizontal) {
    return this.r55(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  };
  protoOf(CharStringType2).w55 = function (_this__u8e3s4, v, horizontal) {
    return this.s55(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  };
  protoOf(CharStringType2).x55 = function (_this__u8e3s4) {
    var tmp$ret$1;
    // Inline function 'kotlin.also' call
    var tmp0_also = _this__u8e3s4.h33();
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    tmp$ret$0 = Unit_getInstance();
    tmp$ret$1 = tmp0_also;
    return tmp$ret$1;
  };
  protoOf(CharStringType2).y55 = function (ctx, s, evalCtx, stack, stackLevel) {
    while (s.gs()) {
      var v0 = this.x55(s);
      var tmp0_subject = v0;
      if ((0 <= tmp0_subject ? tmp0_subject <= 27 : false) ? true : 29 <= tmp0_subject ? tmp0_subject <= 31 : false) {
        var tmp = Companion_getInstance_35();
        var tmp1_subject = v0;
        var op = tmp.k(tmp1_subject === 12 ? v0 << 8 | this.x55(s) : v0);
        var tmp2_subject = op;
        var tmp0 = tmp2_subject.j5_1;
        switch (tmp0) {
          case 13:
            return Unit_getInstance();
          case 16:
            var tmp_0;
            var tmp$ret$0;
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp$ret$0 = !stack.l();

            if (tmp$ret$0) {
              tmp_0 = !evalCtx.t54_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.s54_1 = stack.k(0) + evalCtx.m54_1;
              evalCtx.t54_1 = true;
            }

            if (!(ctx.l3y() === 0)) {
              this.q55(ctx);
            }

            return Unit_getInstance();
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.n55(stack));
            var bytes = global ? evalCtx.j54_1.k(evalCtx.p54_1 + funcOffset | 0) : evalCtx.k54_1.k(evalCtx.q54_1 + funcOffset | 0);
            this.y55(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            ;
            break;
          case 22:
            this.n55(stack);
            ;
            break;
          case 38:
            var tmp$ret$1;
            // Inline function 'kotlin.also' call
            var tmp0_also = this.n55(stack);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            stack.sm(tmp0_also, tmp0_also);
            tmp$ret$1 = tmp0_also;

            ;
            break;
          case 39:
            stack.xm(stack.j() - 2 | 0, stack.j() - 1 | 0);
            ;
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw new NotImplementedError();
          case 41:
            // Inline function 'kotlin.TODO' call
            throw new NotImplementedError();

            break;
          case 25:
            var index = this.n55(stack);
            var value = this.n55(stack);
            evalCtx.o54_1[numberToInt(index)] = value;
            ;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            var tmp$ret$2;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            var tmp2__anonymous__z9zvc9 = this.m55(stack);
            tmp$ret$2 = evalCtx.o54_1[numberToInt(tmp2__anonymous__z9zvc9)];

            this.l55(stack, tmp$ret$2);
            ;
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.n55(stack);
            var l = this.n55(stack);
            var tmp$ret$4;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            var tmp$ret$3;
            // Inline function 'korlibs.memory.toInt' call
            var tmp0_toInt = !(l === 0.0) ? !(r === 0.0) : false;
            tmp$ret$3 = tmp0_toInt ? 1 : 0;
            tmp$ret$4 = tmp$ret$3;

            this.o55(stack, tmp$ret$4);
            ;
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.n55(stack);
            var l_0 = this.n55(stack);
            var tmp$ret$6;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            var tmp$ret$5;
            // Inline function 'korlibs.memory.toInt' call
            var tmp0_toInt_0 = !(l_0 === 0.0) ? true : !(r_0 === 0.0);
            tmp$ret$5 = tmp0_toInt_0 ? 1 : 0;
            tmp$ret$6 = tmp$ret$5;

            this.o55(stack, tmp$ret$6);
            ;
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            var tmp$ret$8;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            var tmp3__anonymous__ufb84q = this.m55(stack);
            var tmp$ret$7;
            // Inline function 'korlibs.memory.toInt' call
            var tmp0_toInt_1 = tmp3__anonymous__ufb84q === 0.0;
            tmp$ret$7 = tmp0_toInt_1 ? 1 : 0;
            tmp$ret$8 = tmp$ret$7;

            this.l55(stack, tmp$ret$8);
            ;
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.n55(stack);
            var l_1 = this.n55(stack);
            var tmp$ret$10;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            var tmp$ret$9;
            // Inline function 'korlibs.memory.toInt' call
            var tmp0_toInt_2 = l_1 === r_1;
            tmp$ret$9 = tmp0_toInt_2 ? 1 : 0;
            tmp$ret$10 = tmp$ret$9;

            this.o55(stack, tmp$ret$10);
            ;
            break;
          case 29:
            var v2 = this.n55(stack);
            var v1 = this.n55(stack);
            var s2 = this.n55(stack);
            var s1 = this.n55(stack);
            this.o55(stack, v1 <= v2 ? s1 : s2);
            ;
            break;
          case 31:
            stack.rm(Default_getInstance().y5());
            ;
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            var tmp$ret$12;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            var tmp4__anonymous__pkmkx7 = this.m55(stack);
            var tmp$ret$11;
            // Inline function 'kotlin.math.sqrt' call
            tmp$ret$11 = Math.sqrt(tmp4__anonymous__pkmkx7);
            tmp$ret$12 = tmp$ret$11;

            this.l55(stack, tmp$ret$12);
            ;
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            var tmp$ret$14;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            var tmp5__anonymous__kpxxpo = this.m55(stack);
            var tmp$ret$13;
            // Inline function 'kotlin.math.abs' call
            tmp$ret$13 = Math.abs(tmp5__anonymous__kpxxpo);
            tmp$ret$14 = tmp$ret$13;

            this.l55(stack, tmp$ret$14);
            ;
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            var tmp$ret$15;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            var tmp6__anonymous__fv9ai5 = this.m55(stack);
            tmp$ret$15 = -tmp6__anonymous__fv9ai5;

            this.l55(stack, tmp$ret$15);
            ;
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.n55(stack);
            var l_2 = this.n55(stack);
            var tmp$ret$16;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            tmp$ret$16 = l_2 + r_2;

            this.o55(stack, tmp$ret$16);
            ;
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.n55(stack);
            var l_3 = this.n55(stack);
            var tmp$ret$17;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            tmp$ret$17 = l_3 - r_3;

            this.o55(stack, tmp$ret$17);
            ;
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.n55(stack);
            var l_4 = this.n55(stack);
            var tmp$ret$18;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            tmp$ret$18 = l_4 / r_4;

            this.o55(stack, tmp$ret$18);
            ;
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.n55(stack);
            var l_5 = this.n55(stack);
            var tmp$ret$19;
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call
            tmp$ret$19 = l_5 * r_5;

            this.o55(stack, tmp$ret$19);
            ;
            break;
          case 26:
            if (stack.j() > 2) {
              evalCtx.s54_1 = stack.k(0) + evalCtx.m54_1;
              evalCtx.t54_1 = true;
            }

            if (!(ctx.l3y() === 0)) {
              this.q55(ctx);
            }

            this.r55(ctx, stack.k(stack.j() - 2 | 0), stack.k(stack.j() - 1 | 0));
            stack.v2();
            ;
            break;
          case 3:
          case 28:
            if (stack.j() > 1) {
              evalCtx.s54_1 = stack.k(0) + evalCtx.m54_1;
              evalCtx.t54_1 = true;
            }

            this.v55(ctx, this.n55(stack), op.equals(Op_hmoveto_getInstance()));
            stack.v2();
            ;
            break;
          case 5:
            var progression = step(until(0, stack.j()), 2);
            var inductionVariable = progression.a1_1;
            var last = progression.b1_1;
            var step_0 = progression.c1_1;
            if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.s55(ctx, stack.k(n), stack.k(n + 1 | 0));
              }
               while (!(n === last));
            stack.v2();
            ;
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.j();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.w55(ctx, stack.k(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.v2();
            ;
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.j() - n_1 | 0) < 6) {
                var tmp5 = n_1;
                n_1 = tmp5 + 1 | 0;
                var tmp_1 = stack.k(tmp5);
                var tmp6 = n_1;
                n_1 = tmp6 + 1 | 0;
                this.s55(ctx, tmp_1, stack.k(tmp6));
              }
            }

            while ((stack.j() - n_1 | 0) >= 6) {
              var tmp7 = n_1;
              n_1 = tmp7 + 1 | 0;
              var tmp_2 = stack.k(tmp7);
              var tmp8 = n_1;
              n_1 = tmp8 + 1 | 0;
              var tmp_3 = stack.k(tmp8);
              var tmp9 = n_1;
              n_1 = tmp9 + 1 | 0;
              var tmp_4 = stack.k(tmp9);
              var tmp10 = n_1;
              n_1 = tmp10 + 1 | 0;
              var tmp_5 = stack.k(tmp10);
              var tmp11 = n_1;
              n_1 = tmp11 + 1 | 0;
              var tmp_6 = stack.k(tmp11);
              var tmp12 = n_1;
              n_1 = tmp12 + 1 | 0;
              this.u55(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.k(tmp12));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.j()) {
                var tmp13 = n_1;
                n_1 = tmp13 + 1 | 0;
                var tmp_7 = stack.k(tmp13);
                var tmp14 = n_1;
                n_1 = tmp14 + 1 | 0;
                this.s55(ctx, tmp_7, stack.k(tmp14));
              }
            }

            stack.v2();
            ;
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.j() % 2 | 0) === 1) {
              var tmp15 = n_2;
              n_2 = tmp15 + 1 | 0;
              tmp_8 = stack.k(tmp15);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.j() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              throw IllegalStateException_init_$Create$('Invalid number of operands');
            }

            while (n_2 < stack.j()) {
              var tmp16 = n_2;
              n_2 = tmp16 + 1 | 0;
              var vv = stack.k(tmp16);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var tmp17 = n_2;
              n_2 = tmp17 + 1 | 0;
              var x2 = stack.k(tmp17);
              var tmp18 = n_2;
              n_2 = tmp18 + 1 | 0;
              var y2 = stack.k(tmp18);
              var tmp19 = n_2;
              n_2 = tmp19 + 1 | 0;
              var v1_0 = stack.k(tmp19);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.u55(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.v2();
            ;
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              var tmp$ret$20;
              // Inline function 'kotlin.collections.isNotEmpty' call
              tmp$ret$20 = !stack.l();
              if (!tmp$ret$20) {
                break $l$loop;
              }
              var vv_0 = this.n55(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.n55(stack);
              var y2_0 = this.n55(stack);
              var v1_1 = this.n55(stack);
              var v2_0 = stack.j() === 1 ? this.n55(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.u55(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.v2();
            ;
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call
            throw new NotImplementedError();

            break;
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.j() % 2 | 0) === 0) ? !evalCtx.t54_1 : false) {
              var value_0 = stack.k(0);
              evalCtx.s54_1 = value_0 + evalCtx.m54_1;
            }

            var tmp20_this = evalCtx;
            tmp20_this.r54_1 = tmp20_this.r54_1 + (stack.j() >>> 1 | 0) | 0;
            evalCtx.t54_1 = true;
            stack.v2();
            if (op.equals(Op_hintmask_getInstance()) ? true : op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.r54_1 + 7 | 0) >>> 3 | 0;
              s.b2b(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw new NotImplementedError();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw new NotImplementedError();
        }
      } else if (tmp0_subject === 255) {
        var integerPart = this.x55(s) << 8 | this.x55(s);
        var fractionPart = this.x55(s) << 8 | this.x55(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.o55(stack, value_1);
      } else {
        var tmp21_subject = v0;
        var tmp_9;
        if (tmp21_subject === 28) {
          tmp_9 = toShort(this.x55(s) << 8 | this.x55(s));
        } else if (32 <= tmp21_subject ? tmp21_subject <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= tmp21_subject ? tmp21_subject <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.x55(s) | 0) + 108 | 0;
        } else if (251 <= tmp21_subject ? tmp21_subject <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.x55(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.p55(stack, value_2);
      }
    }
  };
  protoOf(CharStringType2).i54 = function (ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? new DoubleArrayList(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.y55(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.y55.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  };
  var CharStringType2_instance;
  function CharStringType2_getInstance() {
    if (CharStringType2_instance == null)
      new CharStringType2();
    return CharStringType2_instance;
  }
  function TtfCIDFont() {
    TtfCIDFont_instance = this;
    this.f55_1 = Companion_getInstance_11().kz('TtfCIDFont');
  }
  var TtfCIDFont_instance;
  function TtfCIDFont_getInstance() {
    if (TtfCIDFont_instance == null)
      new TtfCIDFont();
    return TtfCIDFont_instance;
  }
  function Companion_16() {
    Companion_instance_16 = this;
    this.z55_1 = Companion_getInstance_11().kz('TTF');
  }
  var Companion_instance_16;
  function Companion_getInstance_36() {
    if (Companion_instance_16 == null)
      new Companion_16();
    return Companion_instance_16;
  }
  function TtfFont(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_36();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    BaseTtfFont_init_$Init$(d, extName, onlyReadMetadata, enableLigatures, this);
    this.k58_1 = LinkedHashMap_init_$Create$_0();
    this.v5a();
  }
  protoOf(TtfFont).w5a = function () {
    this.k58_1.db(Companion_getInstance_39().x5a(this.l58_1.d33()));
  };
  protoOf(TtfFont).y5a = function (name) {
    return this.k58_1.z1(name);
  };
  function _get_ss__ndcawb($this) {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = ss$factory();
    tmp$ret$0 = $this.d5d_1.q();
    return tmp$ret$0;
  }
  function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
    return function () {
      return ensureNotNull(this$0.c5d_1)();
    };
  }
  function BaseTtfFont$Companion$readHeaderTables$lambda($s, $table) {
    return function () {
      return $s.b33($table.a5d_1, $table.b5d_1);
    };
  }
  var NameId_COPYRIGHT_instance;
  var NameId_NAME_instance;
  var NameId_STYLE_instance;
  var NameId_UNAME_instance;
  var NameId_COMPLETE_NAME_instance;
  var NameId_RELEASE_VERSION_instance;
  var NameId_POSTSCRIPT_NAME_instance;
  var NameId_TRADEMARK_instance;
  var NameId_MANUFACTURER_instance;
  var NameId_DESIGNER_instance;
  var NameId_DESCRIPTION_instance;
  var NameId_URL_VENDOR_instance;
  var NameId_URL_DESIGNER_instance;
  var NameId_LICENSE_DESCRIPTION_instance;
  var NameId_LICENSE_URL_instance;
  var NameId_RESERVED_15_instance;
  var NameId_PREFERRED_FAMILY_instance;
  var NameId_PREFERRED_SUBFAMILY_instance;
  var NameId_COMPATIBLE_FULL_instance;
  var NameId_SAMPLE_TEXT_instance;
  var NameId_POSTSCRIPT_CID_instance;
  var NameId_WWS_FAMILY_NAME_instance;
  var NameId_WWS_SUBFAMILY_NAME_instance;
  var NameId_LIGHT_BACKGROUND_instance;
  var NameId_DARK_BACKGROUND_instance;
  var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
  function Companion_17() {
    Companion_instance_17 = this;
    this.e5d_1 = 26;
  }
  var Companion_instance_17;
  function Companion_getInstance_37() {
    NameId_initEntries();
    if (Companion_instance_17 == null)
      new Companion_17();
    return Companion_instance_17;
  }
  function values_2() {
    return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
  }
  var NameId_entriesInitialized;
  function NameId_initEntries() {
    if (NameId_entriesInitialized)
      return Unit_getInstance();
    NameId_entriesInitialized = true;
    NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
    NameId_NAME_instance = new NameId('NAME', 1, 1);
    NameId_STYLE_instance = new NameId('STYLE', 2, 2);
    NameId_UNAME_instance = new NameId('UNAME', 3, 3);
    NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
    NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
    NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
    NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
    NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
    NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
    NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
    NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
    NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
    NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
    NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
    NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
    NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
    NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
    NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
    NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
    NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
    NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
    NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
    NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
    NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
    NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
    Companion_getInstance_37();
  }
  var Colrv1Paint_PaintColrLayers_instance;
  var Colrv1Paint_PaintSolid_instance;
  var Colrv1Paint_PaintVarSolid_instance;
  var Colrv1Paint_PaintLinearGradient_instance;
  var Colrv1Paint_PaintVarLinearGradient_instance;
  var Colrv1Paint_PaintRadialGradient_instance;
  var Colrv1Paint_PaintVarRadialGradient_instance;
  var Colrv1Paint_PaintSweepGradient_instance;
  var Colrv1Paint_PaintVarSweepGradient_instance;
  var Colrv1Paint_PaintGlyph_instance;
  var Colrv1Paint_PaintColrGlyph_instance;
  var Colrv1Paint_PaintTransform_instance;
  var Colrv1Paint_PaintVarTransform_instance;
  var Colrv1Paint_PaintTranslate_instance;
  var Colrv1Paint_PaintVarTranslate_instance;
  var Colrv1Paint_PaintScale_instance;
  var Colrv1Paint_PaintVarScale_instance;
  var Colrv1Paint_PaintScaleAroundCenter_instance;
  var Colrv1Paint_PaintVarScaleAroundCenter_instance;
  var Colrv1Paint_PaintScaleUniform_instance;
  var Colrv1Paint_PaintVarScaleUniform_instance;
  var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
  var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
  var Colrv1Paint_PaintRotate_instance;
  var Colrv1Paint_PaintVarRotate_instance;
  var Colrv1Paint_PaintRotateAroundCenter_instance;
  var Colrv1Paint_PaintVarRotateAroundCenter_instance;
  var Colrv1Paint_PaintSkew_instance;
  var Colrv1Paint_PaintVarSkew_instance;
  var Colrv1Paint_PaintSkewAroundCenter_instance;
  var Colrv1Paint_PaintVarSkewAroundCenter_instance;
  var Colrv1Paint_PaintComposite_instance;
  function Companion_18() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.plus' call
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(1), null);
    var tmp0_plus = tmp$ret$0;
    var tmp1_plus = values_3();
    var tmp$ret$1;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$1 = tmp0_plus;
    tmp$ret$2 = tmp$ret$1.concat(tmp1_plus);
    tmp.f5d_1 = tmp$ret$2;
  }
  var Companion_instance_18;
  function Companion_getInstance_38() {
    Colrv1Paint_initEntries();
    if (Companion_instance_18 == null)
      new Companion_18();
    return Companion_instance_18;
  }
  function values_3() {
    return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
  }
  var Colrv1Paint_entriesInitialized;
  function Colrv1Paint_initEntries() {
    if (Colrv1Paint_entriesInitialized)
      return Unit_getInstance();
    Colrv1Paint_entriesInitialized = true;
    Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
    Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
    Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
    Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
    Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
    Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
    Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
    Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
    Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
    Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
    Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
    Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
    Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
    Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
    Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
    Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
    Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
    Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
    Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
    Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
    Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
    Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
    Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
    Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
    Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
    Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
    Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
    Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
    Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
    Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
    Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
    Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
    Companion_getInstance_38();
  }
  function BaseTtfFont_init_$Init$(d, extName, onlyReadMetadata, enableLigatures, $this) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    BaseTtfFont.call($this, openFastStream(d), extName, onlyReadMetadata, enableLigatures);
    return $this;
  }
  function NamesInfo() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    Companion_getInstance_37();
    var tmp0_arrayOfNulls = 26;
    tmp$ret$0 = fillArrayVal(Array(tmp0_arrayOfNulls), null);
    tmp.g5d_1 = tmp$ret$0;
    var tmp_0 = this;
    Companion_getInstance_37();
    tmp_0.h5d_1 = new Int32Array(26);
    var tmp_1 = this;
    var tmp_2 = 0;
    Companion_getInstance_37();
    var tmp_3 = 26;
    var tmp_4 = new Int32Array(tmp_3);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp$ret$1;
      // Inline function 'korlibs.image.font.NamesInfo.namesLengths.<anonymous>' call
      tmp$ret$1 = -1;
      tmp_4[tmp_5] = tmp$ret$1;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.i5d_1 = tmp_4;
    var tmp_6 = this;
    var tmp_7 = 0;
    Companion_getInstance_37();
    var tmp_8 = 26;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$2 = fillArrayVal(Array(tmp_8), null);
    var tmp_9 = tmp$ret$2;
    while (tmp_7 < tmp_8) {
      var tmp_10 = tmp_7;
      var tmp$ret$3;
      // Inline function 'korlibs.image.font.NamesInfo.namesCharsets.<anonymous>' call
      tmp$ret$3 = get_UTF8();
      tmp_9[tmp_10] = tmp$ret$3;
      tmp_7 = tmp_7 + 1 | 0;
    }
    tmp_6.j5d_1 = tmp_9;
    this.k5d_1 = null;
  }
  protoOf(NamesInfo).f5b = function () {
    var tmp0_elvis_lhs = this.l5d(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.l5d(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  };
  protoOf(NamesInfo).m5d = function (nameId) {
    if (this.g5d_1[nameId] == null) {
      var nameLength = this.i5d_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.k5d_1).z32(this.h5d_1[nameId], nameLength, this.j5d_1[nameId]);
      var tmp;
      var tmp$ret$0;
      // Inline function 'kotlin.text.isEmpty' call
      tmp$ret$0 = charSequenceLength(string) === 0;
      if (tmp$ret$0) {
        tmp = string;
      } else {
        if (equals(new Char(charSequenceGet(string, 0)), new Char(_Char___init__impl__6a9atx(0)))) {
          var tmp$ret$3;
          // Inline function 'kotlin.text.filter' call
          var tmp$ret$2;
          // Inline function 'kotlin.text.filterTo' call
          var tmp0_filterTo = StringBuilder_init_$Create$();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              var tmp$ret$1;
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              tmp$ret$1 = !equals(new Char(element), new Char(_Char___init__impl__6a9atx(0)));
              if (tmp$ret$1) {
                tmp0_filterTo.f7(element);
              }
            }
             while (inductionVariable < last);
          tmp$ret$2 = tmp0_filterTo;
          tmp$ret$3 = tmp$ret$2.toString();
          tmp = tmp$ret$3;
        } else {
          tmp = string;
        }
      }
      this.g5d_1[nameId] = tmp;
    }
    return this.g5d_1[nameId];
  };
  protoOf(NamesInfo).l5d = function (nameId) {
    return this.m5d(nameId.p5d_1);
  };
  protoOf(NamesInfo).q5d = function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.associateWith' call
    var tmp0_associateWith = values_2();
    var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(tmp0_associateWith.length), 16));
    var tmp$ret$1;
    // Inline function 'kotlin.collections.associateWithTo' call
    var indexedObject = tmp0_associateWith;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      tmp$ret$0 = this.l5d(element);
      result.x3(element, tmp$ret$0);
    }
    tmp$ret$1 = result;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  protoOf(NamesInfo).toString = function () {
    return 'NamesInfo(' + this.q5d() + ')';
  };
  function SubstitutionInfo(maxSequence, map) {
    this.r5d_1 = maxSequence;
    this.s5d_1 = map;
  }
  function Table(id, checksum, offset, length) {
    this.y5c_1 = id;
    this.z5c_1 = checksum;
    this.a5d_1 = offset;
    this.b5d_1 = length;
    this.c5d_1 = null;
    var tmp = this;
    tmp.d5d_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  protoOf(Table).t5d = function () {
    return _get_ss__ndcawb(this).dn();
  };
  protoOf(Table).toString = function () {
    return 'Table(id=' + this.y5c_1 + ', checksum=' + this.z5c_1 + ', offset=' + this.a5d_1 + ', length=' + this.b5d_1 + ')';
  };
  protoOf(Table).hashCode = function () {
    var result = getStringHashCode(this.y5c_1);
    result = imul(result, 31) + this.z5c_1 | 0;
    result = imul(result, 31) + this.a5d_1 | 0;
    result = imul(result, 31) + this.b5d_1 | 0;
    return result;
  };
  protoOf(Table).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.y5c_1 === tmp0_other_with_cast.y5c_1))
      return false;
    if (!(this.z5c_1 === tmp0_other_with_cast.z5c_1))
      return false;
    if (!(this.a5d_1 === tmp0_other_with_cast.a5d_1))
      return false;
    if (!(this.b5d_1 === tmp0_other_with_cast.b5d_1))
      return false;
    return true;
  };
  function HorMetric(advanceWidth, lsb) {
    this.u5d_1 = advanceWidth;
    this.v5d_1 = lsb;
  }
  protoOf(HorMetric).toString = function () {
    return 'HorMetric(advanceWidth=' + this.u5d_1 + ', lsb=' + this.v5d_1 + ')';
  };
  protoOf(HorMetric).hashCode = function () {
    var result = this.u5d_1;
    result = imul(result, 31) + this.v5d_1 | 0;
    return result;
  };
  protoOf(HorMetric).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.u5d_1 === tmp0_other_with_cast.u5d_1))
      return false;
    if (!(this.v5d_1 === tmp0_other_with_cast.v5d_1))
      return false;
    return true;
  };
  function Companion_19() {
    Companion_instance_19 = this;
  }
  protoOf(Companion_19).w5d = function (s, info) {
    var tmp$ret$0;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.j33();
    var count = s.j33();
    var stringOffset = s.j33();
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < count) {
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.j33();
        var encodingId = s.j33();
        var languageId = s.j33();
        var nameId = s.j33();
        var length = s.j33();
        var offset = s.j33();
        var tmp_0;
        if (nameId < 0) {
          tmp_0 = true;
        } else {
          Companion_getInstance_37();
          tmp_0 = nameId >= 26;
        }
        if (tmp_0)
          continue $l$loop;
        var tmp1_subject = encodingId;
        {
          var charset;
          switch (tmp1_subject) {
            case 0:
              charset = get_UTF8();
              break;
            case 1:
              charset = get_UTF16_BE();
              break;
            default:
              charset = get_UTF16_BE();
              break;
          }
        }
        if ((platformId === 0 ? languageId === 0 : false) ? true : info.i5d_1[nameId] === -1) {
          info.h5d_1[nameId] = stringOffset + offset | 0;
          info.i5d_1[nameId] = length;
          info.j5d_1[nameId] = charset;
          info.k5d_1 = s;
        }
      }
       while (inductionVariable < count);
      tmp = Unit_getInstance();
    }
    tmp$ret$0 = tmp;
    return tmp$ret$0;
  };
  protoOf(Companion_19).x5a = function (s) {
    var tmp$ret$5;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.l33() === 1953784678) {
      var majorVersion = s.j33();
      var minorVersion = s.j33();
      var numFonts = s.l33();
      var tableDirectoryOffsets = s.r33(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.l33();
        var dsigLength = s.l33();
        var dsigOffset = s.l33();
      }
      s.x32(tableDirectoryOffsets[0]);
    } else {
      s.e33(4);
    }
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = s.j33();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(tmp0_apply === 1) ? !(tmp0_apply === 20308) : false) {
      invalidOp('Not a TTF/OTF file');
    }
    tmp$ret$0 = tmp0_apply;
    var majorVersion_0 = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.apply' call
    var tmp1_apply = s.j33();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(tmp1_apply === 0) ? !(tmp1_apply === 21583) : false) {
      invalidOp('Not a TTF/OTF file');
    }
    tmp$ret$1 = tmp1_apply;
    var minorVersion_0 = tmp$ret$1;
    var numTables = s.j33();
    var searchRange = s.j33();
    var entrySelector = s.j33();
    var rangeShift = s.j33();
    var tmp$ret$4;
    // Inline function 'kotlin.collections.map' call
    var tmp3_map = until(0, numTables);
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp2_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map, 10));
    var inductionVariable = tmp3_map.a1_1;
    var last = tmp3_map.b1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$2;
        // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
        tmp$ret$2 = new Table(s.t33(4), s.l33(), s.l33(), s.l33());
        tmp2_mapTo.b(tmp$ret$2);
      }
       while (!(item === last));
    tmp$ret$3 = tmp2_mapTo;
    tmp$ret$4 = tmp$ret$3;
    var tables = tmp$ret$4;
    var tablesByName = LinkedHashMap_init_$Create$_0();
    var tmp0_iterator = tables.g();
    while (tmp0_iterator.h()) {
      var table = tmp0_iterator.i();
      var tmp = table;
      tmp.c5d_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var tmp4_set = table.y5c_1;
      tablesByName.x3(tmp4_set, table);
    }
    return tablesByName;
    return tmp$ret$5;
  };
  var Companion_instance_19;
  function Companion_getInstance_39() {
    if (Companion_instance_19 == null)
      new Companion_19();
    return Companion_instance_19;
  }
  function NameId(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.p5d_1 = id;
  }
  function ColorBitmapInfo(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.x5d_1 = indexSubTableArrayOffset;
    this.y5d_1 = indexTablesSize;
    this.z5d_1 = numberofIndexSubTables;
    this.a5e_1 = colorRef;
    this.b5e_1 = hori;
    this.c5e_1 = vert;
    this.d5e_1 = startGlyphIndex;
    this.e5e_1 = endGlyphIndex;
    this.f5e_1 = ppemX;
    this.g5e_1 = ppemY;
    this.h5e_1 = bitDepth;
    this.i5e_1 = flags;
  }
  protoOf(ColorBitmapInfo).toString = function () {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.x5d_1 + ', indexTablesSize=' + this.y5d_1 + ', numberofIndexSubTables=' + this.z5d_1 + ', colorRef=' + this.a5e_1 + ', hori=' + this.b5e_1 + ', vert=' + this.c5e_1 + ', startGlyphIndex=' + this.d5e_1 + ', endGlyphIndex=' + this.e5e_1 + ', ppemX=' + this.f5e_1 + ', ppemY=' + this.g5e_1 + ', bitDepth=' + this.h5e_1 + ', flags=' + this.i5e_1 + ')';
  };
  protoOf(ColorBitmapInfo).hashCode = function () {
    var result = this.x5d_1;
    result = imul(result, 31) + this.y5d_1 | 0;
    result = imul(result, 31) + this.z5d_1 | 0;
    result = imul(result, 31) + this.a5e_1 | 0;
    result = imul(result, 31) + this.b5e_1.hashCode() | 0;
    result = imul(result, 31) + this.c5e_1.hashCode() | 0;
    result = imul(result, 31) + this.d5e_1 | 0;
    result = imul(result, 31) + this.e5e_1 | 0;
    result = imul(result, 31) + this.f5e_1 | 0;
    result = imul(result, 31) + this.g5e_1 | 0;
    result = imul(result, 31) + this.h5e_1 | 0;
    result = imul(result, 31) + this.i5e_1 | 0;
    return result;
  };
  protoOf(ColorBitmapInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.x5d_1 === tmp0_other_with_cast.x5d_1))
      return false;
    if (!(this.y5d_1 === tmp0_other_with_cast.y5d_1))
      return false;
    if (!(this.z5d_1 === tmp0_other_with_cast.z5d_1))
      return false;
    if (!(this.a5e_1 === tmp0_other_with_cast.a5e_1))
      return false;
    if (!this.b5e_1.equals(tmp0_other_with_cast.b5e_1))
      return false;
    if (!this.c5e_1.equals(tmp0_other_with_cast.c5e_1))
      return false;
    if (!(this.d5e_1 === tmp0_other_with_cast.d5e_1))
      return false;
    if (!(this.e5e_1 === tmp0_other_with_cast.e5e_1))
      return false;
    if (!(this.f5e_1 === tmp0_other_with_cast.f5e_1))
      return false;
    if (!(this.g5e_1 === tmp0_other_with_cast.g5e_1))
      return false;
    if (!(this.h5e_1 === tmp0_other_with_cast.h5e_1))
      return false;
    if (!(this.i5e_1 === tmp0_other_with_cast.i5e_1))
      return false;
    return true;
  };
  function SbitLineMetrics(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.j5e_1 = ascender;
    this.k5e_1 = descender;
    this.l5e_1 = widthMax;
    this.m5e_1 = caretSlopeNumerator;
    this.n5e_1 = caretSlopeDenominator;
    this.o5e_1 = caretOffset;
    this.p5e_1 = minOriginSB;
    this.q5e_1 = minAdvanceSB;
    this.r5e_1 = maxBeforeBL;
    this.s5e_1 = minAfterBL;
    this.t5e_1 = pad1;
    this.u5e_1 = pad2;
  }
  protoOf(SbitLineMetrics).toString = function () {
    return 'SbitLineMetrics(ascender=' + this.j5e_1 + ', descender=' + this.k5e_1 + ', widthMax=' + this.l5e_1 + ', caretSlopeNumerator=' + this.m5e_1 + ', caretSlopeDenominator=' + this.n5e_1 + ', caretOffset=' + this.o5e_1 + ', minOriginSB=' + this.p5e_1 + ', minAdvanceSB=' + this.q5e_1 + ', maxBeforeBL=' + this.r5e_1 + ', minAfterBL=' + this.s5e_1 + ', pad1=' + this.t5e_1 + ', pad2=' + this.u5e_1 + ')';
  };
  protoOf(SbitLineMetrics).hashCode = function () {
    var result = this.j5e_1;
    result = imul(result, 31) + this.k5e_1 | 0;
    result = imul(result, 31) + this.l5e_1 | 0;
    result = imul(result, 31) + this.m5e_1 | 0;
    result = imul(result, 31) + this.n5e_1 | 0;
    result = imul(result, 31) + this.o5e_1 | 0;
    result = imul(result, 31) + this.p5e_1 | 0;
    result = imul(result, 31) + this.q5e_1 | 0;
    result = imul(result, 31) + this.r5e_1 | 0;
    result = imul(result, 31) + this.s5e_1 | 0;
    result = imul(result, 31) + this.t5e_1 | 0;
    result = imul(result, 31) + this.u5e_1 | 0;
    return result;
  };
  protoOf(SbitLineMetrics).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.j5e_1 === tmp0_other_with_cast.j5e_1))
      return false;
    if (!(this.k5e_1 === tmp0_other_with_cast.k5e_1))
      return false;
    if (!(this.l5e_1 === tmp0_other_with_cast.l5e_1))
      return false;
    if (!(this.m5e_1 === tmp0_other_with_cast.m5e_1))
      return false;
    if (!(this.n5e_1 === tmp0_other_with_cast.n5e_1))
      return false;
    if (!(this.o5e_1 === tmp0_other_with_cast.o5e_1))
      return false;
    if (!(this.p5e_1 === tmp0_other_with_cast.p5e_1))
      return false;
    if (!(this.q5e_1 === tmp0_other_with_cast.q5e_1))
      return false;
    if (!(this.r5e_1 === tmp0_other_with_cast.r5e_1))
      return false;
    if (!(this.s5e_1 === tmp0_other_with_cast.s5e_1))
      return false;
    if (!(this.t5e_1 === tmp0_other_with_cast.t5e_1))
      return false;
    if (!(this.u5e_1 === tmp0_other_with_cast.u5e_1))
      return false;
    return true;
  };
  function BitmapGlyphInfo(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.v5e_1 = glyphID;
    this.w5e_1 = imageFormat;
    this.x5e_1 = offset;
    this.y5e_1 = size;
    this.z5e_1 = info;
    this.a5f_1 = height;
    this.b5f_1 = width;
    this.c5f_1 = horiBearingX;
    this.d5f_1 = horiBearingY;
    this.e5f_1 = horiAdvance;
    this.f5f_1 = vertBearingX;
    this.g5f_1 = vertBearingY;
    this.h5f_1 = vertAdvance;
    this.i5f_1 = null;
    this.j5f_1 = null;
  }
  protoOf(BitmapGlyphInfo).k5f = function () {
    return this.z5e_1.b5e_1.k5e_1;
  };
  protoOf(BitmapGlyphInfo).l5f = function (cache) {
    var tmp0_elvis_lhs = this.j5f_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().n5f(toSyncStream(ensureNotNull(this.i5f_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          var tmp$ret$0;
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
          tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.j5f_1 = bmp;
    return bmp;
  };
  protoOf(BitmapGlyphInfo).o5f = function (cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.l5f(cache) : $super.l5f.call(this, cache);
  };
  protoOf(BitmapGlyphInfo).toString = function () {
    return 'BitmapGlyphInfo(glyphID=' + this.v5e_1 + ', imageFormat=' + this.w5e_1 + ', offset=' + this.x5e_1 + ', size=' + this.y5e_1 + ', info=' + this.z5e_1 + ', height=' + this.a5f_1 + ', width=' + this.b5f_1 + ', horiBearingX=' + this.c5f_1 + ', horiBearingY=' + this.d5f_1 + ', horiAdvance=' + this.e5f_1 + ', vertBearingX=' + this.f5f_1 + ', vertBearingY=' + this.g5f_1 + ', vertAdvance=' + this.h5f_1 + ')';
  };
  protoOf(BitmapGlyphInfo).hashCode = function () {
    var result = this.v5e_1;
    result = imul(result, 31) + this.w5e_1 | 0;
    result = imul(result, 31) + this.x5e_1 | 0;
    result = imul(result, 31) + this.y5e_1 | 0;
    result = imul(result, 31) + this.z5e_1.hashCode() | 0;
    result = imul(result, 31) + this.a5f_1 | 0;
    result = imul(result, 31) + this.b5f_1 | 0;
    result = imul(result, 31) + this.c5f_1 | 0;
    result = imul(result, 31) + this.d5f_1 | 0;
    result = imul(result, 31) + this.e5f_1 | 0;
    result = imul(result, 31) + this.f5f_1 | 0;
    result = imul(result, 31) + this.g5f_1 | 0;
    result = imul(result, 31) + this.h5f_1 | 0;
    return result;
  };
  protoOf(BitmapGlyphInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.v5e_1 === tmp0_other_with_cast.v5e_1))
      return false;
    if (!(this.w5e_1 === tmp0_other_with_cast.w5e_1))
      return false;
    if (!(this.x5e_1 === tmp0_other_with_cast.x5e_1))
      return false;
    if (!(this.y5e_1 === tmp0_other_with_cast.y5e_1))
      return false;
    if (!this.z5e_1.equals(tmp0_other_with_cast.z5e_1))
      return false;
    if (!(this.a5f_1 === tmp0_other_with_cast.a5f_1))
      return false;
    if (!(this.b5f_1 === tmp0_other_with_cast.b5f_1))
      return false;
    if (!(this.c5f_1 === tmp0_other_with_cast.c5f_1))
      return false;
    if (!(this.d5f_1 === tmp0_other_with_cast.d5f_1))
      return false;
    if (!(this.e5f_1 === tmp0_other_with_cast.e5f_1))
      return false;
    if (!(this.f5f_1 === tmp0_other_with_cast.f5f_1))
      return false;
    if (!(this.g5f_1 === tmp0_other_with_cast.g5f_1))
      return false;
    if (!(this.h5f_1 === tmp0_other_with_cast.h5f_1))
      return false;
    return true;
  };
  function ColorLine(cycle, stops) {
    this.p5f_1 = cycle;
    this.q5f_1 = stops;
  }
  protoOf(ColorLine).r5f = function (paint, palette) {
    var tmp0_iterator = this.q5f_1.g();
    while (tmp0_iterator.h()) {
      var stop = tmp0_iterator.i();
      paint.t5g(stop.s5f_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.t4l_1, stop.t5f_1), stop.u5f_1));
    }
  };
  protoOf(ColorLine).toString = function () {
    return 'ColorLine(cycle=' + this.p5f_1 + ', stops=' + this.q5f_1 + ')';
  };
  protoOf(ColorLine).hashCode = function () {
    var result = this.p5f_1.hashCode();
    result = imul(result, 31) + hashCode(this.q5f_1) | 0;
    return result;
  };
  protoOf(ColorLine).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.p5f_1.equals(tmp0_other_with_cast.p5f_1))
      return false;
    if (!equals(this.q5f_1, tmp0_other_with_cast.q5f_1))
      return false;
    return true;
  };
  function ColorStop(stopOffset, paletteIndex, alpha) {
    this.s5f_1 = stopOffset;
    this.t5f_1 = paletteIndex;
    this.u5f_1 = alpha;
  }
  function Colrv1Paint(name, ordinal) {
    Enum.call(this, name, ordinal);
    this.w5g_1 = this.j5_1 + 1 | 0;
  }
  function COLRv1(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.intArrayOf' call
      tmp$ret$0 = new Int32Array([]);
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      var tmp$ret$0_1;
      var tmp$ret$1;
      // Inline function 'kotlin.byteArrayOf' call
      tmp$ret$0_1 = new Int8Array([]);
      tmp$ret$1 = Unit_getInstance();
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      var tmp$ret$0_2;
      var tmp$ret$2;
      // Inline function 'kotlin.byteArrayOf' call
      tmp$ret$0_2 = new Int8Array([]);
      tmp$ret$2 = Unit_getInstance();
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_2);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      var tmp$ret$0_3;
      var tmp$ret$3;
      // Inline function 'kotlin.byteArrayOf' call
      tmp$ret$0_3 = new Int8Array([]);
      tmp$ret$3 = Unit_getInstance();
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_3);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.x5g_1 = layerList;
    this.y5g_1 = s;
    this.z5g_1 = sBaseOffset;
    this.a5h_1 = sLayerOffset;
    this.b5h_1 = sClipOffset;
    this.c5h_1 = IntIntMap_init_$Create$();
  }
  function Contour(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.d5h_1 = x;
    this.e5h_1 = y;
    this.f5h_1 = onCurve;
  }
  protoOf(Contour).toString = function () {
    return 'Contour(x=' + this.d5h_1 + ', y=' + this.e5h_1 + ', onCurve=' + this.f5h_1 + ')';
  };
  protoOf(Contour).hashCode = function () {
    var result = this.d5h_1;
    result = imul(result, 31) + this.e5h_1 | 0;
    result = imul(result, 31) + (this.f5h_1 | 0) | 0;
    return result;
  };
  protoOf(Contour).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.d5h_1 === tmp0_other_with_cast.d5h_1))
      return false;
    if (!(this.e5h_1 === tmp0_other_with_cast.e5h_1))
      return false;
    if (!(this.f5h_1 === tmp0_other_with_cast.f5h_1))
      return false;
    return true;
  };
  function GlyphReference(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.g5h_1 = glyph;
    this.h5h_1 = x;
    this.i5h_1 = y;
    this.j5h_1 = scaleX;
    this.k5h_1 = scale01;
    this.l5h_1 = scale10;
    this.m5h_1 = scaleY;
  }
  protoOf(GlyphReference).toString = function () {
    return 'GlyphReference(glyph=' + this.g5h_1 + ', x=' + this.h5h_1 + ', y=' + this.i5h_1 + ', scaleX=' + this.j5h_1 + ', scale01=' + this.k5h_1 + ', scale10=' + this.l5h_1 + ', scaleY=' + this.m5h_1 + ')';
  };
  protoOf(GlyphReference).hashCode = function () {
    var result = hashCode(this.g5h_1);
    result = imul(result, 31) + this.h5h_1 | 0;
    result = imul(result, 31) + this.i5h_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.j5h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k5h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l5h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m5h_1) | 0;
    return result;
  };
  protoOf(GlyphReference).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.g5h_1, tmp0_other_with_cast.g5h_1))
      return false;
    if (!(this.h5h_1 === tmp0_other_with_cast.h5h_1))
      return false;
    if (!(this.i5h_1 === tmp0_other_with_cast.i5h_1))
      return false;
    if (!equals(this.j5h_1, tmp0_other_with_cast.j5h_1))
      return false;
    if (!equals(this.k5h_1, tmp0_other_with_cast.k5h_1))
      return false;
    if (!equals(this.l5h_1, tmp0_other_with_cast.l5h_1))
      return false;
    if (!equals(this.m5h_1, tmp0_other_with_cast.m5h_1))
      return false;
    return true;
  };
  function ColrLayerInfo($outer, glyphID, paletteIndex) {
    this.p5h_1 = $outer;
    this.n5h_1 = glyphID;
    this.o5h_1 = paletteIndex;
  }
  protoOf(ColrLayerInfo).q5h = function (pal) {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_getOrElse = getCyclic(this.p5h_1.m5a_1, pal).t4l_1;
    var tmp1_getOrElse = this.o5h_1;
    var tmp;
    if (tmp1_getOrElse >= 0 ? tmp1_getOrElse <= get_lastIndex(new RgbaArray(tmp0_getOrElse)) : false) {
      tmp = (new RgbaArray(tmp0_getOrElse)).k(tmp1_getOrElse).q4n_1;
    } else {
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp$ret$0 = Colors_getInstance().l4a_1;
      tmp = tmp$ret$0;
    }
    tmp$ret$1 = tmp;
    return tmp$ret$1;
  };
  protoOf(ColrLayerInfo).r5h = function () {
    return this.q5h(0);
  };
  protoOf(ColrLayerInfo).s5h = function (pal) {
    var tmp0_safe_receiver = this.p5h_1.t5c(this.n5h_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g1z();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp$ret$0 = new FillShape(tmp1_safe_receiver.c5i_1, null, new RGBA(this.q5h(pal)));
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    return tmp;
  };
  protoOf(ColrLayerInfo).toString = function () {
    return 'ColrLayerInfo(' + this.n5h_1 + ', ' + this.o5h_1 + ', ' + new RGBA(this.r5h()) + ')';
  };
  function ColrGlyphInfo() {
  }
  function ColrGlyphInfoV1($outer, glyphID, paint) {
    this.h5i_1 = $outer;
    this.f5i_1 = glyphID;
    this.g5i_1 = paint;
  }
  protoOf(ColrGlyphInfoV1).d5i = function (pal) {
    var tmp$ret$3;
    // Inline function 'kotlin.also' call
    var tmp$ret$1;
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.h5i_1.n5a_1.z5g_1.c33(this.g5i_1);
    try {
      this.h5i_1.g5c(this.f5i_1, paintS, tmp0_apply, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.b4w();
    var tmp1_also = tmp$ret$1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$2;
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    tmp$ret$2 = Unit_getInstance();
    tmp$ret$3 = tmp1_also;
    return tmp$ret$3;
  };
  protoOf(ColrGlyphInfoV1).toString = function () {
    return 'ColrGlyphInfoV1[' + this.f5i_1 + '][' + this.g5i_1 + ']';
  };
  function ColrGlyphInfoV0($outer, glyphID, firstLayerIndex, numLayers) {
    this.l5i_1 = $outer;
    this.i5i_1 = glyphID;
    this.j5i_1 = firstLayerIndex;
    this.k5i_1 = numLayers;
  }
  protoOf(ColrGlyphInfoV0).k = function (index) {
    return this.l5i_1.k5a_1[this.j5i_1 + index | 0];
  };
  protoOf(ColrGlyphInfoV0).w54 = function () {
    var tmp = 0;
    var tmp_0 = this.k5i_1;
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(tmp_0), null);
    var tmp_1 = tmp$ret$0;
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp$ret$1;
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.toList.<anonymous>' call
      tmp$ret$1 = this.k(tmp_2);
      tmp_1[tmp_2] = tmp$ret$1;
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  };
  protoOf(ColrGlyphInfoV0).d5i = function (pal) {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp1_mapNotNull = this.w54();
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp1_mapNotNull.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      tmp$ret$0 = element.s5h(pal);
      var tmp0_safe_receiver = tmp$ret$0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.b(tmp0_safe_receiver);
        tmp$ret$1 = Unit_getInstance();
      }
    }
    tmp$ret$2 = tmp0_mapNotNullTo;
    tmp$ret$3 = tmp$ret$2;
    return new CompoundShape(tmp$ret$3);
  };
  protoOf(ColrGlyphInfoV0).toString = function () {
    return 'ColrGlyphInfoV0[' + this.i5i_1 + '][' + this.k5i_1 + '](' + this.w54() + ')';
  };
  function GlyphGraphicsPath(glpyhIndex, path) {
    this.b5i_1 = glpyhIndex;
    this.c5i_1 = path;
  }
  protoOf(GlyphGraphicsPath).m3y = function () {
    return this.c5i_1.g3o_1;
  };
  protoOf(GlyphGraphicsPath).l3y = function () {
    return this.c5i_1.l3y();
  };
  protoOf(GlyphGraphicsPath).s3y = function (center, r, start, end, counterclockwise) {
    this.c5i_1.s3y(center, r, start, end, counterclockwise);
  };
  protoOf(GlyphGraphicsPath).v3b = function (center, radius) {
    this.c5i_1.v3b(center, radius);
  };
  protoOf(GlyphGraphicsPath).c1c = function () {
    this.c5i_1.c1c();
  };
  protoOf(GlyphGraphicsPath).f3k = function (c1, c2, a) {
    this.c5i_1.f3k(c1, c2, a);
  };
  protoOf(GlyphGraphicsPath).n3y = function (p0, p1) {
    this.c5i_1.n3y(p0, p1);
  };
  protoOf(GlyphGraphicsPath).j3o = function (p) {
    this.c5i_1.j3o(p);
  };
  protoOf(GlyphGraphicsPath).e3k = function (p) {
    this.c5i_1.e3k(p);
  };
  protoOf(GlyphGraphicsPath).k3o = function (c, a) {
    this.c5i_1.k3o(c, a);
  };
  protoOf(GlyphGraphicsPath).v3y = function (delta) {
    this.c5i_1.v3y(delta);
  };
  protoOf(GlyphGraphicsPath).u3y = function (delta) {
    this.c5i_1.u3y(delta);
  };
  protoOf(GlyphGraphicsPath).p3y = function (pos, size) {
    this.c5i_1.p3y(pos, size);
  };
  protoOf(GlyphGraphicsPath).o3y = function (rect) {
    this.c5i_1.o3y(rect);
  };
  protoOf(GlyphGraphicsPath).q3y = function (x, y, width, height) {
    this.c5i_1.q3y(x, y, width, height);
  };
  protoOf(GlyphGraphicsPath).r3y = function (x, y, width, height) {
    this.c5i_1.r3y(x, y, width, height);
  };
  protoOf(GlyphGraphicsPath).w3y = function (m) {
    return this.c5i_1.w3y(m);
  };
  protoOf(GlyphGraphicsPath).toString = function () {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.b5i_1 + ', "' + toSvgPathString(this.c5i_1) + '")';
  };
  protoOf(GlyphGraphicsPath).hashCode = function () {
    var result = this.b5i_1;
    result = imul(result, 31) + this.c5i_1.hashCode() | 0;
    return result;
  };
  protoOf(GlyphGraphicsPath).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.b5i_1 === tmp0_other_with_cast.b5i_1))
      return false;
    if (!this.c5i_1.equals(tmp0_other_with_cast.c5i_1))
      return false;
    return true;
  };
  function Glyph_0($outer, index, xMin, yMin, xMax, yMax, advanceWidth) {
    this.a5i_1 = $outer;
    this.t5h_1 = index;
    this.u5h_1 = xMin;
    this.v5h_1 = yMin;
    this.w5h_1 = xMax;
    this.x5h_1 = yMax;
    this.y5h_1 = advanceWidth;
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.u5h_1;
    var yMin_0 = this.v5h_1;
    var xMax_0 = this.w5h_1;
    var yMax_0 = this.x5h_1;
    if (((xMin_0 === 0 ? yMin_0 === 0 : false) ? xMax_0 === 0 : false) ? yMax_0 === 0 : false) {
      var sClipOffset = this.a5i_1.n5a_1.b5h_1;
      var glyphIDToClipOffset = this.a5i_1.n5a_1.c5h_1;
      var tmp_0;
      if (!(sClipOffset == null) ? glyphIDToClipOffset.l6(this.t5h_1) : false) {
        var clipOffset = glyphIDToClipOffset.k(this.t5h_1);
        tmp_0 = this.a5i_1.e5c(sClipOffset.c33(clipOffset));
      } else {
        var tmp0_safe_receiver = this.m5i();
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e5i();
        tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n5i();
      }
      var bounds = tmp_0;
      var tmp_1 = bounds;
      if (!((tmp_1 == null ? null : new Rectangle(tmp_1)) == null)) {
        xMin_0 = numberToInt(_Rectangle___get_left__impl__sgtjiw(bounds));
        xMax_0 = numberToInt(_Rectangle___get_right__impl__7wa90z(bounds));
        yMin_0 = numberToInt(_Rectangle___get_top__impl__3kuxui(bounds));
        yMax_0 = numberToInt(_Rectangle___get_bottom__impl__1duj44(bounds));
      }
    }
    var size = this.a5i_1.v59_1;
    var scale = this.a5i_1.e4q(size);
    tmp$ret$0 = new GlyphMetrics(size, true, -1, Companion_getInstance_6().s3i(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.y5h_1 * scale);
    tmp$ret$1 = tmp$ret$0;
    tmp.z5h_1 = tmp$ret$1;
  }
  protoOf(Glyph_0).m5i = function () {
    return this.a5i_1.l5a_1.k(this.t5h_1);
  };
  protoOf(Glyph_0).o5i = function () {
    return this.a5i_1.j5a_1.z1(this.t5h_1);
  };
  function CompositeGlyph($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth) {
    this.a5j_1 = $outer;
    Glyph_0.call(this, $outer, index, xMin, yMin, xMax, yMax, advanceWidth);
    this.x5i_1 = refs;
    var tmp = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map = this.x5i_1;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
    var tmp0_iterator = tmp1_map.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$1;
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.g5h_1.g1z().c5i_1;
      var tmp$ret$0;
      // Inline function 'kotlin.also' call
      var tmp0_also = new GlyphGraphicsPath(item.g5h_1.t5h_1, new VectorPath(new IntArrayList(gpath.z3n_1.j()), new FloatArrayList(gpath.a3o_1.j())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Matrix__translated_impl_3xg5y_0(Matrix__scaled_impl_ogn4b6(Companion_getInstance_9().g3g(), item.j5h_1, item.m5h_1), item.h5h_1, -item.i5h_1 | 0);
      tmp0_also.c5i_1.h3z(item.g5h_1.g1z().c5i_1, m);
      tmp$ret$0 = tmp0_also;
      tmp$ret$1 = tmp$ret$0;
      tmp0_mapTo.b(tmp$ret$1);
    }
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    tmp.y5i_1 = tmp$ret$3;
    var tmp_0 = this;
    var tmp$ret$6;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$5;
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.y5i_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      commandsSize = commandsSize + tmp1__anonymous__uwfjfc.c5i_1.z3n_1.j() | 0;
      dataSize = dataSize + tmp1__anonymous__uwfjfc.c5i_1.a3o_1.j() | 0;
    }
    var tmp$ret$4;
    // Inline function 'kotlin.also' call
    var tmp2_also = new GlyphGraphicsPath(index, new VectorPath(new IntArrayList(commandsSize), new FloatArrayList(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach_0 = this.y5i_1;
    var n_0 = 0;
    while (n_0 < tmp0_fastForEach_0.j()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var tmp1__anonymous__uwfjfc_0 = tmp0_fastForEach_0.k(tmp0_0);
      tmp2_also.c5i_1.i3z(tmp1__anonymous__uwfjfc_0.c5i_1);
    }
    tmp$ret$4 = tmp2_also;
    tmp$ret$5 = tmp$ret$4;
    tmp$ret$6 = tmp$ret$5;
    tmp_0.z5i_1 = tmp$ret$6;
  }
  protoOf(CompositeGlyph).toString = function () {
    return 'CompositeGlyph[' + this.y5h_1 + '](' + this.x5i_1 + ')';
  };
  protoOf(CompositeGlyph).g1z = function () {
    return this.z5i_1;
  };
  function CFFGlyph($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path) {
    this.l5j_1 = $outer;
    Glyph_0.call(this, $outer, index, xMin, yMin, xMax, yMax, advanceWidth);
    this.j5j_1 = path;
    this.k5j_1 = listOf(this.j5j_1);
  }
  protoOf(CFFGlyph).g1z = function () {
    return this.j5j_1;
  };
  function SimpleGlyph($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy) {
    dummy = dummy === VOID ? false : dummy;
    this.b5k_1 = $outer;
    Glyph_0.call(this, $outer, index, xMin, yMin, xMax, yMax, advanceWidth);
    this.u5j_1 = contoursIndices;
    this.v5j_1 = flags;
    this.w5j_1 = xPos;
    this.x5j_1 = yPos;
    this.y5j_1 = dummy;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$1;
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var inductionVariable = 0;
    var last = this.u5j_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.u5j_1[n] + 1 | 0;
        var cend = this.u5j_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new GlyphGraphicsPath(index, new VectorPath(new IntArrayList(commandSize), new FloatArrayList(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var inductionVariable_0 = 0;
    var last_0 = this.u5j_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.u5j_1[n_0] + 1 | 0;
        var cend_0 = this.u5j_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.c5k(cend_0, this.b5k_1.r58_1[0]);
        var next = this.c5k(cstart_0, this.b5k_1.r58_1[1]);
        if (curr.f5h_1) {
          tmp0_also.e3k(_Vector2___init__impl__67w0ru(curr.d5h_1, -curr.e5h_1 | 0));
        } else if (next.f5h_1) {
          tmp0_also.e3k(_Vector2___init__impl__67w0ru(next.d5h_1, -next.e5h_1 | 0));
        } else {
          tmp0_also.e3k(_Vector2___init__impl__67w0ru(imul(curr.d5h_1 + next.d5h_1 | 0, 0), -numberToInt((curr.e5h_1 + next.e5h_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.c5k(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this.b5k_1.r58_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.f5h_1) {
              tmp0_also.j3o(_Vector2___init__impl__67w0ru(curr.d5h_1, -curr.e5h_1 | 0));
            } else {
              var prev2X = prev.d5h_1;
              var prev2Y = prev.e5h_1;
              var next2X = next.d5h_1;
              var next2Y = next.e5h_1;
              if (!prev.f5h_1) {
                prev2X = numberToInt((curr.d5h_1 + prev.d5h_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.e5h_1 + prev.e5h_1 | 0) * 0.5);
                tmp0_also.j3o(_Vector2___init__impl__67w0ru(prev2X, -prev2Y | 0));
              }
              if (!next.f5h_1) {
                next2X = numberToInt((curr.d5h_1 + next.d5h_1 | 0) * 0.5);
                next2Y = numberToInt((curr.e5h_1 + next.e5h_1 | 0) * 0.5);
              }
              tmp0_also.j3o(_Vector2___init__impl__67w0ru(prev2X, -prev2Y | 0));
              tmp0_also.k3o(_Vector2___init__impl__67w0ru(curr.d5h_1, -curr.e5h_1 | 0), _Vector2___init__impl__67w0ru(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        tmp0_also.c1c();
      }
       while (inductionVariable_0 < last_0);
    tmp$ret$0 = tmp0_also;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp.z5j_1 = tmp$ret$2;
    this.a5k_1 = listOf(this.z5j_1);
  }
  protoOf(SimpleGlyph).toString = function () {
    return 'SimpleGlyph' + (this.y5j_1 ? 'Dummy' : '') + '[' + this.t5h_1 + '](advance=' + this.y5h_1 + ') : ' + this.z5j_1;
  };
  protoOf(SimpleGlyph).d5k = function (n) {
    return !((this.v5j_1[n] & 1) === 0);
  };
  protoOf(SimpleGlyph).c5k = function (n, out) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.d5h_1 = this.w5j_1[n];
    out.e5h_1 = this.x5j_1[n];
    out.f5h_1 = this.d5k(n);
    tmp$ret$0 = out;
    return tmp$ret$0;
  };
  protoOf(SimpleGlyph).g1z = function () {
    return this.z5j_1;
  };
  function BaseTtfFont$readCblc$1$Subtable(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.e5k_1 = firstGlyphIndex;
    this.f5k_1 = lastGlyphIndex;
    this.g5k_1 = additionalOffsetToIndexSubtable;
  }
  protoOf(BaseTtfFont$readCblc$1$Subtable).h5k = function () {
    return this.f5k_1 - this.e5k_1 | 0;
  };
  protoOf(BaseTtfFont$readCblc$1$Subtable).toString = function () {
    return 'Subtable(firstGlyphIndex=' + this.e5k_1 + ', lastGlyphIndex=' + this.f5k_1 + ', additionalOffsetToIndexSubtable=' + this.g5k_1 + ')';
  };
  protoOf(BaseTtfFont$readCblc$1$Subtable).hashCode = function () {
    var result = this.e5k_1;
    result = imul(result, 31) + this.f5k_1 | 0;
    result = imul(result, 31) + this.g5k_1 | 0;
    return result;
  };
  protoOf(BaseTtfFont$readCblc$1$Subtable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$1$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$1$Subtable ? other : THROW_CCE();
    if (!(this.e5k_1 === tmp0_other_with_cast.e5k_1))
      return false;
    if (!(this.f5k_1 === tmp0_other_with_cast.f5k_1))
      return false;
    if (!(this.g5k_1 === tmp0_other_with_cast.g5k_1))
      return false;
    return true;
  };
  function BaseTtfFont$readSbix$1$StrikeInfo(ppem, ppi, strikeOffset, offsets) {
    this.i5k_1 = ppem;
    this.j5k_1 = ppi;
    this.k5k_1 = strikeOffset;
    this.l5k_1 = offsets;
  }
  protoOf(BaseTtfFont$readSbix$1$StrikeInfo).toString = function () {
    return 'StrikeInfo(ppem=' + this.i5k_1 + ', ppi=' + this.j5k_1 + ', strikeOffset=' + this.k5k_1 + ', offsets=' + this.l5k_1 + ')';
  };
  protoOf(BaseTtfFont$readSbix$1$StrikeInfo).hashCode = function () {
    var result = this.i5k_1;
    result = imul(result, 31) + this.j5k_1 | 0;
    result = imul(result, 31) + this.k5k_1 | 0;
    result = imul(result, 31) + this.l5k_1.hashCode() | 0;
    return result;
  };
  protoOf(BaseTtfFont$readSbix$1$StrikeInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$1$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$1$StrikeInfo ? other : THROW_CCE();
    if (!(this.i5k_1 === tmp0_other_with_cast.i5k_1))
      return false;
    if (!(this.j5k_1 === tmp0_other_with_cast.j5k_1))
      return false;
    if (!(this.k5k_1 === tmp0_other_with_cast.k5k_1))
      return false;
    if (!this.l5k_1.equals(tmp0_other_with_cast.l5k_1))
      return false;
    return true;
  };
  function BaseTtfFont$readCoverage$RangeInfo(start, endInclusive, index) {
    this.m5k_1 = start;
    this.n5k_1 = endInclusive;
    this.o5k_1 = index;
    this.p5k_1 = (this.n5k_1 - this.m5k_1 | 0) + 1 | 0;
  }
  protoOf(BaseTtfFont$readCoverage$RangeInfo).toString = function () {
    return 'RangeInfo(start=' + this.m5k_1 + ', endInclusive=' + this.n5k_1 + ', index=' + this.o5k_1 + ')';
  };
  protoOf(BaseTtfFont$readCoverage$RangeInfo).hashCode = function () {
    var result = this.m5k_1;
    result = imul(result, 31) + this.n5k_1 | 0;
    result = imul(result, 31) + this.o5k_1 | 0;
    return result;
  };
  protoOf(BaseTtfFont$readCoverage$RangeInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.m5k_1 === tmp0_other_with_cast.m5k_1))
      return false;
    if (!(this.n5k_1 === tmp0_other_with_cast.n5k_1))
      return false;
    if (!(this.o5k_1 === tmp0_other_with_cast.o5k_1))
      return false;
    return true;
  };
  function BaseTtfFont$readCmap$1$EncodingRecord(platformId, encodingId, offset) {
    this.q5k_1 = platformId;
    this.r5k_1 = encodingId;
    this.s5k_1 = offset;
  }
  protoOf(BaseTtfFont$readCmap$1$EncodingRecord).toString = function () {
    return 'EncodingRecord(platformId=' + this.q5k_1 + ', encodingId=' + this.r5k_1 + ', offset=' + this.s5k_1 + ')';
  };
  protoOf(BaseTtfFont$readCmap$1$EncodingRecord).hashCode = function () {
    var result = this.q5k_1;
    result = imul(result, 31) + this.r5k_1 | 0;
    result = imul(result, 31) + this.s5k_1 | 0;
    return result;
  };
  protoOf(BaseTtfFont$readCmap$1$EncodingRecord).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$1$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$1$EncodingRecord ? other : THROW_CCE();
    if (!(this.q5k_1 === tmp0_other_with_cast.q5k_1))
      return false;
    if (!(this.r5k_1 === tmp0_other_with_cast.r5k_1))
      return false;
    if (!(this.s5k_1 === tmp0_other_with_cast.s5k_1))
      return false;
    return true;
  };
  function NameId_COPYRIGHT_getInstance() {
    NameId_initEntries();
    return NameId_COPYRIGHT_instance;
  }
  function NameId_NAME_getInstance() {
    NameId_initEntries();
    return NameId_NAME_instance;
  }
  function NameId_STYLE_getInstance() {
    NameId_initEntries();
    return NameId_STYLE_instance;
  }
  function NameId_UNAME_getInstance() {
    NameId_initEntries();
    return NameId_UNAME_instance;
  }
  function NameId_COMPLETE_NAME_getInstance() {
    NameId_initEntries();
    return NameId_COMPLETE_NAME_instance;
  }
  function NameId_RELEASE_VERSION_getInstance() {
    NameId_initEntries();
    return NameId_RELEASE_VERSION_instance;
  }
  function NameId_POSTSCRIPT_NAME_getInstance() {
    NameId_initEntries();
    return NameId_POSTSCRIPT_NAME_instance;
  }
  function NameId_TRADEMARK_getInstance() {
    NameId_initEntries();
    return NameId_TRADEMARK_instance;
  }
  function NameId_MANUFACTURER_getInstance() {
    NameId_initEntries();
    return NameId_MANUFACTURER_instance;
  }
  function NameId_DESIGNER_getInstance() {
    NameId_initEntries();
    return NameId_DESIGNER_instance;
  }
  function NameId_DESCRIPTION_getInstance() {
    NameId_initEntries();
    return NameId_DESCRIPTION_instance;
  }
  function NameId_URL_VENDOR_getInstance() {
    NameId_initEntries();
    return NameId_URL_VENDOR_instance;
  }
  function NameId_URL_DESIGNER_getInstance() {
    NameId_initEntries();
    return NameId_URL_DESIGNER_instance;
  }
  function NameId_LICENSE_DESCRIPTION_getInstance() {
    NameId_initEntries();
    return NameId_LICENSE_DESCRIPTION_instance;
  }
  function NameId_LICENSE_URL_getInstance() {
    NameId_initEntries();
    return NameId_LICENSE_URL_instance;
  }
  function NameId_RESERVED_15_getInstance() {
    NameId_initEntries();
    return NameId_RESERVED_15_instance;
  }
  function NameId_PREFERRED_FAMILY_getInstance() {
    NameId_initEntries();
    return NameId_PREFERRED_FAMILY_instance;
  }
  function NameId_PREFERRED_SUBFAMILY_getInstance() {
    NameId_initEntries();
    return NameId_PREFERRED_SUBFAMILY_instance;
  }
  function NameId_COMPATIBLE_FULL_getInstance() {
    NameId_initEntries();
    return NameId_COMPATIBLE_FULL_instance;
  }
  function NameId_SAMPLE_TEXT_getInstance() {
    NameId_initEntries();
    return NameId_SAMPLE_TEXT_instance;
  }
  function NameId_POSTSCRIPT_CID_getInstance() {
    NameId_initEntries();
    return NameId_POSTSCRIPT_CID_instance;
  }
  function NameId_WWS_FAMILY_NAME_getInstance() {
    NameId_initEntries();
    return NameId_WWS_FAMILY_NAME_instance;
  }
  function NameId_WWS_SUBFAMILY_NAME_getInstance() {
    NameId_initEntries();
    return NameId_WWS_SUBFAMILY_NAME_instance;
  }
  function NameId_LIGHT_BACKGROUND_getInstance() {
    NameId_initEntries();
    return NameId_LIGHT_BACKGROUND_instance;
  }
  function NameId_DARK_BACKGROUND_getInstance() {
    NameId_initEntries();
    return NameId_DARK_BACKGROUND_instance;
  }
  function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
    NameId_initEntries();
    return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
  }
  function Colrv1Paint_PaintColrLayers_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintColrLayers_instance;
  }
  function Colrv1Paint_PaintSolid_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintSolid_instance;
  }
  function Colrv1Paint_PaintVarSolid_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarSolid_instance;
  }
  function Colrv1Paint_PaintLinearGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintLinearGradient_instance;
  }
  function Colrv1Paint_PaintVarLinearGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarLinearGradient_instance;
  }
  function Colrv1Paint_PaintRadialGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintRadialGradient_instance;
  }
  function Colrv1Paint_PaintVarRadialGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarRadialGradient_instance;
  }
  function Colrv1Paint_PaintSweepGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintSweepGradient_instance;
  }
  function Colrv1Paint_PaintVarSweepGradient_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarSweepGradient_instance;
  }
  function Colrv1Paint_PaintGlyph_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintGlyph_instance;
  }
  function Colrv1Paint_PaintColrGlyph_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintColrGlyph_instance;
  }
  function Colrv1Paint_PaintTransform_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintTransform_instance;
  }
  function Colrv1Paint_PaintVarTransform_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarTransform_instance;
  }
  function Colrv1Paint_PaintTranslate_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintTranslate_instance;
  }
  function Colrv1Paint_PaintVarTranslate_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarTranslate_instance;
  }
  function Colrv1Paint_PaintScale_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintScale_instance;
  }
  function Colrv1Paint_PaintVarScale_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarScale_instance;
  }
  function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintScaleAroundCenter_instance;
  }
  function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarScaleAroundCenter_instance;
  }
  function Colrv1Paint_PaintScaleUniform_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintScaleUniform_instance;
  }
  function Colrv1Paint_PaintVarScaleUniform_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarScaleUniform_instance;
  }
  function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
  }
  function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
  }
  function Colrv1Paint_PaintRotate_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintRotate_instance;
  }
  function Colrv1Paint_PaintVarRotate_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarRotate_instance;
  }
  function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintRotateAroundCenter_instance;
  }
  function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarRotateAroundCenter_instance;
  }
  function Colrv1Paint_PaintSkew_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintSkew_instance;
  }
  function Colrv1Paint_PaintVarSkew_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarSkew_instance;
  }
  function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintSkewAroundCenter_instance;
  }
  function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintVarSkewAroundCenter_instance;
  }
  function Colrv1Paint_PaintComposite_getInstance() {
    Colrv1Paint_initEntries();
    return Colrv1Paint_PaintComposite_instance;
  }
  function BaseTtfFont(s, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_39();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    this.l58_1 = s;
    this.m58_1 = extName;
    this.n58_1 = onlyReadMetadata;
    this.o58_1 = enableLigatures;
    this.p58_1 = new Mixin();
    this.q58_1 = new NamesInfo();
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 3;
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(tmp_1), null);
    var tmp_2 = tmp$ret$0;
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp$ret$1;
      // Inline function 'korlibs.image.font.BaseTtfFont.tempContours.<anonymous>' call
      tmp$ret$1 = new Contour();
      tmp_2[tmp_3] = tmp$ret$1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.r58_1 = tmp_2;
    this.s58_1 = 0;
    this.t58_1 = 0;
    this.u58_1 = 0;
    this.v58_1 = 0;
    this.w58_1 = 0;
    this.x58_1 = 0;
    this.y58_1 = 0;
    this.z58_1 = 0;
    this.a59_1 = 0;
    this.b59_1 = 0;
    this.c59_1 = 0;
    this.d59_1 = 0;
    this.e59_1 = 0;
    this.f59_1 = 0;
    this.g59_1 = Companion_getInstance_40().t5k(0, 0);
    this.h59_1 = 0;
    this.i59_1 = 0;
    this.j59_1 = 0;
    this.k59_1 = 0;
    this.l59_1 = 0;
    this.m59_1 = 0;
    this.n59_1 = 0;
    this.o59_1 = 0;
    this.p59_1 = 0;
    this.q59_1 = 0;
    this.r59_1 = 0;
    this.s59_1 = 0;
    this.t59_1 = new Int32Array(0);
    this.u59_1 = Companion_getInstance_40().t5k(0, 0);
    this.v59_1 = 128;
    this.w59_1 = 0;
    this.x59_1 = 0;
    this.y59_1 = 0;
    this.z59_1 = 0;
    this.a5a_1 = 0;
    this.b5a_1 = 0;
    this.c5a_1 = 0;
    this.d5a_1 = 0;
    this.e5a_1 = 0;
    var tmp_4 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.listOf' call
    tmp$ret$2 = emptyList();
    tmp_4.f5a_1 = tmp$ret$2;
    this.g5a_1 = LinkedHashMap_init_$Create$_0();
    this.h5a_1 = LinkedHashMap_init_$Create$_0();
    this.i5a_1 = IntMap_init_$Create$(512);
    this.j5a_1 = LinkedHashMap_init_$Create$_0();
    var tmp_5 = this;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = [];
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    tmp_5.k5a_1 = tmp$ret$5;
    this.l5a_1 = IntMap_init_$Create$();
    var tmp_6 = this;
    var tmp$ret$6;
    // Inline function 'kotlin.collections.listOf' call
    tmp$ret$6 = emptyList();
    tmp_6.m5a_1 = tmp$ret$6;
    this.n5a_1 = new COLRv1();
    this.o5a_1 = false;
    this.p5a_1 = IntIntMap_init_$Create$();
    this.q5a_1 = IntMap_init_$Create$();
    this.s5a_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_6().p3i(), 0.0);
    this.t5a_1 = false;
    this.u5a_1 = null;
  }
  protoOf(BaseTtfFont).lu = function (_set____db54di) {
    this.p58_1.lu(_set____db54di);
  };
  protoOf(BaseTtfFont).mu = function () {
    return this.p58_1.mu();
  };
  protoOf(BaseTtfFont).k4p = function (size, metrics) {
    return metrics.u4p(this.e5b(), size);
  };
  protoOf(BaseTtfFont).v4p = function (size, codePoint, metrics, reader) {
    var tmp0_safe_receiver = this.p5c(reader, codePoint);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z5h_1;
    return metrics.c4q(tmp1_elvis_lhs == null ? this.s5a_1 : tmp1_elvis_lhs, size, codePoint);
  };
  protoOf(BaseTtfFont).g4r = function (size, leftCodePoint, rightCodePoint) {
    return 0.0;
  };
  protoOf(BaseTtfFont).z5a = function (size, codePoint, path, reader) {
    var tmp0_safe_receiver = reader;
    var spos = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2a_1;
    var tmp1_safe_receiver = reader;
    var codePointPeek = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x2a(0);
    var tmp2_elvis_lhs = this.o5c(reader, codePoint, true);
    var tmp;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var g = tmp;
    var scale = this.e4q(size);
    path.f52_1 = g.g1z().c5i_1;
    var tmp_0 = path;
    var tmp3_safe_receiver = g.m5i();
    tmp_0.g52_1 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.e5i();
    var bitmapEntry = g.o5i();
    var tmp4_safe_receiver = bitmapEntry;
    var bitmap = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.o5f();
    path.h52_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.v59_1 / bitmapEntry.z5e_1.f5e_1;
      var scaleY = this.v59_1 / bitmapEntry.z5e_1.g5e_1;
      path.i52_1 = _Vector2___init__impl__67w0ru_1(0.0, ((-bitmapEntry.a5f_1 | 0) - bitmapEntry.k5f() | 0) * scaleY);
      path.j52_1 = _Scale___init__impl__ov1qs1_0(scaleX, scaleY);
    } else {
    }
    path.k52_1 = Matrix__scaled_impl_ogn4b6(Companion_getInstance_9().v3f_1, scale, scale);
    path.l52_1 = scale;
    return path;
  };
  protoOf(BaseTtfFont).e4q = function (size) {
    return size / this.v59_1;
  };
  protoOf(BaseTtfFont).b5b = function (key) {
    return this.g5a_1.z1(key);
  };
  protoOf(BaseTtfFont).c5b = function (codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.g5a_1;
    tmp0_set.x3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    var tmp1_set = this.h5a_1;
    tmp1_set.x3(glyphID, codePoint);
  };
  protoOf(BaseTtfFont).d5b = function (codePoint, glyphID) {
  };
  protoOf(BaseTtfFont).e5b = function () {
    var tmp = this.r5a_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  };
  protoOf(BaseTtfFont).f5b = function () {
    return this.q58_1.f5b();
  };
  protoOf(BaseTtfFont).qg = function () {
    var tmp0_elvis_lhs = this.m58_1;
    return tmp0_elvis_lhs == null ? this.f5b() : tmp0_elvis_lhs;
  };
  protoOf(BaseTtfFont).v5a = function () {
    this.w5a();
    this.l5b();
    this.m5b();
    this.n5b();
    this.j5b();
    if (!this.n58_1) {
      if (!(this.y5a('CFF ') == null) ? this.y5a('glyf') == null : false) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp0_safe_receiver = this.i5b('CFF ');
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          var tmp$ret$0;
          // Inline function 'kotlin.apply' call
          var tmp0_apply = CFF_getInstance();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.u5a_1 = tmp0_apply.b55(tmp0_safe_receiver);
          tmp$ret$0 = tmp0_apply;
        }
      }
      this.k5b();
      this.l5c();
      this.o5b();
      this.p5b();
      this.k5c();
      this.j5c();
      this.r5b();
      this.s5b();
      this.t5b();
    }
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.also' call
    var tmp0_also = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.e4q(1.0);
    tmp0_also.l4p_1 = 1.0;
    tmp0_also.m4p_1 = this.z59_1 * scale;
    tmp0_also.n4p_1 = this.h59_1 * scale;
    tmp0_also.o4p_1 = 0.0 * scale;
    tmp0_also.p4p_1 = this.i59_1 * scale;
    tmp0_also.q4p_1 = this.x59_1 * scale;
    tmp0_also.r4p_1 = this.j59_1 * scale;
    tmp0_also.s4p_1 = this.k59_1 * scale;
    tmp0_also.t4p_1 = this.v59_1 * scale;
    tmp$ret$1 = tmp0_also;
    tmp.r5a_1 = tmp$ret$1;
  };
  protoOf(BaseTtfFont).toString = function () {
    return 'TtfFont(name=' + this.qg() + ')';
  };
  protoOf(BaseTtfFont).g5b = function (_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.j33());
  };
  protoOf(BaseTtfFont).h5b = function (_this__u8e3s4) {
    return Companion_getInstance_40().t5k(_this__u8e3s4.i33(), _this__u8e3s4.i33());
  };
  protoOf(BaseTtfFont).i5b = function (name) {
    var tmp0_safe_receiver = this.y5a(name);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t5d();
  };
  protoOf(BaseTtfFont).j5b = function () {
    var tmp0_safe_receiver = this.i5b('name');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_getInstance_39().w5d(tmp0_safe_receiver, this.q58_1);
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).k5b = function () {
    var tmp0_safe_receiver = this.i5b('loca');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp0_subject = this.d5a_1;
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp0_safe_receiver.f33(imul(bytesPerEntry, this.s58_1 + 1 | 0));
      var tmp_0 = this;
      var tmp$ret$5;
      // Inline function 'kotlin.run' call
      var tmp0_run = new FastByteArrayInputStream(data);
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$4;
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var tmp0_subject_0 = this.d5a_1;
      var tmp_1;
      switch (tmp0_subject_0) {
        case 0:
          var tmp$ret$3;
          // Inline function 'korlibs.datastructure.mapInt' call
          var tmp1_mapInt = tmp0_run.p33(this.s58_1 + 1 | 0);
          var tmp$ret$2;
          // Inline function 'kotlin.also' call
          var tmp0_also = new Int32Array(tmp1_mapInt.length);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
          var inductionVariable = 0;
          var last = tmp1_mapInt.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp$ret$1;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              var tmp2__anonymous__z9zvc9 = tmp1_mapInt[n];
              var tmp$ret$0;
              // Inline function 'kotlin.code' call
              tmp$ret$0 = Char__toInt_impl_vasixd(tmp2__anonymous__z9zvc9);
              tmp$ret$1 = imul(tmp$ret$0, 2);
              tmp0_also[n] = tmp$ret$1;
            }
             while (inductionVariable < last);
          tmp$ret$2 = tmp0_also;
          tmp$ret$3 = tmp$ret$2;

          tmp_1 = tmp$ret$3;
          break;
        case 1:
          tmp_1 = tmp0_run.r33(this.s58_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp$ret$4 = tmp_1;
      tmp$ret$5 = tmp$ret$4;
      tmp_0.t59_1 = tmp$ret$5;
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).l5b = function () {
    var tmp0_safe_receiver = this.i5b('head');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'kotlin.apply' call
      var tmp0_apply = tmp0_safe_receiver.j33();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp0_apply === 1)) {
        invalidOp('Invalid TTF');
      }
      tmp$ret$0 = tmp0_apply;
      var tmp$ret$1;
      // Inline function 'kotlin.apply' call
      var tmp1_apply = tmp0_safe_receiver.j33();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp1_apply === 0)) {
        invalidOp('Invalid TTF');
      }
      tmp$ret$1 = tmp1_apply;
      this.u59_1 = this.h5b(tmp0_safe_receiver);
      var checkSumAdjustment = tmp0_safe_receiver.l33();
      var tmp$ret$2;
      // Inline function 'kotlin.apply' call
      var tmp2_apply = tmp0_safe_receiver.l33();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp2_apply === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(tmp2_apply));
      }
      tmp$ret$2 = tmp2_apply;
      var flags = tmp0_safe_receiver.j33();
      this.v59_1 = tmp0_safe_receiver.j33();
      var created = tmp0_safe_receiver.m33().v6(new Long(1000, 0));
      var modified = tmp0_safe_receiver.m33().v6(new Long(1000, 0));
      this.w59_1 = tmp0_safe_receiver.i33();
      this.x59_1 = tmp0_safe_receiver.i33();
      this.y59_1 = tmp0_safe_receiver.i33();
      this.z59_1 = tmp0_safe_receiver.i33();
      this.a5a_1 = tmp0_safe_receiver.j33();
      this.b5a_1 = tmp0_safe_receiver.j33();
      this.c5a_1 = tmp0_safe_receiver.i33();
      this.d5a_1 = tmp0_safe_receiver.i33();
      this.e5a_1 = tmp0_safe_receiver.i33();
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).m5b = function () {
    var tmp0_safe_receiver = this.i5b('maxp');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.h5b(tmp0_safe_receiver);
      this.s58_1 = tmp0_safe_receiver.j33();
      this.t58_1 = tmp0_safe_receiver.j33();
      this.u58_1 = tmp0_safe_receiver.j33();
      this.v58_1 = tmp0_safe_receiver.j33();
      this.w58_1 = tmp0_safe_receiver.j33();
      this.x58_1 = tmp0_safe_receiver.j33();
      this.y58_1 = tmp0_safe_receiver.j33();
      this.z58_1 = tmp0_safe_receiver.j33();
      this.a59_1 = tmp0_safe_receiver.j33();
      this.b59_1 = tmp0_safe_receiver.j33();
      this.c59_1 = tmp0_safe_receiver.j33();
      this.d59_1 = tmp0_safe_receiver.j33();
      this.e59_1 = tmp0_safe_receiver.j33();
      this.f59_1 = tmp0_safe_receiver.j33();
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).n5b = function () {
    var tmp0_safe_receiver = this.i5b('hhea');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.g59_1 = this.h5b(tmp0_safe_receiver);
      this.h59_1 = tmp0_safe_receiver.i33();
      this.i59_1 = tmp0_safe_receiver.i33();
      this.j59_1 = tmp0_safe_receiver.i33();
      this.k59_1 = tmp0_safe_receiver.j33();
      this.l59_1 = tmp0_safe_receiver.i33();
      this.m59_1 = tmp0_safe_receiver.i33();
      this.n59_1 = tmp0_safe_receiver.i33();
      this.o59_1 = tmp0_safe_receiver.i33();
      this.p59_1 = tmp0_safe_receiver.i33();
      this.q59_1 = tmp0_safe_receiver.i33();
      tmp0_safe_receiver.i33();
      tmp0_safe_receiver.i33();
      tmp0_safe_receiver.i33();
      tmp0_safe_receiver.i33();
      this.r59_1 = tmp0_safe_receiver.i33();
      this.s59_1 = tmp0_safe_receiver.j33();
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).o5b = function () {
    var tmp0_safe_receiver = this.i5b('hmtx');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = until(0, this.s59_1);
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var inductionVariable = tmp1_map.a1_1;
      var last_0 = tmp1_map.b1_1;
      if (inductionVariable <= last_0)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          tmp$ret$0 = new HorMetric(tmp0_safe_receiver.j33(), tmp0_safe_receiver.i33());
          tmp0_mapTo.b(tmp$ret$0);
        }
         while (!(item === last_0));
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var firstMetrics = tmp$ret$2;
      var lastAdvanceWidth = last(firstMetrics).u5d_1;
      var tmp$ret$5;
      // Inline function 'kotlin.collections.map' call
      var tmp3_map = until(0, this.s58_1 - this.s59_1 | 0);
      var tmp$ret$4;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp2_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map, 10));
      var inductionVariable_0 = tmp3_map.a1_1;
      var last_1 = tmp3_map.b1_1;
      if (inductionVariable_0 <= last_1)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp$ret$3;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp0_safe_receiver.i33());
          tmp2_mapTo.b(tmp$ret$3);
        }
         while (!(item_0 === last_1));
      tmp$ret$4 = tmp2_mapTo;
      tmp$ret$5 = tmp$ret$4;
      var compressedMetrics = tmp$ret$5;
      this.f5a_1 = plus_0(firstMetrics, compressedMetrics);
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).p5b = function () {
    var tmp0_safe_receiver = this.i5b('CPAL');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp0_safe_receiver.j33();
      var tmp0_subject = version;
      switch (tmp0_subject) {
        case 0:
        case 1:
          var numPaletteEntries = tmp0_safe_receiver.j33();
          var numPalettes = tmp0_safe_receiver.j33();
          var numColorRecords = tmp0_safe_receiver.j33();
          var colorRecordsArrayOffset = tmp0_safe_receiver.l33();
          var colorRecordIndices = tmp0_safe_receiver.o33(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp0_safe_receiver.l33() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp0_safe_receiver.l33() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp0_safe_receiver.l33() : -1;
          tmp0_safe_receiver.x32(colorRecordsArrayOffset);
          var colorInts = tmp0_safe_receiver.q33(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_28().g4m(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          var tmp$ret$2;
          // Inline function 'kotlin.collections.map' call
          var tmp$ret$1;
          // Inline function 'kotlin.collections.mapTo' call
          var tmp0_mapTo = ArrayList_init_$Create$_0(colorRecordIndices.length);
          var indexedObject = colorRecordIndices;
          var inductionVariable_0 = 0;
          var last_0 = indexedObject.length;
          while (inductionVariable_0 < last_0) {
            var item = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp$ret$0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            tmp0_mapTo.b(tmp$ret$0);
          }
          tmp$ret$1 = tmp0_mapTo;
          tmp$ret$2 = tmp$ret$1;

          tmp.m5a_1 = tmp$ret$2;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          ;
          break;
      }
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).q5b = function (_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.g33(), _this__u8e3s4.g33(), _this__u8e3s4.h33(), _this__u8e3s4.g33(), _this__u8e3s4.g33(), _this__u8e3s4.g33(), _this__u8e3s4.g33(), _this__u8e3s4.g33(), _this__u8e3s4.g33(), _this__u8e3s4.g33(), _this__u8e3s4.g33(), _this__u8e3s4.g33());
  };
  protoOf(BaseTtfFont).r5b = function () {
    var tmp0_safe_receiver = this.i5b('CBLC');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp0_safe_receiver.j33();
      var minorVersion = tmp0_safe_receiver.j33();
      var tmp0_subject = majorVersion;
      if (tmp0_subject === 3) {
        var numSizes = tmp0_safe_receiver.l33();
        var tmp = 0;
        var tmp_0 = numSizes;
        var tmp$ret$0;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp$ret$0 = fillArrayVal(Array(tmp_0), null);
        var tmp_1 = tmp$ret$0;
        while (tmp < tmp_0) {
          var tmp_2 = tmp;
          var tmp$ret$1;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>.<anonymous>' call
          tmp$ret$1 = new ColorBitmapInfo(tmp0_safe_receiver.l33(), tmp0_safe_receiver.l33(), tmp0_safe_receiver.l33(), tmp0_safe_receiver.l33(), this.q5b(tmp0_safe_receiver), this.q5b(tmp0_safe_receiver), tmp0_safe_receiver.j33(), tmp0_safe_receiver.j33(), tmp0_safe_receiver.h33(), tmp0_safe_receiver.h33(), tmp0_safe_receiver.h33(), tmp0_safe_receiver.g33());
          tmp_1[tmp_2] = tmp$ret$1;
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_1);
        var tmp1_iterator = colorBitmapInfos.g();
        while (tmp1_iterator.h()) {
          var cbi = tmp1_iterator.i();
          var glyphCount = cbi.e5e_1 - cbi.d5e_1 | 0;
          tmp0_safe_receiver.x32(cbi.x5d_1);
          var tmp_3 = 0;
          var tmp_4 = cbi.z5d_1;
          var tmp$ret$2;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp$ret$2 = fillArrayVal(Array(tmp_4), null);
          var tmp_5 = tmp$ret$2;
          while (tmp_3 < tmp_4) {
            var tmp_6 = tmp_3;
            var tmp$ret$3;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>.<anonymous>' call
            tmp$ret$3 = new BaseTtfFont$readCblc$1$Subtable(tmp0_safe_receiver.j33(), tmp0_safe_receiver.j33(), tmp0_safe_receiver.l33());
            tmp_5[tmp_6] = tmp$ret$3;
            tmp_3 = tmp_3 + 1 | 0;
          }
          var subtables = tmp_5;
          var indexedObject = subtables;
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var subtable = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp0_safe_receiver.x32(cbi.x5d_1 + subtable.g5k_1 | 0);
            var indexFormat = tmp0_safe_receiver.j33();
            var imageFormat = tmp0_safe_receiver.j33();
            var imageDataOffset = tmp0_safe_receiver.l33();
            var tmp3_subject = indexFormat;
            var tmp_7;
            if (tmp3_subject === 1) {
              var tmp_8 = 0;
              var tmp_9 = subtable.h5k() + 1 | 0;
              var tmp$ret$4;
              // Inline function 'kotlin.arrayOfNulls' call
              tmp$ret$4 = fillArrayVal(Array(tmp_9), null);
              var tmp_10 = tmp$ret$4;
              while (tmp_8 < tmp_9) {
                var tmp_11 = tmp_8;
                var tmp$ret$5;
                // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>.<anonymous>' call
                tmp$ret$5 = imageDataOffset + tmp0_safe_receiver.l33() | 0;
                tmp_10[tmp_11] = tmp$ret$5;
                tmp_8 = tmp_8 + 1 | 0;
              }
              tmp_7 = tmp_10;
            } else {
              var tmp$ret$6;
              // Inline function 'kotlin.emptyArray' call
              tmp$ret$6 = [];
              tmp_7 = tmp$ret$6;
            }
            var offsets = tmp_7;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.e5k_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var tmp0_set = this.j5a_1;
                var tmp1_set = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                tmp0_set.x3(glyphID, tmp1_set);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).s5b = function () {
    var tmp0_safe_receiver = this.i5b('CBDT');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp0_safe_receiver.j33();
      var minorVersion = tmp0_safe_receiver.j33();
      var tmp0_subject = majorVersion;
      if (tmp0_subject === 3) {
        var tmp1_iterator = this.j5a_1.eb().g();
        while (tmp1_iterator.h()) {
          var i = tmp1_iterator.i();
          var format = i.w5e_1;
          var tmp2_subject = format;
          if (tmp2_subject === 17 ? true : tmp2_subject === 18) {
            i.a5f_1 = tmp0_safe_receiver.h33();
            i.b5f_1 = tmp0_safe_receiver.h33();
            i.c5f_1 = tmp0_safe_receiver.g33();
            i.d5f_1 = tmp0_safe_receiver.g33();
            i.e5f_1 = tmp0_safe_receiver.h33();
            i.f5f_1 = format === 18 ? tmp0_safe_receiver.g33() : i.c5f_1;
            i.g5f_1 = format === 18 ? tmp0_safe_receiver.g33() : i.d5f_1;
            i.h5f_1 = format === 18 ? tmp0_safe_receiver.g33() : i.e5f_1;
          }
          var dataLen = tmp0_safe_receiver.l33();
          i.i5f_1 = tmp0_safe_receiver.a33(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).t5b = function () {
    var tmp0_safe_receiver = this.i5b('sbix');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp0_safe_receiver.j33();
      var flags = tmp0_safe_receiver.j33();
      var numStrikes = tmp0_safe_receiver.l33();
      var strikeOffsets = tmp0_safe_receiver.r33(numStrikes);
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(strikeOffsets.length);
      var indexedObject = strikeOffsets;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var item = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp0_safe_receiver.x32(item);
        tmp$ret$0 = new BaseTtfFont$readSbix$1$StrikeInfo(tmp0_safe_receiver.j33(), tmp0_safe_receiver.j33(), item, toIntArrayList(tmp0_safe_receiver.r33(this.s58_1 + 1 | 0)));
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var strikes = tmp$ret$2;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.g();
        if (!iterator.h()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.i();
        if (!iterator.h()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        var tmp$ret$4;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var tmp1__anonymous__uwfjfc = maxElem;
        tmp$ret$4 = tmp1__anonymous__uwfjfc.i5k_1;
        var maxValue = tmp$ret$4;
        do {
          var e = iterator.i();
          var tmp$ret$5;
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          tmp$ret$5 = e.i5k_1;
          var v = tmp$ret$5;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.h());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.s58_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.l5k_1.k(n);
          var len = strike.l5k_1.k(n + 1 | 0) - offset | 0;
          var start = strike.k5k_1 + offset | 0;
          var end = start + len | 0;
          tmp0_safe_receiver.x32(start);
          var originOffsetX = tmp0_safe_receiver.i33();
          var originOffsetY = tmp0_safe_receiver.i33();
          var graphicType = tmp0_safe_receiver.t33(4);
          var bytes = tmp0_safe_receiver.a33(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var tmp3_set = this.j5a_1;
          var tmp$ret$6;
          // Inline function 'kotlin.also' call
          var tmp2_also = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.i5k_1, strike.i5k_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          tmp2_also.i5f_1 = bytes;
          tmp$ret$6 = tmp2_also;
          var tmp4_set = tmp$ret$6;
          tmp3_set.x3(glyphID, tmp4_set);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).u5b = function (_this__u8e3s4) {
    return _this__u8e3s4.l33();
  };
  protoOf(BaseTtfFont).v5b = function (_this__u8e3s4) {
    return _this__u8e3s4.j33();
  };
  protoOf(BaseTtfFont).w5b = function (_this__u8e3s4) {
    return _this__u8e3s4.i33();
  };
  protoOf(BaseTtfFont).x5b = function (_this__u8e3s4) {
    return _this__u8e3s4.j33();
  };
  protoOf(BaseTtfFont).y5b = function (_this__u8e3s4) {
    return _this__u8e3s4.k33();
  };
  protoOf(BaseTtfFont).z5b = function (_this__u8e3s4) {
    return _this__u8e3s4.l33();
  };
  protoOf(BaseTtfFont).a5c = function (_this__u8e3s4, isVar) {
    var xx = this.v5c(_this__u8e3s4);
    var yx = this.v5c(_this__u8e3s4);
    var xy = this.v5c(_this__u8e3s4);
    var yy = this.v5c(_this__u8e3s4);
    var dx = this.v5c(_this__u8e3s4);
    var dy = this.v5c(_this__u8e3s4);
    return _Matrix___init__impl__q3kp4w(xx, yx, xy, yy, dx, -dy);
  };
  protoOf(BaseTtfFont).b5c = function (_this__u8e3s4, out) {
    out.s5f_1 = this.u5c(_this__u8e3s4);
    out.t5f_1 = _this__u8e3s4.j33();
    out.u5f_1 = this.u5c(_this__u8e3s4);
    return out;
  };
  protoOf(BaseTtfFont).c5c = function (_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.b5c(_this__u8e3s4, out) : $super.b5c.call(this, _this__u8e3s4, out);
  };
  protoOf(BaseTtfFont).d5c = function (_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.h33();
    var xMin = this.w5b(_this__u8e3s4);
    var yMin = this.w5b(_this__u8e3s4);
    var xMax = this.w5b(_this__u8e3s4);
    var yMax = this.w5b(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.u5b(_this__u8e3s4);
    }
    return Companion_getInstance_6().r3i(xMin, yMin, xMax, yMax);
  };
  protoOf(BaseTtfFont).e5c = function (_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.d5c(_this__u8e3s4, doVar) : $super.d5c.call(this, _this__u8e3s4, doVar).q3b_1;
  };
  protoOf(BaseTtfFont).f5c = function (_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4.h33();
    {
      var cycle;
      switch (tmp0_subject) {
        case 0:
          cycle = CycleMethod_NO_CYCLE_getInstance();
          break;
        case 1:
          cycle = CycleMethod_REPEAT_getInstance();
          break;
        case 2:
          cycle = CycleMethod_REFLECT_getInstance();
          break;
        default:
          cycle = CycleMethod_NO_CYCLE_getInstance();
          break;
      }
    }
    var tmp$ret$3;
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.j33();
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(tmp_0), null);
    var tmp_1 = tmp$ret$0;
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp$ret$2;
      // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp$ret$1 = this.c5c(_this__u8e3s4);
      tmp$ret$2 = tmp$ret$1;
      tmp_1[tmp_2] = tmp$ret$2;
      tmp = tmp + 1 | 0;
    }
    tmp$ret$3 = tmp_1;
    return new ColorLine(cycle, toList_1(tmp$ret$3));
  };
  protoOf(BaseTtfFont).g5c = function (glyphID, s, c, pal, level) {
    var nodeFormat = s.h33();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + getOrNull(Companion_getInstance_38().f5d_1, nodeFormat));
    }
    var tmp0_subject = nodeFormat;
    switch (tmp0_subject) {
      case 1:
        var numLayers = s.h33();
        var firstLayerIndex = s.l33();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.n5a_1.x5g_1[firstLayerIndex + n | 0];
            this.g5c(glyphID, this.n5a_1.a5h_1.c33(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.j33();
        var alpha = this.u5c(s);
        if (isVar) {
          var varIndexBase = this.u5b(s);
          // Inline function 'kotlin.TODO' call
          throw new NotImplementedError();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.m5a_1.k(pal).t4l_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + new RGBA(color));
        }

        c.f4z(new RGBA(color));
        ;
        break;
      case 4:
      case 5:
        var colorLineOffset = this.y5b(s);
        var x0 = this.w5b(s);
        var y0 = this.w5b(s);
        var x1 = this.w5b(s);
        var y1 = this.w5b(s);
        var x2 = this.w5b(s);
        var y2 = this.w5b(s);
        var colorLine = this.f5c(s.c33(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.u5b(s);
        }

        var tmp$ret$2;
        // Inline function 'korlibs.image.paint.LinearGradientPaint' call
        var tmp1_LinearGradientPaint = -y0;
        var tmp2_LinearGradientPaint = -y1;
        var tmp3_LinearGradientPaint = colorLine.p5f_1;
        var tmp4_LinearGradientPaint = Companion_getInstance_9().v3f_1;
        var tmp$ret$1;
        // Inline function 'kotlin.also' call
        var tmp0_also = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(tmp1_LinearGradientPaint), 0.0, numberToDouble(x1), numberToDouble(tmp2_LinearGradientPaint), 0.0, VOID, VOID, tmp3_LinearGradientPaint, tmp4_LinearGradientPaint);
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$0;
        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call
        tmp$ret$0 = Unit_getInstance();
        tmp$ret$1 = tmp0_also;
        tmp$ret$2 = tmp$ret$1;

        var paint_0 = tmp$ret$2;
        colorLine.r5f(paint_0, this.m5a_1.k(pal));
        if (debug) {
          println(indent + paint_0);
        }

        c.f4z(paint_0);
        ;
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.y5b(s);
        var x0_0 = this.w5b(s);
        var y0_0 = this.w5b(s);
        var radius0 = this.v5b(s);
        var x1_0 = this.w5b(s);
        var y1_0 = this.w5b(s);
        var radius1 = this.v5b(s);
        var colorLine_0 = this.f5c(s.c33(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.u5b(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_0 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_0 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        var tmp$ret$5;
        // Inline function 'korlibs.image.paint.RadialGradientPaint' call
        var tmp6_RadialGradientPaint = -y0_0;
        var tmp7_RadialGradientPaint = -y1_0;
        var tmp8_RadialGradientPaint = colorLine_0.p5f_1;
        var tmp9_RadialGradientPaint = Companion_getInstance_9().v3f_1;
        var tmp$ret$4;
        // Inline function 'kotlin.also' call
        var tmp5_also = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(tmp6_RadialGradientPaint), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(tmp7_RadialGradientPaint), numberToDouble(radius1), VOID, VOID, tmp8_RadialGradientPaint, tmp9_RadialGradientPaint);
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$3;
        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call
        tmp$ret$3 = Unit_getInstance();
        tmp$ret$4 = tmp5_also;
        tmp$ret$5 = tmp$ret$4;

        var paint_1 = tmp$ret$5;
        colorLine_0.r5f(paint_1, this.m5a_1.k(pal));
        if (debug) {
          println(indent + paint_1);
        }

        c.f4z(paint_1);
        ;
        break;
      case 8:
      case 9:
        var colorLine_1 = this.y5b(s);
        var centerX = this.w5b(s);
        var centerY = this.w5b(s);
        var startAngle = this.u5c(s);
        var endAngle = this.u5c(s);
        if (isVar) {
          var varIndexBase_2 = this.u5b(s);
        }

        // Inline function 'kotlin.TODO' call
        throw new NotImplementedError();

        break;
      case 10:
        var paint_2 = this.y5b(s);
        var glyphID_0 = s.j33();
        var colr = this.l5a_1.k(glyphID_0);
        var glyph = this.t5c(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call
        c.m4z();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.g1z().c5i_1), '\n'));
            }
            c.u5k(glyph.g1z().c5i_1);
            this.g5c(glyphID_0, s.c33(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.u4z();
        }

        break;
      case 11:
        var glyphID_1 = s.j33();
        // Inline function 'kotlin.TODO' call
        throw new NotImplementedError();

        break;
      case 12:
      case 13:
        var paint_3 = this.y5b(s);
        var transform = this.y5b(s);
        var affine = this.a5c(s.c33(transform), isVar);
        if (debug) {
          println(indent + 'affine=' + new Matrix(affine));
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call
        c.m4z();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.h51(affine);
          this.g5c(glyphID, s.c33(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.u4z();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.y5b(s);
        var dx = FWord__toDouble_impl_53j5qp(this.g5b(s));
        var dy = FWord__toDouble_impl_53j5qp(this.g5b(s));
        if (isVar) {
          var varIndexBase_3 = this.u5b(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call
        c.m4z();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.f51(dx, -dy);
          this.g5c(glyphID, s.c33(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.u4z();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.y5b(s);
        var scaleX = this.u5c(s);
        var scaleY = this.u5c(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.w5b(s);
          var centerY_0 = this.w5b(s);
          // Inline function 'kotlin.TODO' call
          throw new NotImplementedError();
        }

        if (isVar) {
          var varIndexBase_4 = this.u5b(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call
        c.m4z();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          var tmp$ret$6;
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.v5k(numberToDouble(scaleX), numberToDouble(scaleY));
          tmp$ret$6 = Unit_getInstance();
          this.g5c(glyphID, s.c33(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.u4z();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.y5b(s);
        var scale = this.u5c(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.w5b(s);
          var centerY_1 = this.w5b(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.u5b(s);
        }

        // Inline function 'kotlin.TODO' call
        throw new NotImplementedError();

        break;
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.y5b(s);
        var angle = this.u5c(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.w5b(s);
          var centerY_2 = this.w5b(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.u5b(s);
        }

        // Inline function 'kotlin.TODO' call
        throw new NotImplementedError();

        break;
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.y5b(s);
        var xSkewAngle = this.u5c(s);
        var ySkewAngle = this.u5c(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.w5b(s);
          var centerY_3 = this.w5b(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.u5b(s);
        }

        // Inline function 'kotlin.TODO' call
        throw new NotImplementedError();

        break;
      case 32:
        var sourcePaint = this.y5b(s);
        var compositeMode = s.h33();
        var backdropPaint = this.y5b(s);
        // Inline function 'kotlin.TODO' call
        throw new NotImplementedError();

        break;
      default:
        // Inline function 'kotlin.TODO' call
        var tmp10_TODO = 'Unknown colorv1 format=' + nodeFormat;
        throw new NotImplementedError('An operation is not implemented: ' + tmp10_TODO);

        break;
    }
  };
  protoOf(BaseTtfFont).h5c = function (_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.j33();
    var tmp0_subject = coverageFormat;
    switch (tmp0_subject) {
      case 1:
        var glyphCount = _this__u8e3s4.j33();
        var tmp$ret$3;
        // Inline function 'korlibs.datastructure.mapInt' call
        var tmp1_mapInt = _this__u8e3s4.p33(glyphCount);
        var tmp$ret$2;
        // Inline function 'kotlin.also' call
        var tmp0_also = new Int32Array(tmp1_mapInt.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable = 0;
        var last = tmp1_mapInt.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$1;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            var tmp2__anonymous__z9zvc9 = tmp1_mapInt[n];
            var tmp$ret$0;
            // Inline function 'kotlin.code' call
            tmp$ret$0 = Char__toInt_impl_vasixd(tmp2__anonymous__z9zvc9);
            tmp$ret$1 = tmp$ret$0;
            tmp0_also[n] = tmp$ret$1;
          }
           while (inductionVariable < last);
        tmp$ret$2 = tmp0_also;
        tmp$ret$3 = tmp$ret$2;

        return tmp$ret$3;
      case 2:
        var rangeCount = _this__u8e3s4.j33();
        var tmp$ret$6;
        // Inline function 'kotlin.collections.map' call
        var tmp4_map = until(0, rangeCount);
        var tmp$ret$5;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp3_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp4_map, 10));
        var inductionVariable_0 = tmp4_map.a1_1;
        var last_0 = tmp4_map.b1_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp$ret$4;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.j33(), _this__u8e3s4.j33(), _this__u8e3s4.j33());
            tmp3_mapTo.b(tmp$ret$4);
          }
           while (!(item === last_0));
        tmp$ret$5 = tmp3_mapTo;
        tmp$ret$6 = tmp$ret$5;

        var ranges = tmp$ret$6;
        var tmp$ret$9;
        // Inline function 'kotlin.collections.maxOf' call
        var iterator = ranges.g();
        if (!iterator.h())
          throw NoSuchElementException_init_$Create$();
        var tmp$ret$7;
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
        var tmp5__anonymous__kpxxpo = iterator.i();
        tmp$ret$7 = tmp5__anonymous__kpxxpo.o5k_1 + tmp5__anonymous__kpxxpo.p5k_1 | 0;
        var maxValue = tmp$ret$7;
        while (iterator.h()) {
          var tmp$ret$8;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var tmp6__anonymous__fv9ai5 = iterator.i();
          tmp$ret$8 = tmp6__anonymous__fv9ai5.o5k_1 + tmp6__anonymous__fv9ai5.p5k_1 | 0;
          var v = tmp$ret$8;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
        tmp$ret$9 = maxValue;

        var glyphCount_0 = tmp$ret$9;
        var glyphArray = new Int32Array(glyphCount_0);
        var tmp1_iterator = ranges.g();
        while (tmp1_iterator.h()) {
          var range = tmp1_iterator.i();
          var inductionVariable_1 = range.m5k_1;
          var last_1 = range.n5k_1;
          if (inductionVariable_1 <= last_1)
            do {
              var glyphID = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var offset = glyphID - range.m5k_1 | 0;
              glyphArray[range.o5k_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_1));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var tmp7_TODO = 'coverageFormat=' + coverageFormat;
        throw new NotImplementedError('An operation is not implemented: ' + tmp7_TODO);
    }
  };
  protoOf(BaseTtfFont).i5c = function (_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.h5c(_this__u8e3s4, hintedCount) : $super.h5c.call(this, _this__u8e3s4, hintedCount);
  };
  protoOf(BaseTtfFont).j5c = function () {
    var tmp0_safe_receiver = this.i5b('GSUB');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp0_safe_receiver.x9();
      var majorVersion = tmp0_safe_receiver.j33();
      var minorVersion = tmp0_safe_receiver.j33();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var tmp0_error = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException_init_$Create$(toString(tmp0_error));
      }
      var scriptListOffset = this.x5b(tmp0_safe_receiver);
      var featureListOffset = this.x5b(tmp0_safe_receiver);
      var lookupListOffset = this.x5b(tmp0_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.z5b(tmp0_safe_receiver);
      }
      var tmp$ret$0;
      // Inline function 'kotlin.apply' call
      var tmp1_apply = tmp0_safe_receiver.c33(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = tmp1_apply.j33();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = tmp1_apply.t33(4);
          var scriptOffset = this.x5b(tmp1_apply);
        }
         while (inductionVariable < scriptCount);
      tmp$ret$0 = tmp1_apply;
      var tmp$ret$1;
      // Inline function 'kotlin.apply' call
      var tmp2_apply = tmp0_safe_receiver.c33(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = tmp2_apply.j33();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = tmp2_apply.t33(4);
          var featureOffset = this.x5b(tmp2_apply);
        }
         while (inductionVariable_0 < featureCount);
      tmp$ret$1 = tmp2_apply;
      var tmp$ret$34;
      // Inline function 'kotlin.apply' call
      var tmp3_apply = tmp0_safe_receiver.c33(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = tmp3_apply.j33();
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.mapInt' call
      var tmp1_mapInt = until(0, lookupCount);
      var tmp$ret$3;
      // Inline function 'kotlin.also' call
      var tmp0_also = new IntArrayList((coerceAtLeast(tmp1_mapInt.k6() - tmp1_mapInt.j6() | 0, 0) / tmp1_mapInt.c1_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = tmp1_mapInt.j6();
      var nestedLast = tmp1_mapInt.k6();
      var stepArg = tmp1_mapInt.c1_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      var step = stepArg;
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + step | 0;
          var tmp$ret$2;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.x5b(tmp3_apply);
          tmp0_also.un(tmp$ret$2);
        }
         while (!(v === last));
      tmp$ret$3 = tmp0_also;
      tmp$ret$4 = tmp$ret$3;
      var lookups = tmp$ret$4;
      var tmp0_iterator = lookups.g();
      while (tmp0_iterator.h()) {
        var lookupOffset = tmp0_iterator.i();
        var tmp$ret$33;
        // Inline function 'kotlin.apply' call
        var tmp2_apply_0 = tmp3_apply.c33(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = tmp2_apply_0.j33();
        var lookupFlag = tmp2_apply_0.j33();
        var subTableCount = tmp2_apply_0.j33();
        var tmp$ret$7;
        // Inline function 'korlibs.datastructure.mapInt' call
        var tmp1_mapInt_0 = tmp2_apply_0.o33(subTableCount);
        var tmp$ret$6;
        // Inline function 'kotlin.also' call
        var tmp0_also_0 = new Int32Array(tmp1_mapInt_0.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = tmp1_mapInt_0.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var tmp$ret$5;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp2__anonymous__z9zvc9 = tmp1_mapInt_0[n_1];
            tmp$ret$5 = tmp2__anonymous__z9zvc9 & 65535;
            tmp0_also_0[n_1] = tmp$ret$5;
          }
           while (inductionVariable_2 < last_0);
        tmp$ret$6 = tmp0_also_0;
        tmp$ret$7 = tmp$ret$6;
        var subtableOffsets = tmp$ret$7;
        var markFilteringSet = tmp2_apply_0.j33();
        var indexedObject = subtableOffsets;
        var inductionVariable_3 = 0;
        var last_1 = indexedObject.length;
        while (inductionVariable_3 < last_1) {
          var offset = indexedObject[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp$ret$32;
          // Inline function 'kotlin.apply' call
          var tmp3_apply_0 = tmp2_apply_0.c33(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = tmp3_apply_0;
          var tmp0_subject = lookupType;
          switch (tmp0_subject) {
            case 1:
              var substFormat = tmp3_apply_0.j33();
              var coverageOffset = this.x5b(tmp3_apply_0);
              var tmp1_subject = substFormat;
              switch (tmp1_subject) {
                case 1:
                  var deltaGlyphID = tmp3_apply_0.i33();
                  var coverageTable = this.i5c(tmp3_apply_0.c33(coverageOffset));
                  var indexedObject_0 = coverageTable;
                  var inductionVariable_4 = 0;
                  var last_2 = indexedObject_0.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = indexedObject_0[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.p5a_1.yq(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = tmp3_apply_0.j33();
                  var coverageTable_0 = this.i5c(tmp3_apply_0.c33(coverageOffset));
                  var tmp$ret$11;
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var tmp1_mapInt_1 = tmp3_apply_0.p33(glyphCount);
                  var tmp$ret$10;
                  // Inline function 'kotlin.also' call
                  var tmp0_also_1 = new Int32Array(tmp1_mapInt_1.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_5 = 0;
                  var last_3 = tmp1_mapInt_1.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      var tmp$ret$9;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      var tmp2__anonymous__z9zvc9_0 = tmp1_mapInt_1[n_2];
                      var tmp$ret$8;
                      // Inline function 'kotlin.code' call
                      tmp$ret$8 = Char__toInt_impl_vasixd(tmp2__anonymous__z9zvc9_0);
                      tmp$ret$9 = tmp$ret$8;
                      tmp0_also_1[n_2] = tmp$ret$9;
                    }
                     while (inductionVariable_5 < last_3);
                  tmp$ret$10 = tmp0_also_1;
                  tmp$ret$11 = tmp$ret$10;

                  var substituteGlyphIDs = tmp$ret$11;
                  // Inline function 'kotlin.repeat' call
                  // Inline function 'kotlin.contracts.contract' call
                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.p5a_1.yq(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);

                  break;
                default:
                  // Inline function 'kotlin.error' call
                  var tmp3_error = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException_init_$Create$(toString(tmp3_error));

                  break;
              }

              break;
            case 4:
              var substFormat_0 = tmp3_apply_0.j33();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                throw IllegalStateException_init_$Create$('For lookType=4 only substFormat=1 is supported');
              }

              var coverageOffset_0 = this.x5b(tmp3_apply_0);
              var ligatureSetCount = tmp3_apply_0.j33();
              var tmp$ret$15;
              // Inline function 'korlibs.datastructure.mapInt' call
              var tmp5_mapInt = tmp3_apply_0.p33(ligatureSetCount);
              var tmp$ret$14;
              // Inline function 'kotlin.also' call
              var tmp4_also = new Int32Array(tmp5_mapInt.length);
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
              var inductionVariable_7 = 0;
              var last_4 = tmp5_mapInt.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  var tmp$ret$13;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var tmp6__anonymous__fv9ai5 = tmp5_mapInt[n_3];
                  var tmp$ret$12;
                  // Inline function 'kotlin.code' call
                  tmp$ret$12 = Char__toInt_impl_vasixd(tmp6__anonymous__fv9ai5);
                  tmp$ret$13 = tmp$ret$12;
                  tmp4_also[n_3] = tmp$ret$13;
                }
                 while (inductionVariable_7 < last_4);
              tmp$ret$14 = tmp4_also;
              tmp$ret$15 = tmp$ret$14;

              var ligatureSetOffsets = tmp$ret$15;
              var glyphArray = this.h5c(tmp3_apply_0.c33(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap_init_$Create$_0();
                  var codePoint = this.n5c(glyphID_0);
                  var tmp$ret$16;
                  // Inline function 'kotlin.intArrayOf' call
                  tmp$ret$16 = new Int32Array([codePoint]);
                  var codePointIntArray = tmp$ret$16;
                  var maxComponentCount = 1;
                  var tmp$ret$29;
                  // Inline function 'kotlin.apply' call
                  var tmp7_apply = subsTable.c33(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = tmp7_apply.j33();
                  var tmp$ret$20;
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var tmp1_mapInt_2 = tmp7_apply.p33(ligatureCount);
                  var tmp$ret$19;
                  // Inline function 'kotlin.also' call
                  var tmp0_also_2 = new Int32Array(tmp1_mapInt_2.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = tmp1_mapInt_2.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      var tmp$ret$18;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      var tmp2__anonymous__z9zvc9_1 = tmp1_mapInt_2[n_5];
                      var tmp$ret$17;
                      // Inline function 'kotlin.code' call
                      tmp$ret$17 = Char__toInt_impl_vasixd(tmp2__anonymous__z9zvc9_1);
                      tmp$ret$18 = tmp$ret$17;
                      tmp0_also_2[n_5] = tmp$ret$18;
                    }
                     while (inductionVariable_9 < last_6);
                  tmp$ret$19 = tmp0_also_2;
                  tmp$ret$20 = tmp$ret$19;
                  var ligatureOffsets = tmp$ret$20;
                  var indexedObject_1 = ligatureOffsets;
                  var inductionVariable_10 = 0;
                  var last_7 = indexedObject_1.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = indexedObject_1[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    var tmp$ret$28;
                    // Inline function 'kotlin.apply' call
                    var tmp3_apply_1 = tmp7_apply.c33(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = tmp3_apply_1.j33();
                    var componentCount = tmp3_apply_1.j33();
                    var tmp$ret$21;
                    // Inline function 'kotlin.math.max' call
                    var tmp0_max = maxComponentCount;
                    var tmp1_max = componentCount + 1 | 0;
                    tmp$ret$21 = Math.max(tmp0_max, tmp1_max);
                    maxComponentCount = tmp$ret$21;
                    var tmp$ret$25;
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var tmp3_mapInt = tmp3_apply_1.p33(componentCount - 1 | 0);
                    var tmp$ret$24;
                    // Inline function 'kotlin.also' call
                    var tmp2_also = new Int32Array(tmp3_mapInt.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = tmp3_mapInt.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        var tmp$ret$23;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var tmp4__anonymous__pkmkx7 = tmp3_mapInt[n_6];
                        var tmp$ret$22;
                        // Inline function 'kotlin.code' call
                        tmp$ret$22 = Char__toInt_impl_vasixd(tmp4__anonymous__pkmkx7);
                        tmp$ret$23 = this.n5c(tmp$ret$22);
                        tmp2_also[n_6] = tmp$ret$23;
                      }
                       while (inductionVariable_11 < last_8);
                    tmp$ret$24 = tmp2_also;
                    tmp$ret$25 = tmp$ret$24;
                    var componentCodePoints = tmp$ret$25;
                    var tmp = Companion_getInstance_12();
                    var tmp$ret$26;
                    // Inline function 'kotlin.collections.plus' call
                    tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.e2b(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    var tmp$ret$27;
                    // Inline function 'kotlin.intArrayOf' call
                    tmp$ret$27 = new Int32Array([ligatureGlyph]);
                    var tmp5_set = tmp$ret$27;
                    map.x3(ligature, tmp5_set);
                    tmp$ret$28 = tmp3_apply_1;
                  }
                  tmp$ret$29 = tmp7_apply;
                  this.q5a_1.wr(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              var tmp$ret$31;
              // Inline function 'korlibs.logger.Logger.info' call
              var tmp9_info = Companion_getInstance_36().z55_1;
              var tmp8_log = Level_INFO_getInstance();
              var tmp_0;
              if (tmp9_info.zz(tmp8_log)) {
                var tmp$ret$30;
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                tmp9_info.a10(tmp8_log, tmp$ret$30);
                tmp_0 = Unit_getInstance();
              }
              tmp$ret$31 = tmp_0;

              break;
          }
          tmp$ret$32 = tmp3_apply_0;
        }
        tmp$ret$33 = tmp2_apply_0;
      }
      tmp$ret$34 = tmp3_apply;
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).k5c = function () {
    var tmp0_safe_receiver = this.i5b('COLR');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp0_safe_receiver.j33();
      var tmp0_subject = version;
      switch (tmp0_subject) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp0_safe_receiver.j33();
          var baseGlyphRecordsOffset = tmp0_safe_receiver.l33();
          var layerRecordsOffset = tmp0_safe_receiver.l33();
          var numLayerRecords = tmp0_safe_receiver.j33();
          var tmp$ret$2;
          // Inline function 'kotlin.apply' call
          var tmp0_apply = tmp0_safe_receiver.c33(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
          var tmp = this;
          var tmp_0 = 0;
          var tmp_1 = numLayerRecords;
          var tmp$ret$0;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp$ret$0 = fillArrayVal(Array(tmp_1), null);
          var tmp_2 = tmp$ret$0;
          while (tmp_0 < tmp_1) {
            var tmp_3 = tmp_0;
            var tmp$ret$1;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>.<anonymous>' call
            tmp$ret$1 = new ColrLayerInfo(this, tmp0_apply.j33(), tmp0_apply.j33());
            tmp_2[tmp_3] = tmp$ret$1;
            tmp_0 = tmp_0 + 1 | 0;
          }
          tmp.k5a_1 = tmp_2;
          tmp$ret$2 = tmp0_apply;

          ;
          var tmp$ret$3;
          // Inline function 'kotlin.apply' call
          var tmp1_apply = tmp0_safe_receiver.c33(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, tmp1_apply.j33(), tmp1_apply.j33(), tmp1_apply.j33());
              this.l5a_1.wr(info.i5i_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          tmp$ret$3 = tmp1_apply;

          ;
          if (version === 1) {
            var baseGlyphListOffset = this.z5b(tmp0_safe_receiver);
            var layerListOffset = this.z5b(tmp0_safe_receiver);
            var clipListOffset = this.z5b(tmp0_safe_receiver);
            var varIdxMapOffset = this.z5b(tmp0_safe_receiver);
            var varStoreOffset = this.z5b(tmp0_safe_receiver);
            this.n5a_1.c5h_1.v2();
            var tmp_4 = this;
            var tmp2_s = tmp0_safe_receiver.c33(0);
            var tmp$ret$7;
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var tmp2_readArrayOf32 = tmp0_safe_receiver.c33(layerListOffset);
            var tmp_5 = 0;
            var tmp_6 = tmp2_readArrayOf32.l33();
            var tmp$ret$4;
            // Inline function 'kotlin.arrayOfNulls' call
            tmp$ret$4 = fillArrayVal(Array(tmp_6), null);
            var tmp_7 = tmp$ret$4;
            while (tmp_5 < tmp_6) {
              var tmp_8 = tmp_5;
              var tmp$ret$6;
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32.<anonymous>' call
              var tmp$ret$5;
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp$ret$5 = this.z5b(tmp2_readArrayOf32);
              tmp$ret$6 = tmp$ret$5;
              tmp_7[tmp_8] = tmp$ret$6;
              tmp_5 = tmp_5 + 1 | 0;
            }
            tmp$ret$7 = tmp_7;
            var tmp3_layerList = toIntArray(tmp$ret$7);
            var tmp4_sBaseOffset = tmp0_safe_receiver.c33(baseGlyphListOffset);
            var tmp5_sLayerOffset = tmp0_safe_receiver.c33(layerListOffset);
            var tmp$ret$9;
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_9;
            var tmp$ret$8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            tmp$ret$8 = !(clipListOffset === 0);
            if (tmp$ret$8) {
              tmp_9 = clipListOffset;
            } else {
              tmp_9 = null;
            }
            tmp$ret$9 = tmp_9;
            var tmp1_safe_receiver = tmp$ret$9;
            var tmp_10;
            if (tmp1_safe_receiver == null) {
              tmp_10 = null;
            } else {
              var tmp$ret$11;
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp$ret$10;
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp$ret$10 = tmp0_safe_receiver.c33(tmp1_safe_receiver);
              tmp$ret$11 = tmp$ret$10;
              tmp_10 = tmp$ret$11;
            }
            var tmp6_sClipOffset = tmp_10;
            tmp_4.n5a_1 = new COLRv1(tmp3_layerList, tmp2_s, tmp4_sBaseOffset, tmp5_sLayerOffset, tmp6_sClipOffset);
            var tmp$ret$13;
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_11;
            var tmp$ret$12;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            tmp$ret$12 = !(clipListOffset === 0);
            if (tmp$ret$12) {
              tmp_11 = clipListOffset;
            } else {
              tmp_11 = null;
            }
            tmp$ret$13 = tmp_11;
            var tmp7_safe_receiver = tmp$ret$13;
            if (tmp7_safe_receiver == null)
              null;
            else {
              var tmp$ret$18;
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp$ret$17;
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp0_safe_receiver.c33(clipListOffset);
              var format = s.h33();
              var tmp$ret$16;
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_12 = 0;
              var tmp_13 = s.l33();
              var tmp$ret$14;
              // Inline function 'kotlin.arrayOfNulls' call
              tmp$ret$14 = fillArrayVal(Array(tmp_13), null);
              var tmp_14 = tmp$ret$14;
              while (tmp_12 < tmp_13) {
                var tmp_15 = tmp_12;
                var tmp$ret$15;
                // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32.<anonymous>' call
                var startGlyphID = s.j33();
                var endGlyphID = s.j33();
                var clipBoxOffset = this.y5b(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.n5a_1.c5h_1.yq(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp$ret$15 = Unit_getInstance();
                tmp_14[tmp_15] = Unit_getInstance();
                tmp_12 = tmp_12 + 1 | 0;
              }
              tmp$ret$16 = tmp_14;
              tmp$ret$17 = tmp$ret$16;
              tmp$ret$18 = tmp$ret$17;
            }
            var tmp$ret$21;
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var tmp3_readArrayOf32 = tmp0_safe_receiver.c33(baseGlyphListOffset);
            var tmp_16 = 0;
            var tmp_17 = tmp3_readArrayOf32.l33();
            var tmp$ret$19;
            // Inline function 'kotlin.arrayOfNulls' call
            tmp$ret$19 = fillArrayVal(Array(tmp_17), null);
            var tmp_18 = tmp$ret$19;
            while (tmp_16 < tmp_17) {
              var tmp_19 = tmp_16;
              var tmp$ret$20;
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32.<anonymous>' call
              var glyphID_0 = tmp3_readArrayOf32.j33();
              var paint = this.z5b(tmp3_readArrayOf32);
              this.l5a_1.wr(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp$ret$20 = Unit_getInstance();
              tmp_18[tmp_19] = Unit_getInstance();
              tmp_16 = tmp_16 + 1 | 0;
            }
            tmp$ret$21 = tmp_18;
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          ;
          break;
      }
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).l5c = function () {
    var tmp0_safe_receiver = this.i5b('cmap');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp0_safe_receiver.j33();
      var numTables = tmp0_safe_receiver.j33();
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = until(0, numTables);
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var inductionVariable = tmp1_map.a1_1;
      var last = tmp1_map.b1_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
          tmp$ret$0 = new BaseTtfFont$readCmap$1$EncodingRecord(tmp0_safe_receiver.j33(), tmp0_safe_receiver.j33(), tmp0_safe_receiver.l33());
          tmp0_mapTo.b(tmp$ret$0);
        }
         while (!(item === last));
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var tables = tmp$ret$2;
      var index = 0;
      var tmp0_iterator = tables.g();
      while (tmp0_iterator.h()) {
        var table = tmp0_iterator.i();
        var tmp$ret$6;
        // Inline function 'kotlin.run' call
        var tmp2_run = tmp0_safe_receiver.c33(table.s5k_1);
        // Inline function 'kotlin.contracts.contract' call
        var format = tmp2_run.j33();
        var tmp;
        try {
          var tmp0_subject = format;
          var tmp_0;
          switch (tmp0_subject) {
            case 0:
              var length = tmp2_run.j33();
              var language = tmp2_run.j33();
              var tmp$ret$5;
              // Inline function 'korlibs.datastructure.mapInt' call
              var tmp1_mapInt = tmp2_run.f33(256);
              var tmp$ret$4;
              // Inline function 'kotlin.also' call
              var tmp0_also = new Int32Array(tmp1_mapInt.length);
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
              var inductionVariable_0 = 0;
              var last_0 = tmp1_mapInt.length;
              if (inductionVariable_0 < last_0)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var tmp$ret$3;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  var tmp2__anonymous__z9zvc9 = tmp1_mapInt[n];
                  tmp$ret$3 = tmp2__anonymous__z9zvc9 & 255;
                  tmp0_also[n] = tmp$ret$3;
                }
                 while (inductionVariable_0 < last_0);
              tmp$ret$4 = tmp0_also;
              tmp$ret$5 = tmp$ret$4;

              var glyphIdArray = tmp$ret$5;
              var inductionVariable_1 = 0;
              var tmp_1;
              if (inductionVariable_1 < 256) {
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  this.d5b(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_1 < 256);
                tmp_1 = Unit_getInstance();
              }

              tmp_0 = tmp_1;
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_getInstance();
              break;
            case 4:
              var length_0 = tmp2_run.j33();
              var language_0 = tmp2_run.j33();
              var segCount = tmp2_run.j33() / 2 | 0;
              var searchRangeS = tmp2_run.j33();
              var entrySelector = tmp2_run.j33();
              var rangeShift = tmp2_run.j33();
              var endCount = tmp2_run.p33(segCount);
              tmp2_run.j33();
              ;
              var startCount = tmp2_run.p33(segCount);
              var idDelta = tmp2_run.o33(segCount);
              var rangeOffsetPos = tmp2_run.l2w();
              var idRangeOffset = tmp2_run.p33(segCount);
              var inductionVariable_2 = 0;
              var tmp_2;
              if (inductionVariable_2 < segCount) {
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_3 = sc;
                  if (inductionVariable_3 <= ec)
                    do {
                      var c = inductionVariable_3;
                      inductionVariable_3 = inductionVariable_3 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = tmp2_run.c33(glyphIndexOffset).j33();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.c5b(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_2 < segCount);
                tmp_2 = Unit_getInstance();
              }

              tmp_0 = tmp_2;
              break;
            case 6:
              var length_1 = tmp2_run.j33();
              var language_1 = tmp2_run.j33();
              var firstCode = tmp2_run.j33();
              var entryCount = tmp2_run.j33();
              var inductionVariable_4 = 0;
              var tmp_3;
              if (inductionVariable_4 < entryCount) {
                do {
                  var n_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.c5b(codePoint, tmp2_run.j33());
                }
                 while (inductionVariable_4 < entryCount);
                tmp_3 = Unit_getInstance();
              }

              tmp_0 = tmp_3;
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_getInstance();
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_getInstance();
              break;
            case 12:
              tmp2_run.j33();
              ;
              var length_2 = tmp2_run.l33();
              var language_2 = tmp2_run.l33();
              var numGroups = tmp2_run.l33();
              var inductionVariable_5 = 0;
              var tmp_4;
              if (inductionVariable_5 < numGroups) {
                do {
                  var n_3 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var startCharCode = tmp2_run.l33();
                  var endCharCode = tmp2_run.l33();
                  var startGlyphId = tmp2_run.l33();
                  var inductionVariable_6 = startCharCode;
                  if (inductionVariable_6 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.c5b(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_5 < numGroups);
                tmp_4 = Unit_getInstance();
              }

              tmp_0 = tmp_4;
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_getInstance();
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              tmp_0 = Unit_getInstance();
              break;
          }
          tmp = tmp_0;
        } catch ($p) {
          var tmp_5;
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
            tmp_5 = Unit_getInstance();
          } else {
            throw $p;
          }
          tmp = tmp_5;
        }
        tmp$ret$6 = tmp;
      }
    }
    return Unit_getInstance();
  };
  protoOf(BaseTtfFont).m5c = function (charIndex, default_0) {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_getOrElse = this.h5a_1;
    var tmp0_elvis_lhs = tmp0_getOrElse.z1(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp$ret$0 = default_0;
      tmp = tmp$ret$0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    tmp$ret$1 = tmp;
    return tmp$ret$1;
  };
  protoOf(BaseTtfFont).n5c = function (charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.m5c(charIndex, default_0) : $super.m5c.call(this, charIndex, default_0);
  };
  protoOf(BaseTtfFont).o5c = function (reader, codePoint, cache) {
    var g = this.r5c(codePoint);
    var skipCount = 1;
    if (this.o58_1 ? !(g == null) : false) {
      var subs = this.q5a_1.k(codePoint);
      if (!(reader == null) ? !(subs == null) : false) {
        var tmp$ret$0;
        // Inline function 'kotlin.math.min' call
        var tmp0_min = reader.s2a();
        var tmp1_min = subs.r5d_1;
        tmp$ret$0 = Math.min(tmp0_min, tmp1_min);
        var inductionVariable = tmp$ret$0;
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.c2b(0, count);
            var replacement = subs.s5d_1.z1(sub);
            if (!(replacement == null)) {
              skipCount = sub.x9();
              var tmp1_elvis_lhs = this.t5c(first_1(replacement));
              var tmp;
              if (tmp1_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp1_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    var tmp2_safe_receiver = reader;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.b2b(skipCount);
    }
    return g;
  };
  protoOf(BaseTtfFont).p5c = function (reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.o5c(reader, codePoint, cache) : $super.o5c.call(this, reader, codePoint, cache);
  };
  protoOf(BaseTtfFont).q5c = function (codePoint, cache) {
    var tmp0_safe_receiver = this.b5b(codePoint);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp$ret$0 = this.s5c(tmp0_safe_receiver, cache, codePoint);
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    return tmp;
  };
  protoOf(BaseTtfFont).r5c = function (codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.q5c(codePoint, cache) : $super.q5c.call(this, codePoint, cache);
  };
  protoOf(BaseTtfFont).s5c = function (index, cache, codePoint) {
    var cff = this.u5a_1;
    if (!(cff == null)) {
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var tmp0_getOrPut = this.i5a_1;
      var res = tmp0_getOrPut.k(index);
      if (res == null) {
        var tmp$ret$0;
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.u54(index);
        tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.y53_1), new GlyphGraphicsPath(index, gvector.x53_1));
        tmp0_getOrPut.wr(index, tmp$ret$0);
      }
      tmp$ret$1 = ensureNotNull(tmp0_getOrPut.k(index));
      return tmp$ret$1;
    }
    var tmp0_elvis_lhs = getOrNull_0(this.t59_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.t59_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.i5a_1.k(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.y5a('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          var tmp$ret$5;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var tmp1__anonymous__uwfjfc = table.t5d();
          var tmp$ret$4;
          // Inline function 'kotlin.also' call
          var tmp0_also = this.x5c(tmp1__anonymous__uwfjfc.c33(start), index);
          // Inline function 'kotlin.contracts.contract' call
          var tmp$ret$3;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$3 = Unit_getInstance();
          tmp$ret$4 = tmp0_also;
          tmp$ret$5 = tmp$ret$4;
          tmp$ret$2 = tmp$ret$5;
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      var tmp$ret$11;
      // Inline function 'kotlin.also' call
      var tmp$ret$6;
      // Inline function 'kotlin.intArrayOf' call
      tmp$ret$6 = new Int32Array([]);
      var tmp_2 = tmp$ret$6;
      var tmp$ret$7;
      // Inline function 'kotlin.intArrayOf' call
      tmp$ret$7 = new Int32Array([]);
      var tmp_3 = tmp$ret$7;
      var tmp$ret$8;
      // Inline function 'kotlin.intArrayOf' call
      tmp$ret$8 = new Int32Array([]);
      var tmp_4 = tmp$ret$8;
      var tmp$ret$9;
      // Inline function 'kotlin.intArrayOf' call
      tmp$ret$9 = new Int32Array([]);
      var tmp2_also = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.f5a_1.k(index).u5d_1, true);
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$10;
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp$ret$10 = Unit_getInstance();
      tmp$ret$11 = tmp2_also;
      tmp = tmp$ret$11;
    }
    var glyph = tmp;
    if (cache ? !this.o5a_1 : false) {
      this.i5a_1.wr(index, glyph);
    }
    return glyph;
  };
  protoOf(BaseTtfFont).t5c = function (index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.s5c(index, cache, codePoint) : $super.s5c.call(this, index, cache, codePoint);
  };
  protoOf(BaseTtfFont).u5c = function (_this__u8e3s4) {
    var v = _this__u8e3s4.i33();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  };
  protoOf(BaseTtfFont).v5c = function (_this__u8e3s4) {
    var v = _this__u8e3s4.l33();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  };
  protoOf(BaseTtfFont).w5c = function (_this__u8e3s4, signed, word) {
    var tmp;
    if (!word ? signed : false) {
      tmp = _this__u8e3s4.g33();
    } else if (!word ? !signed : false) {
      tmp = _this__u8e3s4.h33();
    } else if (word ? signed : false) {
      tmp = _this__u8e3s4.i33();
    } else if (word ? !signed : false) {
      tmp = _this__u8e3s4.j33();
    } else {
      get_invalidOp();
    }
    return tmp;
  };
  protoOf(BaseTtfFont).x5c = function (_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.i33();
    var xMin = _this__u8e3s4.i33();
    var yMin = _this__u8e3s4.i33();
    var xMax = _this__u8e3s4.i33();
    var yMax = _this__u8e3s4.i33();
    var advanceWidth = this.f5a_1.k(index).u5d_1;
    var tmp$ret$2;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      var tmp$ret$0;
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp$ret$0 = ArrayList_init_$Create$();
      var references = tmp$ret$0;
      do {
        var flags = _this__u8e3s4.j33();
        var glyphIndex = _this__u8e3s4.j33();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.w5c(_this__u8e3s4, signed, words);
        var y = this.w5c(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.u5c(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.u5c(_this__u8e3s4);
          scaleY = this.u5c(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.u5c(_this__u8e3s4);
          scale01 = this.u5c(_this__u8e3s4);
          scale10 = this.u5c(_this__u8e3s4);
          scaleY = this.u5c(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.t5c(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.b(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.j33();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.j33();
      var instructions = _this__u8e3s4.f33(instructionLength);
      var tmp1_safe_receiver = lastOrNull(contoursIndices);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver + 1 | 0;
      var numPoints = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
      var flags_0 = new IntArrayList();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.h33();
        flags_0.un(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.h33();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.un(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          var tmp4 = npos;
          npos = tmp4 + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.ek(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.h33();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.i33() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.eo(), xPos, yPos, advanceWidth);
    }
    var tmp0_also = tmp;
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$1;
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    tmp$ret$1 = Unit_getInstance();
    tmp$ret$2 = tmp0_also;
    return tmp$ret$2;
  };
  function Companion_20() {
    Companion_instance_20 = this;
  }
  protoOf(Companion_20).t5k = function (num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  };
  var Companion_instance_20;
  function Companion_getInstance_40() {
    if (Companion_instance_20 == null)
      new Companion_20();
    return Companion_instance_20;
  }
  function _FWord___init__impl__2rjyqf(data) {
    return data;
  }
  function _FWord___get_data__impl__9ys4ze($this) {
    return $this;
  }
  function FWord__toDouble_impl_53j5qp($this) {
    return _FWord___get_data__impl__9ys4ze($this);
  }
  function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var tmp = new $readTtfFontCOROUTINE$12(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function $readTtfFontCOROUTINE$12(_this__u8e3s4, onlyReadMetadata, enableLigatures, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e5l_1 = _this__u8e3s4;
    this.f5l_1 = onlyReadMetadata;
    this.g5l_1 = enableLigatures;
  }
  protoOf($readTtfFontCOROUTINE$12).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.e5l_1.x1y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new TtfFont(ARGUMENT, get_baseName(this.e5l_1), this.f5l_1, this.g5l_1);
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function ss$factory() {
    return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
      return _get_ss__ndcawb(receiver);
    }, null);
  }
  function VectorFont() {
  }
  var DataFormat_UBYTE_instance;
  var DataFormat_STRING_instance;
  var DataFormat_USHORT_instance;
  var DataFormat_ULONG_instance;
  var DataFormat_URATIO_instance;
  var DataFormat_SBYTE_instance;
  var DataFormat_UNDEFINED_instance;
  var DataFormat_SSHORT_instance;
  var DataFormat_SLONG_instance;
  var DataFormat_SRATIO_instance;
  var DataFormat_SFLOAT_instance;
  var DataFormat_DFLOAT_instance;
  var DataFormat_UNKNOWN_instance;
  function Companion_21() {
    Companion_instance_21 = this;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy = values_4();
    var capacity = coerceAtLeast(mapCapacity(tmp1_associateBy.length), 16);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap_init_$Create$(capacity);
    var indexedObject = tmp1_associateBy;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      tmp$ret$0 = element.j5l_1;
      tmp0_associateByTo.x3(tmp$ret$0, element);
    }
    tmp$ret$1 = tmp0_associateByTo;
    tmp$ret$2 = tmp$ret$1;
    tmp.l5l_1 = tmp$ret$2;
  }
  protoOf(Companion_21).k = function (index) {
    var tmp0_elvis_lhs = this.l5l_1.z1(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  };
  var Companion_instance_21;
  function Companion_getInstance_41() {
    DataFormat_initEntries();
    if (Companion_instance_21 == null)
      new Companion_21();
    return Companion_instance_21;
  }
  function values_4() {
    return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
  }
  function EXIF$DataFormat$lambda(it) {
    return it;
  }
  function EXIF$DataFormat$lambda_0(it) {
    return 4;
  }
  function EXIF$DataFormat$lambda_1(it) {
    return imul(it, 2);
  }
  function EXIF$DataFormat$lambda_2(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_3(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_4(it) {
    return it;
  }
  function EXIF$DataFormat$lambda_5(it) {
    return it;
  }
  function EXIF$DataFormat$lambda_6(it) {
    return imul(it, 2);
  }
  function EXIF$DataFormat$lambda_7(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_8(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_9(it) {
    return imul(it, 4);
  }
  function EXIF$DataFormat$lambda_10(it) {
    return imul(it, 8);
  }
  function EXIF$DataFormat$lambda_11(it) {
    return 0;
  }
  var DataFormat_entriesInitialized;
  function DataFormat_initEntries() {
    if (DataFormat_entriesInitialized)
      return Unit_getInstance();
    DataFormat_entriesInitialized = true;
    DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
    DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
    DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
    DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
    DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
    DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
    DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
    DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
    DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
    DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
    DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
    DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
    DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
    Companion_getInstance_41();
  }
  function DataFormat(name, ordinal, id, indexBytes) {
    Enum.call(this, name, ordinal);
    this.j5l_1 = id;
    this.k5l_1 = indexBytes;
  }
  function readExifBase$readUShort(data, endian, index) {
    return readU16(data, imul(index, 2), endian.qv());
  }
  function readExifBase$readInt(data, endian, index) {
    return readS32(data, imul(index, 4), endian.qv());
  }
  function DataFormat_UBYTE_getInstance() {
    DataFormat_initEntries();
    return DataFormat_UBYTE_instance;
  }
  function DataFormat_STRING_getInstance() {
    DataFormat_initEntries();
    return DataFormat_STRING_instance;
  }
  function DataFormat_USHORT_getInstance() {
    DataFormat_initEntries();
    return DataFormat_USHORT_instance;
  }
  function DataFormat_ULONG_getInstance() {
    DataFormat_initEntries();
    return DataFormat_ULONG_instance;
  }
  function DataFormat_URATIO_getInstance() {
    DataFormat_initEntries();
    return DataFormat_URATIO_instance;
  }
  function DataFormat_SBYTE_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SBYTE_instance;
  }
  function DataFormat_UNDEFINED_getInstance() {
    DataFormat_initEntries();
    return DataFormat_UNDEFINED_instance;
  }
  function DataFormat_SSHORT_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SSHORT_instance;
  }
  function DataFormat_SLONG_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SLONG_instance;
  }
  function DataFormat_SRATIO_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SRATIO_instance;
  }
  function DataFormat_SFLOAT_getInstance() {
    DataFormat_initEntries();
    return DataFormat_SFLOAT_instance;
  }
  function DataFormat_DFLOAT_getInstance() {
    DataFormat_initEntries();
    return DataFormat_DFLOAT_instance;
  }
  function DataFormat_UNKNOWN_getInstance() {
    DataFormat_initEntries();
    return DataFormat_UNKNOWN_instance;
  }
  function $readExifBaseCOROUTINE$16(_this__u8e3s4, ss, info, debug, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u5l_1 = _this__u8e3s4;
    this.v5l_1 = ss;
    this.w5l_1 = info;
    this.x5l_1 = debug;
  }
  protoOf($readExifBaseCOROUTINE$16).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 17;
            this.hh_1 = 1;
            suspendResult = sliceHere(this.v5l_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y5l_1 = suspendResult;
            this.hh_1 = 2;
            suspendResult = readString(this.y5l_1, 2, Charsets_getInstance().g2a(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.z5l_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this.z5l_1 === 'MM') {
              tmp_1 = Endian_BIG_ENDIAN_getInstance();
            } else if (this.z5l_1 === 'II') {
              tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
            } else {
              var tmp0_error = "Not Exif data (not starting with MM or II but '" + this.z5l_1 + "')";
              throw IllegalStateException_init_$Create$(toString(tmp0_error));
            }

            tmp_0.a5m_1 = tmp_1;
            this.hh_1 = 3;
            suspendResult = readU16_0(this.y5l_1, this.a5m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.b5m_1 = suspendResult;
            this.hh_1 = 4;
            suspendResult = readS32_0(this.y5l_1, this.a5m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.c5m_1 = suspendResult;
            this.hh_1 = 5;
            suspendResult = readU16_0(this.y5l_1, this.a5m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.d5m_1 = suspendResult;
            if (this.x5l_1) {
              var tmp2_error = this.u5l_1.q5m_1;
              var tmp1_log = Level_ERROR_getInstance();
              if (tmp2_error.zz(tmp1_log)) {
                tmp2_error.a10(tmp1_log, 'nDirEntry=' + this.d5m_1 + ', tagMark=' + this.b5m_1 + ', offsetFirstFID=' + this.c5m_1);
              }
            }

            this.e5m_1 = until(0, this.d5m_1).g();
            this.hh_1 = 6;
            continue $sm;
          case 6:
            if (!this.e5m_1.h()) {
              this.hh_1 = 16;
              continue $sm;
            }

            this.f5m_1 = this.e5m_1.i();
            this.g5m_1 = this.y5l_1.b1x_1.e1();
            this.hh_1 = 7;
            suspendResult = readU16_0(this.y5l_1, this.a5m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.h5m_1 = suspendResult;
            this.i5m_1 = Companion_getInstance_41();
            this.hh_1 = 8;
            suspendResult = readU16_0(this.y5l_1, this.a5m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.j5m_1 = suspendResult;
            this.k5m_1 = this.i5m_1.k(this.j5m_1);
            this.hh_1 = 9;
            suspendResult = readS32_0(this.y5l_1, this.a5m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.l5m_1 = suspendResult;
            if (this.x5l_1) {
              var tmp4_error = this.u5l_1.q5m_1;
              var tmp3_log = Level_ERROR_getInstance();
              if (tmp4_error.zz(tmp3_log)) {
                tmp4_error.a10(tmp3_log, 'tagPos=' + get_hex(this.g5m_1) + ', tagNumber=' + get_hex(this.h5m_1) + ', dataFormat=' + this.k5m_1 + ', nComponent=' + this.l5m_1 + ', size=' + this.k5m_1.k5l_1(this.l5m_1));
              }
            }

            this.hh_1 = 10;
            suspendResult = readBytesExact(this.y5l_1, this.k5m_1.k5l_1(this.l5m_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            this.m5m_1 = suspendResult;
            if (this.x5l_1) {
              if (this.k5m_1.equals(DataFormat_STRING_getInstance())) {
                var tmp_2 = this;
                tmp_2.n5m_1 = this.u5l_1.q5m_1;
                var tmp_3 = this;
                tmp_3.o5m_1 = Level_ERROR_getInstance();
                if (this.n5m_1.zz(this.o5m_1)) {
                  this.hh_1 = 11;
                  suspendResult = sliceStart(this.y5l_1, toLong(readExifBase$readInt(this.m5m_1, this.a5m_1, 0)), VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.hh_1 = 13;
                  continue $sm;
                }
              } else {
                this.hh_1 = 14;
                continue $sm;
              }
            } else {
              this.hh_1 = 15;
              continue $sm;
            }

            break;
          case 11:
            this.p5m_1 = suspendResult;
            this.hh_1 = 12;
            suspendResult = readStringz(this.p5m_1, this.l5m_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = "  - '" + ARGUMENT + "'";
            this.n5m_1.a10(this.o5m_1, ARGUMENT_0);
            this.hh_1 = 13;
            continue $sm;
          case 13:
            this.hh_1 = 14;
            continue $sm;
          case 14:
            this.hh_1 = 15;
            continue $sm;
          case 15:
            var tmp1_subject = this.h5m_1;
            if (tmp1_subject === 274) {
              var tmp2_subject = readExifBase$readUShort(this.m5m_1, this.a5m_1, 0);
              var tmp_4;
              switch (tmp2_subject) {
                case 1:
                  var tmp7__get_NORMAL__9rbvfn = Companion_getInstance();
                  tmp_4 = tmp7__get_NORMAL__9rbvfn.a3r_1;
                  break;
                case 2:
                  var tmp8__get_MIRROR_HORIZONTAL__f5o9d = Companion_getInstance();
                  tmp_4 = tmp8__get_MIRROR_HORIZONTAL__f5o9d.e3r_1;
                  break;
                case 3:
                  tmp_4 = Companion_getInstance().c3r_1;
                  break;
                case 4:
                  var tmp9__get_MIRROR_VERTICAL__r4lpcy = Companion_getInstance();
                  tmp_4 = tmp9__get_MIRROR_VERTICAL__r4lpcy.g3r_1;
                  break;
                case 5:
                  tmp_4 = Companion_getInstance().h3r_1;
                  break;
                case 6:
                  tmp_4 = Companion_getInstance().b3r_1;
                  break;
                case 7:
                  tmp_4 = Companion_getInstance().f3r_1;
                  break;
                case 8:
                  tmp_4 = Companion_getInstance().d3r_1;
                  break;
                default:
                  var tmp10__get_NORMAL__pbriul = Companion_getInstance();
                  tmp_4 = tmp10__get_NORMAL__pbriul.a3r_1;
                  break;
              }
              set_orientation(this.w5l_1, tmp_4);
            }

            skipToAlign(this.y5l_1, 4, 2);
            this.hh_1 = 6;
            continue $sm;
          case 16:
            return this.w5l_1;
          case 17:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 17) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function EXIF() {
    EXIF_instance = this;
    this.q5m_1 = Companion_getInstance_11().kz('EXIF');
  }
  protoOf(EXIF).r5m = function (ss, info, debug, $completion) {
    var tmp = new $readExifBaseCOROUTINE$16(this, ss, info, debug, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(EXIF).s5m = function (ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.r5m(ss, info, debug, $completion) : $super.r5m.call(this, ss, info, debug, $completion);
  };
  var EXIF_instance;
  function EXIF_getInstance() {
    if (EXIF_instance == null)
      new EXIF();
    return EXIF_instance;
  }
  var Direction_ONCE_FORWARD_instance;
  var Direction_ONCE_REVERSE_instance;
  var Direction_FORWARD_instance;
  var Direction_REVERSE_instance;
  var Direction_PING_PONG_instance;
  var Direction_entriesInitialized;
  function Direction_initEntries() {
    if (Direction_entriesInitialized)
      return Unit_getInstance();
    Direction_entriesInitialized = true;
    Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
    Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
    Direction_FORWARD_instance = new Direction('FORWARD', 2);
    Direction_REVERSE_instance = new Direction('REVERSE', 3);
    Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
  }
  function Direction(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.t5m_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).t4 = function (a, b) {
    return this.t5m_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.t4(a, b);
  };
  function ImageAnimation$_init_$lambda_bxp50i(a, b) {
    var tmp$ret$2;
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp$ret$0;
    // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
    tmp$ret$0 = a.u5m_1;
    var tmp = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
    tmp$ret$1 = b.u5m_1;
    tmp$ret$2 = compareValues(tmp, tmp$ret$1);
    return tmp$ret$2;
  }
  function Direction_FORWARD_getInstance() {
    Direction_initEntries();
    return Direction_FORWARD_instance;
  }
  function ImageAnimation(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      var tmp$ret$7;
      var tmp$ret$7_0;
      // Inline function 'kotlin.collections.sortedBy' call
      var tmp$ret$5;
      var tmp$ret$5_0;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$2;
      var tmp$ret$2_0;
      // Inline function 'kotlin.collections.flatMap' call
      var tmp$ret$1;
      var tmp$ret$1_0;
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList_init_$Create$();
      var tmp0_iterator = frames.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        var tmp$ret$0;
        var tmp$ret$0_0;
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        tmp$ret$0 = element.z5m_1;
        tmp$ret$0_0 = Unit_getInstance();
        var list = tmp$ret$0;
        addAll(tmp0_flatMapTo, list);
      }
      tmp$ret$1 = tmp0_flatMapTo;
      tmp$ret$1_0 = Unit_getInstance();
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$2_0 = Unit_getInstance();
      var tmp2_map = tmp$ret$2;
      var tmp$ret$4;
      var tmp$ret$4_0;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp1_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map, 10));
      var tmp0_iterator_0 = tmp2_map.g();
      while (tmp0_iterator_0.h()) {
        var item = tmp0_iterator_0.i();
        var tmp$ret$3;
        var tmp$ret$3_0;
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        tmp$ret$3 = item.c5n_1;
        tmp$ret$3_0 = Unit_getInstance();
        tmp1_mapTo.b(tmp$ret$3);
      }
      tmp$ret$4 = tmp1_mapTo;
      tmp$ret$4_0 = Unit_getInstance();
      tmp$ret$5 = tmp$ret$4;
      tmp$ret$5_0 = Unit_getInstance();
      var tmp3_sortedBy = distinct(tmp$ret$5);
      var tmp$ret$6;
      var tmp$ret$6_0;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_0);
      tmp$ret$6_0 = Unit_getInstance();
      tmp$ret$7 = sortedWith(tmp3_sortedBy, tmp$ret$6);
      tmp$ret$7_0 = Unit_getInstance();
      tmp = tmp$ret$7;
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.l5n_1 = frames;
    this.m5n_1 = direction;
    this.n5n_1 = name;
    this.o5n_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_1(this.l5n_1);
    tmp_1.p5n_1 = tmp0_elvis_lhs == null ? new ImageFrame(0) : tmp0_elvis_lhs;
  }
  function Companion_22() {
    Companion_instance_22 = this;
  }
  protoOf(Companion_22).q5n = function (simple) {
    return new ImageData(listOf(Companion_getInstance_44().r5n(simple)));
  };
  var Companion_instance_22;
  function Companion_getInstance_42() {
    if (Companion_instance_22 == null)
      new Companion_22();
    return Companion_instance_22;
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.s5n_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).t4 = function (a, b) {
    return this.s5n_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.t4(a, b);
  };
  function ImageData$framesSortedByPriority$lambda(a, b) {
    var tmp$ret$2;
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp$ret$0;
    // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
    var tmp;
    if (b.u5n()) {
      tmp = IntCompanionObject_getInstance().MAX_VALUE;
    } else {
      tmp = imul(imul(b.t5n().r46_1, b.t5n().s46_1), imul(b.t5n().t46_1, b.t5n().t46_1));
    }
    tmp$ret$0 = tmp;
    var tmp_0 = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
    var tmp_1;
    if (a.u5n()) {
      tmp_1 = IntCompanionObject_getInstance().MAX_VALUE;
    } else {
      tmp_1 = imul(imul(a.t5n().r46_1, a.t5n().s46_1), imul(a.t5n().t46_1, a.t5n().t46_1));
    }
    tmp$ret$1 = tmp_1;
    tmp$ret$2 = compareValues(tmp_0, tmp$ret$1);
    return tmp$ret$2;
  }
  function ImageData(frames, loopCount, width, height, layers, animations, name) {
    Companion_getInstance_42();
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp0_safe_receiver = firstOrNull_1(frames);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ck();
      tmp = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp2_safe_receiver = firstOrNull_1(frames);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.dk();
      tmp_0 = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.v5n_1 = frames;
    this.w5n_1 = loopCount;
    this.x5n_1 = width;
    this.y5n_1 = height;
    this.z5n_1 = layers;
    this.a5o_1 = animations;
    this.b5o_1 = name;
    this.c5o_1 = new Mixin();
    this.d5o_1 = new ImageAnimation(this.v5n_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy = this.a5o_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associateBy, 10)), 16);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator = tmp1_associateBy.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      var tmp$ret$0;
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      tmp$ret$0 = element.n5n_1;
      tmp0_associateByTo.x3(tmp$ret$0, element);
    }
    tmp$ret$1 = tmp0_associateByTo;
    tmp$ret$2 = tmp$ret$1;
    tmp_1.e5o_1 = tmp$ret$2;
    var tmp_2 = this;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy_0 = this.v5n_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associateBy_0, 10)), 16);
    var tmp$ret$4;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo_0 = LinkedHashMap_init_$Create$(capacity_0);
    var tmp0_iterator_0 = tmp1_associateBy_0.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      var tmp$ret$3;
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      tmp$ret$3 = element_0.qg();
      tmp0_associateByTo_0.x3(tmp$ret$3, element_0);
    }
    tmp$ret$4 = tmp0_associateByTo_0;
    tmp$ret$5 = tmp$ret$4;
    tmp_2.f5o_1 = tmp$ret$5;
    var tmp_3 = this;
    var tmp$ret$7;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var tmp0_sortedByDescending = this.v5n_1;
    var tmp$ret$6;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_4);
    tmp$ret$7 = sortedWith(tmp0_sortedByDescending, tmp$ret$6);
    tmp_3.g5o_1 = tmp$ret$7;
  }
  protoOf(ImageData).lu = function (_set____db54di) {
    this.c5o_1.lu(_set____db54di);
  };
  protoOf(ImageData).mu = function () {
    return this.c5o_1.mu();
  };
  protoOf(ImageData).h5o = function () {
    var tmp0_safe_receiver = firstOrNull_1(this.g5o_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t5n();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('No bitmap found');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ImageData).toString = function () {
    return 'ImageData(' + this.v5n_1 + ')';
  };
  function Companion_23() {
    Companion_instance_23 = this;
    this.c44_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.d44_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.e44_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
  var Companion_instance_23;
  function Companion_getInstance_43() {
    if (Companion_instance_23 == null)
      new Companion_23();
    return Companion_instance_23;
  }
  function ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_43();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.i5o_1 = filename;
    this.j5o_1 = width;
    this.k5o_1 = height;
    this.l5o_1 = premultiplied;
    this.m5o_1 = asumePremultiplied;
    this.n5o_1 = requestedMaxSize;
    this.o5o_1 = debug;
    this.p5o_1 = preferKotlinDecoder;
    this.q5o_1 = tryNativeDecode;
    this.r5o_1 = format;
    this.s5o_1 = out;
    this.t5o_1 = extra;
  }
  protoOf(ImageDecodingProps).lu = function (_set____db54di) {
    this.t5o_1 = _set____db54di;
  };
  protoOf(ImageDecodingProps).mu = function () {
    return this.t5o_1;
  };
  protoOf(ImageDecodingProps).u5o = function () {
    var tmp0_elvis_lhs = this.l5o_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  };
  protoOf(ImageDecodingProps).v5o = function (filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  };
  protoOf(ImageDecodingProps).w5o = function (filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.i5o_1 : filename;
    width = width === VOID ? this.j5o_1 : width;
    height = height === VOID ? this.k5o_1 : height;
    premultiplied = premultiplied === VOID ? this.l5o_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.m5o_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.n5o_1 : requestedMaxSize;
    debug = debug === VOID ? this.o5o_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.p5o_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.q5o_1 : tryNativeDecode;
    format = format === VOID ? this.r5o_1 : format;
    out = out === VOID ? this.s5o_1 : out;
    extra = extra === VOID ? this.t5o_1 : extra;
    return $super === VOID ? this.v5o(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.v5o.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  };
  protoOf(ImageDecodingProps).toString = function () {
    return 'ImageDecodingProps(filename=' + this.i5o_1 + ', width=' + this.j5o_1 + ', height=' + this.k5o_1 + ', premultiplied=' + this.l5o_1 + ', asumePremultiplied=' + this.m5o_1 + ', requestedMaxSize=' + this.n5o_1 + ', debug=' + this.o5o_1 + ', preferKotlinDecoder=' + this.p5o_1 + ', tryNativeDecode=' + this.q5o_1 + ', format=' + this.r5o_1 + ', out=' + this.s5o_1 + ', extra=' + this.t5o_1 + ')';
  };
  protoOf(ImageDecodingProps).hashCode = function () {
    var result = getStringHashCode(this.i5o_1);
    result = imul(result, 31) + (this.j5o_1 == null ? 0 : this.j5o_1) | 0;
    result = imul(result, 31) + (this.k5o_1 == null ? 0 : this.k5o_1) | 0;
    result = imul(result, 31) + (this.l5o_1 == null ? 0 : this.l5o_1 | 0) | 0;
    result = imul(result, 31) + (this.m5o_1 | 0) | 0;
    result = imul(result, 31) + (this.n5o_1 == null ? 0 : this.n5o_1) | 0;
    result = imul(result, 31) + (this.o5o_1 | 0) | 0;
    result = imul(result, 31) + (this.p5o_1 | 0) | 0;
    result = imul(result, 31) + (this.q5o_1 | 0) | 0;
    result = imul(result, 31) + (this.r5o_1 == null ? 0 : hashCode(this.r5o_1)) | 0;
    result = imul(result, 31) + (this.s5o_1 == null ? 0 : hashCode(this.s5o_1)) | 0;
    result = imul(result, 31) + (this.t5o_1 == null ? 0 : hashCode(this.t5o_1)) | 0;
    return result;
  };
  protoOf(ImageDecodingProps).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.i5o_1 === tmp0_other_with_cast.i5o_1))
      return false;
    if (!(this.j5o_1 == tmp0_other_with_cast.j5o_1))
      return false;
    if (!(this.k5o_1 == tmp0_other_with_cast.k5o_1))
      return false;
    if (!(this.l5o_1 == tmp0_other_with_cast.l5o_1))
      return false;
    if (!(this.m5o_1 === tmp0_other_with_cast.m5o_1))
      return false;
    if (!(this.n5o_1 == tmp0_other_with_cast.n5o_1))
      return false;
    if (!(this.o5o_1 === tmp0_other_with_cast.o5o_1))
      return false;
    if (!(this.p5o_1 === tmp0_other_with_cast.p5o_1))
      return false;
    if (!(this.q5o_1 === tmp0_other_with_cast.q5o_1))
      return false;
    if (!equals(this.r5o_1, tmp0_other_with_cast.r5o_1))
      return false;
    if (!equals(this.s5o_1, tmp0_other_with_cast.s5o_1))
      return false;
    if (!equals(this.t5o_1, tmp0_other_with_cast.t5o_1))
      return false;
    return true;
  };
  function $decodeCOROUTINE$20(_this__u8e3s4, s, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f5p_1 = _this__u8e3s4;
    this.g5p_1 = s;
    this.h5p_1 = props;
  }
  protoOf($decodeCOROUTINE$20).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.g5p_1.b1z(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.f5p_1.i5p(ARGUMENT, this.h5p_1.w5o(get_baseName(this.g5p_1)));
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function ImageFormat(exts) {
    var tmp = this;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$_0(exts.length);
    var indexedObject = exts;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$3;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$1;
      // Inline function 'kotlin.text.toLowerCase' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = item;
      tmp$ret$1 = tmp$ret$0.toLowerCase();
      var tmp0_trim = tmp$ret$1;
      tmp$ret$2 = toString(trim(isCharSequence(tmp0_trim) ? tmp0_trim : THROW_CCE()));
      tmp$ret$3 = tmp$ret$2;
      tmp0_mapTo.b(tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapTo;
    tmp$ret$5 = tmp$ret$4;
    tmp.m5f_1 = toSet(tmp$ret$5);
  }
  protoOf(ImageFormat).j5p = function (s, props) {
    throw new NotImplementedError();
  };
  protoOf(ImageFormat).k5p = function (s, props) {
    var tmp$ret$2;
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      var tmp$ret$1;
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.i5p(s, props);
      var tmp$ret$0;
      // Inline function 'kotlin.apply' call
      var tmp0_apply = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      tmp0_apply.m5p_1 = bmp.r46_1;
      tmp0_apply.n5p_1 = bmp.s46_1;
      tmp0_apply.o5p_1 = bmp.t46_1;
      tmp$ret$0 = tmp0_apply;
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    tmp$ret$2 = tmp;
    return tmp$ret$2;
  };
  protoOf(ImageFormat).i5p = function (s, props) {
    return this.j5p(s, props).h5o();
  };
  protoOf(ImageFormat).p5p = function (s, props) {
    var tmp$ret$1;
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      var tmp$ret$0;
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp$ret$0 = !(this.k5p(s, props) == null);
      tmp = tmp$ret$0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    tmp$ret$1 = tmp;
    var tmp0_elvis_lhs = tmp$ret$1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  };
  protoOf(ImageFormat).q5p = function (s, props) {
    return this.i5p(s, props);
  };
  protoOf(ImageFormat).n5f = function (s, props, $super) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    return $super === VOID ? this.q5p(s, props) : $super.q5p.call(this, s, props);
  };
  protoOf(ImageFormat).r5p = function (data, props) {
    return this.i5p(openSync(data), props);
  };
  protoOf(ImageFormat).s5p = function (data, props, $completion) {
    return this.r5p(data, props);
  };
  protoOf(ImageFormat).t5p = function (s, props, $completion) {
    var tmp = new $decodeCOROUTINE$20(this, s, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(ImageFormat).toString = function () {
    return 'ImageFormat(' + this.m5f_1 + ')';
  };
  function toProps(_this__u8e3s4, props) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    return props.w5o(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
  }
  function ImageDecoderNotFoundException() {
  }
  function ImageFormats_init_$Init$(formats, $this) {
    ImageFormats.call($this, toList_1(formats));
    return $this;
  }
  function ImageFormats(formats) {
    ImageFormat.call(this, ['']);
    this.v5p_1 = KorAtomicRef(minus(listFormats(formats), this));
  }
  protoOf(ImageFormats).w5p = function (_set____db54di) {
    var tmp0_setValue = _formats$factory();
    return this.v5p_1.wt(_set____db54di);
  };
  protoOf(ImageFormats).x5p = function () {
    var tmp$ret$0;
    // Inline function 'korlibs.io.concurrent.atomic.getValue' call
    var tmp0_getValue = _formats$factory_0();
    tmp$ret$0 = this.v5p_1.q();
    return tmp$ret$0;
  };
  protoOf(ImageFormats).y5p = function () {
    return this.x5p();
  };
  protoOf(ImageFormats).toString = function () {
    return 'ImageFormats(' + this.y5p().j() + ')' + this.y5p();
  };
  protoOf(ImageFormats).k5p = function (s, props) {
    if (this.y5p().l())
      return null;
    var tmp0_iterator = this.y5p().g();
    $l$loop_0: while (tmp0_iterator.h()) {
      var format = tmp0_iterator.i();
      var tmp;
      try {
        var tmp1_elvis_lhs = format.k5p(sliceStart_0(s), props);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
      return tmp;
    }
    return null;
  };
  protoOf(ImageFormats).j5p = function (s, props) {
    var tmp0_iterator = this.y5p().g();
    while (tmp0_iterator.h()) {
      var format = tmp0_iterator.i();
      if (format.p5p(sliceStart_0(s), props)) {
        return format.j5p(sliceStart_0(s), props);
      }
    }
    throw UnsupportedOperationException_init_$Create$('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_0(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
  };
  function listFormats(_this__u8e3s4) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList_init_$Create$();
    var tmp0_iterator = _this__u8e3s4.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      var tmp$ret$0;
      // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
      tmp$ret$0 = listFormats_0(element);
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toMutableSet(tmp$ret$2);
  }
  function listFormats_0(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp;
    if (tmp0_subject instanceof ImageFormats) {
      tmp = _this__u8e3s4.y5p();
    } else {
      tmp = setOf_0(_this__u8e3s4);
    }
    return tmp;
  }
  function _formats$factory() {
    return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
      return receiver.x5p();
    }, function (receiver, value) {
      return receiver.w5p(value);
    });
  }
  function _formats$factory_0() {
    return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
      return receiver.x5p();
    }, function (receiver, value) {
      return receiver.w5p(value);
    });
  }
  function ImageFormatsMutable() {
    ImageFormats_init_$Init$([], this);
    this.b5q_1 = new NonRecursiveLock();
  }
  protoOf(ImageFormatsMutable).c5q = function (formats) {
    var tmp$ret$0;
    // Inline function 'korlibs.datastructure.lock.NonRecursiveLock.invoke' call
    var tmp0_invoke = this.b5q_1;
    this.w5p(minus(plus_2(this.x5p(), formats), this));
    tmp$ret$0 = Unit_getInstance();
  };
  function Companion_24() {
    Companion_instance_24 = this;
  }
  protoOf(Companion_24).d5q = function (bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return new ImageFrame(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  };
  protoOf(Companion_24).r5n = function (bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance_7().ej(0.0);
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.d5q(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.d5q.call(this, bitmap, new TimeSpan(time), targetX, targetY, main, includeInAtlas, name, index);
  };
  var Companion_instance_24;
  function Companion_getInstance_44() {
    if (Companion_instance_24 == null)
      new Companion_24();
    return Companion_instance_24;
  }
  function ImageFrame(index, time, layerData) {
    Companion_getInstance_44();
    var tmp;
    if (time === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance_7().ej(0.0);
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = time;
    }
    time = tmp;
    layerData = layerData === VOID ? emptyList() : layerData;
    this.x5m_1 = index;
    this.y5m_1 = time;
    this.z5m_1 = layerData;
    this.a5n_1 = new Mixin();
    this.b5n_1 = firstOrNull_1(this.z5m_1);
  }
  protoOf(ImageFrame).lu = function (_set____db54di) {
    this.a5n_1.lu(_set____db54di);
  };
  protoOf(ImageFrame).mu = function () {
    return this.a5n_1.mu();
  };
  protoOf(ImageFrame).e5q = function () {
    var tmp0_safe_receiver = this.b5n_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k5n_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp$ret$0;
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
      tmp$ret$0 = get_Bitmaps_transparent();
      tmp = tmp$ret$0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ImageFrame).f5q = function () {
    var tmp0_safe_receiver = this.b5n_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d5n_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ImageFrame).g5q = function () {
    var tmp0_safe_receiver = this.b5n_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e5n_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ImageFrame).u5n = function () {
    var tmp0_safe_receiver = this.b5n_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f5n_1;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(ImageFrame).ck = function () {
    return this.e5q().s3r_1;
  };
  protoOf(ImageFrame).dk = function () {
    return this.e5q().t3r_1;
  };
  protoOf(ImageFrame).t5n = function () {
    var tmp0_safe_receiver = this.b5n_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t5n();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp$ret$0;
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
      tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ImageFrame).qg = function () {
    return this.e5q().n3r_1;
  };
  protoOf(ImageFrame).toString = function () {
    return 'ImageFrame(' + this.e5q() + ', time=' + new TimeSpan(this.y5m_1) + ', targetX=' + this.f5q() + ', targetY=' + this.g5q() + ', main=' + this.u5n() + ')';
  };
  function ImageFrameLayer(layer, slice, targetX, targetY, main, includeInAtlas, tilemap) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    this.c5n_1 = layer;
    this.d5n_1 = targetX;
    this.e5n_1 = targetY;
    this.f5n_1 = main;
    this.g5n_1 = includeInAtlas;
    this.h5n_1 = tilemap;
    this.i5n_1 = null;
    this.j5n_1 = null;
    this.k5n_1 = slice;
  }
  protoOf(ImageFrameLayer).ck = function () {
    return this.k5n_1.s3r_1;
  };
  protoOf(ImageFrameLayer).dk = function () {
    return this.k5n_1.t3r_1;
  };
  protoOf(ImageFrameLayer).t5n = function () {
    if (get_bmp(this.k5n_1).r46_1 === this.ck() ? get_bmp(this.k5n_1).s46_1 === this.dk() : false)
      return get_bmp(this.k5n_1);
    if (this.i5n_1 == null)
      this.i5n_1 = extract_0(this.k5n_1);
    return ensureNotNull(this.i5n_1);
  };
  function ImageInfo() {
    this.l5p_1 = new Mixin();
    this.m5p_1 = 0;
    this.n5p_1 = 0;
    this.o5p_1 = 8;
  }
  protoOf(ImageInfo).lu = function (_set____db54di) {
    this.l5p_1.lu(_set____db54di);
  };
  protoOf(ImageInfo).mu = function () {
    return this.l5p_1.mu();
  };
  protoOf(ImageInfo).toString = function () {
    var tmp = this.m5p_1;
    var tmp_0 = this.n5p_1;
    var tmp_1 = this.o5p_1;
    var tmp0_safe_receiver = this.mu();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + (tmp0_safe_receiver == null ? null : toMap_0(tmp0_safe_receiver)) + ')';
  };
  var Type_NORMAL_instance;
  var Type_GROUP_instance;
  var Type_TILEMAP_instance;
  function Companion_25() {
    Companion_instance_25 = this;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp.h5q_1 = tmp$ret$2;
  }
  var Companion_instance_25;
  function Companion_getInstance_45() {
    Type_initEntries();
    if (Companion_instance_25 == null)
      new Companion_25();
    return Companion_instance_25;
  }
  var Type_entriesInitialized;
  function Type_initEntries() {
    if (Type_entriesInitialized)
      return Unit_getInstance();
    Type_entriesInitialized = true;
    Type_NORMAL_instance = new Type('NORMAL', 0);
    Type_GROUP_instance = new Type('GROUP', 1);
    Type_TILEMAP_instance = new Type('TILEMAP', 2);
    Companion_getInstance_45();
  }
  function Type(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Type_NORMAL_getInstance() {
    Type_initEntries();
    return Type_NORMAL_instance;
  }
  function Type_GROUP_getInstance() {
    Type_initEntries();
    return Type_GROUP_instance;
  }
  function Type_TILEMAP_getInstance() {
    Type_initEntries();
    return Type_TILEMAP_instance;
  }
  function ImageLayer(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.u5m_1 = index;
    this.v5m_1 = name;
    this.w5m_1 = type;
  }
  function set_orientation(_this__u8e3s4, _set____db54di) {
    _init_properties_ImageOrientation_kt__rodtsl();
    var tmp0_setValue = orientation$factory();
    var tmp0_elvis_lhs = orientation$delegate.nu_1;
    var tmp = tmp0_elvis_lhs == null ? tmp0_setValue.callableName : tmp0_elvis_lhs;
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.fastCastTo' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = _set____db54di;
    tmp$ret$0 = tmp_0 == null ? null : new SliceOrientation(tmp_0);
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return setExtra(_this__u8e3s4, tmp, tmp$ret$2);
  }
  function get_orientation(_this__u8e3s4) {
    _init_properties_ImageOrientation_kt__rodtsl();
    var tmp$ret$8;
    $l$block: {
      // Inline function 'korlibs.datastructure.Property.getValue' call
      var tmp2_getValue = orientation$factory_0();
      var tmp$ret$4;
      // Inline function 'korlibs.datastructure.fastCastTo' call
      var tmp1_safe_receiver = _this__u8e3s4.mu();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        // Inline function 'korlibs.datastructure.get' call
        var tmp0_elvis_lhs = orientation$delegate.nu_1;
        var tmp0_get = tmp0_elvis_lhs == null ? tmp2_getValue.callableName : tmp0_elvis_lhs;
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp1_safe_receiver;
        tmp$ret$1 = tmp$ret$0.get(tmp0_get);
        tmp = tmp$ret$1;
      }
      var tmp1_fastCastTo = tmp;
      var tmp$ret$3;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$2;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$2 = tmp1_fastCastTo;
      tmp$ret$3 = tmp$ret$2;
      tmp$ret$4 = tmp$ret$3;
      var res = tmp$ret$4;
      if (res == null) {
        var r = orientation$delegate.ou_1();
        var tmp_0;
        if (!(r == null)) {
          tmp_0 = true;
        } else {
          var tmp2_elvis_lhs = orientation$delegate.nu_1;
          tmp_0 = hasExtra(_this__u8e3s4, tmp2_elvis_lhs == null ? tmp2_getValue.callableName : tmp2_elvis_lhs);
        }
        if (tmp_0) {
          // Inline function 'korlibs.datastructure.Property.setValue' call
          var tmp0_elvis_lhs_0 = orientation$delegate.nu_1;
          var tmp_1 = tmp0_elvis_lhs_0 == null ? tmp2_getValue.callableName : tmp0_elvis_lhs_0;
          var tmp$ret$7;
          // Inline function 'korlibs.datastructure.fastCastTo' call
          var tmp$ret$6;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$5;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$5 = r;
          tmp$ret$6 = tmp$ret$5;
          tmp$ret$7 = tmp$ret$6;
          setExtra(_this__u8e3s4, tmp_1, tmp$ret$7);
        }
        var tmp_2 = r;
        tmp$ret$8 = tmp_2 == null ? null : tmp_2.y3t_1;
        break $l$block;
      }
      var tmp_3 = res;
      tmp$ret$8 = tmp_3 == null ? null : tmp_3.y3t_1;
    }
    return tmp$ret$8;
  }
  var orientation$delegate;
  function orientation$delegate$lambda() {
    _init_properties_ImageOrientation_kt__rodtsl();
    return null;
  }
  function orientation$factory() {
    return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
      var tmp = get_orientation(receiver);
      return tmp == null ? null : new SliceOrientation(tmp);
    }, function (receiver, value) {
      var tmp = value;
      return set_orientation(receiver, tmp == null ? null : tmp.y3t_1);
    });
  }
  function orientation$factory_0() {
    return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
      var tmp = get_orientation(receiver);
      return tmp == null ? null : new SliceOrientation(tmp);
    }, function (receiver, value) {
      var tmp = value;
      return set_orientation(receiver, tmp == null ? null : tmp.y3t_1);
    });
  }
  var properties_initialized_ImageOrientation_kt_37wzbr;
  function _init_properties_ImageOrientation_kt__rodtsl() {
    if (properties_initialized_ImageOrientation_kt_37wzbr) {
    } else {
      properties_initialized_ImageOrientation_kt_37wzbr = true;
      orientation$delegate = new Property(VOID, orientation$delegate$lambda);
    }
  }
  function get_imageLoadingLogger() {
    _init_properties_KorioExt_kt__tiega5();
    return imageLoadingLogger;
  }
  var imageLoadingLogger;
  function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
    name = name === VOID ? null : name;
    atlas = atlas === VOID ? null : atlas;
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    var tmp = new $readBitmapSliceCOROUTINE$25(_this__u8e3s4, name, atlas, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function readBitmap(_this__u8e3s4, props, $completion) {
    props = props === VOID ? new ImageDecodingProps('file.bin') : props;
    var tmp = new $readBitmapCOROUTINE$26(_this__u8e3s4, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function readBitmap_0(_this__u8e3s4, format, $completion) {
    var tmp0 = readBitmap_1(_this__u8e3s4, toProps(format), $completion);
    return tmp0;
  }
  function readBitmap_1(_this__u8e3s4, props, $completion) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    var tmp0 = _readBitmap(_this__u8e3s4, VOID, props, $completion);
    return tmp0;
  }
  function _readBitmap(file, bytes, props, $completion) {
    file = file === VOID ? null : file;
    bytes = bytes === VOID ? null : bytes;
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    var tmp = new $_readBitmapCOROUTINE$27(file, bytes, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function $readBitmapSliceCOROUTINE$25(_this__u8e3s4, name, atlas, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q5q_1 = _this__u8e3s4;
    this.r5q_1 = name;
    this.s5q_1 = atlas;
    this.t5q_1 = props;
  }
  protoOf($readBitmapSliceCOROUTINE$25).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = readBitmap_1(this.q5q_1, this.t5q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            return !(this.s5q_1 == null) ? this.s5q_1.p46(result.c4f(), Unit_getInstance(), this.r5q_1).b46_1 : slice(result);
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $readBitmapCOROUTINE$26(_this__u8e3s4, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c5r_1 = _this__u8e3s4;
    this.d5r_1 = props;
  }
  protoOf($readBitmapCOROUTINE$26).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.hh_1 = 1;
            suspendResult = readAll(this.c5r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.e5r_1 = suspendResult;
            this.hh_1 = 2;
            suspendResult = _readBitmap(VOID, this.e5r_1, this.d5r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $_readBitmapCOROUTINE$27(file, bytes, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n5r_1 = file;
    this.o5r_1 = bytes;
    this.p5r_1 = props;
  }
  protoOf($_readBitmapCOROUTINE$27).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 8;
            this.q5r_1 = !(this.n5r_1 == null) ? this.p5r_1.w5o(get_baseName(this.n5r_1)) : this.p5r_1;
            this.r5r_1 = !this.q5r_1.q5o_1 ? listOf(this.q5r_1.r5o_1) : this.q5r_1.r5o_1 == null ? listOf(null) : this.q5r_1.p5o_1 ? listOf_0([this.q5r_1.r5o_1, null]) : listOf_0([null, this.q5r_1.r5o_1]);
            this.s5r_1 = null;
            this.t5r_1 = this.r5r_1.g();
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (!this.t5r_1.h()) {
              this.hh_1 = 7;
              continue $sm;
            }

            this.u5r_1 = this.t5r_1.i();
            this.ih_1 = 5;
            var tmp_0 = this;
            var tmp1_elvis_lhs = this.u5r_1;
            tmp_0.v5r_1 = tmp1_elvis_lhs == null ? get_nativeImageFormatProvider() : tmp1_elvis_lhs;
            if (!(this.o5r_1 == null)) {
              this.hh_1 = 3;
              suspendResult = this.v5r_1.s5p(this.o5r_1, this.q5r_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(this.n5r_1 == null)) {
                this.hh_1 = 2;
                suspendResult = this.v5r_1.t5p(this.n5r_1, this.q5r_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_1 = this;
                throw new NotImplementedError();
              }
            }

            break;
          case 2:
            this.w5r_1 = suspendResult;
            this.hh_1 = 4;
            continue $sm;
          case 3:
            this.w5r_1 = suspendResult;
            this.hh_1 = 4;
            continue $sm;
          case 4:
            var bmp = this.w5r_1;
            if (this.q5r_1.m5o_1) {
              asumePremultiplied(bmp);
            }

            return bmp;
          case 5:
            this.ih_1 = 8;
            var tmp_2 = this.kh_1;
            if (tmp_2 instanceof Error) {
              var e = this.kh_1;
              this.s5r_1 = e;
              var tmp2_subject = e;
              if (tmp2_subject instanceof CancellationException)
                throw e;
              else {
                var tmp_3;
                if (tmp2_subject instanceof FileNotFoundException) {
                  tmp_3 = true;
                } else {
                  tmp_3 = tmp2_subject instanceof ImageDecoderNotFoundException;
                }
                if (tmp_3)
                ;
                else {
                  var tmp1_info = get_imageLoadingLogger();
                  var tmp0_log = Level_INFO_getInstance();
                  if (tmp1_info.zz(tmp0_log)) {
                    tmp1_info.a10(tmp0_log, e);
                  }
                }
              }
              this.hh_1 = 6;
              continue $sm;
            } else {
              throw this.kh_1;
            }

            break;
          case 6:
            this.ih_1 = 8;
            this.hh_1 = 1;
            continue $sm;
          case 7:
            throw ensureNotNull(this.s5r_1);
          case 8:
            throw this.kh_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.ih_1 === 8) {
          throw e_0;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e_0;
        }
      }
     while (true);
  };
  var properties_initialized_KorioExt_kt_kjvlu9;
  function _init_properties_KorioExt_kt__tiega5() {
    if (properties_initialized_KorioExt_kt_kjvlu9) {
    } else {
      properties_initialized_KorioExt_kt_kjvlu9 = true;
      imageLoadingLogger = Companion_getInstance_11().kz('ImageLoading');
    }
  }
  function $decodeInternalCOROUTINE$29(_this__u8e3s4, vfs, path, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f5s_1 = _this__u8e3s4;
    this.g5s_1 = vfs;
    this.h5s_1 = path;
    this.i5s_1 = props;
  }
  protoOf($decodeInternalCOROUTINE$29).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.hh_1 = 1;
            suspendResult = this.g5s_1.i1v(this.h5s_1).y1y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.j5s_1 = suspendResult;
            this.hh_1 = 2;
            suspendResult = this.f5s_1.k5s(this.j5s_1, this.i5s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $decodeSuspendCOROUTINE$33(_this__u8e3s4, data, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t5s_1 = _this__u8e3s4;
    this.u5s_1 = data;
    this.v5s_1 = props;
  }
  protoOf($decodeSuspendCOROUTINE$33).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.t5s_1.k5s(this.u5s_1, this.v5s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.w5s_1;
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $decodeCOROUTINE$34(_this__u8e3s4, file, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h5t_1 = _this__u8e3s4;
    this.i5t_1 = file;
    this.j5t_1 = props;
  }
  protoOf($decodeCOROUTINE$34).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.h5t_1.k5t(this.i5t_1.f1z(), this.i5t_1.g1z(), this.j5t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.w5s_1;
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $decodeCOROUTINE$35(_this__u8e3s4, file, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t5t_1 = _this__u8e3s4;
    this.u5t_1 = file;
    this.v5t_1 = props;
  }
  protoOf($decodeCOROUTINE$35).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.hh_1 = 1;
            suspendResult = this.u5t_1.j1t(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.w5t_1 = suspendResult;
            this.hh_1 = 2;
            suspendResult = this.t5t_1.x5t(this.w5t_1, this.v5t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function NativeImageFormatProvider() {
  }
  protoOf(NativeImageFormatProvider).k5t = function (vfs, path, props, $completion) {
    var tmp = new $decodeInternalCOROUTINE$29(this, vfs, path, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(NativeImageFormatProvider).y5t = function (data, props, $completion) {
    var tmp = new $decodeSuspendCOROUTINE$33(this, data, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(NativeImageFormatProvider).s5p = function (data, props, $completion) {
    return this.y5t(data, props, $completion);
  };
  protoOf(NativeImageFormatProvider).x5t = function (file, props, $completion) {
    var tmp = new $decodeCOROUTINE$34(this, file, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(NativeImageFormatProvider).t5p = function (file, props, $completion) {
    var tmp = new $decodeCOROUTINE$35(this, file, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(NativeImageFormatProvider).o4l = function (bmp) {
    var tmp$ret$2;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = this.p4l(bmp.r46_1, bmp.s46_1, bmp.y46_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    var tmp$ret$1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var tmp0_lock = tmp0_apply.w46_1;
    {
      tmp0_apply.f47();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = tmp0_apply.b4f(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.z5t(bmp, Companion_getInstance_0().h3b_1);
      }finally {
        ctx.p13();
      }
    }finally {
      result = tmp0_apply.x47(tmp0_lock);
    }
    tmp$ret$0 = result;
    tmp$ret$1 = tmp0_apply;
    tmp$ret$2 = tmp0_apply;
    return tmp$ret$2;
  };
  function BaseNativeImageFormatProvider() {
    NativeImageFormatProvider.call(this);
  }
  protoOf(BaseNativeImageFormatProvider).y5p = function () {
    return get_RegisteredImageFormats();
  };
  protoOf(BaseNativeImageFormatProvider).k5s = function (data, props, $completion) {
    return this.a5u(this.y5p().r5p(data, props), props);
  };
  protoOf(BaseNativeImageFormatProvider).b5u = function (bmp) {
    return BitmapNativeImage_init_$Create$(bmp);
  };
  protoOf(BaseNativeImageFormatProvider).a5u = function (bmp, props) {
    var bmp32 = bmp.c4f();
    return new NativeImageResult(this.b5u(props.m5o_1 ? asumePremultiplied(bmp32) : props.u5o() ? bmp32.z4h() : bmp32.a4i()));
  };
  protoOf(BaseNativeImageFormatProvider).p4l = function (width, height, premultiplied) {
    var tmp0_elvis_lhs = premultiplied;
    return this.b5u(new Bitmap32(width, height, VOID, tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs));
  };
  protoOf(BaseNativeImageFormatProvider).o4l = function (bmp) {
    return this.b5u(bmp);
  };
  function NativeImageResult(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.r46_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.s46_1 : originalHeight;
    this.w5s_1 = image;
    this.x5s_1 = originalWidth;
    this.y5s_1 = originalHeight;
  }
  protoOf(NativeImageResult).toString = function () {
    return 'NativeImageResult(image=' + this.w5s_1 + ', originalWidth=' + this.x5s_1 + ', originalHeight=' + this.y5s_1 + ')';
  };
  protoOf(NativeImageResult).hashCode = function () {
    var result = hashCode(this.w5s_1);
    result = imul(result, 31) + this.x5s_1 | 0;
    result = imul(result, 31) + this.y5s_1 | 0;
    return result;
  };
  protoOf(NativeImageResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.w5s_1, tmp0_other_with_cast.w5s_1))
      return false;
    if (!(this.x5s_1 === tmp0_other_with_cast.x5s_1))
      return false;
    if (!(this.y5s_1 === tmp0_other_with_cast.y5s_1))
      return false;
    return true;
  };
  function BitmapNativeImage_init_$Init$(bitmap, $this) {
    BitmapNativeImage.call($this, bitmap.c4f());
    return $this;
  }
  function BitmapNativeImage_init_$Create$(bitmap) {
    return BitmapNativeImage_init_$Init$(bitmap, objectCreate(protoOf(BitmapNativeImage)));
  }
  function BitmapNativeImage(bitmap) {
    NativeImage.call(this, bitmap.r46_1, bitmap.s46_1, bitmap, bitmap.y46_1);
    this.q5u_1 = bitmap;
    this.r5u_1 = this.q5u_1.t47_1;
  }
  protoOf(BitmapNativeImage).qg = function () {
    return 'BitmapNativeImage';
  };
  protoOf(BitmapNativeImage).b4f = function (antialiasing) {
    return this.q5u_1.b4f(antialiasing);
  };
  protoOf(BitmapNativeImage).e47 = function () {
    return this.q5u_1;
  };
  protoOf(BitmapNativeImage).e48 = function (x, y, width, height, out, offset) {
    return this.q5u_1.e48(x, y, width, height, out, offset);
  };
  protoOf(BitmapNativeImage).g48 = function (x, y, width, height, out, offset) {
    return this.q5u_1.g48(x, y, width, height, out, offset);
  };
  protoOf(BitmapNativeImage).h48 = function (x, y, v) {
    return this.q5u_1.h48(x, y, v);
  };
  protoOf(BitmapNativeImage).f48 = function (x, y) {
    return this.q5u_1.f48(x, y);
  };
  var Colorspace_GRAYSCALE_instance;
  var Colorspace_RGB_instance;
  var Colorspace_INDEXED_instance;
  var Colorspace_GRAYSCALE_ALPHA_instance;
  var Colorspace_RGBA_instance;
  function Companion_26() {
    Companion_instance_26 = this;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.associateBy' call
    var tmp1_associateBy = values_5();
    var capacity = coerceAtLeast(mapCapacity(tmp1_associateBy.length), 16);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_associateByTo = LinkedHashMap_init_$Create$(capacity);
    var indexedObject = tmp1_associateBy;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      tmp$ret$0 = element.u5u_1;
      tmp0_associateByTo.x3(tmp$ret$0, element);
    }
    tmp$ret$1 = tmp0_associateByTo;
    tmp$ret$2 = tmp$ret$1;
    tmp.w5u_1 = tmp$ret$2;
  }
  var Companion_instance_26;
  function Companion_getInstance_46() {
    Colorspace_initEntries();
    if (Companion_instance_26 == null)
      new Companion_26();
    return Companion_instance_26;
  }
  function values_5() {
    return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
  }
  var Colorspace_entriesInitialized;
  function Colorspace_initEntries() {
    if (Colorspace_entriesInitialized)
      return Unit_getInstance();
    Colorspace_entriesInitialized = true;
    Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
    Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
    Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
    Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
    Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
    Companion_getInstance_46();
  }
  function InterlacedPass(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.x5u_1 = startingRow;
    this.y5u_1 = startingCol;
    this.z5u_1 = rowIncrement;
    this.a5v_1 = colIncrement;
    this.b5v_1 = blockHeight;
    this.c5v_1 = blockWidth;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.math.log2' call
    var tmp0_log2 = this.a5v_1;
    tmp$ret$0 = log2(tmp0_log2);
    tmp.d5v_1 = numberToInt(tmp$ret$0);
  }
  protoOf(InterlacedPass).toString = function () {
    return 'InterlacedPass(startingRow=' + this.x5u_1 + ', startingCol=' + this.y5u_1 + ', rowIncrement=' + this.z5u_1 + ', colIncrement=' + this.a5v_1 + ', blockHeight=' + this.b5v_1 + ', blockWidth=' + this.c5v_1 + ')';
  };
  protoOf(InterlacedPass).hashCode = function () {
    var result = this.x5u_1;
    result = imul(result, 31) + this.y5u_1 | 0;
    result = imul(result, 31) + this.z5u_1 | 0;
    result = imul(result, 31) + this.a5v_1 | 0;
    result = imul(result, 31) + this.b5v_1 | 0;
    result = imul(result, 31) + this.c5v_1 | 0;
    return result;
  };
  protoOf(InterlacedPass).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.x5u_1 === tmp0_other_with_cast.x5u_1))
      return false;
    if (!(this.y5u_1 === tmp0_other_with_cast.y5u_1))
      return false;
    if (!(this.z5u_1 === tmp0_other_with_cast.z5u_1))
      return false;
    if (!(this.a5v_1 === tmp0_other_with_cast.a5v_1))
      return false;
    if (!(this.b5v_1 === tmp0_other_with_cast.b5v_1))
      return false;
    if (!(this.c5v_1 === tmp0_other_with_cast.c5v_1))
      return false;
    return true;
  };
  function Colorspace(name, ordinal, id, nchannels) {
    Enum.call(this, name, ordinal);
    this.u5u_1 = id;
    this.v5u_1 = nchannels;
  }
  function Header(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.e5v_1 = width;
    this.f5v_1 = height;
    this.g5v_1 = bitsPerChannel;
    this.h5v_1 = colorspace;
    this.i5v_1 = compressionmethod;
    this.j5v_1 = filtermethod;
    this.k5v_1 = interlacemethod;
    var tmp = this;
    var tmp0_subject = this.h5v_1;
    var tmp0 = tmp0_subject.j5_1;
    var tmp_0;
    switch (tmp0) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.l5v_1 = tmp_0;
    this.m5v_1 = imul(imul(this.e5v_1, this.l5v_1), this.g5v_1) / 8 | 0;
  }
  function readCommon($this, s, readHeader, info) {
    var magic = readS32BE_0(s);
    if (!(magic === -1991225785))
      throw IllegalArgumentException_init_$Create$('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
    readS32BE_0(s);
    var pheader = {_v: null};
    var pngdata = ByteArrayBuilder_init_$Create$();
    var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
    var tmp = 0;
    var tmp_0 = 256;
    var tmp_1 = new Int8Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp$ret$0;
      // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
      tmp$ret$0 = -1;
      tmp_1[tmp_2] = tmp$ret$0;
      tmp = tmp + 1 | 0;
    }
    var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_1);
    var paletteCount = {_v: 0};
    while (!get_eof(s) ? readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata) : false)
    ;
    if (readHeader)
      return pheader._v;
    var tmp0_elvis_lhs = pheader._v;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('PNG without header!');
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var header = tmp_3;
    var width = header.e5v_1;
    var height = header.f5v_1;
    var outputSizeHint = imul(imul(1 + width | 0, height), header.l5v_1);
    var databb = uncompress(pngdata.mv(), Companion_getInstance_8());
    var databbp = 0;
    var context = new DecodingContext(header);
    var bpp = context.n5v_1.l5v_1;
    var row32 = context.q5v_1;
    var tmp_4;
    if (header.l5v_1 === 1) {
      var tmp$ret$3;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = until(0, paletteCount._v);
      var tmp$ret$2;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var inductionVariable = tmp1_map.a1_1;
      var last = tmp1_map.b1_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$1;
          // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
          tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_28().g4m(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, item)));
          tmp0_mapTo.b(tmp$ret$1);
        }
         while (!(item === last));
      tmp$ret$2 = tmp0_mapTo;
      tmp$ret$3 = tmp$ret$2;
      tmp_4 = new Bitmap8(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray_0(tmp$ret$3)));
    } else {
      tmp_4 = new Bitmap32(width, height, VOID, false);
    }
    var bmp = tmp_4;
    var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
    var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
    var tmp1_subject = header.k5v_1;
    var passes = tmp1_subject === 1 ? $this.u5v_1 : $this.v5v_1;
    var tmp2_iterator = passes.g();
    while (tmp2_iterator.h()) {
      var pass = tmp2_iterator.i();
      var progression = step(until(pass.x5u_1, height), pass.z5u_1);
      var inductionVariable_0 = progression.a1_1;
      var last_0 = progression.b1_1;
      var step_0 = progression.c1_1;
      if ((step_0 > 0 ? inductionVariable_0 <= last_0 : false) ? true : step_0 < 0 ? last_0 <= inductionVariable_0 : false)
        do {
          var row = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          var col = pass.y5u_1;
          var colIncrement = pass.a5v_1;
          var pixelsInThisRow = width >>> pass.d5v_1 | 0;
          var bytesInThisRow = imul(imul(pixelsInThisRow, header.l5v_1), header.g5v_1) / 8 | 0;
          var tmp4 = databbp;
          databbp = tmp4 + 1 | 0;
          var filter = databb[tmp4] & 255;
          var currentRow = context.p5v_1;
          var lastRow = context.o5v_1;
          arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
          databbp = databbp + bytesInThisRow | 0;
          if (!(bmp8 == null)) {
            $this.x5v(filter, lastRow, currentRow, header.l5v_1);
            var tmp5_subject = header.g5v_1;
            switch (tmp5_subject) {
              case 1:
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < width)
                  do {
                    var n = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var tmp$ret$4;
                    // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                    var tmp2_set = bmp;
                    var tmp3_set = col + n | 0;
                    var tmp4_set = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n / 8 | 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                    tmp2_set.b4e(tmp3_set, row, tmp4_set);
                    tmp$ret$4 = Unit_getInstance();
                  }
                   while (inductionVariable_1 < width);
                break;
              case 2:
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < width)
                  do {
                    var n_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var tmp$ret$5;
                    // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                    var tmp5_set = bmp;
                    var tmp6_set = col + n_0 | 0;
                    var tmp7_set = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n_0 / 4 | 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                    tmp5_set.b4e(tmp6_set, row, tmp7_set);
                    tmp$ret$5 = Unit_getInstance();
                  }
                   while (inductionVariable_2 < width);
                break;
              case 4:
                var inductionVariable_3 = 0;
                if (inductionVariable_3 < width)
                  do {
                    var n_1 = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var tmp$ret$6;
                    // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                    var tmp8_set = bmp;
                    var tmp9_set = col + n_1 | 0;
                    var tmp10_set = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n_1 / 2 | 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                    tmp8_set.b4e(tmp9_set, row, tmp10_set);
                    tmp$ret$6 = Unit_getInstance();
                  }
                   while (inductionVariable_3 < width);
                break;
              case 8:
                bmp8.g4j(col, row, asByteArray(currentRow), width, colIncrement);
                ;
                break;
              default:
                // Inline function 'kotlin.error' call

                var tmp11_error = 'Unsupported header.bitsPerChannel=' + header.g5v_1;
                throw IllegalStateException_init_$Create$(toString(tmp11_error));
            }
          } else if (!(bmp32 == null)) {
            var tmp9_subject = header.g5v_1;
            if (tmp9_subject === 8) {
              $this.w5v(filter, lastRow, currentRow, bpp, bytesInThisRow);
              var tmp10_subject = bpp;
              switch (tmp10_subject) {
                case 3:
                  decode(Companion_getInstance_26(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                  ;
                  break;
                case 4:
                  decode(Companion_getInstance_28(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                  ;
                  break;
                default:
                  // Inline function 'kotlin.TODO' call

                  var tmp12_TODO = 'Bytes: ' + bpp;
                  throw new NotImplementedError('An operation is not implemented: ' + tmp12_TODO);
              }
              bmp32.e4i(col, row, row32, width, colIncrement);
            } else {
              // Inline function 'kotlin.error' call
              var tmp13_error = 'Unsupported header.bitsPerChannel=' + header.g5v_1;
              throw IllegalStateException_init_$Create$(toString(tmp13_error));
            }
          }
          context.y5v();
        }
         while (!(row === last_0));
    }
    return bmp;
  }
  function readCommon$default($this, s, readHeader, info, $super) {
    info = info === VOID ? new ImageInfo() : info;
    return readCommon($this, s, readHeader, info);
  }
  function DecodingContext(header) {
    this.n5v_1 = header;
    this.o5v_1 = _UByteArrayInt___init__impl__xif7bu_0(this.n5v_1.m5v_1);
    this.p5v_1 = _UByteArrayInt___init__impl__xif7bu_0(this.n5v_1.m5v_1);
    this.q5v_1 = Companion_getInstance_27().g4i(this.n5v_1.e5v_1);
  }
  protoOf(DecodingContext).y5v = function () {
    var temp = this.p5v_1;
    this.p5v_1 = this.o5v_1;
    this.o5v_1 = temp;
  };
  function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
    if (get_eof(_this__u8e3s4))
      return false;
    var length = readS32BE_0(_this__u8e3s4);
    var type = readStringz_0(_this__u8e3s4, 4);
    var data = readStream(_this__u8e3s4, toLong(length));
    var crc = readS32BE_0(_this__u8e3s4);
    var tmp0_subject = type;
    switch (tmp0_subject) {
      case 'IHDR':
        var tmp$ret$2;
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$1;
        // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call
        var tmp$ret$0;
        // Inline function 'kotlin.also' call
        var tmp = readS32BE_0(data);
        var tmp_0 = readS32BE_0(data);
        var tmp_1 = readU8_0(data);
        var tmp0_elvis_lhs = Companion_getInstance_46().w5u_1.z1(readU8_0(data));
        var tmp0_also = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8_0(data), readU8_0(data), readU8_0(data));
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call
        $info.m5p_1 = tmp0_also.e5v_1;
        $info.n5p_1 = tmp0_also.f5v_1;
        $info.o5p_1 = imul(tmp0_also.g5v_1, tmp0_also.h5v_1.v5u_1);
        tmp$ret$0 = tmp0_also;
        tmp$ret$1 = tmp$ret$0;
        tmp$ret$2 = tmp$ret$1;

        pheader._v = tmp$ret$2;
        ;
        break;
      case 'PLTE':
        var tmp$ret$3;
        // Inline function 'kotlin.math.max' call
        var tmp0_max = paletteCount._v;
        var tmp1_max = data.x9().e1() / 3 | 0;
        tmp$ret$3 = Math.max(tmp0_max, tmp1_max);

        paletteCount._v = tmp$ret$3;
        data.gu(asByteArray(rgbPalette), 0, data.x9().e1());
        ;
        break;
      case 'tRNS':
        var tmp$ret$4;
        // Inline function 'kotlin.math.max' call
        var tmp2_max = paletteCount._v;
        var tmp3_max = data.x9().e1();
        tmp$ret$4 = Math.max(tmp2_max, tmp3_max);

        paletteCount._v = tmp$ret$4;
        data.gu(asByteArray(aPalette), 0, data.x9().e1());
        ;
        break;
      case 'IDAT':
        if ($readHeader) {
          return false;
        }

        pngdata.kv(readAll_0(data));
        ;
        break;
      case 'eXIf':
        runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info, null));
        ;
        break;
      case 'IEND':
        return false;
    }
    return true;
  }
  function PNG$readCommon$readChunk$slambda($data, $info, resultContinuation) {
    this.h5w_1 = $data;
    this.i5w_1 = $info;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PNG$readCommon$readChunk$slambda).j5w = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(PNG$readCommon$readChunk$slambda).ai = function ($completion) {
    return this.j5w($completion);
  };
  protoOf(PNG$readCommon$readChunk$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = EXIF_getInstance().s5m(openAsync(readAll_0(this.h5w_1)), this.i5w_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(PNG$readCommon$readChunk$slambda).n1f = function (completion) {
    var i = new PNG$readCommon$readChunk$slambda(this.h5w_1, this.i5w_1, completion);
    return i;
  };
  function PNG$readCommon$readChunk$slambda_0($data, $info, resultContinuation) {
    var i = new PNG$readCommon$readChunk$slambda($data, $info, resultContinuation);
    var l = function ($completion) {
      return i.j5w($completion);
    };
    l.$arity = 0;
    return l;
  }
  function Colorspace_GRAYSCALE_getInstance() {
    Colorspace_initEntries();
    return Colorspace_GRAYSCALE_instance;
  }
  function Colorspace_RGB_getInstance() {
    Colorspace_initEntries();
    return Colorspace_RGB_instance;
  }
  function Colorspace_INDEXED_getInstance() {
    Colorspace_initEntries();
    return Colorspace_INDEXED_instance;
  }
  function Colorspace_GRAYSCALE_ALPHA_getInstance() {
    Colorspace_initEntries();
    return Colorspace_GRAYSCALE_ALPHA_instance;
  }
  function Colorspace_RGBA_getInstance() {
    Colorspace_initEntries();
    return Colorspace_RGBA_instance;
  }
  function PNG() {
    PNG_instance = this;
    ImageFormat.call(this, ['png']);
    this.s5v_1 = -1991225785;
    this.t5v_1 = 218765834;
    this.u5v_1 = listOf_0([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    this.v5v_1 = listOf(new InterlacedPass(0, 0, 1, 1, 1, 1));
  }
  protoOf(PNG).k5p = function (s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  protoOf(PNG).j5p = function (s, props) {
    var tmp = Companion_getInstance_42();
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.q5n(tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE());
  };
  protoOf(PNG).k5w = function (a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return (pa <= pb ? pa <= pc : false) ? a : pb <= pc ? b : c;
  };
  protoOf(PNG).w5v = function (filter, p, c, bpp, size) {
    var tmp0_subject = filter;
    switch (tmp0_subject) {
      case 0:
        ;
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp2_array = c;
            var tmp3_index0 = n;
            UByteArrayInt__set_impl_gn4532(tmp2_array, tmp3_index0, UByteArrayInt__get_impl_px6q8a(tmp2_array, tmp3_index0) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp5_array = c;
            var tmp6_index0 = n_0;
            UByteArrayInt__set_impl_gn4532(tmp5_array, tmp6_index0, UByteArrayInt__get_impl_px6q8a(tmp5_array, tmp6_index0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp8_array = c;
            var tmp9_index0 = n_1;
            UByteArrayInt__set_impl_gn4532(tmp8_array, tmp9_index0, UByteArrayInt__get_impl_px6q8a(tmp8_array, tmp9_index0) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var tmp11_array = c;
            var tmp12_index0 = n_2;
            UByteArrayInt__set_impl_gn4532(tmp11_array, tmp12_index0, UByteArrayInt__get_impl_px6q8a(tmp11_array, tmp12_index0) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var tmp14_array = c;
            var tmp15_index0 = n_3;
            UByteArrayInt__set_impl_gn4532(tmp14_array, tmp15_index0, UByteArrayInt__get_impl_px6q8a(tmp14_array, tmp15_index0) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            var tmp17_array = c;
            var tmp18_index0 = n_4;
            UByteArrayInt__set_impl_gn4532(tmp17_array, tmp18_index0, UByteArrayInt__get_impl_px6q8a(tmp17_array, tmp18_index0) + this.k5w(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var tmp0_TODO = 'Filter: ' + filter;
        throw new NotImplementedError('An operation is not implemented: ' + tmp0_TODO);
    }
  };
  protoOf(PNG).x5v = function (filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.w5v(filter, p, c, bpp, size);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.w5v.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  };
  var PNG_instance;
  function PNG_getInstance() {
    if (PNG_instance == null)
      new PNG();
    return PNG_instance;
  }
  function get_RegisteredImageFormats() {
    _init_properties_RegisteredImageFormats_kt__dq34zn();
    return RegisteredImageFormats;
  }
  var RegisteredImageFormats;
  var properties_initialized_RegisteredImageFormats_kt_ribwxx;
  function _init_properties_RegisteredImageFormats_kt__dq34zn() {
    if (properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    } else {
      properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
      RegisteredImageFormats = new ImageFormatsMutable();
    }
  }
  function sumPacked4MulR(a, b, mul) {
    var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
    var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
    var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
    var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
    var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
    var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
    return packIntClamped(r, g, b_0, a_0);
  }
  function f2i(v) {
    return toIntRound_0(clamp01_0(v) * 255);
  }
  function packIntUnchecked(r, g, b, a) {
    return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
  }
  function packIntClamped(r, g, b, a) {
    return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
  }
  function ColorFiller() {
    BaseFiller.call(this);
    this.l5w_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().l48_1);
  }
  protoOf(ColorFiller).m5w = function (fill, state) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.l5w_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    tmp$ret$0 = this;
    return tmp$ret$0;
  };
  protoOf(ColorFiller).n5w = function (x, y) {
    return this.l5w_1;
  };
  protoOf(ColorFiller).o5w = function (data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.l5w_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  };
  function Companion_27() {
    Companion_instance_27 = this;
    this.r5w_1 = 256;
  }
  var Companion_instance_27;
  function Companion_getInstance_47() {
    if (Companion_instance_27 == null)
      new Companion_27();
    return Companion_instance_27;
  }
  function _get_fill__d6ivc8($this) {
    var tmp = $this.t5w_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fill');
    }
  }
  function color($this, ratio) {
    var tmp = clamp01_0(ratio);
    Companion_getInstance_47();
    return RgbaPremultipliedArray__get_impl_1u69ta($this.s5w_1, numberToInt(tmp * (256 - 1 | 0)));
  }
  function GradientFiller() {
    Companion_getInstance_47();
    BaseFiller.call(this);
    var tmp = this;
    var tmp_0 = Companion_getInstance_30();
    Companion_getInstance_47();
    tmp.s5w_1 = tmp_0.k4o(256);
  }
  protoOf(GradientFiller).u5w = function (fill, state) {
    fill.v5w(this.s5w_1);
    this.t5w_1 = fill.w5w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Matrix__preconcated_impl_s9s2ig(Matrix__preconcated_impl_s9s2ig(Companion_getInstance_9().v3f_1, fill.f5g_1), state.g4q_1));
    return this;
  };
  protoOf(GradientFiller).x5w = function (x, y) {
    return _get_fill__d6ivc8(this).y5w(_Vector2___init__impl__67w0ru_0(x, y));
  };
  protoOf(GradientFiller).n5w = function (x, y) {
    return color(this, this.x5w(x, y));
  };
  function _set_texture__qu271y($this, value) {
    $this.e5x_1 = value;
    $this.a5x_1 = $this.e5x_1.r46_1;
    $this.b5x_1 = $this.e5x_1.s46_1;
    $this.c5x_1 = 1.0 / $this.a5x_1;
    $this.d5x_1 = 1.0 / $this.b5x_1;
  }
  function BitmapFiller() {
    BaseFiller.call(this);
    this.z5w_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.a5x_1 = 0.0;
    this.b5x_1 = 0.0;
    this.c5x_1 = 0.0;
    this.d5x_1 = 0.0;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
    tmp$ret$0 = get_Bitmaps_transparent();
    tmp.e5x_1 = get_bmp(tmp$ret$0);
    this.f5x_1 = Companion_getInstance_9().v3f_1;
    this.g5x_1 = true;
    this.h5x_1 = Companion_getInstance_9().v3f_1;
  }
  protoOf(BitmapFiller).i5x = function (fill, state) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.z5w_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.l5x_1, fill.m5x_1);
    _set_texture__qu271y(this, fill.p5x_1);
    this.f5x_1 = fill.k5x_1;
    this.g5x_1 = fill.n5x_1;
    this.h5x_1 = Matrix__inverted_impl_3pqbyv(Matrix__premultiplied_impl_rsndx4(Matrix__premultiplied_impl_rsndx4(Companion_getInstance_9().v3f_1, state.g4q_1), fill.k5x_1));
    tmp$ret$0 = this;
    return tmp$ret$0;
  };
  protoOf(BitmapFiller).q5x = function (x, y) {
    return this.e5x_1.d4e(x, y);
  };
  protoOf(BitmapFiller).r5x = function (x, y) {
    return this.e5x_1.i4h(numberToInt(x), numberToInt(y));
  };
  protoOf(BitmapFiller).n5w = function (x, y) {
    var mat = this.h5x_1;
    var tmp$ret$1;
    // Inline function 'korlibs.math.geom.Vector2.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var tmp0_transform = _Vector2___init__impl__67w0ru_0(x, y);
      if (_Matrix___get_isNIL__impl__n63x5q(mat)) {
        tmp$ret$0 = tmp0_transform;
        break $l$block;
      }
      tmp$ret$0 = _Vector2___init__impl__67w0ru_0(_Matrix___get_a__impl__f7jypo(mat) * _Vector2___get_x__impl__zywdz(tmp0_transform) + _Matrix___get_c__impl__slf2ke(mat) * _Vector2___get_y__impl__ttldg6(tmp0_transform) + _Matrix___get_tx__impl__yc1n9(mat), _Matrix___get_d__impl__87eht(mat) * _Vector2___get_y__impl__ttldg6(tmp0_transform) + _Matrix___get_b__impl__dm2icj(mat) * _Vector2___get_x__impl__zywdz(tmp0_transform) + _Matrix___get_ty__impl__tryipg(mat));
    }
    var tmp1_times = tmp$ret$0;
    var tmp2_times = _Vector2___init__impl__67w0ru_0(this.c5x_1, this.d5x_1);
    tmp$ret$1 = _Vector2___init__impl__67w0ru_0(_Vector2___get_x__impl__zywdz(tmp1_times) * _Vector2___get_x__impl__zywdz(tmp2_times), _Vector2___get_y__impl__ttldg6(tmp1_times) * _Vector2___get_y__impl__ttldg6(tmp2_times));
    var p = tmp$ret$1;
    var tmp$ret$2;
    // Inline function 'korlibs.math.geom.Vector2.times' call
    var tmp3_times = CycleMethodPair__apply_impl_g3sekg(this.z5w_1, p);
    var tmp4_times = _Vector2___init__impl__67w0ru_0(this.a5x_1, this.b5x_1);
    tmp$ret$2 = _Vector2___init__impl__67w0ru_0(_Vector2___get_x__impl__zywdz(tmp3_times) * _Vector2___get_x__impl__zywdz(tmp4_times), _Vector2___get_y__impl__ttldg6(tmp3_times) * _Vector2___get_y__impl__ttldg6(tmp4_times));
    var t = tmp$ret$2;
    return this.g5x_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.q5x(_Vector2___get_x__impl__zywdz(t), _Vector2___get_y__impl__ttldg6(t))) : _RGBA___get_premultiplied__impl__3bulqc(this.r5x(_Vector2___get_x__impl__zywdz(t), _Vector2___get_y__impl__ttldg6(t)));
  };
  function BaseFiller() {
  }
  protoOf(BaseFiller).o5w = function (data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.n5w(n, yFloat));
      }
       while (!(n === x1));
  };
  protoOf(BaseFiller).p5w = function (bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.t47_1);
    var inductionVariable = _RectangleInt___get_top__impl__ie2ifj(rect);
    var last = _RectangleInt___get_bottom__impl__za67bh(rect);
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.r46_1);
        this.o5w(cols, offset, _RectangleInt___get_left__impl__rhzld(rect), _RectangleInt___get_right__impl__9c8zzq(rect) - 1 | 0, y);
      }
       while (inductionVariable < last);
  };
  protoOf(BaseFiller).q5w = function (bmp, rect, $super) {
    rect = rect === VOID ? bmp.v47_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.p5w(bmp, rect);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.p5w.call(this, bmp, new RectangleInt(rect));
    }
    return tmp;
  };
  function NoneFiller() {
    NoneFiller_instance = this;
    BaseFiller.call(this);
  }
  protoOf(NoneFiller).n5w = function (x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  };
  protoOf(NoneFiller).o5w = function (data, offset, x0, x1, y) {
    return Unit_getInstance();
  };
  var NoneFiller_instance;
  function NoneFiller_getInstance() {
    if (NoneFiller_instance == null)
      new NoneFiller();
    return NoneFiller_instance;
  }
  function toFiller(_this__u8e3s4, state) {
    var tmp0_subject = _this__u8e3s4;
    var tmp;
    if (tmp0_subject instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (tmp0_subject instanceof RGBA) {
        var tmp$ret$0;
        // Inline function 'kotlin.also' call
        var tmp0_also = new ColorFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        tmp0_also.m5w(_this__u8e3s4.q4n_1, state);
        tmp$ret$0 = tmp0_also;
        tmp = tmp$ret$0;
      } else {
        if (tmp0_subject instanceof GradientPaint) {
          var tmp$ret$1;
          // Inline function 'kotlin.also' call
          var tmp1_also = new GradientFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          tmp1_also.u5w(_this__u8e3s4, state);
          tmp$ret$1 = tmp1_also;
          tmp = tmp$ret$1;
        } else {
          if (tmp0_subject instanceof BitmapPaint) {
            var tmp$ret$2;
            // Inline function 'kotlin.also' call
            var tmp2_also = new BitmapFiller();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
            tmp2_also.i5x(_this__u8e3s4, state);
            tmp$ret$2 = tmp2_also;
            tmp = tmp$ret$2;
          } else {
            throw new NotImplementedError();
          }
        }
      }
    }
    return tmp;
  }
  function colorInt(_this__u8e3s4, $this, premultiplied) {
    return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
  }
  function _fillColors($this, out, stops, colors, premultiplied) {
    var numberOfStops = stops.j();
    var NCOLORS = out.length;
    var tmp0_subject = numberOfStops;
    switch (tmp0_subject) {
      case 0:
      case 1:
        var color = numberOfStops === 0 ? Colors_getInstance().l4a_1 : _RGBA___init__impl__lqpay5(colors.bo());
        var pcolor = colorInt(color, $this, premultiplied);
        var inductionVariable = 0;
        if (inductionVariable < NCOLORS)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            out[n] = pcolor;
          }
           while (inductionVariable < NCOLORS);
        break;
      default:
        var inductionVariable_0 = 0;
        var last = _fillColors$stopN(stops, NCOLORS, 0);
        if (inductionVariable_0 < last)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.bo()), $this, premultiplied);
          }
           while (inductionVariable_0 < last);
        var inductionVariable_1 = 0;
        var last_0 = numberOfStops - 1 | 0;
        if (inductionVariable_1 < last_0)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
            var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
            var color0 = _RGBA___init__impl__lqpay5(colors.ek(n_1 + 0 | 0));
            var color1 = _RGBA___init__impl__lqpay5(colors.ek(n_1 + 1 | 0));
            var inductionVariable_2 = stop0;
            if (inductionVariable_2 < stop1)
              do {
                var s = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
                out[s] = colorInt(Companion_getInstance_28().f4o(color0, color1, ratio), $this, premultiplied);
              }
               while (inductionVariable_2 < stop1);
          }
           while (inductionVariable_1 < last_0);
        var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
        if (inductionVariable_3 < NCOLORS)
          do {
            var n_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.co()), $this, premultiplied);
          }
           while (inductionVariable_3 < NCOLORS);
        break;
    }
  }
  function _fillColors$stopN($stops, NCOLORS, n) {
    return numberToInt($stops.k(n) * NCOLORS);
  }
  function Companion_28() {
    Companion_instance_28 = this;
  }
  var Companion_instance_28;
  function Companion_getInstance_48() {
    if (Companion_instance_28 == null)
      new Companion_28();
    return Companion_instance_28;
  }
  function colorsToString($this, colors) {
    var tmp = new RgbaArray(colors);
    return '[' + joinToString(tmp, ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
  }
  function colorsToString_0($this, colors) {
    return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.eo()));
  }
  function GradientPaint$colorsToString$lambda(it) {
    return _RGBA___get_hexString__impl__kocngm(it.q4n_1);
  }
  function GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    Companion_getInstance_48();
    stops = stops === VOID ? new DoubleArrayList() : stops;
    colors = colors === VOID ? new IntArrayList() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_9().v3f_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_13().v3a_1 : startAngle;
    this.v5f_1 = kind;
    this.w5f_1 = x0;
    this.x5f_1 = y0;
    this.y5f_1 = r0;
    this.z5f_1 = x1;
    this.a5g_1 = y1;
    this.b5g_1 = r1;
    this.c5g_1 = stops;
    this.d5g_1 = colors;
    this.e5g_1 = cycle;
    this.f5g_1 = transform;
    this.g5g_1 = interpolationMethod;
    this.h5g_1 = units;
    this.i5g_1 = startAngle;
    var tmp = this;
    var tmp_0 = Matrix__scaled$default_impl_qe0yl1(Matrix__translated_impl_3xg5y_1(Companion_getInstance_9().v3f_1, -this.w5f_1, -this.x5f_1), 1.0 / clamp_1(Companion_getInstance_0().a3f(this.w5f_1, this.x5f_1, this.z5f_1, this.a5g_1), 1.0, 16000.0));
    var tmp$ret$0;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var tmp0_between = Companion_getInstance_13();
    var tmp1_between = this.w5f_1;
    var tmp2_between = this.x5f_1;
    var tmp3_between = this.z5f_1;
    var tmp4_between = this.a5g_1;
    tmp$ret$0 = Angle_between(tmp1_between, tmp2_between, tmp3_between, tmp4_between);
    tmp.j5g_1 = Matrix__rotated_impl_2adiit(tmp_0, Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.k5g_1 = Matrix__inverted_impl_3pqbyv(this.f5g_1);
    this.l5g_1 = Matrix__premultiplied_impl_rsndx4(Matrix__premultiplied_impl_rsndx4(Companion_getInstance_9().v3f_1, this.j5g_1), this.k5g_1);
    this.m5g_1 = 2 * this.y5f_1 * this.b5g_1;
    this.n5g_1 = this.s5x(this.y5f_1);
    this.o5g_1 = this.s5x(this.b5g_1);
    this.p5g_1 = this.x5f_1 - this.a5g_1;
    this.q5g_1 = this.y5f_1 - this.b5g_1;
    this.r5g_1 = this.w5f_1 - this.z5f_1;
    this.s5g_1 = 1.0 / (this.s5x(this.y5f_1 - this.b5g_1) - this.s5x(this.w5f_1 - this.z5f_1) - this.s5x(this.x5f_1 - this.a5g_1));
  }
  protoOf(GradientPaint).g51 = function () {
    return this.f5g_1;
  };
  protoOf(GradientPaint).v5w = function (out) {
    return _fillColors(Companion_getInstance_48(), _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.c5g_1, this.d5g_1, true);
  };
  protoOf(GradientPaint).t5g = function (stop, color) {
    return this.t5x(stop, color);
  };
  protoOf(GradientPaint).t5x = function (stop, color) {
    var tmp0_this = this;
    tmp0_this.c5g_1.tm(stop);
    var tmp1_this = this;
    tmp1_this.d5g_1.vn(_RGBA___get_value__impl__hhco8v(color));
    return this;
  };
  protoOf(GradientPaint).y5w = function (p) {
    var tmp0_subject = this.v5f_1;
    var tmp0 = tmp0_subject.j5_1;
    var tmp;
    switch (tmp0) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var tmp0_transform = this.k5g_1;
          if (_Matrix___get_isNIL__impl__n63x5q(tmp0_transform)) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = _Vector2___init__impl__67w0ru_0(_Matrix___get_a__impl__f7jypo(tmp0_transform) * _Vector2___get_x__impl__zywdz(p) + _Matrix___get_c__impl__slf2ke(tmp0_transform) * _Vector2___get_y__impl__ttldg6(p) + _Matrix___get_tx__impl__yc1n9(tmp0_transform), _Matrix___get_d__impl__87eht(tmp0_transform) * _Vector2___get_y__impl__ttldg6(p) + _Matrix___get_b__impl__dm2icj(tmp0_transform) * _Vector2___get_x__impl__zywdz(p) + _Matrix___get_ty__impl__tryipg(tmp0_transform));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_0().o3j(_Vector2___init__impl__67w0ru_1(this.w5f_1, this.x5f_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var tmp1_transform = this.k5g_1;
          if (_Matrix___get_isNIL__impl__n63x5q(tmp1_transform)) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = _Vector2___init__impl__67w0ru_0(_Matrix___get_a__impl__f7jypo(tmp1_transform) * _Vector2___get_x__impl__zywdz(p) + _Matrix___get_c__impl__slf2ke(tmp1_transform) * _Vector2___get_y__impl__ttldg6(p) + _Matrix___get_tx__impl__yc1n9(tmp1_transform), _Matrix___get_d__impl__87eht(tmp1_transform) * _Vector2___get_y__impl__ttldg6(p) + _Matrix___get_b__impl__dm2icj(tmp1_transform) * _Vector2___get_x__impl__zywdz(p) + _Matrix___get_ty__impl__tryipg(tmp1_transform));
        }

        var tmp1_container = tmp$ret$1;
        var x = Vector2__component1_impl_k3h45m(tmp1_container);
        var y = Vector2__component2_impl_kkiqjt(tmp1_container);
        var tmp_0 = -this.b5g_1 * this.q5g_1 + this.r5g_1 * (this.z5f_1 - x) + this.p5g_1 * (this.a5g_1 - y);
        var tmp$ret$2;
        // Inline function 'kotlin.math.sqrt' call
        var tmp2_sqrt = this.o5g_1 * (this.s5x(this.w5f_1 - x) + this.s5x(this.x5f_1 - y)) - this.m5g_1 * ((this.w5f_1 - x) * (this.z5f_1 - x) + (this.x5f_1 - y) * (this.a5g_1 - y)) + this.n5g_1 * (this.s5x(this.z5f_1 - x) + this.s5x(this.a5g_1 - y)) - this.s5x(this.z5f_1 * this.x5f_1 - x * this.x5f_1 - this.w5f_1 * this.a5g_1 + x * this.a5g_1 + this.w5f_1 * y - this.z5f_1 * y);
        tmp$ret$2 = Math.sqrt(tmp2_sqrt);

        tmp = 1.0 - (tmp_0 - tmp$ret$2) * this.s5g_1;
        break;
      default:
        tmp = Matrix__transformX_impl_adb2o0(this.l5g_1, p);
        break;
    }
    return this.e5g_1.w5x(tmp);
  };
  protoOf(GradientPaint).s5x = function (_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  };
  protoOf(GradientPaint).dn = function () {
    return this.w5w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.f5g_1);
  };
  protoOf(GradientPaint).toString = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp0_subject = this.v5f_1;
    var tmp0 = tmp0_subject.j5_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = 'LinearGradient([' + this.w5f_1 + ', ' + this.x5f_1 + '], [' + this.z5f_1 + ', ' + this.a5g_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.w5f_1 + ', ' + this.x5f_1 + ', ' + this.y5f_1 + '], [' + this.z5f_1 + ', ' + this.a5g_1 + ', ' + this.b5g_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.w5f_1 + ', ' + this.x5f_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp0_apply.ve(tmp);
    tmp0_apply.ve(', stops=' + this.c5g_1 + ', colors=' + colorsToString_0(this, this.d5g_1) + ', cycle=' + this.e5g_1 + ', transform=' + new Matrix(this.f5g_1) + ', interpolationMethod=' + this.g5g_1 + ', units=' + this.h5g_1 + ')');
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  protoOf(GradientPaint).x5x = function (kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  };
  protoOf(GradientPaint).w5w = function (kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.v5f_1 : kind;
    x0 = x0 === VOID ? this.w5f_1 : x0;
    y0 = y0 === VOID ? this.x5f_1 : y0;
    r0 = r0 === VOID ? this.y5f_1 : r0;
    x1 = x1 === VOID ? this.z5f_1 : x1;
    y1 = y1 === VOID ? this.a5g_1 : y1;
    r1 = r1 === VOID ? this.b5g_1 : r1;
    stops = stops === VOID ? this.c5g_1 : stops;
    colors = colors === VOID ? this.d5g_1 : colors;
    cycle = cycle === VOID ? this.e5g_1 : cycle;
    transform = transform === VOID ? this.f5g_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.g5g_1 : interpolationMethod;
    units = units === VOID ? this.h5g_1 : units;
    startAngle = startAngle === VOID ? this.i5g_1 : startAngle;
    return $super === VOID ? this.x5x(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.x5x.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, new Matrix(transform), interpolationMethod, units, new Angle(startAngle));
  };
  protoOf(GradientPaint).hashCode = function () {
    var result = this.v5f_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.w5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a5g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b5g_1) | 0;
    result = imul(result, 31) + this.c5g_1.hashCode() | 0;
    result = imul(result, 31) + this.d5g_1.hashCode() | 0;
    result = imul(result, 31) + this.e5g_1.hashCode() | 0;
    result = imul(result, 31) + Matrix__hashCode_impl_s9ntm9(this.f5g_1) | 0;
    result = imul(result, 31) + this.g5g_1.hashCode() | 0;
    result = imul(result, 31) + this.h5g_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.i5g_1) | 0;
    return result;
  };
  protoOf(GradientPaint).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.v5f_1.equals(tmp0_other_with_cast.v5f_1))
      return false;
    if (!equals(this.w5f_1, tmp0_other_with_cast.w5f_1))
      return false;
    if (!equals(this.x5f_1, tmp0_other_with_cast.x5f_1))
      return false;
    if (!equals(this.y5f_1, tmp0_other_with_cast.y5f_1))
      return false;
    if (!equals(this.z5f_1, tmp0_other_with_cast.z5f_1))
      return false;
    if (!equals(this.a5g_1, tmp0_other_with_cast.a5g_1))
      return false;
    if (!equals(this.b5g_1, tmp0_other_with_cast.b5g_1))
      return false;
    if (!this.c5g_1.equals(tmp0_other_with_cast.c5g_1))
      return false;
    if (!this.d5g_1.equals(tmp0_other_with_cast.d5g_1))
      return false;
    if (!this.e5g_1.equals(tmp0_other_with_cast.e5g_1))
      return false;
    if (!equals(this.f5g_1, tmp0_other_with_cast.f5g_1))
      return false;
    if (!this.g5g_1.equals(tmp0_other_with_cast.g5g_1))
      return false;
    if (!this.h5g_1.equals(tmp0_other_with_cast.h5g_1))
      return false;
    if (!equals(this.i5g_1, tmp0_other_with_cast.i5g_1))
      return false;
    return true;
  };
  function TransformedPaint() {
  }
  var GradientKind_LINEAR_instance;
  var GradientKind_RADIAL_instance;
  var GradientKind_SWEEP_instance;
  var GradientKind_entriesInitialized;
  function GradientKind_initEntries() {
    if (GradientKind_entriesInitialized)
      return Unit_getInstance();
    GradientKind_entriesInitialized = true;
    GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
    GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
    GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
  }
  function GradientKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  var GradientInterpolationMethod_LINEAR_instance;
  var GradientInterpolationMethod_NORMAL_instance;
  var GradientInterpolationMethod_entriesInitialized;
  function GradientInterpolationMethod_initEntries() {
    if (GradientInterpolationMethod_entriesInitialized)
      return Unit_getInstance();
    GradientInterpolationMethod_entriesInitialized = true;
    GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
    GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
  }
  function GradientInterpolationMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  var GradientUnits_USER_SPACE_ON_USE_instance;
  var GradientUnits_OBJECT_BOUNDING_BOX_instance;
  var GradientUnits_entriesInitialized;
  function GradientUnits_initEntries() {
    if (GradientUnits_entriesInitialized)
      return Unit_getInstance();
    GradientUnits_entriesInitialized = true;
    GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
    GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
  }
  function GradientUnits(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NonePaint() {
    NonePaint_instance = this;
  }
  protoOf(NonePaint).dn = function () {
    return this;
  };
  var NonePaint_instance;
  function NonePaint_getInstance() {
    if (NonePaint_instance == null)
      new NonePaint();
    return NonePaint_instance;
  }
  function BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_9().v3f_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.j5x_1 = bitmap;
    this.k5x_1 = transform;
    this.l5x_1 = cycleX;
    this.m5x_1 = cycleY;
    this.n5x_1 = smooth;
    this.o5x_1 = units;
    this.p5x_1 = this.j5x_1.e47();
  }
  protoOf(BitmapPaint).g51 = function () {
    return this.k5x_1;
  };
  protoOf(BitmapPaint).y5x = function () {
    return this.l5x_1.z5x();
  };
  protoOf(BitmapPaint).a5y = function () {
    return this.m5x_1.z5x();
  };
  protoOf(BitmapPaint).dn = function () {
    return this.b5y(VOID, this.k5x_1);
  };
  protoOf(BitmapPaint).toString = function () {
    return 'BitmapPaint(' + this.j5x_1 + ', cycle=(' + this.l5x_1 + ', ' + this.m5x_1 + '), smooth=' + this.n5x_1 + ', transform=' + new Matrix(this.k5x_1) + ')';
  };
  protoOf(BitmapPaint).c5y = function (bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  };
  protoOf(BitmapPaint).b5y = function (bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.j5x_1 : bitmap;
    transform = transform === VOID ? this.k5x_1 : transform;
    cycleX = cycleX === VOID ? this.l5x_1 : cycleX;
    cycleY = cycleY === VOID ? this.m5x_1 : cycleY;
    smooth = smooth === VOID ? this.n5x_1 : smooth;
    units = units === VOID ? this.o5x_1 : units;
    return $super === VOID ? this.c5y(bitmap, transform, cycleX, cycleY, smooth, units) : $super.c5y.call(this, bitmap, new Matrix(transform), cycleX, cycleY, smooth, units);
  };
  protoOf(BitmapPaint).hashCode = function () {
    var result = hashCode(this.j5x_1);
    result = imul(result, 31) + Matrix__hashCode_impl_s9ntm9(this.k5x_1) | 0;
    result = imul(result, 31) + this.l5x_1.hashCode() | 0;
    result = imul(result, 31) + this.m5x_1.hashCode() | 0;
    result = imul(result, 31) + (this.n5x_1 | 0) | 0;
    result = imul(result, 31) + this.o5x_1.hashCode() | 0;
    return result;
  };
  protoOf(BitmapPaint).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.j5x_1, tmp0_other_with_cast.j5x_1))
      return false;
    if (!equals(this.k5x_1, tmp0_other_with_cast.k5x_1))
      return false;
    if (!this.l5x_1.equals(tmp0_other_with_cast.l5x_1))
      return false;
    if (!this.m5x_1.equals(tmp0_other_with_cast.m5x_1))
      return false;
    if (!(this.n5x_1 === tmp0_other_with_cast.n5x_1))
      return false;
    if (!this.o5x_1.equals(tmp0_other_with_cast.o5x_1))
      return false;
    return true;
  };
  function get_DefaultPaint() {
    return Colors_getInstance().k48_1;
  }
  function GradientKind_LINEAR_getInstance() {
    GradientKind_initEntries();
    return GradientKind_LINEAR_instance;
  }
  function GradientKind_RADIAL_getInstance() {
    GradientKind_initEntries();
    return GradientKind_RADIAL_instance;
  }
  function GradientInterpolationMethod_NORMAL_getInstance() {
    GradientInterpolationMethod_initEntries();
    return GradientInterpolationMethod_NORMAL_instance;
  }
  function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
    GradientUnits_initEntries();
    return GradientUnits_OBJECT_BOUNDING_BOX_instance;
  }
  function _VerticalAlign___init__impl__f42kfq(ratio) {
    return ratio;
  }
  function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
    return $this;
  }
  function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
    return equals($this, Companion_getInstance_49().g5y_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
  }
  function Companion_29() {
    Companion_instance_29 = this;
    this.d5y_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.e5y_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.f5y_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    var tmp = this;
    FloatCompanionObject_getInstance();
    tmp.g5y_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp_0 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [new VerticalAlign(this.d5y_1), new VerticalAlign(this.e5y_1), new VerticalAlign(this.g5y_1), new VerticalAlign(this.f5y_1)];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp_0.h5y_1 = tmp$ret$2;
    this.i5y_1 = toList_1(this.h5y_1);
  }
  var Companion_instance_29;
  function Companion_getInstance_49() {
    if (Companion_instance_29 == null)
      new Companion_29();
    return Companion_instance_29;
  }
  function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
    var tmp0_subject = $this;
    return equals(tmp0_subject, Companion_getInstance_49().g5y_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
  }
  function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
    var tmp0_subject = $this;
    return equals(tmp0_subject, Companion_getInstance_49().g5y_1) ? 0.0 : interpolate_0(toRatio(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.m4p_1, font.m4p_1 - totalHeight);
  }
  function VerticalAlign__toString_impl_hcpnn2($this) {
    var tmp0_subject = $this;
    return equals(tmp0_subject, Companion_getInstance_49().d5y_1) ? 'TOP' : equals(tmp0_subject, Companion_getInstance_49().e5y_1) ? 'MIDDLE' : equals(tmp0_subject, Companion_getInstance_49().f5y_1) ? 'BOTTOM' : equals(tmp0_subject, Companion_getInstance_49().g5y_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
  }
  function VerticalAlign__hashCode_impl_vx8hj7($this) {
    return getNumberHashCode($this);
  }
  function VerticalAlign__equals_impl_xp13z($this, other) {
    if (!(other instanceof VerticalAlign))
      return false;
    var tmp0_other_with_cast = other instanceof VerticalAlign ? other.j5y_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function VerticalAlign(ratio) {
    Companion_getInstance_49();
    this.j5y_1 = ratio;
  }
  protoOf(VerticalAlign).toString = function () {
    return VerticalAlign__toString_impl_hcpnn2(this.j5y_1);
  };
  protoOf(VerticalAlign).hashCode = function () {
    return VerticalAlign__hashCode_impl_vx8hj7(this.j5y_1);
  };
  protoOf(VerticalAlign).equals = function (other) {
    return VerticalAlign__equals_impl_xp13z(this.j5y_1, other);
  };
  function _HorizontalAlign___init__impl__ad654o(ratio) {
    return ratio;
  }
  function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
    return $this;
  }
  function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
    return equals($this, Companion_getInstance_50().k5y_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
  }
  function Companion_30() {
    Companion_instance_30 = this;
    this.k5y_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.l5y_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.m5y_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.n5y_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [new HorizontalAlign(this.l5y_1), new HorizontalAlign(this.m5y_1), new HorizontalAlign(this.n5y_1), new HorizontalAlign(this.k5y_1)];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp.o5y_1 = tmp$ret$2;
    this.p5y_1 = toList_1(this.o5y_1);
  }
  var Companion_instance_30;
  function Companion_getInstance_50() {
    if (Companion_instance_30 == null)
      new Companion_30();
    return Companion_instance_30;
  }
  function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
    var tmp0_subject = $this;
    return equals(tmp0_subject, Companion_getInstance_50().k5y_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
  }
  function HorizontalAlign__toString_impl_toflc0($this) {
    var tmp0_subject = $this;
    return equals(tmp0_subject, Companion_getInstance_50().l5y_1) ? 'LEFT' : equals(tmp0_subject, Companion_getInstance_50().m5y_1) ? 'CENTER' : equals(tmp0_subject, Companion_getInstance_50().n5y_1) ? 'RIGHT' : equals(tmp0_subject, Companion_getInstance_50().k5y_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
  }
  function HorizontalAlign__hashCode_impl_7x9oj5($this) {
    return getNumberHashCode($this);
  }
  function HorizontalAlign__equals_impl_hkfbhv($this, other) {
    if (!(other instanceof HorizontalAlign))
      return false;
    var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.q5y_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function HorizontalAlign(ratio) {
    Companion_getInstance_50();
    this.q5y_1 = ratio;
  }
  protoOf(HorizontalAlign).toString = function () {
    return HorizontalAlign__toString_impl_toflc0(this.q5y_1);
  };
  protoOf(HorizontalAlign).hashCode = function () {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.q5y_1);
  };
  protoOf(HorizontalAlign).equals = function (other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.q5y_1, other);
  };
  function Companion_31() {
    Companion_instance_31 = this;
    this.t4w_1 = listOf_0([new HorizontalAlign(Companion_getInstance_50().l5y_1), new HorizontalAlign(Companion_getInstance_50().m5y_1), new HorizontalAlign(Companion_getInstance_50().n5y_1), new HorizontalAlign(Companion_getInstance_50().k5y_1)]);
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map = this.t4w_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
    var tmp0_iterator = tmp1_map.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i().q5y_1;
      var tmp$ret$0;
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      tmp$ret$0 = new TextAlignment(item, Companion_getInstance_49().d5y_1);
      tmp0_mapTo.b(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    tmp.u4w_1 = tmp$ret$2;
    var tmp_0 = this;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map_0 = this.t4w_1;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var tmp0_iterator_0 = tmp1_map_0.g();
    while (tmp0_iterator_0.h()) {
      var item_0 = tmp0_iterator_0.i().q5y_1;
      var tmp$ret$3;
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      tmp$ret$3 = new TextAlignment(item_0, Companion_getInstance_49().g5y_1);
      tmp0_mapTo_0.b(tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapTo_0;
    tmp$ret$5 = tmp$ret$4;
    tmp_0.v4w_1 = tmp$ret$5;
    var tmp_1 = this;
    var tmp$ret$8;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map_1 = this.t4w_1;
    var tmp$ret$7;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_1, 10));
    var tmp0_iterator_1 = tmp1_map_1.g();
    while (tmp0_iterator_1.h()) {
      var item_1 = tmp0_iterator_1.i().q5y_1;
      var tmp$ret$6;
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      tmp$ret$6 = new TextAlignment(item_1, Companion_getInstance_49().e5y_1);
      tmp0_mapTo_1.b(tmp$ret$6);
    }
    tmp$ret$7 = tmp0_mapTo_1;
    tmp$ret$8 = tmp$ret$7;
    tmp_1.w4w_1 = tmp$ret$8;
    var tmp_2 = this;
    var tmp$ret$11;
    // Inline function 'kotlin.collections.map' call
    var tmp1_map_2 = this.t4w_1;
    var tmp$ret$10;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_2, 10));
    var tmp0_iterator_2 = tmp1_map_2.g();
    while (tmp0_iterator_2.h()) {
      var item_2 = tmp0_iterator_2.i().q5y_1;
      var tmp$ret$9;
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      tmp$ret$9 = new TextAlignment(item_2, Companion_getInstance_49().f5y_1);
      tmp0_mapTo_2.b(tmp$ret$9);
    }
    tmp$ret$10 = tmp0_mapTo_2;
    tmp$ret$11 = tmp$ret$10;
    tmp_2.x4w_1 = tmp$ret$11;
    this.y4w_1 = plus_0(plus_0(plus_0(this.u4w_1, this.v4w_1), this.w4w_1), this.x4w_1);
    this.z4w_1 = this.u4w_1.k(0);
    this.a4x_1 = this.u4w_1.k(1);
    this.b4x_1 = this.u4w_1.k(2);
    this.c4x_1 = this.u4w_1.k(3);
    this.d4x_1 = this.v4w_1.k(0);
    this.e4x_1 = this.v4w_1.k(1);
    this.f4x_1 = this.v4w_1.k(2);
    this.g4x_1 = this.v4w_1.k(3);
    this.h4x_1 = this.u4w_1.k(0);
    this.i4x_1 = this.u4w_1.k(1);
    this.j4x_1 = this.u4w_1.k(2);
    this.k4x_1 = this.u4w_1.k(3);
    this.l4x_1 = this.w4w_1.k(0);
    this.m4x_1 = this.w4w_1.k(1);
    this.n4x_1 = this.w4w_1.k(2);
    this.o4x_1 = this.w4w_1.k(3);
    this.p4x_1 = this.x4w_1.k(0);
    this.q4x_1 = this.x4w_1.k(1);
    this.r4x_1 = this.x4w_1.k(2);
    this.s4x_1 = this.x4w_1.k(3);
  }
  protoOf(Companion_31).r5y = function (horizontal, vertical) {
    var tmp0_subject = horizontal;
    var tmp;
    if (equals(tmp0_subject, Companion_getInstance_50().l5y_1)) {
      tmp = 0;
    } else if (equals(tmp0_subject, Companion_getInstance_50().m5y_1)) {
      tmp = 1;
    } else if (equals(tmp0_subject, Companion_getInstance_50().n5y_1)) {
      tmp = 2;
    } else if (equals(tmp0_subject, Companion_getInstance_50().k5y_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    var tmp1_subject = vertical;
    return equals(tmp1_subject, Companion_getInstance_49().d5y_1) ? this.u4w_1.k(horizontalIndex) : equals(tmp1_subject, Companion_getInstance_49().g5y_1) ? this.v4w_1.k(horizontalIndex) : equals(tmp1_subject, Companion_getInstance_49().e5y_1) ? this.w4w_1.k(horizontalIndex) : equals(tmp1_subject, Companion_getInstance_49().f5y_1) ? this.x4w_1.k(horizontalIndex) : new TextAlignment(horizontal, vertical);
  };
  var Companion_instance_31;
  function Companion_getInstance_51() {
    if (Companion_instance_31 == null)
      new Companion_31();
    return Companion_instance_31;
  }
  function TextAlignment(horizontal, vertical) {
    Companion_getInstance_51();
    this.r4y_1 = horizontal;
    this.s4y_1 = vertical;
    this.t4y_1 = _Anchor___init__impl__4yyw24(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.r4y_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.s4y_1));
  }
  protoOf(TextAlignment).toString = function () {
    return '' + new VerticalAlign(this.s4y_1) + '_' + new HorizontalAlign(this.r4y_1);
  };
  protoOf(TextAlignment).hashCode = function () {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.r4y_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.s4y_1) | 0;
    return result;
  };
  protoOf(TextAlignment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.r4y_1, tmp0_other_with_cast.r4y_1))
      return false;
    if (!equals(this.s4y_1, tmp0_other_with_cast.s4y_1))
      return false;
    return true;
  };
  var DefaultWStringTextRenderer;
  function get_DefaultStringTextRenderer() {
    _init_properties_TextRenderer_kt__4uayeo();
    return DefaultStringTextRenderer;
  }
  var DefaultStringTextRenderer;
  function TextRenderer() {
  }
  function CreateWStringTextRenderer(getVersion, handler) {
    var tmp;
    if (getVersion === VOID) {
      tmp = CreateWStringTextRenderer$lambda;
    } else {
      tmp = getVersion;
    }
    getVersion = tmp;
    _init_properties_TextRenderer_kt__4uayeo();
    return new CreateWStringTextRenderer$2(getVersion, handler);
  }
  function ITextRendererActions() {
  }
  function CreateStringTextRenderer(getVersion, handler) {
    var tmp;
    if (getVersion === VOID) {
      tmp = CreateStringTextRenderer$lambda;
    } else {
      tmp = getVersion;
    }
    getVersion = tmp;
    _init_properties_TextRenderer_kt__4uayeo();
    return new CreateStringTextRenderer$2(getVersion, handler);
  }
  function TextRendererActions() {
    this.s50_1 = new GlyphPath();
    this.t50_1 = new GlyphMetrics();
    this.u50_1 = new FontMetrics();
    this.v50_1 = 0;
    this.x50_1 = 0.0;
    this.y50_1 = Companion_getInstance_0().h3b_1;
    this.z50_1 = Companion_getInstance_9().v3f_1;
    this.a51_1 = null;
    this.b51_1 = Colors_getInstance().j48_1;
  }
  protoOf(TextRendererActions).c4p = function () {
    return this.u50_1.c4p();
  };
  protoOf(TextRendererActions).j51 = function (_set____db54di) {
    this.v50_1 = _set____db54di;
  };
  protoOf(TextRendererActions).c51 = function () {
    return this.v50_1;
  };
  protoOf(TextRendererActions).i51 = function () {
    var tmp = this.w50_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  };
  protoOf(TextRendererActions).k51 = function (font, size) {
    this.w50_1 = font;
    this.x50_1 = size;
    font.k4p(size, this.u50_1);
  };
  protoOf(TextRendererActions).l51 = function (_set____db54di) {
    this.y50_1 = _set____db54di;
  };
  protoOf(TextRendererActions).e51 = function () {
    return this.y50_1;
  };
  protoOf(TextRendererActions).m51 = function (reader, codePoint) {
    return this.i51().v4p(this.x50_1, codePoint, this.t50_1, reader);
  };
  protoOf(TextRendererActions).n51 = function (_set____db54di) {
    this.z50_1 = _set____db54di;
  };
  protoOf(TextRendererActions).g51 = function () {
    return this.z50_1;
  };
  protoOf(TextRendererActions).d4q = function (leftCodePoint, rightCodePoint) {
    return this.i51().g4r(this.x50_1, leftCodePoint, rightCodePoint);
  };
  function LineStats(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_10().f3b() : bounds;
    this.v4y_1 = maxLineHeight;
    this.w4y_1 = maxX;
    this.x4y_1 = bounds;
  }
  protoOf(LineStats).y4y = function (align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.w4y_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.x4y_1, 0.0);
  };
  protoOf(LineStats).o51 = function (dx) {
    var tmp0_this = this;
    tmp0_this.w4y_1 = tmp0_this.w4y_1 + dx;
  };
  protoOf(LineStats).u5y = function (fontMetrics) {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    var tmp0_max = this.v4y_1;
    var tmp1_max = fontMetrics.c4p();
    tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
    tmp.v4y_1 = tmp$ret$0;
  };
  protoOf(LineStats).v5y = function () {
  };
  protoOf(LineStats).dt = function () {
    this.w4y_1 = 0.0;
    this.x4y_1 = Companion_getInstance_10().a3b_1;
    this.v4y_1 = 0.0;
  };
  protoOf(LineStats).toString = function () {
    return 'LineStats(maxLineHeight=' + this.v4y_1 + ', maxX=' + this.w4y_1 + ', bounds=' + new BoundsBuilder(this.x4y_1) + ')';
  };
  protoOf(LineStats).hashCode = function () {
    var result = getNumberHashCode(this.v4y_1);
    result = imul(result, 31) + getNumberHashCode(this.w4y_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.x4y_1) | 0;
    return result;
  };
  protoOf(LineStats).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.v4y_1, tmp0_other_with_cast.v4y_1))
      return false;
    if (!equals(this.w4y_1, tmp0_other_with_cast.w4y_1))
      return false;
    if (!equals(this.x4y_1, tmp0_other_with_cast.x4y_1))
      return false;
    return true;
  };
  function add($this, x, y) {
    var rx = _Vector2___get_x__impl__zywdz($this.e51()) + Matrix__transformX_impl_adb2o0_0($this.g51(), x, y);
    var ry = _Vector2___get_y__impl__ttldg6($this.e51()) + Matrix__transformY_impl_aucp27($this.g51(), x, y);
    var tmp0_this = $this;
    tmp0_this.m4y_1 = BoundsBuilder__plus_impl_cz7f7x_1(tmp0_this.m4y_1, _Vector2___init__impl__67w0ru_0(rx, ry));
    if ($this.n4y_1 === 0) {
      var tmp1_this = $this;
      tmp1_this.l4y_1 = BoundsBuilder__plus_impl_cz7f7x_1(tmp1_this.l4y_1, _Vector2___init__impl__67w0ru_0(rx, ry));
    }
    var tmp2_this = $this.p4y_1;
    tmp2_this.x4y_1 = BoundsBuilder__plus_impl_cz7f7x_1(tmp2_this.x4y_1, _Vector2___init__impl__67w0ru_0(rx, ry));
  }
  function add_0($this, rect) {
    var fx = _Rectangle___get_left__impl__sgtjiw(rect);
    var fy = _Rectangle___get_top__impl__3kuxui(rect);
    var w = _Rectangle___get_width__impl__y1u79l(rect);
    var h = _Rectangle___get_height__impl__kro6o8(rect);
    add($this, fx, fy);
    add($this, fx + w, fy);
    add($this, fx + w, fy + h);
    add($this, fx, fy + h);
  }
  function BoundBuilderTextRendererActions() {
    TextRendererActions.call(this);
    this.l4y_1 = Companion_getInstance_10().f3b();
    this.m4y_1 = Companion_getInstance_10().f3b();
    this.n4y_1 = 0;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    tmp.o4y_1 = tmp$ret$0;
    this.p4y_1 = new LineStats();
  }
  protoOf(BoundBuilderTextRendererActions).q4y = function () {
    return this.n4y_1;
  };
  protoOf(BoundBuilderTextRendererActions).w5y = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sumOf' call
    var tmp0_sumOf = this.o4y_1;
    var sum = 0.0;
    var tmp0_iterator = tmp0_sumOf.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      var tmp = sum;
      var tmp$ret$0;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      tmp$ret$0 = element.v4y_1;
      sum = tmp + tmp$ret$0;
    }
    tmp$ret$1 = sum;
    return tmp$ret$1;
  };
  protoOf(BoundBuilderTextRendererActions).d51 = function (align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.o4y_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.w4y_1);
  };
  protoOf(BoundBuilderTextRendererActions).u4y = function (align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.w5y());
  };
  protoOf(BoundBuilderTextRendererActions).dt = function () {
    protoOf(TextRendererActions).dt.call(this);
    this.n4y_1 = 0;
    this.m4y_1 = Companion_getInstance_10().a3b_1;
    this.l4y_1 = Companion_getInstance_10().a3b_1;
    this.p4y_1.dt();
    this.o4y_1.v2();
  };
  protoOf(BoundBuilderTextRendererActions).r50 = function (reader, codePoint) {
    var g = this.m51(reader, codePoint);
    add_0(this, g.a4q_1);
    this.p4y_1.u5y(this.u50_1);
    return g;
  };
  protoOf(BoundBuilderTextRendererActions).o51 = function (x) {
    protoOf(TextRendererActions).o51.call(this, x);
    this.p4y_1.o51(x);
  };
  protoOf(BoundBuilderTextRendererActions).p51 = function (y, end) {
    protoOf(TextRendererActions).p51.call(this, y, end);
    var tmp0_this = this;
    var tmp1 = tmp0_this.n4y_1;
    tmp0_this.n4y_1 = tmp1 + 1 | 0;
    this.p4y_1.u5y(this.u50_1);
    this.p4y_1.v5y();
    this.o4y_1.b(this.p4y_1);
    this.p4y_1 = new LineStats();
  };
  function measure(_this__u8e3s4, text, size, defaultFont) {
    _init_properties_TextRenderer_kt__4uayeo();
    var actions = new BoundBuilderTextRendererActions();
    invoke(_this__u8e3s4, actions, text, size, defaultFont);
    return actions;
  }
  function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
    _init_properties_TextRenderer_kt__4uayeo();
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.invoke.<anonymous>' call
    _this__u8e3s4.t5y(actions, text, size, defaultFont);
    tmp$ret$0 = actions;
  }
  function LineInfo(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.x5y_1 = maxTop;
    this.y5y_1 = minBottom;
    this.z5y_1 = maxLineHeight;
  }
  protoOf(LineInfo).toString = function () {
    return 'LineInfo(maxTop=' + this.x5y_1 + ', minBottom=' + this.y5y_1 + ', maxLineHeight=' + this.z5y_1 + ')';
  };
  protoOf(LineInfo).hashCode = function () {
    var result = getNumberHashCode(this.x5y_1);
    result = imul(result, 31) + getNumberHashCode(this.y5y_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5y_1) | 0;
    return result;
  };
  protoOf(LineInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.x5y_1, tmp0_other_with_cast.x5y_1))
      return false;
    if (!equals(this.y5y_1, tmp0_other_with_cast.y5y_1))
      return false;
    if (!equals(this.z5y_1, tmp0_other_with_cast.z5y_1))
      return false;
    return true;
  };
  function Entry_1(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp0__get_transparent__6k58e1 = Bitmaps_getInstance();
      tmp$ret$0 = get_Bitmaps_transparent();
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians(0) : rot;
    this.a5z_1 = tex;
    this.b5z_1 = x;
    this.c5z_1 = y;
    this.d5z_1 = sx;
    this.e5z_1 = sy;
    this.f5z_1 = rot;
  }
  protoOf(Entry_1).toString = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    tmp0_apply.ve('Entry(');
    tmp0_apply.ve("'" + this.a5z_1.n3r_1 + "', " + numberToInt(this.b5z_1) + ', ' + numberToInt(this.c5z_1) + ', ' + this.a5z_1.s3r_1 + ', ' + this.a5z_1.t3r_1);
    if (!(this.d5z_1 === 1.0)) {
      tmp0_apply.ve(', sx=' + get_niceStr(this.d5z_1));
    }
    if (!(this.e5z_1 === 1.0)) {
      tmp0_apply.ve(', sy=' + get_niceStr(this.e5z_1));
    }
    if (!equals(this.f5z_1, get_radians(0))) {
      tmp0_apply.ve(', rot=' + get_niceStr_0(_Angle___get_degreesD__impl__9qro6(this.f5z_1)));
    }
    tmp0_apply.ve(')');
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  protoOf(Entry_1).hashCode = function () {
    var result = this.a5z_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.b5z_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c5z_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d5z_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e5z_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.f5z_1) | 0;
    return result;
  };
  protoOf(Entry_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_1))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_1 ? other : THROW_CCE();
    if (!this.a5z_1.equals(tmp0_other_with_cast.a5z_1))
      return false;
    if (!equals(this.b5z_1, tmp0_other_with_cast.b5z_1))
      return false;
    if (!equals(this.c5z_1, tmp0_other_with_cast.c5z_1))
      return false;
    if (!equals(this.d5z_1, tmp0_other_with_cast.d5z_1))
      return false;
    if (!equals(this.e5z_1, tmp0_other_with_cast.e5z_1))
      return false;
    if (!equals(this.f5z_1, tmp0_other_with_cast.f5z_1))
      return false;
    return true;
  };
  function Text2TextRendererActions() {
    TextRendererActions.call(this);
    this.q5z_1 = Companion_getInstance_51().z4w_1;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    tmp.r5z_1 = tmp$ret$0;
    this.s5z_1 = floatArrayListOf(new Float32Array([]));
    this.t5z_1 = floatArrayListOf(new Float32Array([]));
    this.u5z_1 = floatArrayListOf(new Float32Array([]));
    this.v5z_1 = floatArrayListOf(new Float32Array([]));
    this.w5z_1 = floatArrayListOf(new Float32Array([]));
    this.x5z_1 = new VectorArrayList(4);
    this.y5z_1 = _MatrixTransform___init__impl__7axsoi();
  }
  protoOf(Text2TextRendererActions).z5z = function () {
    return this.q5z_1.s4y_1;
  };
  protoOf(Text2TextRendererActions).j = function () {
    return this.s5z_1.j();
  };
  protoOf(Text2TextRendererActions).a60 = function () {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var tmp0_fastForEachGeneric = this.x5z_1;
    var inductionVariable = 0;
    var last = tmp0_fastForEachGeneric.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(tmp0_fastForEachGeneric.fk(n, 0));
        while (out.j() <= line) {
          out.b(new LineInfo());
        }
        var lineInfo = out.k(line);
        var top = tmp0_fastForEachGeneric.fk(n, 1);
        var bottom = tmp0_fastForEachGeneric.fk(n, 2);
        var lineHeight = tmp0_fastForEachGeneric.fk(n, 3);
        var tmp = lineInfo;
        var tmp$ret$0;
        // Inline function 'kotlin.math.max' call
        var tmp0_max = lineInfo.x5y_1;
        tmp$ret$0 = Math.max(tmp0_max, top);
        tmp.x5y_1 = tmp$ret$0;
        var tmp_0 = lineInfo;
        var tmp$ret$1;
        // Inline function 'kotlin.math.min' call
        var tmp1_min = lineInfo.y5y_1;
        tmp$ret$1 = Math.min(tmp1_min, bottom);
        tmp_0.y5y_1 = tmp$ret$1;
        var tmp_1 = lineInfo;
        var tmp$ret$2;
        // Inline function 'kotlin.math.max' call
        var tmp2_max = lineInfo.z5y_1;
        tmp$ret$2 = Math.max(tmp2_max, lineHeight);
        tmp_1.z5y_1 = tmp$ret$2;
      }
       while (inductionVariable < last);
    return out;
  };
  protoOf(Text2TextRendererActions).b60 = function (n) {
    return n >= this.j() ? Companion_getInstance_6().b3b_1 : Companion_getInstance_6().s3i(this.s5z_1.k(n), this.t5z_1.k(n), this.s5z_1.k(n) + this.r5z_1.k(n).s3r_1 * this.u5z_1.k(n), this.t5z_1.k(n) + this.r5z_1.k(n).t3r_1 * this.v5z_1.k(n));
  };
  protoOf(Text2TextRendererActions).w3l = function () {
    if (this.j() === 0) {
      return Companion_getInstance_6().b3b_1;
    }
    var bb = Companion_getInstance_10().f3b();
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.b60(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  };
  protoOf(Text2TextRendererActions).c60 = function (n, out) {
    out.a5z_1 = this.r5z_1.k(n);
    out.b5z_1 = this.s5z_1.k(n);
    out.c5z_1 = this.t5z_1.k(n);
    out.d5z_1 = this.u5z_1.k(n);
    out.e5z_1 = this.v5z_1.k(n);
    var tmp = out;
    var tmp$ret$0;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    var tmp0_fromRatio = Companion_getInstance_13();
    var tmp1_fromRatio = this.w5z_1.k(n);
    tmp$ret$0 = _Angle___init__impl__g23q1m(tmp1_fromRatio);
    tmp.f5z_1 = tmp$ret$0;
    return out;
  };
  protoOf(Text2TextRendererActions).d60 = function () {
    this.l51(Companion_getInstance_0().h3b_1);
    this.r5z_1.v2();
    this.s5z_1.v2();
    this.t5z_1.v2();
    this.u5z_1.v2();
    this.v5z_1.v2();
    this.w5z_1.v2();
    this.x5z_1.v2();
    this.j51(0);
  };
  protoOf(Text2TextRendererActions).r50 = function (reader, codePoint) {
    var tmp = this.i51();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_safe_receiver = reader;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2a_1;
      var old = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      try {
        var tmp$ret$0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$0 = this.m51(reader, codePoint);
        tmp$ret$1 = tmp$ret$0;
        break $l$block;
      }finally {
        var tmp2_safe_receiver = reader;
        if (tmp2_safe_receiver == null) {
        } else
          tmp2_safe_receiver.r2a_1 = old;
      }
    }
    var m = tmp$ret$1;
    var g = bf.k(codePoint);
    var x = g.q4o_1;
    var tmp_0 = g.r4o_1;
    var tmp0_subject = this.z5z();
    var y = tmp_0 - (equals(tmp0_subject, Companion_getInstance_49().g5y_1) ? bf.l3s() : bf.c4p() * _VerticalAlign___get_ratio__impl__b3ilr8(this.z5z()));
    var fontScale = this.x50_1 / bf.b4p();
    this.y5z_1 = Matrix__toTransform_impl_lr8urh(_Matrix___get_immutable__impl__k08qr(this.g51()));
    this.r5z_1.b(g.p4o_1);
    this.s5z_1.fn(_Vector2___get_x__impl__zywdz(this.e51()) + Matrix__transformX_impl_adb2o0_0(this.g51(), x, y) * fontScale);
    this.t5z_1.fn(_Vector2___get_y__impl__ttldg6(this.e51()) + Matrix__transformY_impl_aucp27(this.g51(), x, y) * fontScale);
    this.u5z_1.fn(_MatrixTransform___get_scaleX__impl__t9pp1f(this.y5z_1) * fontScale);
    this.v5z_1.fn(_MatrixTransform___get_scaleY__impl__g37z8(this.y5z_1) * fontScale);
    this.w5z_1.fn(_Angle___get_ratio__impl__ap3on4(_MatrixTransform___get_rotation__impl__d5fsj(this.y5z_1)));
    this.x5z_1.hn(this.c51(), this.u50_1.m4p_1, this.u50_1.q4p_1, this.u50_1.c4p());
    return m;
  };
  function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
    _init_properties_TextRenderer_kt__4uayeo();
    $this$CreateWStringTextRenderer.r50(text, c);
    $this$CreateWStringTextRenderer.o51(advance);
    return Unit_getInstance();
  }
  function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
    _init_properties_TextRenderer_kt__4uayeo();
    $this$CreateStringTextRenderer.r50(text, c);
    $this$CreateStringTextRenderer.o51(advance);
    return Unit_getInstance();
  }
  function CreateWStringTextRenderer$lambda() {
    _init_properties_TextRenderer_kt__4uayeo();
    return 0;
  }
  function CreateWStringTextRenderer$2($getVersion, $handler) {
    this.e60_1 = $getVersion;
    this.f60_1 = $handler;
  }
  protoOf(CreateWStringTextRenderer$2).s5y = function () {
    return this.e60_1();
  };
  protoOf(CreateWStringTextRenderer$2).g60 = function (_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.dt();
    _this__u8e3s4.k51(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.gs()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.z2a());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.x2a(1));
      var startPos = reader.r2a_1;
      var tmp$ret$0;
      // Inline function 'kotlin.code' call
      tmp$ret$0 = 10;
      if (c === tmp$ret$0) {
        _this__u8e3s4.p51(_this__u8e3s4.c4p(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_safe_receiver = reader;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2a_1;
          var old = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
          try {
            var tmp$ret$1;
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$1 = _this__u8e3s4.m51(reader, c);
            tmp$ret$2 = tmp$ret$1;
            break $l$block;
          }finally {
            var tmp2_safe_receiver = reader;
            if (tmp2_safe_receiver == null) {
            } else
              tmp2_safe_receiver.r2a_1 = old;
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.n51(Companion_getInstance_9().v3f_1);
        this.f60_1(_this__u8e3s4, reader, c, g, g.b4q_1 + _this__u8e3s4.d4q(c, c1));
      }
      if (reader.r2a_1 <= startPos) {
        reader.b2b(1);
      }
    }
    _this__u8e3s4.p51(_this__u8e3s4.c4p(), true);
  };
  protoOf(CreateWStringTextRenderer$2).t5y = function (_this__u8e3s4, text, size, defaultFont) {
    return this.g60(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  };
  function CreateStringTextRenderer$lambda() {
    _init_properties_TextRenderer_kt__4uayeo();
    return 0;
  }
  function CreateStringTextRenderer$o$wstring$lambda($handler) {
    return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
      $handler($this$CreateWStringTextRenderer, text, c, g, advance);
      return Unit_getInstance();
    };
  }
  function CreateStringTextRenderer$2($getVersion, $handler) {
    var tmp = this;
    tmp.h60_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  protoOf(CreateStringTextRenderer$2).s5y = function () {
    return this.h60_1.s5y();
  };
  protoOf(CreateStringTextRenderer$2).i60 = function (_this__u8e3s4, text, size, defaultFont) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = this.h60_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    tmp0_apply.t5y(_this__u8e3s4, Companion_getInstance_12().kz(text), size, defaultFont);
    tmp$ret$0 = tmp0_apply;
  };
  protoOf(CreateStringTextRenderer$2).t5y = function (_this__u8e3s4, text, size, defaultFont) {
    return this.i60(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  };
  var properties_initialized_TextRenderer_kt_lfmsb6;
  function _init_properties_TextRenderer_kt__4uayeo() {
    if (properties_initialized_TextRenderer_kt_lfmsb6) {
    } else {
      properties_initialized_TextRenderer_kt_lfmsb6 = true;
      DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
      DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
    }
  }
  function overlaps($this, a0, a1, b0, b1) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.min' call
    tmp$ret$0 = Math.min(a0, a0);
    var min = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.math.max' call
    tmp$ret$1 = Math.max(a1, a1);
    var max = tmp$ret$1;
    var tmp$ret$2;
    // Inline function 'kotlin.math.max' call
    tmp$ret$2 = Math.max(a0, b0);
    var maxMinor = tmp$ret$2;
    var tmp$ret$3;
    // Inline function 'kotlin.math.min' call
    tmp$ret$3 = Math.min(a1, b1);
    var minMajor = tmp$ret$3;
    return (min <= maxMinor ? maxMinor <= max : false) ? true : min <= minMajor ? minMajor <= max : false;
  }
  function SegmentHandler() {
    this.j60_1 = intArrayListOf(new Int32Array([]));
    this.k60_1 = intArrayListOf(new Int32Array([]));
    this.dt();
  }
  protoOf(SegmentHandler).j = function () {
    return this.j60_1.j();
  };
  protoOf(SegmentHandler).dt = function () {
    this.j60_1.v2();
    this.k60_1.v2();
  };
  protoOf(SegmentHandler).h3w = function (x0, x1) {
    var inductionVariable = 0;
    var last = this.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.j60_1.ek(n);
        var xmax = this.k60_1.ek(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          var tmp$ret$0;
          // Inline function 'kotlin.math.min' call
          tmp$ret$0 = Math.min(x0, xmin);
          this.j60_1.yn(n, tmp$ret$0);
          var tmp$ret$1;
          // Inline function 'kotlin.math.max' call
          tmp$ret$1 = Math.max(x1, xmax);
          this.k60_1.yn(n, tmp$ret$1);
          return Unit_getInstance();
        }
      }
       while (inductionVariable < last);
    this.j60_1.un(x0);
    this.k60_1.un(x1);
  };
  function ScanlineWriter($outer) {
    this.w60_1 = $outer;
    this.l60_1 = get_DEFAULT(Companion_getInstance_52());
    this.m60_1 = NoneFiller_getInstance();
    this.n60_1 = -1;
    this.o60_1 = -1;
    this.p60_1 = new Float32Array(this.j());
    this.q60_1 = new Int32Array(this.j());
    this.r60_1 = Companion_getInstance_30().k4o(this.j());
    this.s60_1 = Companion_getInstance_30().k4o(this.j());
    this.t60_1 = new SegmentHandler();
    this.u60_1 = 0;
    this.v60_1 = 1.0;
  }
  protoOf(ScanlineWriter).j = function () {
    return this.w60_1.z60_1.r46_1;
  };
  protoOf(ScanlineWriter).j61 = function () {
    return this.w60_1.z60_1.r46_1 - 1 | 0;
  };
  protoOf(ScanlineWriter).dt = function () {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var tmp0_forEachFast = this.t60_1;
    var inductionVariable = 0;
    var last = tmp0_forEachFast.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var tmp1__anonymous__uwfjfc = tmp0_forEachFast.j60_1.ek(n);
        var tmp2__anonymous__z9zvc9 = tmp0_forEachFast.k60_1.ek(n);
        fill_0(this.p60_1, 0.0, tmp1__anonymous__uwfjfc, tmp2__anonymous__z9zvc9 + 1 | 0);
        fill(this.q60_1, 0, tmp1__anonymous__uwfjfc, tmp2__anonymous__z9zvc9 + 1 | 0);
      }
       while (inductionVariable < last);
    this.u60_1 = 0;
    this.t60_1.dt();
  };
  protoOf(ScanlineWriter).k61 = function (x0, x1, y0) {
    if (this.j61() < 1)
      return Unit_getInstance();
    var tmp = this.j61();
    Companion_getInstance_14();
    var x0_0 = coerceIn(x0, 0, imul(tmp, 20));
    var tmp_0 = this.j61();
    Companion_getInstance_14();
    var x1_0 = coerceIn(x1, 0, imul(tmp_0, 20));
    Companion_getInstance_14();
    var a = x0_0 / 20 | 0;
    Companion_getInstance_14();
    var b = x1_0 / 20 | 0;
    Companion_getInstance_14();
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.j61());
    var i1 = coerceIn(b, 0, this.j61());
    Companion_getInstance_14();
    var i0m = x0_0 % 20 | 0;
    Companion_getInstance_14();
    var i1m = x1_0 % 20 | 0;
    if (!(this.o60_1 === y)) {
      if (y >= 0) {
        this.hd();
      }
      this.o60_1 = y;
      this.dt();
    }
    if (!(this.n60_1 === y0)) {
      this.n60_1 = y0;
      var tmp0_this = this;
      var tmp1 = tmp0_this.u60_1;
      tmp0_this.u60_1 = tmp1 + 1 | 0;
    }
    if (i1 > i0) {
      this.t60_1.h3w(i0, i1);
      var tmp_1 = i0m;
      Companion_getInstance_14();
      this.l61(i0, 1.0 - tmp_1 / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.l61(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        var tmp_2 = i1m;
        Companion_getInstance_14();
        this.l61(i1, tmp_2 / 20);
      }
    }
  };
  protoOf(ScanlineWriter).l61 = function (x, ratio) {
    var mask = 1 << this.u60_1;
    if ((this.q60_1[x] & mask) === 0) {
      this.q60_1[x] = this.q60_1[x] | mask;
      var tmp0_array = this.p60_1;
      var tmp1_index0 = x;
      tmp0_array[tmp1_index0] = tmp0_array[tmp1_index0] + ratio;
    }
  };
  protoOf(ScanlineWriter).hd = function () {
    var containsUpper = this.w60_1.z60_1.s46_1;
    var containsArg = this.o60_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_getInstance();
    var galpha = clamp01_0(this.v60_1);
    var scale_0 = 1.0 / this.u60_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var tmp0_forEachFast = this.t60_1;
    var inductionVariable = 0;
    var last = tmp0_forEachFast.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var tmp1__anonymous__uwfjfc = tmp0_forEachFast.j60_1.ek(n);
        var tmp2__anonymous__z9zvc9 = tmp0_forEachFast.k60_1.ek(n);
        var x = tmp1__anonymous__uwfjfc;
        var count = (tmp2__anonymous__z9zvc9 - tmp1__anonymous__uwfjfc | 0) + 1 | 0;
        this.m60_1.o5w(this.s60_1, 0, tmp1__anonymous__uwfjfc, tmp2__anonymous__z9zvc9, this.o60_1);
        var inductionVariable_0 = tmp1__anonymous__uwfjfc;
        if (inductionVariable_0 <= tmp2__anonymous__z9zvc9)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp1_array = this.p60_1;
            var tmp2_index0 = n_0;
            tmp1_array[tmp2_index0] = tmp1_array[tmp2_index0] * scale_0;
          }
           while (!(n_0 === tmp2__anonymous__z9zvc9));
        scale(this.s60_1, tmp1__anonymous__uwfjfc, this.p60_1, tmp1__anonymous__uwfjfc, count);
        var index = this.w60_1.z60_1.c48(0, this.o60_1) + x | 0;
        if (this.w60_1.z60_1.y46_1) {
          arraycopy(this.w60_1.z60_1.t47_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.r60_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.w60_1.z60_1.t47_1), index, this.r60_1, x, count);
        }
        this.l60_1.m61(this.r60_1, x, this.s60_1, x, count);
        if (this.w60_1.z60_1.y46_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.r60_1), x, this.w60_1.z60_1.t47_1, index, count);
        } else {
          depremultiply(this.r60_1, x, _RgbaArray___init__impl__oib4y4(this.w60_1.z60_1.t47_1), index, count);
        }
      }
       while (inductionVariable < last);
  };
  function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
    if (this$0.c61_1.q61_1.ao()) {
      this$0.c61_1.o61_1 = this$0.a61_1 ? 4 : 1;
      this$0.g61_1.m60_1 = filler;
      this$0.g61_1.v60_1 = $state.w4q_1;
      this$0.g61_1.dt();
      var tmp0_elvis_lhs = $winding;
      var tmp = tmp0_elvis_lhs == null ? fillPath.b3o_1 : tmp0_elvis_lhs;
      this$0.c61_1.w61(this$0.b61_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
      this$0.g61_1.hd();
      this$0.c61_1.q61_1.dt();
    }
  }
  function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
    return function (x0, x1, y) {
      this$0.g61_1.k61(x0, x1, y);
      return Unit_getInstance();
    };
  }
  function Bitmap32Context2d(bmp, antialiasing) {
    Renderer.call(this);
    this.z60_1 = bmp;
    this.a61_1 = antialiasing;
    this.b61_1 = _RectangleInt___get_float__impl__bwdmra(this.z60_1.v47_1);
    this.c61_1 = new Rasterizer();
    this.d61_1 = new ColorFiller();
    this.e61_1 = new GradientFiller();
    this.f61_1 = new BitmapFiller();
    this.g61_1 = new ScanlineWriter(this);
    this.h61_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.i61_1 = new StrokeToFill();
  }
  protoOf(Bitmap32Context2d).ck = function () {
    return this.z60_1.r46_1;
  };
  protoOf(Bitmap32Context2d).dk = function () {
    return this.z60_1.s46_1;
  };
  protoOf(Bitmap32Context2d).x61 = function (state, fill, winding) {
    var style = fill ? state.q4q_1 : state.p4q_1;
    var tmp0_subject = style;
    var tmp;
    if (tmp0_subject instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (tmp0_subject instanceof RGBA) {
        tmp = this.d61_1.m5w(style.q4n_1, state);
      } else {
        if (tmp0_subject instanceof GradientPaint) {
          tmp = this.e61_1.u5w(style, state);
        } else {
          if (tmp0_subject instanceof BitmapPaint) {
            tmp = this.f61_1.i5x(style, state);
          } else {
            throw new NotImplementedError();
          }
        }
      }
    }
    var filler = tmp;
    this.g61_1.l60_1 = state.x4q_1;
    this.c61_1.dt();
    this.c61_1.n61_1 = this.y61_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.i4q_1;
    } else {
      this.h61_1.v2();
      var tmp1_$receiver = state.i4q_1;
      var tmp2_lineWidth = state.a62();
      var tmp3_joins = state.n4q_1;
      var tmp4_startCap = state.l4q_1;
      var tmp5_endCap = state.m4q_1;
      var tmp6_miterLimit = state.o4q_1;
      var tmp7_temp = this.i61_1;
      var tmp8_outFill = this.h61_1;
      var tmp9_lineDash = state.y4q_1;
      var tmp10_lineDashOffset = state.z4q_1;
      tmp_0 = strokeToFill(tmp1_$receiver, tmp2_lineWidth, tmp3_joins, tmp4_startCap, tmp5_endCap, tmp6_miterLimit, tmp9_lineDash, tmp10_lineDashOffset, tmp7_temp, tmp8_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.h4q_1 == null)) {
      this.c61_1.r61_1.n3v_1 = ensureNotNull(state.h4q_1).b3o_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var tmp9_emitPoints2 = ensureNotNull(state.h4q_1);
      var i = _Vector2___init__impl__67w0ru_2();
      var l = _Vector2___init__impl__67w0ru_2();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.c61_1.r61_1.c1c();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var tmp0_fastForEach = tmp9_emitPoints2.z3n_1;
      var n_0 = 0;
      while (n_0 < tmp0_fastForEach.j()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var tmp0 = n_0;
        n_0 = tmp0 + 1 | 0;
        var tmp1__anonymous__uwfjfc = tmp0_fastForEach.ek(tmp0);
        var tmp0_subject_0 = tmp1__anonymous__uwfjfc;
        Command_getInstance();
        if (tmp0_subject_0 === 0) {
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          var tmp1 = n;
          n = tmp1 + 1 | 0;
          var tmp_1 = tmp9_emitPoints2.a3o_1.k(tmp1);
          var tmp2 = n;
          n = tmp2 + 1 | 0;
          var tmp2__anonymous__z9zvc9 = _Vector2___init__impl__67w0ru_0(tmp_1, tmp9_emitPoints2.a3o_1.k(tmp2));
          i = tmp2__anonymous__z9zvc9;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
          var x = Vector2__component1_impl_k3h45m(tmp2__anonymous__z9zvc9);
          var y = Vector2__component2_impl_kkiqjt(tmp2__anonymous__z9zvc9);
          this.c61_1.r61_1.q3w(x, y, true);
          l = tmp2__anonymous__z9zvc9;
        } else {
          Command_getInstance();
          if (tmp0_subject_0 === 1) {
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            var tmp3 = n;
            n = tmp3 + 1 | 0;
            var tmp_2 = tmp9_emitPoints2.a3o_1.k(tmp3);
            var tmp4 = n;
            n = tmp4 + 1 | 0;
            var tmp3__anonymous__ufb84q = _Vector2___init__impl__67w0ru_0(tmp_2, tmp9_emitPoints2.a3o_1.k(tmp4));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
            var x_0 = Vector2__component1_impl_k3h45m(tmp3__anonymous__ufb84q);
            var y_0 = Vector2__component2_impl_kkiqjt(tmp3__anonymous__ufb84q);
            this.c61_1.r61_1.q3w(x_0, y_0, false);
            l = tmp3__anonymous__ufb84q;
            var tmp$ret$0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            tmp$ret$0 = Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_0 === 2) {
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              var tmp5 = n;
              n = tmp5 + 1 | 0;
              var tmp_3 = tmp9_emitPoints2.a3o_1.k(tmp5);
              var tmp6 = n;
              n = tmp6 + 1 | 0;
              var tmp4__anonymous__pkmkx7 = _Vector2___init__impl__67w0ru_0(tmp_3, tmp9_emitPoints2.a3o_1.k(tmp6));
              var tmp7 = n;
              n = tmp7 + 1 | 0;
              var tmp_4 = tmp9_emitPoints2.a3o_1.k(tmp7);
              var tmp8 = n;
              n = tmp8 + 1 | 0;
              var tmp5__anonymous__kpxxpo = _Vector2___init__impl__67w0ru_0(tmp_4, tmp9_emitPoints2.a3o_1.k(tmp8));
              var sum = Companion_getInstance_0().p3j(l, tmp4__anonymous__pkmkx7) + Companion_getInstance_0().p3j(tmp4__anonymous__pkmkx7, tmp5__anonymous__kpxxpo);
              // Inline function 'korlibs.math.geom.shape.approximateCurve' call
              var tmp0_approximateCurve = numberToInt(sum);
              var tmp$ret$1;
              // Inline function 'kotlin.math.max' call
              tmp$ret$1 = Math.max(tmp0_approximateCurve, 20);
              var rcurveSteps = tmp$ret$1;
              var dt = 1.0 / rcurveSteps;
              var lastPos = {_v: new Vector2(_Vector2___init__impl__67w0ru_2())};
              var prevPos = {_v: new Vector2(_Vector2___init__impl__67w0ru_2())};
              var emittedCount = {_v: 0};
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var tmp1__anonymous__uwfjfc_0 = Companion_getInstance_15().l3l(l, tmp4__anonymous__pkmkx7, tmp5__anonymous__kpxxpo, 0.0);
              lastPos._v = new Vector2(tmp1__anonymous__uwfjfc_0);
              var nStart = false ? 0 : 1;
              var nEnd = rcurveSteps;
              var inductionVariable = nStart;
              if (inductionVariable <= nEnd)
                do {
                  var n_1 = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var ratio = n_1 * dt;
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                  var tmp2__anonymous__z9zvc9_0 = Companion_getInstance_15().l3l(l, tmp4__anonymous__pkmkx7, tmp5__anonymous__kpxxpo, ratio);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                  var x_1 = Vector2__component1_impl_k3h45m(tmp2__anonymous__z9zvc9_0);
                  var y_1 = Vector2__component2_impl_kkiqjt(tmp2__anonymous__z9zvc9_0);
                  this.c61_1.r61_1.q3w(x_1, y_1, false);
                  var tmp0_0 = emittedCount._v;
                  emittedCount._v = tmp0_0 + 1 | 0;
                  lastPos._v = prevPos._v;
                  prevPos._v = new Vector2(tmp2__anonymous__z9zvc9_0);
                }
                 while (!(n_1 === nEnd));
              l = tmp5__anonymous__kpxxpo;
              var tmp$ret$2;
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              tmp$ret$2 = Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_0 === 3) {
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                var tmp9 = n;
                n = tmp9 + 1 | 0;
                var tmp_5 = tmp9_emitPoints2.a3o_1.k(tmp9);
                var tmp10 = n;
                n = tmp10 + 1 | 0;
                var tmp6__anonymous__fv9ai5 = _Vector2___init__impl__67w0ru_0(tmp_5, tmp9_emitPoints2.a3o_1.k(tmp10));
                var tmp11 = n;
                n = tmp11 + 1 | 0;
                var tmp_6 = tmp9_emitPoints2.a3o_1.k(tmp11);
                var tmp12 = n;
                n = tmp12 + 1 | 0;
                var tmp7__anonymous__b0knam = _Vector2___init__impl__67w0ru_0(tmp_6, tmp9_emitPoints2.a3o_1.k(tmp12));
                var tmp13 = n;
                n = tmp13 + 1 | 0;
                var tmp_7 = tmp9_emitPoints2.a3o_1.k(tmp13);
                var tmp14 = n;
                n = tmp14 + 1 | 0;
                var tmp8__anonymous__65w033 = _Vector2___init__impl__67w0ru_0(tmp_7, tmp9_emitPoints2.a3o_1.k(tmp14));
                var sum_0 = Companion_getInstance_0().p3j(l, tmp6__anonymous__fv9ai5) + Companion_getInstance_0().p3j(tmp6__anonymous__fv9ai5, tmp7__anonymous__b0knam) + Companion_getInstance_0().p3j(tmp7__anonymous__b0knam, tmp8__anonymous__65w033);
                // Inline function 'korlibs.math.geom.shape.approximateCurve' call
                var tmp0_approximateCurve_0 = numberToInt(sum_0);
                var tmp$ret$3;
                // Inline function 'kotlin.math.max' call
                tmp$ret$3 = Math.max(tmp0_approximateCurve_0, 20);
                var rcurveSteps_0 = tmp$ret$3;
                var dt_0 = 1.0 / rcurveSteps_0;
                var lastPos_0 = {_v: new Vector2(_Vector2___init__impl__67w0ru_2())};
                var prevPos_0 = {_v: new Vector2(_Vector2___init__impl__67w0ru_2())};
                var emittedCount_0 = {_v: 0};
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var tmp1__anonymous__uwfjfc_1 = Companion_getInstance_15().k3l(l, tmp6__anonymous__fv9ai5, tmp7__anonymous__b0knam, tmp8__anonymous__65w033, 0.0);
                lastPos_0._v = new Vector2(tmp1__anonymous__uwfjfc_1);
                var nStart_0 = false ? 0 : 1;
                var nEnd_0 = rcurveSteps_0;
                var inductionVariable_0 = nStart_0;
                if (inductionVariable_0 <= nEnd_0)
                  do {
                    var n_2 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var ratio_0 = n_2 * dt_0;
                    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                    // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                    var tmp2__anonymous__z9zvc9_1 = Companion_getInstance_15().k3l(l, tmp6__anonymous__fv9ai5, tmp7__anonymous__b0knam, tmp8__anonymous__65w033, ratio_0);
                    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                    var x_2 = Vector2__component1_impl_k3h45m(tmp2__anonymous__z9zvc9_1);
                    var y_2 = Vector2__component2_impl_kkiqjt(tmp2__anonymous__z9zvc9_1);
                    this.c61_1.r61_1.q3w(x_2, y_2, false);
                    var tmp0_1 = emittedCount_0._v;
                    emittedCount_0._v = tmp0_1 + 1 | 0;
                    lastPos_0._v = prevPos_0._v;
                    prevPos_0._v = new Vector2(tmp2__anonymous__z9zvc9_1);
                  }
                   while (!(n_2 === nEnd_0));
                l = tmp8__anonymous__65w033;
                var tmp$ret$4;
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                tmp$ret$4 = Unit_getInstance();
              } else {
                Command_getInstance();
                if (tmp0_subject_0 === 4) {
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                  // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                  var tmp10__anonymous__yfiz50 = i;
                  var x_3 = Vector2__component1_impl_k3h45m(tmp10__anonymous__yfiz50);
                  var y_3 = Vector2__component2_impl_kkiqjt(tmp10__anonymous__yfiz50);
                  this.c61_1.r61_1.q3w(x_3, y_3, false);
                  var tmp$ret$5;
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                  tmp$ret$5 = Unit_getInstance();
                  // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                  {
                    this.c61_1.r61_1.c1c();
                  }
                }
              }
            }
          }
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.c61_1.r61_1.c1c();
      }
    }
    var tmp_8 = this.c61_1.q61_1;
    var tmp11_elvis_lhs = winding;
    tmp_8.n3v_1 = tmp11_elvis_lhs == null ? ensureNotNull(state.i4q_1).b3o_1 : tmp11_elvis_lhs;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = _Vector2___init__impl__67w0ru_2();
    var l_0 = _Vector2___init__impl__67w0ru_2();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.c61_1.q61_1.c1c();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp11_fastForEach = fillPath.z3n_1;
    var n_4 = 0;
    while (n_4 < tmp11_fastForEach.j()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0_2 = n_4;
      n_4 = tmp0_2 + 1 | 0;
      var tmp12__anonymous__oq5opy = tmp11_fastForEach.ek(tmp0_2);
      var tmp0_subject_1 = tmp12__anonymous__oq5opy;
      Command_getInstance();
      if (tmp0_subject_1 === 0) {
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
        var tmp1_0 = n_3;
        n_3 = tmp1_0 + 1 | 0;
        var tmp_9 = fillPath.a3o_1.k(tmp1_0);
        var tmp2_0 = n_3;
        n_3 = tmp2_0 + 1 | 0;
        var tmp13__anonymous__jvh1if = _Vector2___init__impl__67w0ru_0(tmp_9, fillPath.a3o_1.k(tmp2_0));
        i_0 = tmp13__anonymous__jvh1if;
        // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
        var x_4 = Vector2__component1_impl_k3h45m(tmp13__anonymous__jvh1if);
        var y_4 = Vector2__component2_impl_kkiqjt(tmp13__anonymous__jvh1if);
        if (doingStroke) {
          {
            renderFinal$flush(this, filler, state, winding, fillPath);
          }
        }
        this.c61_1.q61_1.q3w(x_4, y_4, true);
        l_0 = tmp13__anonymous__jvh1if;
      } else {
        Command_getInstance();
        if (tmp0_subject_1 === 1) {
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          var tmp3_0 = n_3;
          n_3 = tmp3_0 + 1 | 0;
          var tmp_10 = fillPath.a3o_1.k(tmp3_0);
          var tmp4_0 = n_3;
          n_3 = tmp4_0 + 1 | 0;
          var tmp14__anonymous__f0seaw = _Vector2___init__impl__67w0ru_0(tmp_10, fillPath.a3o_1.k(tmp4_0));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
          var x_5 = Vector2__component1_impl_k3h45m(tmp14__anonymous__f0seaw);
          var y_5 = Vector2__component2_impl_kkiqjt(tmp14__anonymous__f0seaw);
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }
          this.c61_1.q61_1.q3w(x_5, y_5, false);
          l_0 = tmp14__anonymous__f0seaw;
          var tmp$ret$6;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          tmp$ret$6 = Unit_getInstance();
        } else {
          Command_getInstance();
          if (tmp0_subject_1 === 2) {
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            var tmp5_0 = n_3;
            n_3 = tmp5_0 + 1 | 0;
            var tmp_11 = fillPath.a3o_1.k(tmp5_0);
            var tmp6_0 = n_3;
            n_3 = tmp6_0 + 1 | 0;
            var tmp15__anonymous__a63r3d = _Vector2___init__impl__67w0ru_0(tmp_11, fillPath.a3o_1.k(tmp6_0));
            var tmp7_0 = n_3;
            n_3 = tmp7_0 + 1 | 0;
            var tmp_12 = fillPath.a3o_1.k(tmp7_0);
            var tmp8_0 = n_3;
            n_3 = tmp8_0 + 1 | 0;
            var tmp16__anonymous__5bf3vu = _Vector2___init__impl__67w0ru_0(tmp_12, fillPath.a3o_1.k(tmp8_0));
            var sum_1 = Companion_getInstance_0().p3j(l_0, tmp15__anonymous__a63r3d) + Companion_getInstance_0().p3j(tmp15__anonymous__a63r3d, tmp16__anonymous__5bf3vu);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call
            var tmp0_approximateCurve_1 = numberToInt(sum_1);
            var tmp$ret$7;
            // Inline function 'kotlin.math.max' call
            tmp$ret$7 = Math.max(tmp0_approximateCurve_1, 20);
            var rcurveSteps_1 = tmp$ret$7;
            var dt_1 = 1.0 / rcurveSteps_1;
            var lastPos_1 = {_v: new Vector2(_Vector2___init__impl__67w0ru_2())};
            var prevPos_1 = {_v: new Vector2(_Vector2___init__impl__67w0ru_2())};
            var emittedCount_1 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var tmp1__anonymous__uwfjfc_2 = Companion_getInstance_15().l3l(l_0, tmp15__anonymous__a63r3d, tmp16__anonymous__5bf3vu, 0.0);
            lastPos_1._v = new Vector2(tmp1__anonymous__uwfjfc_2);
            var nStart_1 = false ? 0 : 1;
            var nEnd_1 = rcurveSteps_1;
            var inductionVariable_1 = nStart_1;
            if (inductionVariable_1 <= nEnd_1)
              do {
                var n_5 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var ratio_1 = n_5 * dt_1;
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var tmp2__anonymous__z9zvc9_2 = Companion_getInstance_15().l3l(l_0, tmp15__anonymous__a63r3d, tmp16__anonymous__5bf3vu, ratio_1);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_6 = Vector2__component1_impl_k3h45m(tmp2__anonymous__z9zvc9_2);
                var y_6 = Vector2__component2_impl_kkiqjt(tmp2__anonymous__z9zvc9_2);
                if (doingStroke) {
                  if (false) {
                    renderFinal$flush(this, filler, state, winding, fillPath);
                  }
                }
                this.c61_1.q61_1.q3w(x_6, y_6, false);
                var tmp0_3 = emittedCount_1._v;
                emittedCount_1._v = tmp0_3 + 1 | 0;
                lastPos_1._v = prevPos_1._v;
                prevPos_1._v = new Vector2(tmp2__anonymous__z9zvc9_2);
              }
               while (!(n_5 === nEnd_1));
            l_0 = tmp16__anonymous__5bf3vu;
            var tmp$ret$8;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            tmp$ret$8 = Unit_getInstance();
          } else {
            Command_getInstance();
            if (tmp0_subject_1 === 3) {
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              var tmp9_0 = n_3;
              n_3 = tmp9_0 + 1 | 0;
              var tmp_13 = fillPath.a3o_1.k(tmp9_0);
              var tmp10_0 = n_3;
              n_3 = tmp10_0 + 1 | 0;
              var tmp17__anonymous__gqgob = _Vector2___init__impl__67w0ru_0(tmp_13, fillPath.a3o_1.k(tmp10_0));
              var tmp11_0 = n_3;
              n_3 = tmp11_0 + 1 | 0;
              var tmp_14 = fillPath.a3o_1.k(tmp11_0);
              var tmp12_0 = n_3;
              n_3 = tmp12_0 + 1 | 0;
              var tmp18__anonymous__4dy6j8 = _Vector2___init__impl__67w0ru_0(tmp_14, fillPath.a3o_1.k(tmp12_0));
              var tmp13_0 = n_3;
              n_3 = tmp13_0 + 1 | 0;
              var tmp_15 = fillPath.a3o_1.k(tmp13_0);
              var tmp14_0 = n_3;
              n_3 = tmp14_0 + 1 | 0;
              var tmp19__anonymous__98mtqr = _Vector2___init__impl__67w0ru_0(tmp_15, fillPath.a3o_1.k(tmp14_0));
              var sum_2 = Companion_getInstance_0().p3j(l_0, tmp17__anonymous__gqgob) + Companion_getInstance_0().p3j(tmp17__anonymous__gqgob, tmp18__anonymous__4dy6j8) + Companion_getInstance_0().p3j(tmp18__anonymous__4dy6j8, tmp19__anonymous__98mtqr);
              // Inline function 'korlibs.math.geom.shape.approximateCurve' call
              var tmp0_approximateCurve_2 = numberToInt(sum_2);
              var tmp$ret$9;
              // Inline function 'kotlin.math.max' call
              tmp$ret$9 = Math.max(tmp0_approximateCurve_2, 20);
              var rcurveSteps_2 = tmp$ret$9;
              var dt_2 = 1.0 / rcurveSteps_2;
              var lastPos_2 = {_v: new Vector2(_Vector2___init__impl__67w0ru_2())};
              var prevPos_2 = {_v: new Vector2(_Vector2___init__impl__67w0ru_2())};
              var emittedCount_2 = {_v: 0};
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var tmp1__anonymous__uwfjfc_3 = Companion_getInstance_15().k3l(l_0, tmp17__anonymous__gqgob, tmp18__anonymous__4dy6j8, tmp19__anonymous__98mtqr, 0.0);
              lastPos_2._v = new Vector2(tmp1__anonymous__uwfjfc_3);
              var nStart_2 = false ? 0 : 1;
              var nEnd_2 = rcurveSteps_2;
              var inductionVariable_2 = nStart_2;
              if (inductionVariable_2 <= nEnd_2)
                do {
                  var n_6 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ratio_2 = n_6 * dt_2;
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                  var tmp2__anonymous__z9zvc9_3 = Companion_getInstance_15().k3l(l_0, tmp17__anonymous__gqgob, tmp18__anonymous__4dy6j8, tmp19__anonymous__98mtqr, ratio_2);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                  var x_7 = Vector2__component1_impl_k3h45m(tmp2__anonymous__z9zvc9_3);
                  var y_7 = Vector2__component2_impl_kkiqjt(tmp2__anonymous__z9zvc9_3);
                  if (doingStroke) {
                    if (false) {
                      renderFinal$flush(this, filler, state, winding, fillPath);
                    }
                  }
                  this.c61_1.q61_1.q3w(x_7, y_7, false);
                  var tmp0_4 = emittedCount_2._v;
                  emittedCount_2._v = tmp0_4 + 1 | 0;
                  lastPos_2._v = prevPos_2._v;
                  prevPos_2._v = new Vector2(tmp2__anonymous__z9zvc9_3);
                }
                 while (!(n_6 === nEnd_2));
              l_0 = tmp19__anonymous__98mtqr;
              var tmp$ret$10;
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              tmp$ret$10 = Unit_getInstance();
            } else {
              Command_getInstance();
              if (tmp0_subject_1 === 4) {
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var tmp20__anonymous__q2j3lv = i_0;
                var x_8 = Vector2__component1_impl_k3h45m(tmp20__anonymous__q2j3lv);
                var y_8 = Vector2__component2_impl_kkiqjt(tmp20__anonymous__q2j3lv);
                if (doingStroke) {
                  if (false) {
                    renderFinal$flush(this, filler, state, winding, fillPath);
                  }
                }
                this.c61_1.q61_1.q3w(x_8, y_8, false);
                var tmp$ret$11;
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                tmp$ret$11 = Unit_getInstance();
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                {
                  this.c61_1.q61_1.c1c();
                }
              }
            }
          }
        }
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.c61_1.q61_1.c1c();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  };
  function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
    mix_0(dst.l4o_1, dstN, src.l4o_1, srcN, count);
    return Unit_getInstance();
  }
  function CompositeOperation$Companion$invoke$1($func) {
    this.h62_1 = $func;
  }
  protoOf(CompositeOperation$Companion$invoke$1).m61 = function (dst, dstN, src, srcN, count) {
    return this.h62_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  };
  function Companion_32() {
    Companion_instance_32 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_52();
    tmp.i62_1 = tmp_0.j62(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  protoOf(Companion_32).j62 = function (func) {
    return new CompositeOperation$Companion$invoke$1(func);
  };
  var Companion_instance_32;
  function Companion_getInstance_52() {
    if (Companion_instance_32 == null)
      new Companion_32();
    return Companion_instance_32;
  }
  var CompositeMode_CLEAR_instance;
  var CompositeMode_COPY_instance;
  var CompositeMode_SOURCE_OVER_instance;
  var CompositeMode_DESTINATION_OVER_instance;
  var CompositeMode_SOURCE_IN_instance;
  var CompositeMode_DESTINATION_IN_instance;
  var CompositeMode_SOURCE_OUT_instance;
  var CompositeMode_DESTINATION_OUT_instance;
  var CompositeMode_SOURCE_ATOP_instance;
  var CompositeMode_DESTINATION_ATOP_instance;
  var CompositeMode_XOR_instance;
  var CompositeMode_LIGHTER_instance;
  function Companion_33() {
    Companion_instance_33 = this;
  }
  protoOf(Companion_33).d3z = function () {
    return CompositeMode_SOURCE_OVER_getInstance();
  };
  var Companion_instance_33;
  function Companion_getInstance_53() {
    CompositeMode_initEntries();
    if (Companion_instance_33 == null)
      new Companion_33();
    return Companion_instance_33;
  }
  function CompositeMode$lambda(dst, dstN, src, srcN, count) {
    var inductionVariable = 0;
    var last = count;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.l4o_1, dstN + n | 0);
        var s = RgbaPremultipliedArray__get_impl_1u69ta(src.l4o_1, srcN + n | 0);
        var tmp = dst.l4o_1;
        var tmp_0 = dstN + n | 0;
        var tmp$ret$0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
        RgbaPremultipliedArray__set_impl_7fwbby(tmp, tmp_0, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
      }
       while (inductionVariable < last);
    return Unit_getInstance();
  }
  function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
    mix_1(dst.l4o_1, dstN, dst.l4o_1, dstN, src.l4o_1, srcN, count);
    return Unit_getInstance();
  }
  function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
    mix_1(dst.l4o_1, dstN, src.l4o_1, srcN, dst.l4o_1, dstN, count);
    return Unit_getInstance();
  }
  var CompositeMode_entriesInitialized;
  function CompositeMode_initEntries() {
    if (CompositeMode_entriesInitialized)
      return Unit_getInstance();
    CompositeMode_entriesInitialized = true;
    var tmp = Companion_getInstance_52();
    CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.j62(CompositeMode$lambda));
    CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_52().i62_1);
    var tmp_0 = Companion_getInstance_52();
    CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.j62(CompositeMode$lambda_0));
    var tmp_1 = Companion_getInstance_52();
    CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.j62(CompositeMode$lambda_1));
    CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_52().i62_1);
    CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_52().i62_1);
    CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_52().i62_1);
    CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_52().i62_1);
    CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_52().i62_1);
    CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_52().i62_1);
    CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_52().i62_1);
    CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_52().i62_1);
    Companion_getInstance_53();
  }
  function CompositeMode(name, ordinal, op) {
    Enum.call(this, name, ordinal);
    this.m62_1 = op;
  }
  protoOf(CompositeMode).m61 = function (dst, dstN, src, srcN, count) {
    this.m62_1.m61(dst, dstN, src, srcN, count);
  };
  function get_DEFAULT(_this__u8e3s4) {
    return Companion_getInstance_53().d3z();
  }
  function BlendMode() {
  }
  function CompositeMode_SOURCE_OVER_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_OVER_instance;
  }
  function Context2d$State$transformTransform$delegate$lambda(this$0) {
    return function () {
      return new MatrixTransform(Matrix__toTransform_impl_lr8urh(this$0.g4q_1));
    };
  }
  function State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_9().v3f_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_49().g5y_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_50().l5y_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.g4q_1 = transform;
    this.h4q_1 = clip;
    this.i4q_1 = path;
    this.j4q_1 = lineScaleMode;
    this.k4q_1 = lineWidth;
    this.l4q_1 = startLineCap;
    this.m4q_1 = endLineCap;
    this.n4q_1 = lineJoin;
    this.o4q_1 = miterLimit;
    this.p4q_1 = strokeStyle;
    this.q4q_1 = fillStyle;
    this.r4q_1 = fontRegistry;
    this.s4q_1 = font;
    this.t4q_1 = fontSize;
    this.u4q_1 = verticalAlign;
    this.v4q_1 = horizontalAlign;
    this.w4q_1 = globalAlpha;
    this.x4q_1 = globalCompositeOperation;
    this.y4q_1 = lineDash;
    this.z4q_1 = lineDashOffset;
    var tmp = this;
    tmp.a4r_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  protoOf(State).n62 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = transformTransform$factory();
    tmp$ret$0 = this.a4r_1.q().q3g_1;
    return tmp$ret$0;
  };
  protoOf(State).a62 = function () {
    var tmp = this.k4q_1;
    var tmp$ret$0;
    // Inline function 'kotlin.math.absoluteValue' call
    var tmp0__get_absoluteValue__nukmtt = _MatrixTransform___get_scaleAvg__impl__ku8ljx(this.n62());
    tmp$ret$0 = Math.abs(tmp0__get_absoluteValue__nukmtt);
    return tmp * tmp$ret$0;
  };
  protoOf(State).o4z = function (value) {
    this.l4q_1 = value;
    this.m4q_1 = value;
  };
  protoOf(State).h4z = function () {
    return this.l4q_1;
  };
  protoOf(State).dn = function () {
    var tmp = this.g4q_1;
    var tmp0_safe_receiver = this.h4q_1;
    var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dn();
    var tmp_1 = this.i4q_1.dn();
    var tmp1_safe_receiver = this.y4q_1;
    return this.o62(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.dn());
  };
  protoOf(State).p62 = function (transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  };
  protoOf(State).o62 = function (transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.g4q_1 : transform;
    clip = clip === VOID ? this.h4q_1 : clip;
    path = path === VOID ? this.i4q_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.j4q_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.k4q_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.l4q_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.m4q_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.n4q_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.o4q_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.p4q_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.q4q_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.r4q_1 : fontRegistry;
    font = font === VOID ? this.s4q_1 : font;
    fontSize = fontSize === VOID ? this.t4q_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.u4q_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.v4q_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.w4q_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.x4q_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.y4q_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.z4q_1 : lineDashOffset;
    return $super === VOID ? this.p62(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.p62.call(this, new Matrix(transform), clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  };
  protoOf(State).toString = function () {
    return 'State(transform=' + new Matrix(this.g4q_1) + ', clip=' + this.h4q_1 + ', path=' + this.i4q_1 + ', lineScaleMode=' + this.j4q_1 + ', lineWidth=' + this.k4q_1 + ', startLineCap=' + this.l4q_1 + ', endLineCap=' + this.m4q_1 + ', lineJoin=' + this.n4q_1 + ', miterLimit=' + this.o4q_1 + ', strokeStyle=' + this.p4q_1 + ', fillStyle=' + this.q4q_1 + ', fontRegistry=' + this.r4q_1 + ', font=' + this.s4q_1 + ', fontSize=' + this.t4q_1 + ', verticalAlign=' + new VerticalAlign(this.u4q_1) + ', horizontalAlign=' + new HorizontalAlign(this.v4q_1) + ', globalAlpha=' + this.w4q_1 + ', globalCompositeOperation=' + this.x4q_1 + ', lineDash=' + this.y4q_1 + ', lineDashOffset=' + this.z4q_1 + ')';
  };
  protoOf(State).hashCode = function () {
    var result = Matrix__hashCode_impl_s9ntm9(this.g4q_1);
    result = imul(result, 31) + (this.h4q_1 == null ? 0 : this.h4q_1.hashCode()) | 0;
    result = imul(result, 31) + this.i4q_1.hashCode() | 0;
    result = imul(result, 31) + this.j4q_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.k4q_1) | 0;
    result = imul(result, 31) + this.l4q_1.hashCode() | 0;
    result = imul(result, 31) + this.m4q_1.hashCode() | 0;
    result = imul(result, 31) + this.n4q_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4q_1) | 0;
    result = imul(result, 31) + hashCode(this.p4q_1) | 0;
    result = imul(result, 31) + hashCode(this.q4q_1) | 0;
    result = imul(result, 31) + (this.r4q_1 == null ? 0 : hashCode(this.r4q_1)) | 0;
    result = imul(result, 31) + (this.s4q_1 == null ? 0 : hashCode(this.s4q_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t4q_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.u4q_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.v4q_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w4q_1) | 0;
    result = imul(result, 31) + hashCode(this.x4q_1) | 0;
    result = imul(result, 31) + (this.y4q_1 == null ? 0 : hashCode(this.y4q_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z4q_1) | 0;
    return result;
  };
  protoOf(State).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!equals(this.g4q_1, tmp0_other_with_cast.g4q_1))
      return false;
    if (!equals(this.h4q_1, tmp0_other_with_cast.h4q_1))
      return false;
    if (!this.i4q_1.equals(tmp0_other_with_cast.i4q_1))
      return false;
    if (!this.j4q_1.equals(tmp0_other_with_cast.j4q_1))
      return false;
    if (!equals(this.k4q_1, tmp0_other_with_cast.k4q_1))
      return false;
    if (!this.l4q_1.equals(tmp0_other_with_cast.l4q_1))
      return false;
    if (!this.m4q_1.equals(tmp0_other_with_cast.m4q_1))
      return false;
    if (!this.n4q_1.equals(tmp0_other_with_cast.n4q_1))
      return false;
    if (!equals(this.o4q_1, tmp0_other_with_cast.o4q_1))
      return false;
    if (!equals(this.p4q_1, tmp0_other_with_cast.p4q_1))
      return false;
    if (!equals(this.q4q_1, tmp0_other_with_cast.q4q_1))
      return false;
    if (!equals(this.r4q_1, tmp0_other_with_cast.r4q_1))
      return false;
    if (!equals(this.s4q_1, tmp0_other_with_cast.s4q_1))
      return false;
    if (!equals(this.t4q_1, tmp0_other_with_cast.t4q_1))
      return false;
    if (!equals(this.u4q_1, tmp0_other_with_cast.u4q_1))
      return false;
    if (!equals(this.v4q_1, tmp0_other_with_cast.v4q_1))
      return false;
    if (!equals(this.w4q_1, tmp0_other_with_cast.w4q_1))
      return false;
    if (!equals(this.x4q_1, tmp0_other_with_cast.x4q_1))
      return false;
    if (!equals(this.y4q_1, tmp0_other_with_cast.y4q_1))
      return false;
    if (!equals(this.z4q_1, tmp0_other_with_cast.z4q_1))
      return false;
    return true;
  };
  function trans($this, p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var tmp0_transform = $this.g4f_1.g4q_1;
      if (_Matrix___get_isNIL__impl__n63x5q(tmp0_transform)) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = _Vector2___init__impl__67w0ru_0(_Matrix___get_a__impl__f7jypo(tmp0_transform) * _Vector2___get_x__impl__zywdz(p) + _Matrix___get_c__impl__slf2ke(tmp0_transform) * _Vector2___get_y__impl__ttldg6(p) + _Matrix___get_tx__impl__yc1n9(tmp0_transform), _Matrix___get_d__impl__87eht(tmp0_transform) * _Vector2___get_y__impl__ttldg6(p) + _Matrix___get_b__impl__dm2icj(tmp0_transform) * _Vector2___get_x__impl__zywdz(p) + _Matrix___get_ty__impl__tryipg(tmp0_transform));
    }
    return tmp$ret$0;
  }
  function Context2d(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.d4f_1 = renderer;
    this.e4f_1 = defaultFontRegistry;
    this.f4f_1 = defaultFont;
    this.g4f_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.e4f_1, this.f4f_1);
    this.h4f_1 = _TGenStack___init__impl__yynjgt();
    this.i4f_1 = _Vector2___init__impl__67w0ru_2();
    this.j4f_1 = _Vector2___init__impl__67w0ru_2();
  }
  protoOf(Context2d).q62 = function () {
    return this.d4f_1.ck();
  };
  protoOf(Context2d).r62 = function () {
    return this.d4f_1.dk();
  };
  protoOf(Context2d).s62 = function (state, fill, winding) {
    return this.d4f_1.d62(state, fill, winding);
  };
  protoOf(Context2d).t62 = function (state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.s62(state, fill, winding);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.s62.call(this, state, fill, winding);
    }
    return tmp;
  };
  protoOf(Context2d).u62 = function (image, pos, size, transform) {
    return this.d4f_1.g62(image, pos, size, transform);
  };
  protoOf(Context2d).v62 = function () {
    return this.d4f_1.p13();
  };
  protoOf(Context2d).w62 = function () {
    return this.d4f_1.b62();
  };
  protoOf(Context2d).x62 = function () {
    return this.d4f_1.c62();
  };
  protoOf(Context2d).ck = function () {
    return this.q62();
  };
  protoOf(Context2d).dk = function () {
    return this.r62();
  };
  protoOf(Context2d).p13 = function () {
    this.v62();
  };
  protoOf(Context2d).y62 = function () {
    return this.w62();
  };
  protoOf(Context2d).z62 = function () {
    return this.x62();
  };
  protoOf(Context2d).a63 = function (value) {
    this.g4f_1.j4q_1 = value;
  };
  protoOf(Context2d).n4z = function (value) {
    this.g4f_1.k4q_1 = value;
  };
  protoOf(Context2d).g4z = function () {
    return this.g4f_1.k4q_1;
  };
  protoOf(Context2d).o4z = function (value) {
    this.g4f_1.o4z(value);
  };
  protoOf(Context2d).h4z = function () {
    return this.g4f_1.h4z();
  };
  protoOf(Context2d).q4z = function (value) {
    this.g4f_1.o4q_1 = value;
  };
  protoOf(Context2d).j4z = function () {
    return this.g4f_1.o4q_1;
  };
  protoOf(Context2d).p4z = function (value) {
    this.g4f_1.n4q_1 = value;
  };
  protoOf(Context2d).i4z = function () {
    return this.g4f_1.n4q_1;
  };
  protoOf(Context2d).b63 = function (value) {
    this.g4f_1.p4q_1 = value;
  };
  protoOf(Context2d).c63 = function () {
    return this.g4f_1.p4q_1;
  };
  protoOf(Context2d).d4r = function (value) {
    this.g4f_1.q4q_1 = value;
  };
  protoOf(Context2d).c4r = function () {
    return this.g4f_1.q4q_1;
  };
  protoOf(Context2d).i51 = function () {
    return this.g4f_1.s4q_1;
  };
  protoOf(Context2d).b4p = function () {
    return this.g4f_1.t4q_1;
  };
  protoOf(Context2d).z5z = function () {
    return this.g4f_1.u4q_1;
  };
  protoOf(Context2d).d63 = function () {
    return this.g4f_1.v4q_1;
  };
  protoOf(Context2d).e63 = function () {
    return Companion_getInstance_51().r5y(this.d63(), this.z5z());
  };
  protoOf(Context2d).r4z = function (value) {
    this.g4f_1.y4q_1 = value;
  };
  protoOf(Context2d).k4z = function () {
    return this.g4f_1.y4q_1;
  };
  protoOf(Context2d).s4z = function (value) {
    this.g4f_1.z4q_1 = value;
  };
  protoOf(Context2d).l4z = function () {
    return this.g4f_1.z4q_1;
  };
  protoOf(Context2d).m4z = function () {
    TGenStack__push_impl_9yh33t(this.h4f_1, this.g4f_1.dn());
  };
  protoOf(Context2d).u4z = function () {
    this.g4f_1 = TGenStack__pop_impl_qisxa0(this.h4f_1);
  };
  protoOf(Context2d).v5k = function (sx, sy) {
    this.g4f_1.g4q_1 = Matrix__prescaled_impl_gy2bxt(this.g4f_1.g4q_1, sx, sy);
  };
  protoOf(Context2d).b4r = function (sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.v5k(sx, sy);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.v5k.call(this, sx, sy);
    }
    return tmp;
  };
  protoOf(Context2d).f51 = function (tx, ty) {
    this.g4f_1.g4q_1 = Matrix__pretranslated_impl_9mjs3v(this.g4f_1.g4q_1, tx, ty);
  };
  protoOf(Context2d).h51 = function (m) {
    this.g4f_1.g4q_1 = Matrix__premultiplied_impl_rsndx4(this.g4f_1.g4q_1, m);
  };
  protoOf(Context2d).f63 = function (_set____db54di) {
    this.j4f_1 = _set____db54di;
  };
  protoOf(Context2d).m3y = function () {
    return this.j4f_1;
  };
  protoOf(Context2d).l3y = function () {
    return this.g4f_1.i4q_1.l3y();
  };
  protoOf(Context2d).c1c = function () {
    this.g4f_1.i4q_1.c1c();
    this.f63(this.i4f_1);
  };
  protoOf(Context2d).e3k = function (p) {
    this.g4f_1.i4q_1.e3k(trans(this, p));
    this.f63(p);
    this.i4f_1 = p;
  };
  protoOf(Context2d).j3o = function (p) {
    this.g4f_1.i4q_1.j3o(trans(this, p));
    this.f63(p);
  };
  protoOf(Context2d).k3o = function (c, a) {
    this.g4f_1.i4q_1.k3o(trans(this, c), trans(this, a));
    this.f63(a);
  };
  protoOf(Context2d).f3k = function (c1, c2, a) {
    this.g4f_1.i4q_1.f3k(trans(this, c1), trans(this, c2), trans(this, a));
    this.f63(a);
  };
  protoOf(Context2d).u5k = function (path) {
    if (this.l())
      this.g4f_1.i4q_1.b3o_1 = path.b3o_1;
    write_0(this, path);
  };
  protoOf(Context2d).o52 = function (d) {
    d.n52(this);
  };
  protoOf(Context2d).e4r = function (x, y, width, height) {
    this.t4x();
    this.q3y(x, y, width, height);
    this.c4z();
  };
  protoOf(Context2d).t4x = function () {
    this.g4f_1.i4q_1 = new VectorPath();
  };
  protoOf(Context2d).b4z = function () {
    if (!equals(this.g4f_1.p4q_1, NonePaint_getInstance())) {
      this.t62(this.g4f_1, false);
    }
  };
  protoOf(Context2d).g63 = function (winding) {
    if (!equals(this.g4f_1.q4q_1, NonePaint_getInstance())) {
      this.s62(this.g4f_1, true, winding);
    }
  };
  protoOf(Context2d).c4z = function (winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.g63(winding);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.g63.call(this, winding);
    }
    return tmp;
  };
  protoOf(Context2d).h63 = function (paint, winding) {
    if (paint == null)
      return Unit_getInstance();
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.c4r();
    this.d4r(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.g63(winding);
    }finally {
      this.d4r(oldStyle);
    }
  };
  protoOf(Context2d).f4z = function (paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.h63(paint, winding);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.h63.call(this, paint, winding);
    }
    return tmp;
  };
  protoOf(Context2d).t4z = function (paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.c63();
    this.b63(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.b4z();
    }finally {
      this.b63(oldStyle);
    }
  };
  protoOf(Context2d).i63 = function (path, winding) {
    if (!(path == null)) {
      if (this.g4f_1.h4q_1 == null) {
        this.g4f_1.h4q_1 = new VectorPath();
      }
      ensureNotNull(this.g4f_1.h4q_1).v2();
      ensureNotNull(this.g4f_1.h4q_1).b3o_1 = winding;
      ensureNotNull(this.g4f_1.h4q_1).i3z(path);
      if (path === this.g4f_1.i4q_1) {
        path.v2();
      }
    } else {
      this.g4f_1.h4q_1 = null;
    }
  };
  protoOf(Context2d).j63 = function (path, winding, $super) {
    path = path === VOID ? this.g4f_1.i4q_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.i63(path, winding);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.i63.call(this, path, winding);
    }
    return tmp;
  };
  protoOf(Context2d).k63 = function (text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var tmp0_elvis_lhs = paint;
    var paint_0 = tmp0_elvis_lhs == null ? fill ? this.c4r() : this.c63() : tmp0_elvis_lhs;
    var tmp1_safe_receiver = font;
    return tmp1_safe_receiver == null ? null : drawText(tmp1_safe_receiver, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  };
  protoOf(Context2d).l63 = function (text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_0().h3b_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.i51() : font;
    size = size === VOID ? this.b4p() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.e63() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? IntCompanionObject_getInstance().MAX_VALUE : textRangeEnd;
    return $super === VOID ? this.k63(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.k63.call(this, text, new Vector2(pos), fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  };
  protoOf(Context2d).f4r = function (image, pos, size) {
    return this.u62(image, pos, size, this.g4f_1.g4q_1);
  };
  protoOf(Context2d).z5t = function (image, pos, size, $super) {
    size = size === VOID ? toFloat(image.k3s()) : size;
    var tmp;
    if ($super === VOID) {
      this.f4r(image, pos, size);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.f4r.call(this, image, new Vector2(pos), new Size(size));
    }
    return tmp;
  };
  function write_0(_this__u8e3s4, path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = path.z3n_1;
    var n_0 = 0;
    while (n_0 < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.ek(tmp0);
      var tmp0_subject = tmp1__anonymous__uwfjfc;
      Command_getInstance();
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.image.vector.write.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = path.a3o_1.k(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var tmp2__anonymous__z9zvc9 = _Vector2___init__impl__67w0ru_0(tmp, path.a3o_1.k(tmp2));
        _this__u8e3s4.e3k(tmp2__anonymous__z9zvc9);
      } else {
        Command_getInstance();
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.image.vector.write.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = path.a3o_1.k(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var tmp3__anonymous__ufb84q = _Vector2___init__impl__67w0ru_0(tmp_0, path.a3o_1.k(tmp4));
          _this__u8e3s4.j3o(tmp3__anonymous__ufb84q);
        } else {
          Command_getInstance();
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.image.vector.write.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = path.a3o_1.k(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var tmp4__anonymous__pkmkx7 = _Vector2___init__impl__67w0ru_0(tmp_1, path.a3o_1.k(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = path.a3o_1.k(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var tmp5__anonymous__kpxxpo = _Vector2___init__impl__67w0ru_0(tmp_2, path.a3o_1.k(tmp8));
            _this__u8e3s4.k3o(tmp4__anonymous__pkmkx7, tmp5__anonymous__kpxxpo);
          } else {
            Command_getInstance();
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.image.vector.write.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = path.a3o_1.k(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var tmp6__anonymous__fv9ai5 = _Vector2___init__impl__67w0ru_0(tmp_3, path.a3o_1.k(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = path.a3o_1.k(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var tmp7__anonymous__b0knam = _Vector2___init__impl__67w0ru_0(tmp_4, path.a3o_1.k(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = path.a3o_1.k(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var tmp8__anonymous__65w033 = _Vector2___init__impl__67w0ru_0(tmp_5, path.a3o_1.k(tmp14));
              _this__u8e3s4.f3k(tmp6__anonymous__fv9ai5, tmp7__anonymous__b0knam, tmp8__anonymous__65w033);
            } else {
              Command_getInstance();
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.image.vector.write.<anonymous>' call
                _this__u8e3s4.c1c();
              }
            }
          }
        }
      }
    }
  }
  function toBitmapPaint(_this__u8e3s4, state) {
    var filler = toFiller(_this__u8e3s4, state);
    var bb = Companion_getInstance_10().f3b();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.i4q_1.w3l());
    var tmp = bb;
    var tmp0_safe_receiver = state.h4q_1;
    bb = BoundsBuilder__plus_impl_cz7f7x_2(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w3l());
    var bounds = Rectangle__transformed_impl_5k4zxr(_BoundsBuilder___get_bounds__impl__s1l1gx(bb), state.g4q_1);
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new Bitmap32(toIntCeil(_Rectangle___get_width__impl__y1u79l(bounds)), toIntCeil(_Rectangle___get_height__impl__kro6o8(bounds)), VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
    filler.q5w(tmp0_also);
    tmp$ret$0 = tmp0_also;
    var bmp = tmp$ret$0;
    return new BitmapPaint(bmp, Matrix__translated_impl_3xg5y_2(Companion_getInstance_9().g3g(), -_Rectangle___get_left__impl__sgtjiw(bounds), -_Rectangle___get_top__impl__3kuxui(bounds)));
  }
  function transformTransform$factory() {
    return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
      return new MatrixTransform(receiver.n62());
    }, null);
  }
  var CycleMethod_NO_CYCLE_instance;
  var CycleMethod_NO_CYCLE_CLAMP_instance;
  var CycleMethod_REPEAT_instance;
  var CycleMethod_REFLECT_instance;
  function Companion_34() {
    Companion_instance_34 = this;
    this.m63_1 = values_6();
  }
  var Companion_instance_34;
  function Companion_getInstance_54() {
    CycleMethod_initEntries();
    if (Companion_instance_34 == null)
      new Companion_34();
    return Companion_instance_34;
  }
  function values_6() {
    return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
  }
  var CycleMethod_entriesInitialized;
  function CycleMethod_initEntries() {
    if (CycleMethod_entriesInitialized)
      return Unit_getInstance();
    CycleMethod_entriesInitialized = true;
    CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
    CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
    CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
    CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
    Companion_getInstance_54();
  }
  function CycleMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(CycleMethod).z5x = function () {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) ? !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance()) : false;
  };
  protoOf(CycleMethod).w5x = function (ratio) {
    var tmp0_subject = this;
    var tmp0 = tmp0_subject.j5_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        var tmp$ret$0;
        // Inline function 'korlibs.memory.fract' call
        tmp$ret$0 = ratio - toIntFloor(ratio);

        tmp = tmp$ret$0;
        break;
      case 3:
        var part = umod(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function _CycleMethodPair___init__impl__y6jlco(data) {
    return data;
  }
  function _CycleMethodPair___get_data__impl__r5ik0n($this) {
    return $this;
  }
  function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
    var tmp = _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.j5_1, 0), y.j5_1, 8));
    return tmp;
  }
  function _CycleMethodPair___get_x__impl__dgz5uj($this) {
    var tmp = Companion_getInstance_54().m63_1;
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = _CycleMethodPair___get_data__impl__r5ik0n($this);
    tmp$ret$0 = (tmp0_extract8 >>> 0 | 0) & 255;
    return tmp[tmp$ret$0];
  }
  function _CycleMethodPair___get_y__impl__fcnb7o($this) {
    var tmp = Companion_getInstance_54().m63_1;
    var tmp$ret$0;
    // Inline function 'korlibs.memory.extract8' call
    var tmp0_extract8 = _CycleMethodPair___get_data__impl__r5ik0n($this);
    tmp$ret$0 = (tmp0_extract8 >>> 8 | 0) & 255;
    return tmp[tmp$ret$0];
  }
  function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
    return _Vector2___init__impl__67w0ru_0(_CycleMethodPair___get_x__impl__dgz5uj($this).w5x(_Vector2___get_x__impl__zywdz(ratio)), _CycleMethodPair___get_y__impl__fcnb7o($this).w5x(_Vector2___get_y__impl__ttldg6(ratio)));
  }
  function CycleMethod_NO_CYCLE_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_NO_CYCLE_instance;
  }
  function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_NO_CYCLE_CLAMP_instance;
  }
  function CycleMethod_REPEAT_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_REPEAT_instance;
  }
  function CycleMethod_REFLECT_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_REFLECT_instance;
  }
  function draw_0(_this__u8e3s4, c) {
    c.u5k(_this__u8e3s4);
  }
  function draw_1(_this__u8e3s4, path) {
    _this__u8e3s4.u5k(path);
  }
  function msdfBmp(_this__u8e3s4, width, height) {
    var msdf_0 = msdf(_this__u8e3s4, width, height);
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var tmp0_forEach = msdf_0.r46_1 - 0 | 0;
    var tmp1_forEach = msdf_0.s46_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + tmp1_forEach | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = msdf_0.c48(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + tmp0_forEach | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            var tmp2__anonymous__z9zvc9 = tmp2;
            var tmp$ret$0;
            // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
            var tmp3__anonymous__ufb84q = msdf_0.m4k(x, y);
            tmp$ret$0 = false ? -100.0 : tmp3__anonymous__ufb84q;
            var tmp = tmp$ret$0;
            var tmp$ret$1;
            // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
            var tmp4__anonymous__pkmkx7 = msdf_0.n4k(x, y);
            tmp$ret$1 = false ? -100.0 : tmp4__anonymous__pkmkx7;
            var tmp_0 = tmp$ret$1;
            var tmp$ret$2;
            // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
            var tmp5__anonymous__kpxxpo = msdf_0.o4k(x, y);
            tmp$ret$2 = false ? -100.0 : tmp5__anonymous__kpxxpo;
            var tmp_1 = tmp$ret$2;
            var tmp$ret$3;
            // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
            var tmp6__anonymous__fv9ai5 = msdf_0.p4k(x, y);
            tmp$ret$3 = -100.0;
            msdf_0.q4k(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    msdf_0.x4k(-1.0);
    msdf_0.z4k(-1.0, 1.0);
    msdf_0.w4k();
    var msdfBitmap = msdf_0.e47();
    return msdfBitmap;
  }
  function sdfBmp(_this__u8e3s4, width, height) {
    var tmp = NewSDF_getInstance();
    var newImage = tmp.o4m(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).e47(), VOID, 0);
    return newImage.h4m_1.c4f();
  }
  function msdf(_this__u8e3s4, width, height) {
    return msdf_0(_this__u8e3s4, new FloatBitmap32(width, height));
  }
  function msdf_0(_this__u8e3s4, data) {
    var path = _this__u8e3s4;
    var curvesList = toCurvesList(path);
    var p = _Vector2___init__impl__67w0ru_2();
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(curvesList, 10));
    var tmp0_iterator = curvesList.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$0;
      // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
      tmp$ret$0 = colorize(item.n3n_1, item.o3n_1);
      tmp0_mapTo.b(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var colorizedCurves = tmp$ret$2;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp1_flatMapTo = ArrayList_init_$Create$();
    var tmp0_iterator_0 = colorizedCurves.g();
    while (tmp0_iterator_0.h()) {
      var element = tmp0_iterator_0.i();
      var tmp$ret$3;
      // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
      tmp$ret$3 = element.n63_1;
      var list = tmp$ret$3;
      addAll(tmp1_flatMapTo, list);
    }
    tmp$ret$4 = tmp1_flatMapTo;
    tmp$ret$5 = tmp$ret$4;
    var allColorizedCurves = new ColorizedBeziers(tmp$ret$5);
    var inductionVariable = 0;
    var last = data.s46_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = data.r46_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            p = _Vector2___init__impl__67w0ru_1(x + 0.5, y + 0.5);
            var inside = path.g3z(p);
            var allDist = allColorizedCurves.v63().z63(p);
            var redDist = allColorizedCurves.a64().z63(p);
            var greenDist = allColorizedCurves.b64().z63(p);
            var blueDist = allColorizedCurves.c64().z63(p);
            var minR = redDist;
            var minG = greenDist;
            var minB = blueDist;
            var minA = allDist;
            if (inside) {
              minR = -minR;
              minG = -minG;
              minB = -minB;
              minA = -minA;
            }
            data.q4k(x, y, minR, minG, minB, minA);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    return data;
  }
  function ColorizedBeziers$red$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.filter' call
      var tmp1_filter = this$0.n63_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList_init_$Create$();
      var tmp0_iterator = tmp1_filter.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
        tmp$ret$0 = !(_RGBA___get_r__impl__duz7mo(element.e64_1) === 0);
        if (tmp$ret$0) {
          tmp0_filterTo.b(element);
        }
      }
      tmp$ret$1 = tmp0_filterTo;
      tmp$ret$2 = tmp$ret$1;
      return tmp$ret$2;
    };
  }
  function ColorizedBeziers$green$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.filter' call
      var tmp1_filter = this$0.n63_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList_init_$Create$();
      var tmp0_iterator = tmp1_filter.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
        tmp$ret$0 = !(_RGBA___get_g__impl__o8pukr(element.e64_1) === 0);
        if (tmp$ret$0) {
          tmp0_filterTo.b(element);
        }
      }
      tmp$ret$1 = tmp0_filterTo;
      tmp$ret$2 = tmp$ret$1;
      return tmp$ret$2;
    };
  }
  function ColorizedBeziers$blue$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.filter' call
      var tmp1_filter = this$0.n63_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList_init_$Create$();
      var tmp0_iterator = tmp1_filter.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
        tmp$ret$0 = !(_RGBA___get_b__impl__m6tl80(element.e64_1) === 0);
        if (tmp$ret$0) {
          tmp0_filterTo.b(element);
        }
      }
      tmp$ret$1 = tmp0_filterTo;
      tmp$ret$2 = tmp$ret$1;
      return tmp$ret$2;
    };
  }
  function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = this$0.n63_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var tmp0_iterator = tmp1_map.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
        tmp$ret$0 = item.d64_1;
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      return new ProjectCurvesLookup(tmp$ret$2);
    };
  }
  function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = this$0.f64();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var tmp0_iterator = tmp1_map.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
        tmp$ret$0 = item.d64_1;
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      return new ProjectCurvesLookup(tmp$ret$2);
    };
  }
  function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = this$0.g64();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var tmp0_iterator = tmp1_map.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
        tmp$ret$0 = item.d64_1;
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      return new ProjectCurvesLookup(tmp$ret$2);
    };
  }
  function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp1_map = this$0.h64();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map, 10));
      var tmp0_iterator = tmp1_map.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
        tmp$ret$0 = item.d64_1;
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      return new ProjectCurvesLookup(tmp$ret$2);
    };
  }
  function ColorizedBeziers(beziers) {
    this.n63_1 = beziers;
    var tmp = this;
    tmp.o63_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.p63_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.q63_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.r63_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.s63_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.t63_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.u63_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  protoOf(ColorizedBeziers).f64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = red$factory();
    tmp$ret$0 = this.o63_1.q();
    return tmp$ret$0;
  };
  protoOf(ColorizedBeziers).g64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = green$factory();
    tmp$ret$0 = this.p63_1.q();
    return tmp$ret$0;
  };
  protoOf(ColorizedBeziers).h64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = blue$factory();
    tmp$ret$0 = this.q63_1.q();
    return tmp$ret$0;
  };
  protoOf(ColorizedBeziers).v63 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allProjected$factory();
    tmp$ret$0 = this.r63_1.q();
    return tmp$ret$0;
  };
  protoOf(ColorizedBeziers).a64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = redProjected$factory();
    tmp$ret$0 = this.s63_1.q();
    return tmp$ret$0;
  };
  protoOf(ColorizedBeziers).b64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = greenProjected$factory();
    tmp$ret$0 = this.t63_1.q();
    return tmp$ret$0;
  };
  protoOf(ColorizedBeziers).c64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = blueProjected$factory();
    tmp$ret$0 = this.u63_1.q();
    return tmp$ret$0;
  };
  function colorize(_this__u8e3s4, closed) {
    closed = closed === VOID ? true : closed;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapIndexed' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var tmp0_mapIndexedTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var index = 0;
    var tmp0_iterator = _this__u8e3s4.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$0;
      // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp1__anonymous__uwfjfc = checkIndexOverflow(tmp1);
      var color = msdfColor(tmp1__anonymous__uwfjfc, _this__u8e3s4.j(), closed);
      tmp$ret$0 = new ColoredBezier(item, color);
      tmp0_mapIndexedTo.b(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapIndexedTo;
    tmp$ret$2 = tmp$ret$1;
    return new ColorizedBeziers(tmp$ret$2);
  }
  function ColoredBezier(bezier, color) {
    this.d64_1 = bezier;
    this.e64_1 = color;
  }
  protoOf(ColoredBezier).toString = function () {
    return 'ColoredBezier(bezier=' + this.d64_1 + ', color=' + new RGBA(this.e64_1) + ')';
  };
  protoOf(ColoredBezier).hashCode = function () {
    var result = this.d64_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.e64_1) | 0;
    return result;
  };
  protoOf(ColoredBezier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.d64_1.equals(tmp0_other_with_cast.d64_1))
      return false;
    if (!(this.e64_1 === tmp0_other_with_cast.e64_1))
      return false;
    return true;
  };
  function ProjectCurvesLookup(beziers) {
    this.w63_1 = beziers;
    this.x63_1 = new ProjectedPoint();
    this.y63_1 = Companion_getInstance_16().y3e();
  }
  protoOf(ProjectCurvesLookup).z63 = function (point) {
    return Companion_getInstance_0().p3j(point, this.i64(point));
  };
  protoOf(ProjectCurvesLookup).i64 = function (point) {
    if (this.w63_1.l())
      return _Vector2___init__impl__67w0ru(0, 0);
    DoubleCompanionObject_getInstance();
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.w63_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      var dist = tmp1__anonymous__uwfjfc.z3l().a3c(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    FloatCompanionObject_getInstance();
    var bminDistSq = Infinity;
    var out = _Vector2___init__impl__67w0ru_2();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp2_fastForEach = this.w63_1;
    var n_0 = 0;
    while (n_0 < tmp2_fastForEach.j()) {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var tmp0_0 = n_0;
        n_0 = tmp0_0 + 1 | 0;
        var tmp3__anonymous__ufb84q = tmp2_fastForEach.k(tmp0_0);
        if (tmp3__anonymous__ufb84q.z3l().z3b(point) > minDistSq) {
          tmp$ret$0 = Unit_getInstance();
          break $l$block;
        }
        tmp3__anonymous__ufb84q.m3m(point, this.x63_1);
        if (this.x63_1.g3l_1 < bminDistSq) {
          bminDistSq = this.x63_1.g3l_1;
          out = this.x63_1.e3l_1;
        }
      }
    }
    return out;
  };
  function msdfColor(index, size, closed) {
    if (size === 1)
      return Colors_getInstance().j48_1;
    if (index === 0)
      return Colors_getInstance().l4a_1;
    return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().z4d_1 : Colors_getInstance().j49_1;
  }
  function sdfBmp$lambda($this_sdfBmp) {
    return function ($this$NativeImageContext2d) {
      var tmp0_fill = Colors_getInstance().j48_1;
      {
        $this$NativeImageContext2d.t4x();
      }
      // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
      write($this$NativeImageContext2d, $this_sdfBmp);
      $this$NativeImageContext2d.h63(new RGBA(tmp0_fill), null);
      return Unit_getInstance();
    };
  }
  function red$factory() {
    return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
      return receiver.f64();
    }, null);
  }
  function green$factory() {
    return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
      return receiver.g64();
    }, null);
  }
  function blue$factory() {
    return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
      return receiver.h64();
    }, null);
  }
  function allProjected$factory() {
    return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
      return receiver.v63();
    }, null);
  }
  function redProjected$factory() {
    return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
      return receiver.a64();
    }, null);
  }
  function greenProjected$factory() {
    return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
      return receiver.b64();
    }, null);
  }
  function blueProjected$factory() {
    return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
      return receiver.c64();
    }, null);
  }
  function Shape() {
  }
  function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
    prefix = prefix === VOID ? 'ctx.' : prefix;
    suffix = suffix === VOID ? ';' : suffix;
    decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.buildListInternal' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = ArrayList_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = _this__u8e3s4.z3n_1;
    var n_0 = 0;
    while (n_0 < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.ek(tmp0);
      var tmp0_subject = tmp1__anonymous__uwfjfc;
      Command_getInstance();
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = _this__u8e3s4.a3o_1.k(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var tmp2__anonymous__z9zvc9 = _Vector2___init__impl__67w0ru_0(tmp, _this__u8e3s4.a3o_1.k(tmp2));
        var x = Vector2__component1_impl_k3h45m(tmp2__anonymous__z9zvc9);
        var y = Vector2__component2_impl_kkiqjt(tmp2__anonymous__z9zvc9);
        tmp0_apply.b('moveTo(' + toContext2dCommands$_anonymous_$round_n7bczj(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(y, decimalPlaces) + ')');
      } else {
        Command_getInstance();
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = _this__u8e3s4.a3o_1.k(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var tmp3__anonymous__ufb84q = _Vector2___init__impl__67w0ru_0(tmp_0, _this__u8e3s4.a3o_1.k(tmp4));
          var x_0 = Vector2__component1_impl_k3h45m(tmp3__anonymous__ufb84q);
          var y_0 = Vector2__component2_impl_kkiqjt(tmp3__anonymous__ufb84q);
          tmp0_apply.b('lineTo(' + toContext2dCommands$_anonymous_$round_n7bczj(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(y_0, decimalPlaces) + ')');
        } else {
          Command_getInstance();
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = _this__u8e3s4.a3o_1.k(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var tmp4__anonymous__pkmkx7 = _Vector2___init__impl__67w0ru_0(tmp_1, _this__u8e3s4.a3o_1.k(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = _this__u8e3s4.a3o_1.k(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var tmp5__anonymous__kpxxpo = _Vector2___init__impl__67w0ru_0(tmp_2, _this__u8e3s4.a3o_1.k(tmp8));
            var cx = Vector2__component1_impl_k3h45m(tmp4__anonymous__pkmkx7);
            var cy = Vector2__component2_impl_kkiqjt(tmp4__anonymous__pkmkx7);
            var ax = Vector2__component1_impl_k3h45m(tmp5__anonymous__kpxxpo);
            var ay = Vector2__component2_impl_kkiqjt(tmp5__anonymous__kpxxpo);
            tmp0_apply.b('quadTo(' + toContext2dCommands$_anonymous_$round_n7bczj(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(ay, decimalPlaces) + ')');
          } else {
            Command_getInstance();
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = _this__u8e3s4.a3o_1.k(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var tmp6__anonymous__fv9ai5 = _Vector2___init__impl__67w0ru_0(tmp_3, _this__u8e3s4.a3o_1.k(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = _this__u8e3s4.a3o_1.k(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var tmp7__anonymous__b0knam = _Vector2___init__impl__67w0ru_0(tmp_4, _this__u8e3s4.a3o_1.k(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = _this__u8e3s4.a3o_1.k(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var tmp8__anonymous__65w033 = _Vector2___init__impl__67w0ru_0(tmp_5, _this__u8e3s4.a3o_1.k(tmp14));
              var cx1 = Vector2__component1_impl_k3h45m(tmp6__anonymous__fv9ai5);
              var cy1 = Vector2__component2_impl_kkiqjt(tmp6__anonymous__fv9ai5);
              var cx2 = Vector2__component1_impl_k3h45m(tmp7__anonymous__b0knam);
              var cy2 = Vector2__component2_impl_kkiqjt(tmp7__anonymous__b0knam);
              var ax_0 = Vector2__component1_impl_k3h45m(tmp8__anonymous__65w033);
              var ay_0 = Vector2__component2_impl_kkiqjt(tmp8__anonymous__65w033);
              tmp0_apply.b('cubicTo(' + toContext2dCommands$_anonymous_$round_n7bczj(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round_n7bczj(ay_0, decimalPlaces) + ')');
            } else {
              Command_getInstance();
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call
                tmp0_apply.b('close()');
              }
            }
          }
        }
      }
    }
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.gb();
    tmp$ret$2 = tmp$ret$1;
    var tmp2_map = tmp$ret$2;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp1_mapTo = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map, 10));
    var tmp0_iterator = tmp2_map.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$3;
      // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
      tmp$ret$3 = prefix + item + suffix;
      tmp1_mapTo.b(tmp$ret$3);
    }
    tmp$ret$4 = tmp1_mapTo;
    tmp$ret$5 = tmp$ret$4;
    return tmp$ret$5;
  }
  function FillShape$pathCurvesList$delegate$lambda(this$0) {
    return function () {
      return toCurvesList(this$0.l64_1);
    };
  }
  function FillShape$clipCurvesList$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.m64_1;
      return tmp0_safe_receiver == null ? null : toCurvesList(tmp0_safe_receiver);
    };
  }
  function FillShape(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_9().v3f_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.l64_1 = path;
    this.m64_1 = clip;
    this.n64_1 = paint;
    this.o64_1 = transform;
    this.p64_1 = globalAlpha;
    var tmp = this;
    tmp.q64_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.r64_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  protoOf(FillShape).g1z = function () {
    return this.l64_1;
  };
  protoOf(FillShape).s64 = function () {
    return this.m64_1;
  };
  protoOf(FillShape).g51 = function () {
    return this.o64_1;
  };
  protoOf(FillShape).t64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = pathCurvesList$factory();
    tmp$ret$0 = this.q64_1.q();
    return tmp$ret$0;
  };
  protoOf(FillShape).u64 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = clipCurvesList$factory();
    tmp$ret$0 = this.r64_1.q();
    return tmp$ret$0;
  };
  protoOf(FillShape).v64 = function () {
    return (this.t64().j() === 1 ? get_isConvex(first(this.t64())) : false) ? this.u64() == null : false;
  };
  protoOf(FillShape).w64 = function (c) {
    c.h63(this.n64_1, this.l64_1.b3o_1);
  };
  protoOf(FillShape).toString = function () {
    return 'FillShape(path=' + this.l64_1 + ', clip=' + this.m64_1 + ', paint=' + this.n64_1 + ', transform=' + new Matrix(this.o64_1) + ', globalAlpha=' + this.p64_1 + ')';
  };
  protoOf(FillShape).hashCode = function () {
    var result = this.l64_1.hashCode();
    result = imul(result, 31) + (this.m64_1 == null ? 0 : this.m64_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.n64_1) | 0;
    result = imul(result, 31) + Matrix__hashCode_impl_s9ntm9(this.o64_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p64_1) | 0;
    return result;
  };
  protoOf(FillShape).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.l64_1.equals(tmp0_other_with_cast.l64_1))
      return false;
    if (!equals(this.m64_1, tmp0_other_with_cast.m64_1))
      return false;
    if (!equals(this.n64_1, tmp0_other_with_cast.n64_1))
      return false;
    if (!equals(this.o64_1, tmp0_other_with_cast.o64_1))
      return false;
    if (!equals(this.p64_1, tmp0_other_with_cast.p64_1))
      return false;
    return true;
  };
  function CompoundShape(components) {
    this.x64_1 = components;
  }
  protoOf(CompoundShape).k64 = function (includeStrokes) {
    var bb = Companion_getInstance_10().f3b();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.x64_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, tmp1__anonymous__uwfjfc.k64(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  };
  protoOf(CompoundShape).n52 = function (c) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.y62();
      try {
        var tmp0_fastForEach = this.x64_1;
        var n = 0;
        while (n < tmp0_fastForEach.j()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var tmp0 = n;
          n = tmp0 + 1 | 0;
          var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
          tmp1__anonymous__uwfjfc.n52(c);
        }
        tmp$ret$0 = Unit_getInstance();
        break $l$block;
      }finally {
        c.z62();
      }
    }
    return tmp$ret$0;
  };
  protoOf(CompoundShape).j64 = function (path) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.x64_1;
    var n = 0;
    while (n < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.k(tmp0);
      tmp1__anonymous__uwfjfc.j64(path);
    }
    tmp$ret$0 = path;
    return tmp$ret$0;
  };
  protoOf(CompoundShape).toString = function () {
    return 'CompoundShape(\n  ' + joinToString(this.x64_1, ',\n  ') + '\n)';
  };
  function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
    separator = separator === VOID ? ' ' : separator;
    decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
    return SvgPath_getInstance().y64(_this__u8e3s4, separator, decimalPlaces);
  }
  function EmptyShape() {
    EmptyShape_instance = this;
  }
  protoOf(EmptyShape).k64 = function (includeStrokes) {
    return Companion_getInstance_6().e3b();
  };
  protoOf(EmptyShape).n52 = function (c) {
    return Unit_getInstance();
  };
  var EmptyShape_instance;
  function EmptyShape_getInstance() {
    if (EmptyShape_instance == null)
      new EmptyShape();
    return EmptyShape_instance;
  }
  function StyledShape() {
  }
  function PolylineShape$fillShape$delegate$lambda(this$0) {
    return function () {
      return new FillShape(strokeToFill_0(this$0.z64_1, this$0.d65_1), this$0.a65_1, this$0.b65_1, this$0.c65_1, this$0.e65_1);
    };
  }
  function PolylineShape(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.z64_1 = path;
    this.a65_1 = clip;
    this.b65_1 = paint;
    this.c65_1 = transform;
    this.d65_1 = strokeInfo;
    this.e65_1 = globalAlpha;
    this.f65_1 = thickness$factory(this.d65_1);
    this.g65_1 = scaleMode$factory(this.d65_1);
    this.h65_1 = startCap$factory(this.d65_1);
    this.i65_1 = endCap$factory(this.d65_1);
    this.j65_1 = join$factory(this.d65_1);
    this.k65_1 = miterLimit$factory(this.d65_1);
    this.l65_1 = dash$factory(this.d65_1);
    this.m65_1 = dashOffset$factory(this.d65_1);
    var tmp = this;
    tmp.n65_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  protoOf(PolylineShape).g1z = function () {
    return this.z64_1;
  };
  protoOf(PolylineShape).s64 = function () {
    return this.a65_1;
  };
  protoOf(PolylineShape).g51 = function () {
    return this.c65_1;
  };
  protoOf(PolylineShape).k64 = function (includeStrokes) {
    var tmp0_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_1(Companion_getInstance_10().f3b(), this.z64_1));
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new Rectangle(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = _Rectangle___get_mutable__impl__e29r87(tmp0_safe_receiver);
    }
    var bounds = tmp;
    if (includeStrokes) {
      var tmp$ret$0;
      // Inline function 'kotlin.math.max' call
      var tmp0_max = this.d65_1.m3o_1 / 2.0;
      tmp$ret$0 = Math.max(tmp0_max, 0.0);
      var halfThickness = tmp$ret$0;
      var tmp1_safe_receiver = bounds;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.q3f(halfThickness, halfThickness);
    }
    var tmp2_safe_receiver = bounds;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.r3f();
    var tmp_1;
    var tmp_2 = tmp3_elvis_lhs;
    if ((tmp_2 == null ? null : new Rectangle(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_6().b3b_1;
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(PolylineShape).w64 = function (c) {
    c.a63(this.d65_1.o3o_1);
    c.n4z(this.d65_1.m3o_1);
    c.o4z(this.d65_1.q3o_1);
    c.p4z(this.d65_1.r3o_1);
    c.t4z(this.b65_1);
  };
  protoOf(PolylineShape).toString = function () {
    return 'PolylineShape(path=' + this.z64_1 + ', clip=' + this.a65_1 + ', paint=' + this.b65_1 + ', transform=' + new Matrix(this.c65_1) + ', strokeInfo=' + this.d65_1 + ', globalAlpha=' + this.e65_1 + ')';
  };
  protoOf(PolylineShape).hashCode = function () {
    var result = this.z64_1.hashCode();
    result = imul(result, 31) + (this.a65_1 == null ? 0 : this.a65_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.b65_1) | 0;
    result = imul(result, 31) + Matrix__hashCode_impl_s9ntm9(this.c65_1) | 0;
    result = imul(result, 31) + this.d65_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.e65_1) | 0;
    return result;
  };
  protoOf(PolylineShape).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.z64_1.equals(tmp0_other_with_cast.z64_1))
      return false;
    if (!equals(this.a65_1, tmp0_other_with_cast.a65_1))
      return false;
    if (!equals(this.b65_1, tmp0_other_with_cast.b65_1))
      return false;
    if (!equals(this.c65_1, tmp0_other_with_cast.c65_1))
      return false;
    if (!this.d65_1.equals(tmp0_other_with_cast.d65_1))
      return false;
    if (!equals(this.e65_1, tmp0_other_with_cast.e65_1))
      return false;
    return true;
  };
  function TextShape() {
  }
  protoOf(TextShape).p65 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = primitiveShapes$factory();
    tmp$ret$0 = this.o65_1.q();
    return tmp$ret$0;
  };
  function toContext2dCommands$_anonymous_$round_n7bczj(_this__u8e3s4, $decimalPlaces) {
    return niceStr(_this__u8e3s4, $decimalPlaces);
  }
  function pathCurvesList$factory() {
    return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
      return receiver.t64();
    }, null);
  }
  function clipCurvesList$factory() {
    return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
      return receiver.u64();
    }, null);
  }
  function thickness$factory($b0) {
    return getPropertyCallableRef('thickness', 0, KProperty0, function () {
      return $b0.m3o_1;
    }, null);
  }
  function scaleMode$factory($b0) {
    return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
      return $b0.o3o_1;
    }, null);
  }
  function startCap$factory($b0) {
    return getPropertyCallableRef('startCap', 0, KProperty0, function () {
      return $b0.p3o_1;
    }, null);
  }
  function endCap$factory($b0) {
    return getPropertyCallableRef('endCap', 0, KProperty0, function () {
      return $b0.q3o_1;
    }, null);
  }
  function join$factory($b0) {
    return getPropertyCallableRef('join', 0, KProperty0, function () {
      return $b0.r3o_1;
    }, null);
  }
  function miterLimit$factory($b0) {
    return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
      return $b0.s3o_1;
    }, null);
  }
  function dash$factory($b0) {
    return getPropertyCallableRef('dash', 0, KProperty0, function () {
      return $b0.t3o_1;
    }, null);
  }
  function dashOffset$factory($b0) {
    return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
      return $b0.u3o_1;
    }, null);
  }
  function primitiveShapes$factory() {
    return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
      return receiver.p65();
    }, null);
  }
  function ShapeBuilder(width, height) {
    Context2d.call(this, Companion_getInstance_55());
    var tmp = this;
    var tmp0_elvis_lhs = width;
    tmp.y4v_1 = tmp0_elvis_lhs == null ? 256 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp0_elvis_lhs_0 = height;
    tmp_0.z4v_1 = tmp0_elvis_lhs_0 == null ? 256 : tmp0_elvis_lhs_0;
    var tmp_1 = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    tmp_1.a4w_1 = tmp$ret$0;
  }
  protoOf(ShapeBuilder).q62 = function () {
    return this.y4v_1;
  };
  protoOf(ShapeBuilder).r62 = function () {
    return this.z4v_1;
  };
  protoOf(ShapeBuilder).s62 = function (state, fill, winding) {
    if (state.i4q_1.l())
      return Unit_getInstance();
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = state.i4q_1.dn();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = tmp0_also;
    var tmp0_elvis_lhs = winding;
    tmp.b3o_1 = tmp0_elvis_lhs == null ? tmp0_also.b3o_1 : tmp0_elvis_lhs;
    tmp$ret$0 = tmp0_also;
    var path = tmp$ret$0;
    var tmp0_safe_receiver = state.h4q_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dn();
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp1_safe_receiver;
      var tmp0_elvis_lhs_0 = winding;
      tmp_1.b3o_1 = tmp0_elvis_lhs_0 == null ? tmp1_safe_receiver.b3o_1 : tmp0_elvis_lhs_0;
      tmp$ret$1 = tmp1_safe_receiver;
      tmp_0 = tmp$ret$1;
    }
    var clip = tmp_0;
    var transform = state.g4q_1;
    if (fill) {
      var tmp2_this = this;
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp1_plusAssign = tmp2_this.a4w_1;
      var tmp2_plusAssign = new FillShape(path, clip, state.q4q_1.dn(), transform, state.w4q_1);
      tmp1_plusAssign.b(tmp2_plusAssign);
    } else {
      var tmp3_this = this;
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp3_plusAssign = tmp3_this.a4w_1;
      var tmp_2 = state.p4q_1.dn();
      var tmp4_thickness = state.k4q_1;
      var tmp5_scaleMode = state.j4q_1;
      var tmp6_startCap = state.l4q_1;
      var tmp7_endCap = state.m4q_1;
      var tmp8_join = state.n4q_1;
      var tmp9_dash = state.y4q_1;
      var tmp10_dashOffset = state.z4q_1;
      var tmp11_miterLimit = state.o4q_1;
      var tmp4_plusAssign = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp4_thickness, true, tmp5_scaleMode, tmp6_startCap, tmp7_endCap, tmp8_join, tmp11_miterLimit, tmp9_dash, tmp10_dashOffset), state.w4q_1);
      tmp3_plusAssign.b(tmp4_plusAssign);
    }
  };
  protoOf(ShapeBuilder).u62 = function (image, pos, size, transform) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    tmp0_apply.p3y(pos, size);
    tmp$ret$0 = tmp0_apply;
    this.t62(new State(transform, VOID, tmp$ret$0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, Matrix__translated_impl_3xg5y(Matrix__scaled_impl_ogn4b6_0(Companion_getInstance_9().v3f_1, Size__div_impl_f5ffdp(size, toFloat(image.k3s()))), pos))), true);
  };
  protoOf(ShapeBuilder).v62 = function () {
  };
  protoOf(ShapeBuilder).w62 = function () {
    return 0;
  };
  protoOf(ShapeBuilder).x62 = function () {
  };
  protoOf(ShapeBuilder).b4w = function () {
    var tmp0_subject = this.a4w_1.j();
    return tmp0_subject === 1 ? first(this.a4w_1) : new CompoundShape(toList(this.a4w_1));
  };
  protoOf(ShapeBuilder).n52 = function (c) {
    c.o52(this.b4w());
  };
  function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
    return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
  }
  function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
    return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
  }
  function SvgPath() {
    SvgPath_instance = this;
  }
  protoOf(SvgPath).y64 = function (path, separator, decimalPlaces) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    var parts = tmp$ret$0;
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = path.z3n_1;
    var n_0 = 0;
    while (n_0 < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.ek(tmp0);
      var tmp0_subject = tmp1__anonymous__uwfjfc;
      Command_getInstance();
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = path.a3o_1.k(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var tmp2__anonymous__z9zvc9 = _Vector2___init__impl__67w0ru_0(tmp, path.a3o_1.k(tmp2));
        var x = Vector2__component1_impl_k3h45m(tmp2__anonymous__z9zvc9);
        var y = Vector2__component2_impl_kkiqjt(tmp2__anonymous__z9zvc9);
        // Inline function 'kotlin.collections.plusAssign' call
        var tmp0_plusAssign = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
        parts.b(tmp0_plusAssign);
      } else {
        Command_getInstance();
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = path.a3o_1.k(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var tmp3__anonymous__ufb84q = _Vector2___init__impl__67w0ru_0(tmp_0, path.a3o_1.k(tmp4));
          var x_0 = Vector2__component1_impl_k3h45m(tmp3__anonymous__ufb84q);
          var y_0 = Vector2__component2_impl_kkiqjt(tmp3__anonymous__ufb84q);
          // Inline function 'kotlin.collections.plusAssign' call
          var tmp0_plusAssign_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.b(tmp0_plusAssign_0);
        } else {
          Command_getInstance();
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = path.a3o_1.k(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var tmp4__anonymous__pkmkx7 = _Vector2___init__impl__67w0ru_0(tmp_1, path.a3o_1.k(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = path.a3o_1.k(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var tmp5__anonymous__kpxxpo = _Vector2___init__impl__67w0ru_0(tmp_2, path.a3o_1.k(tmp8));
            var x1 = Vector2__component1_impl_k3h45m(tmp4__anonymous__pkmkx7);
            var y1 = Vector2__component2_impl_kkiqjt(tmp4__anonymous__pkmkx7);
            var x2 = Vector2__component1_impl_k3h45m(tmp5__anonymous__kpxxpo);
            var y2 = Vector2__component2_impl_kkiqjt(tmp5__anonymous__kpxxpo);
            // Inline function 'kotlin.collections.plusAssign' call
            var tmp0_plusAssign_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
            parts.b(tmp0_plusAssign_1);
          } else {
            Command_getInstance();
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = path.a3o_1.k(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var tmp6__anonymous__fv9ai5 = _Vector2___init__impl__67w0ru_0(tmp_3, path.a3o_1.k(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = path.a3o_1.k(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var tmp7__anonymous__b0knam = _Vector2___init__impl__67w0ru_0(tmp_4, path.a3o_1.k(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = path.a3o_1.k(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var tmp8__anonymous__65w033 = _Vector2___init__impl__67w0ru_0(tmp_5, path.a3o_1.k(tmp14));
              var x1_0 = Vector2__component1_impl_k3h45m(tmp6__anonymous__fv9ai5);
              var y1_0 = Vector2__component2_impl_kkiqjt(tmp6__anonymous__fv9ai5);
              var x2_0 = Vector2__component1_impl_k3h45m(tmp7__anonymous__b0knam);
              var y2_0 = Vector2__component2_impl_kkiqjt(tmp7__anonymous__b0knam);
              var x3 = Vector2__component1_impl_k3h45m(tmp8__anonymous__65w033);
              var y3 = Vector2__component2_impl_kkiqjt(tmp8__anonymous__65w033);
              // Inline function 'kotlin.collections.plusAssign' call
              var tmp0_plusAssign_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
              parts.b(tmp0_plusAssign_2);
            } else {
              Command_getInstance();
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call
                // Inline function 'kotlin.collections.plusAssign' call
                parts.b('Z');
              }
            }
          }
        }
      }
    }
    return joinToString(parts, '');
  };
  var SvgPath_instance;
  function SvgPath_getInstance() {
    if (SvgPath_instance == null)
      new SvgPath();
    return SvgPath_instance;
  }
  function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
    return function (a, b, y) {
      var tmp;
      if (a <= $xmax ? b >= $xmin : false) {
        var a0 = coerceIn(a, $xmin, $xmax);
        var b0 = coerceIn(b, $xmin, $xmax);
        if (this$0.n61_1) {
          println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
        }
        tmp = $callback(a0, b0, y);
      } else {
        tmp = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function Rasterizer() {
    RastScale.call(this);
    this.n61_1 = false;
    this.o61_1 = 2;
    this.p61_1 = 1;
    this.q61_1 = new PolygonScanline();
    this.r61_1 = new PolygonScanline();
    this.s61_1 = new IntSegmentSet();
    this.t61_1 = new IntSegmentSet();
    this.u61_1 = new IntSegmentSet();
    this.v61_1 = new IntArrayList(1024);
  }
  protoOf(Rasterizer).dt = function () {
    this.q61_1.dt();
    this.r61_1.dt();
  };
  protoOf(Rasterizer).q65 = function (bounds, quality, stats, winding, callback) {
    var tmp0_safe_receiver = stats;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dt();
    }
    var xmin = this.d3x(_Rectangle___get_left__impl__sgtjiw(bounds));
    var xmax = this.d3x(_Rectangle___get_right__impl__7wa90z(bounds));
    var tempRect = this.q61_1.w3l();
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    var tmp0_max = _Rectangle___get_top__impl__3kuxui(bounds);
    var tmp1_max = _Rectangle___get_top__impl__3kuxui(tempRect);
    tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
    var startY = this.d3x(tmp$ret$0);
    var tmp$ret$1;
    // Inline function 'kotlin.math.min' call
    var tmp2_min = _Rectangle___get_bottom__impl__1duj44(bounds);
    var tmp3_min = _Rectangle___get_bottom__impl__1duj44(tempRect);
    tmp$ret$1 = Math.min(tmp2_min, tmp3_min);
    var endY = this.d3x(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.v61_1.v2();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.w3w() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.w3w()) / this.p61_1 | 0) / q | 0) | 0;
        this.v61_1.un(y);
      }
       while (inductionVariable < last);
    var tmp$ret$3;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$2;
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = this.v61_1;
    var n_0 = 0;
    while (n_0 < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.ek(tmp0);
      this.q61_1.r3w(tmp1__anonymous__uwfjfc, winding, this.s61_1);
      edgesChecked = edgesChecked + this.q61_1.c3w_1 | 0;
      if (this.r61_1.ao()) {
        this.r61_1.r3w(tmp1__anonymous__uwfjfc, this.r61_1.n3v_1, this.t61_1);
        edgesChecked = edgesChecked + this.r61_1.c3w_1 | 0;
        this.u61_1.x42(this.s61_1, this.t61_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var tmp0_fastForEach_0 = this.r61_1.ao() ? this.u61_1 : this.s61_1;
      var inductionVariable_0 = 0;
      var last_0 = tmp0_fastForEach_0.j();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          var tmp1__anonymous__uwfjfc_0 = tmp0_fastForEach_0.s3w_1.ek(n_1);
          var tmp2__anonymous__z9zvc9 = tmp0_fastForEach_0.t3w_1.ek(n_1);
          func(tmp1__anonymous__uwfjfc_0, tmp2__anonymous__z9zvc9, tmp1__anonymous__uwfjfc);
          var tmp0_0 = edgesEmitted;
          edgesEmitted = tmp0_0 + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp0_safe_receiver_0 = stats;
    var tmp;
    if (tmp0_safe_receiver_0 == null) {
      tmp = null;
    } else {
      tmp0_safe_receiver_0.u65(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_getInstance();
    }
    tmp$ret$2 = tmp;
    tmp$ret$3 = tmp$ret$2;
  };
  protoOf(Rasterizer).w61 = function (bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.o61_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.q65(bounds, quality, stats, winding, callback);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.q65.call(this, new Rectangle(bounds), quality, stats, winding, callback);
    }
    return tmp;
  };
  function Renderer$drawImage$lambda($pos, $size) {
    return function ($this$transformed) {
      $this$transformed.p3y($pos, $size);
      return Unit_getInstance();
    };
  }
  function Renderer() {
    this.y61_1 = false;
    this.z61_1 = 0;
  }
  protoOf(Renderer).hd = function () {
    return Unit_getInstance();
  };
  protoOf(Renderer).b62 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.z61_1;
    tmp0_this.z61_1 = tmp1 + 1 | 0;
    return tmp1;
  };
  protoOf(Renderer).c62 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.z61_1;
    tmp0_this.z61_1 = tmp1 - 1 | 0;
    if (this.z61_1 === 0) {
      this.hd();
    }
  };
  protoOf(Renderer).d62 = function (state, fill, winding) {
    var rstate = state;
    if (fill ? !this.f62(state.q4q_1) : false) {
      rstate = state.dn();
      rstate.q4q_1 = toBitmapPaint(rstate.q4q_1, state);
    }
    this.x61(rstate, fill, winding);
  };
  protoOf(Renderer).e62 = function (state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.d62(state, fill, winding);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.d62.call(this, state, fill, winding);
    }
    return tmp;
  };
  protoOf(Renderer).x61 = function (state, fill, winding) {
    return Unit_getInstance();
  };
  protoOf(Renderer).f62 = function (_this__u8e3s4) {
    return true;
  };
  protoOf(Renderer).g62 = function (image, pos, size, transform) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (_Matrix___get_type__impl__g2man3(transform).equals(MatrixType_IDENTITY_getInstance())) {
      tmp0_apply.p3y(pos, size);
    } else {
      tmp0_apply.x3y(transform, Renderer$drawImage$lambda(pos, size));
    }
    tmp$ret$0 = tmp0_apply;
    this.e62(new State(transform, VOID, tmp$ret$0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, Matrix__translated_impl_3xg5y(Matrix__scaled_impl_ogn4b6_0(Companion_getInstance_9().v3f_1, Size__div_impl_f5ffdp(size, toFloat(image.k3s()))), pos))), true);
  };
  protoOf(Renderer).p13 = function () {
    this.hd();
  };
  function Companion_35() {
    Companion_instance_35 = this;
    DummyRenderer.call(this, 128, 128);
  }
  var Companion_instance_35;
  function Companion_getInstance_55() {
    if (Companion_instance_35 == null)
      new Companion_35();
    return Companion_instance_35;
  }
  function DummyRenderer(width, height) {
    Companion_getInstance_55();
    Renderer.call(this);
    this.x65_1 = width;
    this.y65_1 = height;
  }
  protoOf(DummyRenderer).ck = function () {
    return this.x65_1;
  };
  protoOf(DummyRenderer).dk = function () {
    return this.y65_1;
  };
  function HtmlCanvas() {
    HtmlCanvas_instance = this;
  }
  protoOf(HtmlCanvas).z65 = function (width, height) {
    if (Companion_getInstance_17().ew()) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$('Canvas not available on Node.JS');
    }
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = document.createElement('canvas');
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    var out = tmp$ret$1;
    out.width = width;
    out.height = height;
    return toLike(out);
  };
  var HtmlCanvas_instance;
  function HtmlCanvas_getInstance() {
    if (HtmlCanvas_instance == null)
      new HtmlCanvas();
    return HtmlCanvas_instance;
  }
  function toLike(_this__u8e3s4) {
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    tmp$ret$1 = tmp$ret$0;
    return tmp$ret$1;
  }
  function toHtmlNative(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp;
    if (tmp0_subject instanceof HtmlNativeImage) {
      tmp = _this__u8e3s4;
    } else {
      tmp = HtmlNativeImage_init_$Create$_0(HtmlImage_getInstance().a66(_this__u8e3s4.e47()));
    }
    return tmp;
  }
  function HtmlImage() {
    HtmlImage_instance = this;
  }
  protoOf(HtmlImage).b66 = function (width, height) {
    return HtmlCanvas_getInstance().z65(width, height);
  };
  protoOf(HtmlImage).c66 = function (bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = canvas.getContext('2d');
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    var ctx = tmp$ret$1;
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var tmp1 = m;
        m = tmp1 + 1 | 0;
        var tmp2_set = tmp1;
        var tmp$ret$2;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_asDynamic = _RGBA___get_r__impl__duz7mo(c);
        tmp$ret$2 = tmp1_asDynamic;
        var tmp3_set = tmp$ret$2;
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = idataData;
        tmp$ret$3[tmp2_set] = tmp3_set;
        // Inline function 'org.khronos.webgl.set' call
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        var tmp5_set = tmp2;
        var tmp$ret$4;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp4_asDynamic = _RGBA___get_g__impl__o8pukr(c);
        tmp$ret$4 = tmp4_asDynamic;
        var tmp6_set = tmp$ret$4;
        var tmp$ret$5;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$5 = idataData;
        tmp$ret$5[tmp5_set] = tmp6_set;
        // Inline function 'org.khronos.webgl.set' call
        var tmp3 = m;
        m = tmp3 + 1 | 0;
        var tmp8_set = tmp3;
        var tmp$ret$6;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp7_asDynamic = _RGBA___get_b__impl__m6tl80(c);
        tmp$ret$6 = tmp7_asDynamic;
        var tmp9_set = tmp$ret$6;
        var tmp$ret$7;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$7 = idataData;
        tmp$ret$7[tmp8_set] = tmp9_set;
        // Inline function 'org.khronos.webgl.set' call
        var tmp4 = m;
        m = tmp4 + 1 | 0;
        var tmp11_set = tmp4;
        var tmp$ret$8;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp10_asDynamic = _RGBA___get_a__impl__6msvu7(c);
        tmp$ret$8 = tmp10_asDynamic;
        var tmp12_set = tmp$ret$8;
        var tmp$ret$9;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$9 = idataData;
        tmp$ret$9[tmp11_set] = tmp12_set;
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  };
  protoOf(HtmlImage).d66 = function (bmp, canvas) {
    return this.c66(_RgbaArray___init__impl__oib4y4(bmp.a4i().t47_1), bmp.r46_1, bmp.s46_1, canvas);
  };
  protoOf(HtmlImage).a66 = function (bmp) {
    return this.d66(bmp, this.b66(bmp.r46_1, bmp.s46_1));
  };
  var HtmlImage_instance;
  function HtmlImage_getInstance() {
    if (HtmlImage_instance == null)
      new HtmlImage();
    return HtmlImage_instance;
  }
  function get_nativeImageFormatProvider() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return nativeImageFormatProvider;
  }
  var nativeImageFormatProvider;
  function get_tempB() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return tempB;
  }
  var tempB;
  function get_tempI() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return tempI;
  }
  var tempI;
  function get_temp8() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return temp8;
  }
  var temp8;
  function get_isLittleEndian() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = isLittleEndian$factory();
    tmp$ret$0 = isLittleEndian$delegate.q();
    return tmp$ret$0;
  }
  var isLittleEndian$delegate;
  function NodeJsNativeImageFormatProvider() {
    NodeJsNativeImageFormatProvider_instance = this;
    BaseNativeImageFormatProvider.call(this);
  }
  protoOf(NodeJsNativeImageFormatProvider).y5p = function () {
    return get_RegisteredImageFormats();
  };
  var NodeJsNativeImageFormatProvider_instance;
  function NodeJsNativeImageFormatProvider_getInstance() {
    if (NodeJsNativeImageFormatProvider_instance == null)
      new NodeJsNativeImageFormatProvider();
    return NodeJsNativeImageFormatProvider_instance;
  }
  function $decodeInternalCOROUTINE$36(_this__u8e3s4, data, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m66_1 = _this__u8e3s4;
    this.n66_1 = data;
    this.o66_1 = props;
  }
  protoOf($decodeInternalCOROUTINE$36).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = BrowserImage_getInstance().p66(this.n66_1, this.o66_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = HtmlNativeImage_init_$Create$_0(ARGUMENT);
            return new NativeImageResult(ARGUMENT_0);
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $decodeInternalCOROUTINE$37(_this__u8e3s4, vfs, path, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y66_1 = _this__u8e3s4;
    this.z66_1 = vfs;
    this.a67_1 = path;
    this.b67_1 = props;
  }
  protoOf($decodeInternalCOROUTINE$37).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 6;
            this.c67_1 = this.z66_1;
            var tmp_0 = this.c67_1;
            if (tmp_0 instanceof LocalVfs) {
              this.hh_1 = 4;
              suspendResult = BrowserImage_getInstance().h67(this.a67_1, this.b67_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.c67_1;
              if (tmp_1 instanceof UrlVfs) {
                this.e67_1 = this.z66_1.z27(this.a67_1);
                this.hh_1 = 3;
                suspendResult = BrowserImage_getInstance().h67(this.e67_1, this.b67_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f67_1 = BrowserImage_getInstance();
                this.hh_1 = 1;
                suspendResult = this.z66_1.ro(this.a67_1).x1y(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

            break;
          case 1:
            this.g67_1 = suspendResult;
            this.hh_1 = 2;
            suspendResult = this.f67_1.p66(this.g67_1, this.b67_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.d67_1 = HtmlNativeImage_init_$Create$_0(ARGUMENT);
            this.hh_1 = 5;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this.d67_1 = HtmlNativeImage_init_$Create$(ARGUMENT_0);
            this.hh_1 = 5;
            continue $sm;
          case 4:
            var ARGUMENT_1 = suspendResult;
            this.d67_1 = HtmlNativeImage_init_$Create$(ARGUMENT_1);
            this.hh_1 = 5;
            continue $sm;
          case 5:
            var ARGUMENT_2 = this.d67_1;
            return new NativeImageResult(ARGUMENT_2);
          case 6:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 6) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function HtmlNativeImageFormatProvider() {
    HtmlNativeImageFormatProvider_instance = this;
    NativeImageFormatProvider.call(this);
  }
  protoOf(HtmlNativeImageFormatProvider).k5s = function (data, props, $completion) {
    var tmp = new $decodeInternalCOROUTINE$36(this, data, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(HtmlNativeImageFormatProvider).k5t = function (vfs, path, props, $completion) {
    var tmp = new $decodeInternalCOROUTINE$37(this, vfs, path, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(HtmlNativeImageFormatProvider).p4l = function (width, height, premultiplied) {
    return HtmlNativeImage_init_$Create$_0(HtmlCanvas_getInstance().z65(width, height));
  };
  protoOf(HtmlNativeImageFormatProvider).o4l = function (bmp) {
    return HtmlNativeImage_init_$Create$_0(HtmlImage_getInstance().a66(bmp.e47()));
  };
  var HtmlNativeImageFormatProvider_instance;
  function HtmlNativeImageFormatProvider_getInstance() {
    if (HtmlNativeImageFormatProvider_instance == null)
      new HtmlNativeImageFormatProvider();
    return HtmlNativeImageFormatProvider_instance;
  }
  function HtmlNativeImage_init_$Init$(img, $this) {
    HtmlNativeImage.call($this, img, img.width, img.height);
    return $this;
  }
  function HtmlNativeImage_init_$Create$(img) {
    return HtmlNativeImage_init_$Init$(img, objectCreate(protoOf(HtmlNativeImage)));
  }
  function HtmlNativeImage_init_$Init$_0(canvas, $this) {
    HtmlNativeImage.call($this, canvas, canvas.width, canvas.height);
    return $this;
  }
  function HtmlNativeImage_init_$Create$_0(canvas) {
    return HtmlNativeImage_init_$Init$_0(canvas, objectCreate(protoOf(HtmlNativeImage)));
  }
  function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
    return function () {
      var tmp$ret$5;
      // Inline function 'kotlin.also' call
      var tmp;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_asDynamic = this$0.x67_1;
      tmp$ret$0 = tmp0_asDynamic;
      if (tmp$ret$0.src !== undefined) {
        var tmp_0 = BrowserImage_getInstance();
        var tmp$ret$2;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp1_unsafeCast = this$0.x67_1;
        var tmp$ret$1;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$1 = tmp1_unsafeCast;
        tmp$ret$2 = tmp$ret$1;
        tmp = tmp_0.b68(tmp$ret$2, $width, $height);
      } else {
        var tmp$ret$4;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp2_unsafeCast = this$0.x67_1;
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = tmp2_unsafeCast;
        tmp$ret$4 = tmp$ret$3;
        tmp = tmp$ret$4;
      }
      var tmp3_also = tmp;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
      this$0.x67_1 = tmp3_also;
      tmp$ret$5 = tmp3_also;
      return tmp$ret$5;
    };
  }
  function HtmlNativeImage$ctx$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast = this$0.c68().getContext('2d');
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_unsafeCast;
      tmp$ret$1 = tmp$ret$0;
      return tmp$ret$1;
    };
  }
  function HtmlNativeImage(texSourceBase, width, height) {
    NativeImage.call(this, width, height, texSourceBase, true);
    this.w67_1 = texSourceBase;
    this.x67_1 = this.w67_1;
    var tmp = this;
    tmp.y67_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda(this, width, height));
    var tmp_0 = this;
    tmp_0.z67_1 = lazy(HtmlNativeImage$ctx$delegate$lambda(this));
    var tmp_1 = this;
    var tmp$ret$0;
    // Inline function 'korlibs.time.milliseconds' call
    tmp$ret$0 = Companion_getInstance_7().bj(0.0);
    tmp_1.a68_1 = tmp$ret$0;
  }
  protoOf(HtmlNativeImage).qg = function () {
    return 'HtmlNativeImage';
  };
  protoOf(HtmlNativeImage).c68 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = lazyCanvasElement$factory();
    tmp$ret$0 = this.y67_1.q();
    return tmp$ret$0;
  };
  protoOf(HtmlNativeImage).d68 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = ctx$factory();
    tmp$ret$0 = this.z67_1.q();
    return tmp$ret$0;
  };
  protoOf(HtmlNativeImage).e48 = function (x, y, width, height, out, offset) {
    if (width <= 0 ? true : height <= 0)
      return Unit_getInstance();
    var size = imul(width, height);
    var tmp = this.w67_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = PerformanceCounter_getInstance().kj();
      var elapsedTime = TimeSpan__minus_impl_5w5v8s(now, this.a68_1);
      var tmp$ret$0;
      // Inline function 'korlibs.time.milliseconds' call
      tmp$ret$0 = Companion_getInstance_7().bj(16.0);
      if (TimeSpan__compareTo_impl_zidry4(elapsedTime, tmp$ret$0) >= 0) {
        this.a68_1 = now;
        this.d68().clearRect(0.0, 0.0, width, height);
        this.d68().drawImage(this.w67_1, 0.0, 0.0);
      }
    }
    var idata = this.d68().getImageData(x, y, width, height);
    var tmp$ret$2;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = asInt32Array(idata.data.buffer);
    var tmp$ret$1;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$1 = tmp0_unsafeCast;
    tmp$ret$2 = tmp$ret$1;
    var data = tmp$ret$2;
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.z46_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  };
  protoOf(HtmlNativeImage).g48 = function (x, y, width, height, out, offset) {
    if (width <= 0 ? true : height <= 0)
      return Unit_getInstance();
    var size = imul(width, height);
    var idata = this.d68().createImageData(width, height);
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = asInt32Array(idata.data.buffer);
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    var data = tmp$ret$1;
    arraycopy(out, offset, data, 0, size);
    if (!this.z46_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.d68().putImageData(idata, x, y);
  };
  protoOf(HtmlNativeImage).b4f = function (antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.c68()));
  };
  protoOf(HtmlNativeImage).e68 = function (type, quality) {
    return this.c68().toDataURL(type, quality);
  };
  protoOf(HtmlNativeImage).f68 = function (type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.e68(type, quality) : $super.e68.call(this, type, quality);
  };
  function BrowserImage$loadImage$lambda($img, $cancellable) {
    return function (it) {
      var tmp$ret$3;
      // Inline function 'kotlin.coroutines.resume' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = $img;
      tmp$ret$1 = tmp$ret$0;
      var tmp1_resume = tmp$ret$1;
      var tmp$ret$2;
      // Inline function 'kotlin.Companion.success' call
      var tmp0_success = Companion_getInstance_18();
      tmp$ret$2 = _Result___init__impl__xyqfz8(tmp1_resume);
      $cancellable.h4(tmp$ret$2);
      tmp$ret$3 = Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function BrowserImage$loadImage$lambda_0($jsUrl, $cancellable) {
    return function (_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen, _anonymous_parameter_4__qggqds) {
      var tmp$ret$1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var tmp1_resumeWithException = RuntimeException_init_$Create$('error loading image ' + $jsUrl);
      var tmp$ret$0;
      // Inline function 'kotlin.Companion.failure' call
      var tmp0_failure = Companion_getInstance_18();
      tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(tmp1_resumeWithException));
      $cancellable.h4(tmp$ret$0);
      tmp$ret$1 = Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function $decodeToCanvasCOROUTINE$38(_this__u8e3s4, bytes, props, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o68_1 = _this__u8e3s4;
    this.p68_1 = bytes;
    this.q68_1 = props;
  }
  protoOf($decodeToCanvasCOROUTINE$38).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 7;
            if (Companion_getInstance_17().ew()) {
              throw IllegalStateException_init_$Create$('Canvas not available on NodeJS');
            }

            var tmp_0 = this;
            var o = {};
            o['type'] = 'image/png';
            tmp_0.r68_1 = new Blob([this.p68_1], o);
            this.s68_1 = URL.createObjectURL(this.r68_1);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            this.hh_1 = 2;
            continue $sm;
          case 2:
            this.ih_1 = 6;
            this.hh_1 = 3;
            suspendResult = this.o68_1.u68(this.s68_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.t68_1 = suspendResult;
            this.ih_1 = 7;
            this.hh_1 = 4;
            var tmp_1 = this;
            continue $sm;
          case 4:
            var tmp_2 = this.t68_1;
            URL.revokeObjectURL(this.s68_1);
            ;
            return tmp_2;
          case 5:
            URL.revokeObjectURL(this.s68_1);
            ;
            return Unit_getInstance();
          case 6:
            this.ih_1 = 7;
            var t = this.kh_1;
            URL.revokeObjectURL(this.s68_1);
            ;
            throw t;
          case 7:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 7) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $loadCanvasCOROUTINE$39(_this__u8e3s4, jsUrl, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d69_1 = _this__u8e3s4;
    this.e69_1 = jsUrl;
  }
  protoOf($loadCanvasCOROUTINE$39).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.d69_1.f69(this.e69_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.d69_1.g69(ARGUMENT);
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function BrowserImage() {
    BrowserImage_instance = this;
  }
  protoOf(BrowserImage).p66 = function (bytes, props, $completion) {
    var tmp = new $decodeToCanvasCOROUTINE$38(this, bytes, props, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(BrowserImage).g69 = function (img) {
    return this.b68(img, img.width, img.height);
  };
  protoOf(BrowserImage).b68 = function (img, width, height) {
    var canvas = HtmlCanvas_getInstance().z65(width, height);
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = canvas.getContext('2d');
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    var ctx = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = img;
    tmp$ret$3 = tmp$ret$2;
    ctx.drawImage(tmp$ret$3, 0.0, 0.0);
    return canvas;
  };
  protoOf(BrowserImage).h67 = function (jsUrl, props, $completion) {
    var tmp$ret$2;
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var tmp0__anonymous__q1qw7t = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(tmp0__anonymous__q1qw7t), get_MODE_CANCELLABLE());
    cancellable.w14();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_17().ew()) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$('Canvas not available on NodeJS');
    }
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = document.createElement('img');
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    var img = tmp$ret$1;
    img.onload = BrowserImage$loadImage$lambda(img, cancellable);
    img.onerror = BrowserImage$loadImage$lambda_0(jsUrl, cancellable);
    img.src = jsUrl;
    tmp$ret$2 = cancellable.i12();
    var tmp0 = tmp$ret$2;
    return tmp0;
  };
  protoOf(BrowserImage).f69 = function (jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_43().c44_1 : props;
    return $super === VOID ? this.h67(jsUrl, props, $completion) : $super.h67.call(this, jsUrl, props, $completion);
  };
  protoOf(BrowserImage).u68 = function (jsUrl, $completion) {
    var tmp = new $loadCanvasCOROUTINE$39(this, jsUrl, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  var BrowserImage_instance;
  function BrowserImage_getInstance() {
    if (BrowserImage_instance == null)
      new BrowserImage();
    return BrowserImage_instance;
  }
  function get_isBigEndian() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return !get_isLittleEndian();
  }
  function bswap32(v, offset, size) {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    var inductionVariable = offset;
    var last = offset + size | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        v[n] = bswap32_0(v[n]);
      }
       while (inductionVariable < last);
  }
  function setFont($this, font, fontSize) {
    var tmp;
    var tmp0_safe_receiver = font;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qg()) == $this.m69_1) {
      tmp = fontSize === $this.l69_1;
    } else {
      tmp = false;
    }
    if (tmp)
      return Unit_getInstance();
    var tmp_0 = $this;
    var tmp1_safe_receiver = font;
    tmp_0.m69_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.qg();
    $this.l69_1 = fontSize;
    var tmp2_safe_receiver = font;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.qg();
    $this.k69_1.font = '' + fontSize + "px '" + (tmp3_elvis_lhs == null ? 'default' : tmp3_elvis_lhs) + "'";
  }
  function setState($this, state, fill, doSetFont) {
    $this.k69_1.globalAlpha = state.w4q_1;
    $this.k69_1.globalCompositeOperation = $this.n69(state.x4q_1);
    if (doSetFont) {
      setFont($this, state.s4q_1, state.t4q_1);
    }
    if (fill) {
      $this.k69_1.fillStyle = $this.o69(state.q4q_1);
    } else {
      $this.k69_1.lineWidth = state.k4q_1;
      var tmp0_subject = state.n4q_1;
      var tmp0 = tmp0_subject.j5_1;
      var tmp;
      switch (tmp0) {
        case 0:
          var tmp$ret$2;
          // Inline function 'org.w3c.dom.BEVEL' call
          var tmp1__get_BEVEL__lazawi = null;
          var tmp$ret$1;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$0;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$0 = 'bevel';
          var tmp0_unsafeCast = tmp$ret$0;
          tmp$ret$1 = tmp0_unsafeCast;
          tmp$ret$2 = tmp$ret$1;

          tmp = tmp$ret$2;
          break;
        case 2:
          var tmp$ret$5;
          // Inline function 'org.w3c.dom.MITER' call
          var tmp3__get_MITER__gv9rd5 = null;
          var tmp$ret$4;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$3;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$3 = 'miter';
          var tmp2_unsafeCast = tmp$ret$3;
          tmp$ret$4 = tmp2_unsafeCast;
          tmp$ret$5 = tmp$ret$4;

          tmp = tmp$ret$5;
          break;
        case 1:
          var tmp$ret$8;
          // Inline function 'org.w3c.dom.ROUND' call
          var tmp5__get_ROUND__9mg5sy = null;
          var tmp$ret$7;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$6;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$6 = 'round';
          var tmp4_unsafeCast = tmp$ret$6;
          tmp$ret$7 = tmp4_unsafeCast;
          tmp$ret$8 = tmp$ret$7;

          tmp = tmp$ret$8;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      $this.k69_1.lineJoin = tmp;
      var tmp1_subject = state.h4z();
      var tmp0_0 = tmp1_subject.j5_1;
      var tmp_0;
      switch (tmp0_0) {
        case 0:
          var tmp$ret$11;
          // Inline function 'org.w3c.dom.BUTT' call
          var tmp7__get_BUTT__mo37sn = null;
          var tmp$ret$10;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$9;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$9 = 'butt';
          var tmp6_unsafeCast = tmp$ret$9;
          tmp$ret$10 = tmp6_unsafeCast;
          tmp$ret$11 = tmp$ret$10;

          tmp_0 = tmp$ret$11;
          break;
        case 2:
          var tmp$ret$14;
          // Inline function 'org.w3c.dom.ROUND' call
          var tmp9__get_ROUND__9saf16 = null;
          var tmp$ret$13;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$12;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$12 = 'round';
          var tmp8_unsafeCast = tmp$ret$12;
          tmp$ret$13 = tmp8_unsafeCast;
          tmp$ret$14 = tmp$ret$13;

          tmp_0 = tmp$ret$14;
          break;
        case 1:
          var tmp$ret$17;
          // Inline function 'org.w3c.dom.SQUARE' call
          var tmp11__get_SQUARE__kb6bme = null;
          var tmp$ret$16;
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$15;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$15 = 'square';
          var tmp10_unsafeCast = tmp$ret$15;
          tmp$ret$16 = tmp10_unsafeCast;
          tmp$ret$17 = tmp$ret$16;

          tmp_0 = tmp$ret$17;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      $this.k69_1.lineCap = tmp_0;
      $this.k69_1.strokeStyle = $this.o69(state.p4q_1);
    }
  }
  function transformPaint($this, paint) {
    if (isInterface(paint, TransformedPaint)) {
      $this.p69($this.k69_1, paint.g51());
    }
  }
  function CanvasContext2dRenderer(canvas) {
    Renderer.call(this);
    this.j69_1 = canvas;
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.j69_1.getContext('2d');
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp.k69_1 = tmp$ret$1;
    var tmp_0 = this;
    DoubleCompanionObject_getInstance();
    tmp_0.l69_1 = NaN;
    this.m69_1 = null;
  }
  protoOf(CanvasContext2dRenderer).ck = function () {
    return this.j69_1.width;
  };
  protoOf(CanvasContext2dRenderer).dk = function () {
    return this.j69_1.height;
  };
  protoOf(CanvasContext2dRenderer).q69 = function (_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.c5g_1.j();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.c5g_1.ek(n);
        var color = paint.d5g_1.ek(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  };
  protoOf(CanvasContext2dRenderer).o69 = function (_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp;
    if (tmp0_subject instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (tmp0_subject instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.q4n_1));
      } else {
        if (tmp0_subject instanceof GradientPaint) {
          var tmp1_subject = _this__u8e3s4.v5f_1;
          var tmp0 = tmp1_subject.j5_1;
          var tmp_0;
          switch (tmp0) {
            case 0:
              tmp_0 = this.q69(this.k69_1.createLinearGradient(_this__u8e3s4.w5f_1, _this__u8e3s4.x5f_1, _this__u8e3s4.z5f_1, _this__u8e3s4.a5g_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.q69(this.k69_1.createRadialGradient(_this__u8e3s4.w5f_1, _this__u8e3s4.x5f_1, _this__u8e3s4.y5f_1, _this__u8e3s4.z5f_1, _this__u8e3s4.a5g_1, _this__u8e3s4.b5g_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.k69_1.createConicGradient, undefined)) {
                var tmp$ret$1;
                // Inline function 'kotlin.js.unsafeCast' call
                var tmp0_unsafeCast = this.k69_1.createConicGradient(_Angle___get_radiansD__impl__thfj8f(_this__u8e3s4.i5g_1), _this__u8e3s4.w5f_1, _this__u8e3s4.x5f_1);
                var tmp$ret$0;
                // Inline function 'kotlin.js.asDynamic' call
                tmp$ret$0 = tmp0_unsafeCast;
                tmp$ret$1 = tmp$ret$0;
                tmp_1 = this.q69(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (tmp0_subject instanceof BitmapPaint) {
            var tmp$ret$3;
            // Inline function 'kotlin.js.unsafeCast' call
            var tmp1_unsafeCast = toHtmlNative(_this__u8e3s4.j5x_1).x67_1;
            var tmp$ret$2;
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$2 = tmp1_unsafeCast;
            tmp$ret$3 = tmp$ret$2;
            tmp = this.k69_1.createPattern(tmp$ret$3, (_this__u8e3s4.y5x() ? _this__u8e3s4.a5y() : false) ? 'repeat' : _this__u8e3s4.y5x() ? 'repeat-x' : _this__u8e3s4.a5y() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  };
  protoOf(CanvasContext2dRenderer).r69 = function (_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp0 = tmp0_subject.j5_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(CanvasContext2dRenderer).s69 = function (_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp0 = tmp0_subject.j5_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        var tmp$ret$1;
        // Inline function 'kotlin.text.lowercase' call
        var tmp0_lowercase = _this__u8e3s4.i5_1;
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp0_lowercase;
        tmp$ret$1 = tmp$ret$0.toLowerCase();

        tmp = tmp$ret$1;
        break;
    }
    return tmp;
  };
  protoOf(CanvasContext2dRenderer).n69 = function (_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp;
    if (tmp0_subject instanceof CompositeMode) {
      tmp = this.r69(_this__u8e3s4);
    } else {
      if (tmp0_subject instanceof BlendMode) {
        tmp = this.s69(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  };
  protoOf(CanvasContext2dRenderer).p69 = function (_this__u8e3s4, m) {
    _this__u8e3s4.transform(_Matrix___get_a__impl__f7jypo(m), _Matrix___get_b__impl__dm2icj(m), _Matrix___get_c__impl__slf2ke(m), _Matrix___get_d__impl__87eht(m), _Matrix___get_tx__impl__yc1n9(m), _Matrix___get_ty__impl__tryipg(m));
  };
  protoOf(CanvasContext2dRenderer).g62 = function (image, pos, size, transform) {
    this.k69_1.save();
    try {
      var tmp$ret$0;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.k69_1.setTransform(_Matrix___get_a__impl__f7jypo(transform), _Matrix___get_b__impl__dm2icj(transform), _Matrix___get_c__impl__slf2ke(transform), _Matrix___get_d__impl__87eht(transform), _Matrix___get_tx__impl__yc1n9(transform), _Matrix___get_ty__impl__tryipg(transform));
      tmp$ret$0 = Unit_getInstance();
      var tmp$ret$2;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      var tmp0_unsafeCast = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).x67_1;
      var tmp$ret$1;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$1 = tmp0_unsafeCast;
      tmp$ret$2 = tmp$ret$1;
      this.k69_1.drawImage(tmp$ret$2, _Vector2___get_xD__impl__1832jh(pos), _Vector2___get_yD__impl__v473bw(pos), _Size___get_widthD__impl__i6r1cr(size), _Size___get_heightD__impl__67jnfc(size));
    }finally {
      this.k69_1.restore();
    }
  };
  protoOf(CanvasContext2dRenderer).t69 = function (path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp0_fastForEach = path.z3n_1;
    var n_0 = 0;
    while (n_0 < tmp0_fastForEach.j()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp1__anonymous__uwfjfc = tmp0_fastForEach.ek(tmp0);
      var tmp0_subject = tmp1__anonymous__uwfjfc;
      Command_getInstance();
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = path.a3o_1.k(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var tmp2__anonymous__z9zvc9 = _Vector2___init__impl__67w0ru_0(tmp, path.a3o_1.k(tmp2));
        var x = Vector2__component1_impl_k3h45m(tmp2__anonymous__z9zvc9);
        var y = Vector2__component2_impl_kkiqjt(tmp2__anonymous__z9zvc9);
        this.k69_1.moveTo(x, y);
      } else {
        Command_getInstance();
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = path.a3o_1.k(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var tmp3__anonymous__ufb84q = _Vector2___init__impl__67w0ru_0(tmp_0, path.a3o_1.k(tmp4));
          var x_0 = Vector2__component1_impl_k3h45m(tmp3__anonymous__ufb84q);
          var y_0 = Vector2__component2_impl_kkiqjt(tmp3__anonymous__ufb84q);
          this.k69_1.lineTo(x_0, y_0);
        } else {
          Command_getInstance();
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = path.a3o_1.k(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var tmp4__anonymous__pkmkx7 = _Vector2___init__impl__67w0ru_0(tmp_1, path.a3o_1.k(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = path.a3o_1.k(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var tmp5__anonymous__kpxxpo = _Vector2___init__impl__67w0ru_0(tmp_2, path.a3o_1.k(tmp8));
            var cx = Vector2__component1_impl_k3h45m(tmp4__anonymous__pkmkx7);
            var cy = Vector2__component2_impl_kkiqjt(tmp4__anonymous__pkmkx7);
            var ax = Vector2__component1_impl_k3h45m(tmp5__anonymous__kpxxpo);
            var ay = Vector2__component2_impl_kkiqjt(tmp5__anonymous__kpxxpo);
            this.k69_1.quadraticCurveTo(cx, cy, ax, ay);
          } else {
            Command_getInstance();
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = path.a3o_1.k(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var tmp6__anonymous__fv9ai5 = _Vector2___init__impl__67w0ru_0(tmp_3, path.a3o_1.k(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = path.a3o_1.k(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var tmp7__anonymous__b0knam = _Vector2___init__impl__67w0ru_0(tmp_4, path.a3o_1.k(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = path.a3o_1.k(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var tmp8__anonymous__65w033 = _Vector2___init__impl__67w0ru_0(tmp_5, path.a3o_1.k(tmp14));
              var cx1 = Vector2__component1_impl_k3h45m(tmp6__anonymous__fv9ai5);
              var cy1 = Vector2__component2_impl_kkiqjt(tmp6__anonymous__fv9ai5);
              var cx2 = Vector2__component1_impl_k3h45m(tmp7__anonymous__b0knam);
              var cy2 = Vector2__component2_impl_kkiqjt(tmp7__anonymous__b0knam);
              var ax_0 = Vector2__component1_impl_k3h45m(tmp8__anonymous__65w033);
              var ay_0 = Vector2__component2_impl_kkiqjt(tmp8__anonymous__65w033);
              this.k69_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
            } else {
              Command_getInstance();
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call
                this.k69_1.closePath();
              }
            }
          }
        }
      }
    }
  };
  protoOf(CanvasContext2dRenderer).x61 = function (state, fill, winding) {
    if (state.i4q_1.l())
      return Unit_getInstance();
    var tmp$ret$4;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.k69_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.h4q_1;
        if (!(clip == null)) {
          this.k69_1.beginPath();
          this.t69(clip);
          var tmp0_elvis_lhs = winding;
          this.k69_1.clip(this.u69(tmp0_elvis_lhs == null ? clip.b3o_1 : tmp0_elvis_lhs));
        }
        this.k69_1.beginPath();
        this.t69(state.i4q_1);
        this.p69(this.k69_1, state.g4q_1);
        var tmp;
        if (fill) {
          transformPaint(this, state.q4q_1);
          var tmp1_elvis_lhs = winding;
          this.k69_1.fill(this.u69(tmp1_elvis_lhs == null ? state.i4q_1.b3o_1 : tmp1_elvis_lhs));
          tmp = Unit_getInstance();
        } else {
          transformPaint(this, state.p4q_1);
          var lineDash = state.y4q_1;
          if (!(lineDash == null)) {
            this.k69_1.lineDashOffset = state.z4q_1;
            var tmp$ret$3;
            // Inline function 'kotlin.collections.toTypedArray' call
            var tmp$ret$2;
            // Inline function 'korlibs.datastructure.mapDouble' call
            var tmp$ret$1;
            // Inline function 'kotlin.also' call
            var tmp0_also = new DoubleArrayList();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var tmp0_iterator = lineDash.g();
            while (tmp0_iterator.h()) {
              var v = tmp0_iterator.i();
              var tmp$ret$0;
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              tmp$ret$0 = v;
              tmp0_also.rm(tmp$ret$0);
            }
            tmp$ret$1 = tmp0_also;
            tmp$ret$2 = tmp$ret$1;
            var tmp1_toTypedArray = tmp$ret$2;
            tmp$ret$3 = copyToArray(tmp1_toTypedArray);
            this.k69_1.setLineDash(tmp$ret$3);
          }
          this.k69_1.stroke();
          tmp = Unit_getInstance();
        }
        tmp$ret$4 = tmp;
        break $l$block;
      }finally {
        this.k69_1.restore();
      }
    }
  };
  protoOf(CanvasContext2dRenderer).u69 = function (_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4;
    var tmp0 = tmp0_subject.j5_1;
    var tmp;
    switch (tmp0) {
      case 1:
        var tmp$ret$2;
        // Inline function 'org.w3c.dom.NONZERO' call
        var tmp1__get_NONZERO__96p2zb = null;
        var tmp$ret$1;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = 'nonzero';
        var tmp0_unsafeCast = tmp$ret$0;
        tmp$ret$1 = tmp0_unsafeCast;
        tmp$ret$2 = tmp$ret$1;

        tmp = tmp$ret$2;
        break;
      case 0:
        var tmp$ret$5;
        // Inline function 'org.w3c.dom.EVENODD' call
        var tmp3__get_EVENODD__v0r1mv = null;
        var tmp$ret$4;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = 'evenodd';
        var tmp2_unsafeCast = tmp$ret$3;
        tmp$ret$4 = tmp2_unsafeCast;
        tmp$ret$5 = tmp$ret$4;

        tmp = tmp$ret$5;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function bswap32_0(v) {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
  }
  function isLittleEndian$delegate$lambda() {
    _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
    // Inline function 'org.khronos.webgl.set' call
    var tmp0_set = get_tempI();
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_set;
    tmp$ret$0[0] = 1;
    var tmp$ret$2;
    // Inline function 'org.khronos.webgl.get' call
    var tmp1_get = get_temp8();
    var tmp$ret$1;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$1 = tmp1_get;
    tmp$ret$2 = tmp$ret$1[0];
    return tmp$ret$2 === 1;
  }
  function isLittleEndian$factory() {
    return getPropertyCallableRef('isLittleEndian', 0, KProperty0, function () {
      return get_isLittleEndian();
    }, null);
  }
  function lazyCanvasElement$factory() {
    return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
      return receiver.c68();
    }, null);
  }
  function ctx$factory() {
    return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
      return receiver.d68();
    }, null);
  }
  var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
  function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
    if (properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    } else {
      properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
      nativeImageFormatProvider = Companion_getInstance_17().ew() ? NodeJsNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
      tempB = new ArrayBuffer(4);
      tempI = new Int32Array(get_tempB());
      temp8 = new Uint8Array(get_tempB());
      isLittleEndian$delegate = lazy(isLittleEndian$delegate$lambda);
    }
  }
  //region block: post-declaration
  protoOf(Atlas).b44 = tryGet;
  protoOf(Atlas).ro = get_0;
  protoOf(BitmapFontImpl).g4p = get_baseBmp;
  protoOf(BitmapFontImpl).k4p = getFontMetrics;
  protoOf(BitmapFontImpl).v4r = getFontMetrics$default;
  protoOf(BitmapFontImpl).v4p = getGlyphMetrics;
  protoOf(BitmapFontImpl).w4r = getGlyphMetrics$default;
  protoOf(BitmapFontImpl).g4r = getKerning;
  protoOf(BitmapFontImpl).e4q = getTextScale;
  protoOf(BitmapFontImpl).k = get_1;
  protoOf(BitmapFontImpl).f4q = renderGlyph;
  protoOf(BitmapFontImpl).x4r = renderGlyph$default;
  protoOf(TextRendererActions).dt = reset;
  protoOf(TextRendererActions).o51 = advance;
  protoOf(TextRendererActions).p51 = newLine;
  protoOf(drawText$actions$1).dt = reset;
  protoOf(drawText$actions$1).o51 = advance;
  protoOf(drawText$actions$1).p51 = newLine;
  protoOf(LazyBitmapFont).g4p = get_baseBmp;
  protoOf(LazyBitmapFont).k4p = getFontMetrics;
  protoOf(LazyBitmapFont).v4r = getFontMetrics$default;
  protoOf(LazyBitmapFont).v4p = getGlyphMetrics;
  protoOf(LazyBitmapFont).w4r = getGlyphMetrics$default;
  protoOf(LazyBitmapFont).g4r = getKerning;
  protoOf(LazyBitmapFont).e4q = getTextScale;
  protoOf(LazyBitmapFont).t2g = getOrNull_2;
  protoOf(LazyBitmapFont).k = get_1;
  protoOf(LazyBitmapFont).f4q = renderGlyph;
  protoOf(LazyBitmapFont).x4r = renderGlyph$default;
  protoOf(BaseTtfFont).v4r = getFontMetrics$default;
  protoOf(BaseTtfFont).w4r = getGlyphMetrics$default;
  protoOf(BaseTtfFont).a5b = getGlyphPath$default;
  protoOf(BaseTtfFont).f4q = renderGlyph_0;
  protoOf(BaseTtfFont).x4r = renderGlyph$default;
  protoOf(BaseTtfFont).t2g = getOrNull_2;
  protoOf(TtfFont).v4r = getFontMetrics$default;
  protoOf(TtfFont).w4r = getGlyphMetrics$default;
  protoOf(TtfFont).a5b = getGlyphPath$default;
  protoOf(TtfFont).f4q = renderGlyph_0;
  protoOf(TtfFont).x4r = renderGlyph$default;
  protoOf(TtfFont).t2g = getOrNull_2;
  protoOf(ColrGlyphInfoV1).e5i = getColorShape$default;
  protoOf(ColrGlyphInfoV0).e5i = getColorShape$default;
  protoOf(GlyphGraphicsPath).t3y = arc$default;
  protoOf(Text2TextRendererActions).dt = reset;
  protoOf(Text2TextRendererActions).o51 = advance;
  protoOf(Text2TextRendererActions).p51 = newLine;
  protoOf(Context2d).n3y = line;
  protoOf(Context2d).l = isEmpty;
  protoOf(Context2d).o3y = rect;
  protoOf(Context2d).p3y = rect_0;
  protoOf(Context2d).q3y = rect_1;
  protoOf(Context2d).r3y = rect_2;
  protoOf(Context2d).s3y = arc;
  protoOf(Context2d).t3y = arc$default;
  protoOf(Context2d).v3b = circle;
  protoOf(Context2d).u3y = rMoveTo;
  protoOf(Context2d).v3y = rLineTo;
  protoOf(Context2d).w3y = transformed;
  protoOf(FillShape).k64 = getBounds;
  protoOf(FillShape).j64 = getPath_0;
  protoOf(FillShape).g53 = getPath$default;
  protoOf(FillShape).n52 = draw;
  protoOf(FillShape).n5i = get_bounds;
  protoOf(CompoundShape).g53 = getPath$default;
  protoOf(CompoundShape).n5i = get_bounds;
  protoOf(EmptyShape).j64 = getPath;
  protoOf(EmptyShape).g53 = getPath$default;
  protoOf(EmptyShape).n5i = get_bounds;
  protoOf(PolylineShape).j64 = getPath_0;
  protoOf(PolylineShape).g53 = getPath$default;
  protoOf(PolylineShape).n52 = draw;
  protoOf(PolylineShape).n5i = get_bounds;
  protoOf(ShapeBuilder).n3y = line;
  protoOf(ShapeBuilder).l = isEmpty;
  protoOf(ShapeBuilder).o3y = rect;
  protoOf(ShapeBuilder).p3y = rect_0;
  protoOf(ShapeBuilder).q3y = rect_1;
  protoOf(ShapeBuilder).r3y = rect_2;
  protoOf(ShapeBuilder).s3y = arc;
  protoOf(ShapeBuilder).t3y = arc$default;
  protoOf(ShapeBuilder).v3b = circle;
  protoOf(ShapeBuilder).u3y = rMoveTo;
  protoOf(ShapeBuilder).v3y = rLineTo;
  protoOf(ShapeBuilder).w3y = transformed;
  //endregion
  //region block: init
  DefaultTtfFontOrNull = null;
  SystemFontRegistryOrNull = null;
  _nativeSystemFontProvider = null;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = readAtlas;
  _.$_$.b = readBitmapFont;
  _.$_$.c = readFont;
  _.$_$.d = readBitmapSlice;
  _.$_$.e = readBitmap_1;
  _.$_$.f = readBitmap;
  _.$_$.g = readBitmap_0;
  _.$_$.h = _RGBA___get_af__impl__vu36qv;
  _.$_$.i = _RGBA___get_bf__impl__1xz5yg;
  _.$_$.j = _RGBA___get_gf__impl__5gcu1f;
  _.$_$.k = RGBA__hashCode_impl_h59qf6;
  _.$_$.l = _RGBA___get_hexString__impl__kocngm;
  _.$_$.m = _RGBA___get_premultiplied__impl__3bulqc;
  _.$_$.n = _RGBA___get_rf__impl__kvz75k;
  _.$_$.o = _RGBA___get_rgb__impl__tijaqt;
  _.$_$.p = _RGBA___get_value__impl__hhco8v;
  _.$_$.q = _RGBAPremultiplied___get_af__impl__euwcjn;
  _.$_$.r = _RGBAPremultiplied___get_bf__impl__qa3on2;
  _.$_$.s = _RGBAPremultiplied___get_gf__impl__ivron7;
  _.$_$.t = _RGBAPremultiplied___get_rf__impl__pt0c4y;
  _.$_$.u = _RgbaPremultipliedArray___init__impl__lx83hy;
  _.$_$.v = HorizontalAlign__getOffsetX_impl_urzzxf;
  _.$_$.w = VerticalAlign__getOffsetY_impl_iso0y6;
  _.$_$.x = _VerticalAlign___get_ratioFake__impl__1h2fwv;
  _.$_$.y = Bitmaps_getInstance;
  _.$_$.z = Colors_getInstance;
  _.$_$.a1 = Companion_getInstance_32;
  _.$_$.b1 = Companion_getInstance_31;
  _.$_$.c1 = Companion_getInstance_51;
  _.$_$.d1 = Companion_getInstance_49;
  _.$_$.e1 = EmptyShape_getInstance;
  _.$_$.f1 = Bitmap32;
  _.$_$.g1 = Bitmap8;
  _.$_$.h1 = get_Bitmaps_transparent;
  _.$_$.i1 = get_Bitmaps_white;
  _.$_$.j1 = FloatBitmap32;
  _.$_$.k1 = ForcedTexId;
  _.$_$.l1 = MultiBitmap;
  _.$_$.m1 = NativeImageOrBitmap32;
  _.$_$.n1 = NativeImage;
  _.$_$.o1 = NullBitmap;
  _.$_$.p1 = get_baseMipmapLevel;
  _.$_$.q1 = get_bmp;
  _.$_$.r1 = get_maxMipmapLevel;
  _.$_$.s1 = slice;
  _.$_$.t1 = ColorTransformMul;
  _.$_$.u1 = RGBA;
  _.$_$.v1 = Glyph;
  _.$_$.w1 = BitmapFont;
  _.$_$.x1 = get_DefaultTtfFontAsBitmap;
  _.$_$.y1 = FontMetrics;
  _.$_$.z1 = Font;
  _.$_$.a2 = TextMetricsResult;
  _.$_$.b2 = TextMetrics;
  _.$_$.c2 = getTextBounds;
  _.$_$.d2 = HtmlNativeImage;
  _.$_$.e2 = ImageDecodingProps;
  _.$_$.f2 = get_RegisteredImageFormats;
  _.$_$.g2 = toHtmlNative;
  _.$_$.h2 = BitmapPaint;
  _.$_$.i2 = GradientPaint;
  _.$_$.j2 = NonePaint;
  _.$_$.k2 = get_DefaultStringTextRenderer;
  _.$_$.l2 = Entry_1;
  _.$_$.m2 = LineInfo;
  _.$_$.n2 = Text2TextRendererActions;
  _.$_$.o2 = invoke;
  _.$_$.p2 = CompoundShape;
  _.$_$.q2 = FillShape;
  _.$_$.r2 = PolylineShape;
  _.$_$.s2 = ShapeBuilder;
  _.$_$.t2 = TextShape;
  //endregion
  return _;
}));
